/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const com = $root.com = (() => {

    /**
     * Namespace com.
     * @exports com
     * @namespace
     */
    const com = {};

    com.achlid = (function() {

        /**
         * Namespace achlid.
         * @memberof com
         * @namespace
         */
        const achlid = {};

        achlid.crash = (function() {

            /**
             * Namespace crash.
             * @memberof com.achlid
             * @namespace
             */
            const crash = {};

            crash.game = (function() {

                /**
                 * Namespace game.
                 * @memberof com.achlid.crash
                 * @namespace
                 */
                const game = {};

                game.GameMessage = (function() {

                    /**
                     * Properties of a GameMessage.
                     * @memberof com.achlid.crash.game
                     * @interface IGameMessage
                     * @property {com.achlid.crash.game.GameMessage.MessageType|null} [type] GameMessage type
                     * @property {number|Long|null} [timestamp] GameMessage timestamp
                     * @property {string|null} [messageId] GameMessage messageId
                     * @property {com.achlid.crash.game.IPlaceBetRequest|null} [placeBet] GameMessage placeBet
                     * @property {com.achlid.crash.game.ICashOutRequest|null} [cashOut] GameMessage cashOut
                     * @property {com.achlid.crash.game.ICancelBetRequest|null} [cancelBet] GameMessage cancelBet
                     * @property {com.achlid.crash.game.IAutoPlayRequest|null} [autoPlay] GameMessage autoPlay
                     * @property {com.achlid.crash.game.IStopAutoPlayRequest|null} [stopAutoPlay] GameMessage stopAutoPlay
                     * @property {com.achlid.crash.game.ISetAutoCashOutRequest|null} [setAutoCashOut] GameMessage setAutoCashOut
                     * @property {com.achlid.crash.game.stateless.IGetWalletRequest|null} [getWallet] GameMessage getWallet
                     * @property {com.achlid.crash.game.stateless.IGetLeaderboardRequest|null} [getLeaderboard] GameMessage getLeaderboard
                     * @property {com.achlid.crash.game.stateless.IGetBetHistoryRequest|null} [getBetHistory] GameMessage getBetHistory
                     * @property {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest|null} [getProvablyFairRound] GameMessage getProvablyFairRound
                     * @property {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest|null} [getProvablyFairBets] GameMessage getProvablyFairBets
                     * @property {com.achlid.crash.game.stateless.IGetUserProfileRequest|null} [getUserProfile] GameMessage getUserProfile
                     * @property {com.achlid.crash.game.stateless.IUpdateUserProfileRequest|null} [updateUserProfile] GameMessage updateUserProfile
                     * @property {com.achlid.crash.game.stateless.IGetFreebetsRequest|null} [getFreebets] GameMessage getFreebets
                     * @property {com.achlid.crash.game.stateless.ISendChatMessageRequest|null} [sendChatMessage] GameMessage sendChatMessage
                     * @property {com.achlid.crash.game.stateless.IGetChatHistoryRequest|null} [getChatHistory] GameMessage getChatHistory
                     * @property {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest|null} [getViewerAwareChatHistory] GameMessage getViewerAwareChatHistory
                     * @property {com.achlid.crash.game.IConnectedResponse|null} [connected] GameMessage connected
                     * @property {com.achlid.crash.game.IBetResult|null} [betResult] GameMessage betResult
                     * @property {com.achlid.crash.game.ICashOutResult|null} [cashOutResult] GameMessage cashOutResult
                     * @property {com.achlid.crash.game.ICancelBetResult|null} [cancelBetResult] GameMessage cancelBetResult
                     * @property {com.achlid.crash.game.IAutoPlayResult|null} [autoPlayResult] GameMessage autoPlayResult
                     * @property {com.achlid.crash.game.IAutoPlayUpdate|null} [autoPlayUpdate] GameMessage autoPlayUpdate
                     * @property {com.achlid.crash.game.ISetAutoCashOutResult|null} [autoCashOutResult] GameMessage autoCashOutResult
                     * @property {com.achlid.crash.game.IYourClientSeed|null} [yourClientSeed] GameMessage yourClientSeed
                     * @property {com.achlid.crash.game.IWalletUpdate|null} [walletUpdate] GameMessage walletUpdate
                     * @property {com.achlid.crash.game.stateless.IWalletResponse|null} [walletResponse] GameMessage walletResponse
                     * @property {com.achlid.crash.game.stateless.ILeaderboardResponse|null} [leaderboardResponse] GameMessage leaderboardResponse
                     * @property {com.achlid.crash.game.stateless.IBetHistoryResponse|null} [betHistoryResponse] GameMessage betHistoryResponse
                     * @property {com.achlid.crash.game.stateless.IProvablyFairRoundResponse|null} [provablyFairRoundResponse] GameMessage provablyFairRoundResponse
                     * @property {com.achlid.crash.game.stateless.IProvablyFairBetsResponse|null} [provablyFairBetsResponse] GameMessage provablyFairBetsResponse
                     * @property {com.achlid.crash.game.stateless.IUserProfileResponse|null} [userProfileResponse] GameMessage userProfileResponse
                     * @property {com.achlid.crash.game.stateless.IUpdateUserProfileResponse|null} [updateUserProfileResponse] GameMessage updateUserProfileResponse
                     * @property {com.achlid.crash.game.stateless.IFreebetsResponse|null} [freebetsResponse] GameMessage freebetsResponse
                     * @property {com.achlid.crash.game.stateless.IChatSendResult|null} [chatSendResult] GameMessage chatSendResult
                     * @property {com.achlid.crash.game.stateless.IChatHistoryResponse|null} [chatHistoryResponse] GameMessage chatHistoryResponse
                     * @property {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse|null} [viewerAwareChatHistoryResponse] GameMessage viewerAwareChatHistoryResponse
                     * @property {com.achlid.crash.game.IMultiplierUpdate|null} [multiplierUpdate] GameMessage multiplierUpdate
                     * @property {com.achlid.crash.game.IRoundCrash|null} [roundCrash] GameMessage roundCrash
                     * @property {com.achlid.crash.game.IRoundStart|null} [roundStart] GameMessage roundStart
                     * @property {com.achlid.crash.game.IPreRoundStart|null} [preRoundStart] GameMessage preRoundStart
                     * @property {com.achlid.crash.game.INewBetNotification|null} [newBetNotification] GameMessage newBetNotification
                     * @property {com.achlid.crash.game.ICashOutNotification|null} [cashOutNotification] GameMessage cashOutNotification
                     * @property {com.achlid.crash.game.IBigWinNotification|null} [bigWinNotification] GameMessage bigWinNotification
                     * @property {com.achlid.crash.game.ICancelBetNotification|null} [cancelBetNotification] GameMessage cancelBetNotification
                     * @property {com.achlid.crash.game.IRoomBetsNotification|null} [roomBetsNotification] GameMessage roomBetsNotification
                     * @property {com.achlid.crash.game.ITotalBetsCountUpdate|null} [totalBetsCount] GameMessage totalBetsCount
                     * @property {com.achlid.crash.game.IFreebetGrantedNotification|null} [freebetGrantedNotification] GameMessage freebetGrantedNotification
                     * @property {com.achlid.crash.game.IFreebetProgressEligibility|null} [freebetProgressEligibility] GameMessage freebetProgressEligibility
                     * @property {com.achlid.crash.game.IFreebetProgressUpdate|null} [freebetProgressUpdate] GameMessage freebetProgressUpdate
                     * @property {com.achlid.crash.game.stateless.IChatMessage|null} [chatMessage] GameMessage chatMessage
                     * @property {com.achlid.crash.game.stateless.IChatMessageDeleted|null} [chatMessageDeleted] GameMessage chatMessageDeleted
                     * @property {com.achlid.crash.game.IErrorMessage|null} [error] GameMessage error
                     * @property {com.achlid.crash.game.IPongResponse|null} [pong] GameMessage pong
                     * @property {com.achlid.crash.game.IGameStateUpdate|null} [gameState] GameMessage gameState
                     * @property {com.achlid.crash.game.IPingRequest|null} [ping] GameMessage ping
                     * @property {com.achlid.crash.game.ISetForcedCrashPointRequest|null} [setForcedCrashPoint] GameMessage setForcedCrashPoint
                     * @property {com.achlid.crash.game.ISetForcedCrashPointResult|null} [forcedCrashPointResult] GameMessage forcedCrashPointResult
                     */

                    /**
                     * Constructs a new GameMessage.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a GameMessage.
                     * @implements IGameMessage
                     * @constructor
                     * @param {com.achlid.crash.game.IGameMessage=} [properties] Properties to set
                     */
                    function GameMessage(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GameMessage type.
                     * @member {com.achlid.crash.game.GameMessage.MessageType} type
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.type = 0;

                    /**
                     * GameMessage timestamp.
                     * @member {number|Long} timestamp
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * GameMessage messageId.
                     * @member {string} messageId
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.messageId = "";

                    /**
                     * GameMessage placeBet.
                     * @member {com.achlid.crash.game.IPlaceBetRequest|null|undefined} placeBet
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.placeBet = null;

                    /**
                     * GameMessage cashOut.
                     * @member {com.achlid.crash.game.ICashOutRequest|null|undefined} cashOut
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cashOut = null;

                    /**
                     * GameMessage cancelBet.
                     * @member {com.achlid.crash.game.ICancelBetRequest|null|undefined} cancelBet
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cancelBet = null;

                    /**
                     * GameMessage autoPlay.
                     * @member {com.achlid.crash.game.IAutoPlayRequest|null|undefined} autoPlay
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.autoPlay = null;

                    /**
                     * GameMessage stopAutoPlay.
                     * @member {com.achlid.crash.game.IStopAutoPlayRequest|null|undefined} stopAutoPlay
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.stopAutoPlay = null;

                    /**
                     * GameMessage setAutoCashOut.
                     * @member {com.achlid.crash.game.ISetAutoCashOutRequest|null|undefined} setAutoCashOut
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.setAutoCashOut = null;

                    /**
                     * GameMessage getWallet.
                     * @member {com.achlid.crash.game.stateless.IGetWalletRequest|null|undefined} getWallet
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getWallet = null;

                    /**
                     * GameMessage getLeaderboard.
                     * @member {com.achlid.crash.game.stateless.IGetLeaderboardRequest|null|undefined} getLeaderboard
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getLeaderboard = null;

                    /**
                     * GameMessage getBetHistory.
                     * @member {com.achlid.crash.game.stateless.IGetBetHistoryRequest|null|undefined} getBetHistory
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getBetHistory = null;

                    /**
                     * GameMessage getProvablyFairRound.
                     * @member {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest|null|undefined} getProvablyFairRound
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getProvablyFairRound = null;

                    /**
                     * GameMessage getProvablyFairBets.
                     * @member {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest|null|undefined} getProvablyFairBets
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getProvablyFairBets = null;

                    /**
                     * GameMessage getUserProfile.
                     * @member {com.achlid.crash.game.stateless.IGetUserProfileRequest|null|undefined} getUserProfile
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getUserProfile = null;

                    /**
                     * GameMessage updateUserProfile.
                     * @member {com.achlid.crash.game.stateless.IUpdateUserProfileRequest|null|undefined} updateUserProfile
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.updateUserProfile = null;

                    /**
                     * GameMessage getFreebets.
                     * @member {com.achlid.crash.game.stateless.IGetFreebetsRequest|null|undefined} getFreebets
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getFreebets = null;

                    /**
                     * GameMessage sendChatMessage.
                     * @member {com.achlid.crash.game.stateless.ISendChatMessageRequest|null|undefined} sendChatMessage
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.sendChatMessage = null;

                    /**
                     * GameMessage getChatHistory.
                     * @member {com.achlid.crash.game.stateless.IGetChatHistoryRequest|null|undefined} getChatHistory
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getChatHistory = null;

                    /**
                     * GameMessage getViewerAwareChatHistory.
                     * @member {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest|null|undefined} getViewerAwareChatHistory
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.getViewerAwareChatHistory = null;

                    /**
                     * GameMessage connected.
                     * @member {com.achlid.crash.game.IConnectedResponse|null|undefined} connected
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.connected = null;

                    /**
                     * GameMessage betResult.
                     * @member {com.achlid.crash.game.IBetResult|null|undefined} betResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.betResult = null;

                    /**
                     * GameMessage cashOutResult.
                     * @member {com.achlid.crash.game.ICashOutResult|null|undefined} cashOutResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cashOutResult = null;

                    /**
                     * GameMessage cancelBetResult.
                     * @member {com.achlid.crash.game.ICancelBetResult|null|undefined} cancelBetResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cancelBetResult = null;

                    /**
                     * GameMessage autoPlayResult.
                     * @member {com.achlid.crash.game.IAutoPlayResult|null|undefined} autoPlayResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.autoPlayResult = null;

                    /**
                     * GameMessage autoPlayUpdate.
                     * @member {com.achlid.crash.game.IAutoPlayUpdate|null|undefined} autoPlayUpdate
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.autoPlayUpdate = null;

                    /**
                     * GameMessage autoCashOutResult.
                     * @member {com.achlid.crash.game.ISetAutoCashOutResult|null|undefined} autoCashOutResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.autoCashOutResult = null;

                    /**
                     * GameMessage yourClientSeed.
                     * @member {com.achlid.crash.game.IYourClientSeed|null|undefined} yourClientSeed
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.yourClientSeed = null;

                    /**
                     * GameMessage walletUpdate.
                     * @member {com.achlid.crash.game.IWalletUpdate|null|undefined} walletUpdate
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.walletUpdate = null;

                    /**
                     * GameMessage walletResponse.
                     * @member {com.achlid.crash.game.stateless.IWalletResponse|null|undefined} walletResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.walletResponse = null;

                    /**
                     * GameMessage leaderboardResponse.
                     * @member {com.achlid.crash.game.stateless.ILeaderboardResponse|null|undefined} leaderboardResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.leaderboardResponse = null;

                    /**
                     * GameMessage betHistoryResponse.
                     * @member {com.achlid.crash.game.stateless.IBetHistoryResponse|null|undefined} betHistoryResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.betHistoryResponse = null;

                    /**
                     * GameMessage provablyFairRoundResponse.
                     * @member {com.achlid.crash.game.stateless.IProvablyFairRoundResponse|null|undefined} provablyFairRoundResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.provablyFairRoundResponse = null;

                    /**
                     * GameMessage provablyFairBetsResponse.
                     * @member {com.achlid.crash.game.stateless.IProvablyFairBetsResponse|null|undefined} provablyFairBetsResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.provablyFairBetsResponse = null;

                    /**
                     * GameMessage userProfileResponse.
                     * @member {com.achlid.crash.game.stateless.IUserProfileResponse|null|undefined} userProfileResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.userProfileResponse = null;

                    /**
                     * GameMessage updateUserProfileResponse.
                     * @member {com.achlid.crash.game.stateless.IUpdateUserProfileResponse|null|undefined} updateUserProfileResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.updateUserProfileResponse = null;

                    /**
                     * GameMessage freebetsResponse.
                     * @member {com.achlid.crash.game.stateless.IFreebetsResponse|null|undefined} freebetsResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.freebetsResponse = null;

                    /**
                     * GameMessage chatSendResult.
                     * @member {com.achlid.crash.game.stateless.IChatSendResult|null|undefined} chatSendResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.chatSendResult = null;

                    /**
                     * GameMessage chatHistoryResponse.
                     * @member {com.achlid.crash.game.stateless.IChatHistoryResponse|null|undefined} chatHistoryResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.chatHistoryResponse = null;

                    /**
                     * GameMessage viewerAwareChatHistoryResponse.
                     * @member {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse|null|undefined} viewerAwareChatHistoryResponse
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.viewerAwareChatHistoryResponse = null;

                    /**
                     * GameMessage multiplierUpdate.
                     * @member {com.achlid.crash.game.IMultiplierUpdate|null|undefined} multiplierUpdate
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.multiplierUpdate = null;

                    /**
                     * GameMessage roundCrash.
                     * @member {com.achlid.crash.game.IRoundCrash|null|undefined} roundCrash
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.roundCrash = null;

                    /**
                     * GameMessage roundStart.
                     * @member {com.achlid.crash.game.IRoundStart|null|undefined} roundStart
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.roundStart = null;

                    /**
                     * GameMessage preRoundStart.
                     * @member {com.achlid.crash.game.IPreRoundStart|null|undefined} preRoundStart
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.preRoundStart = null;

                    /**
                     * GameMessage newBetNotification.
                     * @member {com.achlid.crash.game.INewBetNotification|null|undefined} newBetNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.newBetNotification = null;

                    /**
                     * GameMessage cashOutNotification.
                     * @member {com.achlid.crash.game.ICashOutNotification|null|undefined} cashOutNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cashOutNotification = null;

                    /**
                     * GameMessage bigWinNotification.
                     * @member {com.achlid.crash.game.IBigWinNotification|null|undefined} bigWinNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.bigWinNotification = null;

                    /**
                     * GameMessage cancelBetNotification.
                     * @member {com.achlid.crash.game.ICancelBetNotification|null|undefined} cancelBetNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.cancelBetNotification = null;

                    /**
                     * GameMessage roomBetsNotification.
                     * @member {com.achlid.crash.game.IRoomBetsNotification|null|undefined} roomBetsNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.roomBetsNotification = null;

                    /**
                     * GameMessage totalBetsCount.
                     * @member {com.achlid.crash.game.ITotalBetsCountUpdate|null|undefined} totalBetsCount
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.totalBetsCount = null;

                    /**
                     * GameMessage freebetGrantedNotification.
                     * @member {com.achlid.crash.game.IFreebetGrantedNotification|null|undefined} freebetGrantedNotification
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.freebetGrantedNotification = null;

                    /**
                     * GameMessage freebetProgressEligibility.
                     * @member {com.achlid.crash.game.IFreebetProgressEligibility|null|undefined} freebetProgressEligibility
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.freebetProgressEligibility = null;

                    /**
                     * GameMessage freebetProgressUpdate.
                     * @member {com.achlid.crash.game.IFreebetProgressUpdate|null|undefined} freebetProgressUpdate
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.freebetProgressUpdate = null;

                    /**
                     * GameMessage chatMessage.
                     * @member {com.achlid.crash.game.stateless.IChatMessage|null|undefined} chatMessage
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.chatMessage = null;

                    /**
                     * GameMessage chatMessageDeleted.
                     * @member {com.achlid.crash.game.stateless.IChatMessageDeleted|null|undefined} chatMessageDeleted
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.chatMessageDeleted = null;

                    /**
                     * GameMessage error.
                     * @member {com.achlid.crash.game.IErrorMessage|null|undefined} error
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.error = null;

                    /**
                     * GameMessage pong.
                     * @member {com.achlid.crash.game.IPongResponse|null|undefined} pong
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.pong = null;

                    /**
                     * GameMessage gameState.
                     * @member {com.achlid.crash.game.IGameStateUpdate|null|undefined} gameState
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.gameState = null;

                    /**
                     * GameMessage ping.
                     * @member {com.achlid.crash.game.IPingRequest|null|undefined} ping
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.ping = null;

                    /**
                     * GameMessage setForcedCrashPoint.
                     * @member {com.achlid.crash.game.ISetForcedCrashPointRequest|null|undefined} setForcedCrashPoint
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.setForcedCrashPoint = null;

                    /**
                     * GameMessage forcedCrashPointResult.
                     * @member {com.achlid.crash.game.ISetForcedCrashPointResult|null|undefined} forcedCrashPointResult
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    GameMessage.prototype.forcedCrashPointResult = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * GameMessage payload.
                     * @member {"placeBet"|"cashOut"|"cancelBet"|"autoPlay"|"stopAutoPlay"|"setAutoCashOut"|"getWallet"|"getLeaderboard"|"getBetHistory"|"getProvablyFairRound"|"getProvablyFairBets"|"getUserProfile"|"updateUserProfile"|"getFreebets"|"sendChatMessage"|"getChatHistory"|"getViewerAwareChatHistory"|"connected"|"betResult"|"cashOutResult"|"cancelBetResult"|"autoPlayResult"|"autoPlayUpdate"|"autoCashOutResult"|"yourClientSeed"|"walletUpdate"|"walletResponse"|"leaderboardResponse"|"betHistoryResponse"|"provablyFairRoundResponse"|"provablyFairBetsResponse"|"userProfileResponse"|"updateUserProfileResponse"|"freebetsResponse"|"chatSendResult"|"chatHistoryResponse"|"viewerAwareChatHistoryResponse"|"multiplierUpdate"|"roundCrash"|"roundStart"|"preRoundStart"|"newBetNotification"|"cashOutNotification"|"bigWinNotification"|"cancelBetNotification"|"roomBetsNotification"|"totalBetsCount"|"freebetGrantedNotification"|"freebetProgressEligibility"|"freebetProgressUpdate"|"chatMessage"|"chatMessageDeleted"|"error"|"pong"|"gameState"|"ping"|"setForcedCrashPoint"|"forcedCrashPointResult"|undefined} payload
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     */
                    Object.defineProperty(GameMessage.prototype, "payload", {
                        get: $util.oneOfGetter($oneOfFields = ["placeBet", "cashOut", "cancelBet", "autoPlay", "stopAutoPlay", "setAutoCashOut", "getWallet", "getLeaderboard", "getBetHistory", "getProvablyFairRound", "getProvablyFairBets", "getUserProfile", "updateUserProfile", "getFreebets", "sendChatMessage", "getChatHistory", "getViewerAwareChatHistory", "connected", "betResult", "cashOutResult", "cancelBetResult", "autoPlayResult", "autoPlayUpdate", "autoCashOutResult", "yourClientSeed", "walletUpdate", "walletResponse", "leaderboardResponse", "betHistoryResponse", "provablyFairRoundResponse", "provablyFairBetsResponse", "userProfileResponse", "updateUserProfileResponse", "freebetsResponse", "chatSendResult", "chatHistoryResponse", "viewerAwareChatHistoryResponse", "multiplierUpdate", "roundCrash", "roundStart", "preRoundStart", "newBetNotification", "cashOutNotification", "bigWinNotification", "cancelBetNotification", "roomBetsNotification", "totalBetsCount", "freebetGrantedNotification", "freebetProgressEligibility", "freebetProgressUpdate", "chatMessage", "chatMessageDeleted", "error", "pong", "gameState", "ping", "setForcedCrashPoint", "forcedCrashPointResult"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new GameMessage instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {com.achlid.crash.game.IGameMessage=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.GameMessage} GameMessage instance
                     */
                    GameMessage.create = function create(properties) {
                        return new GameMessage(properties);
                    };

                    /**
                     * Encodes the specified GameMessage message. Does not implicitly {@link com.achlid.crash.game.GameMessage.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {com.achlid.crash.game.IGameMessage} message GameMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameMessage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
                        if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.messageId);
                        if (message.placeBet != null && Object.hasOwnProperty.call(message, "placeBet"))
                            $root.com.achlid.crash.game.PlaceBetRequest.encode(message.placeBet, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.cashOut != null && Object.hasOwnProperty.call(message, "cashOut"))
                            $root.com.achlid.crash.game.CashOutRequest.encode(message.cashOut, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.cancelBet != null && Object.hasOwnProperty.call(message, "cancelBet"))
                            $root.com.achlid.crash.game.CancelBetRequest.encode(message.cancelBet, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.autoPlay != null && Object.hasOwnProperty.call(message, "autoPlay"))
                            $root.com.achlid.crash.game.AutoPlayRequest.encode(message.autoPlay, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.stopAutoPlay != null && Object.hasOwnProperty.call(message, "stopAutoPlay"))
                            $root.com.achlid.crash.game.StopAutoPlayRequest.encode(message.stopAutoPlay, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.ping != null && Object.hasOwnProperty.call(message, "ping"))
                            $root.com.achlid.crash.game.PingRequest.encode(message.ping, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.getWallet != null && Object.hasOwnProperty.call(message, "getWallet"))
                            $root.com.achlid.crash.game.stateless.GetWalletRequest.encode(message.getWallet, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.getLeaderboard != null && Object.hasOwnProperty.call(message, "getLeaderboard"))
                            $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.encode(message.getLeaderboard, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.connected != null && Object.hasOwnProperty.call(message, "connected"))
                            $root.com.achlid.crash.game.ConnectedResponse.encode(message.connected, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.betResult != null && Object.hasOwnProperty.call(message, "betResult"))
                            $root.com.achlid.crash.game.BetResult.encode(message.betResult, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.cashOutResult != null && Object.hasOwnProperty.call(message, "cashOutResult"))
                            $root.com.achlid.crash.game.CashOutResult.encode(message.cashOutResult, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                        if (message.cancelBetResult != null && Object.hasOwnProperty.call(message, "cancelBetResult"))
                            $root.com.achlid.crash.game.CancelBetResult.encode(message.cancelBetResult, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                        if (message.autoPlayResult != null && Object.hasOwnProperty.call(message, "autoPlayResult"))
                            $root.com.achlid.crash.game.AutoPlayResult.encode(message.autoPlayResult, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                        if (message.autoPlayUpdate != null && Object.hasOwnProperty.call(message, "autoPlayUpdate"))
                            $root.com.achlid.crash.game.AutoPlayUpdate.encode(message.autoPlayUpdate, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                        if (message.walletResponse != null && Object.hasOwnProperty.call(message, "walletResponse"))
                            $root.com.achlid.crash.game.stateless.WalletResponse.encode(message.walletResponse, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                        if (message.leaderboardResponse != null && Object.hasOwnProperty.call(message, "leaderboardResponse"))
                            $root.com.achlid.crash.game.stateless.LeaderboardResponse.encode(message.leaderboardResponse, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                        if (message.multiplierUpdate != null && Object.hasOwnProperty.call(message, "multiplierUpdate"))
                            $root.com.achlid.crash.game.MultiplierUpdate.encode(message.multiplierUpdate, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                        if (message.roundCrash != null && Object.hasOwnProperty.call(message, "roundCrash"))
                            $root.com.achlid.crash.game.RoundCrash.encode(message.roundCrash, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                        if (message.roundStart != null && Object.hasOwnProperty.call(message, "roundStart"))
                            $root.com.achlid.crash.game.RoundStart.encode(message.roundStart, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                        if (message.preRoundStart != null && Object.hasOwnProperty.call(message, "preRoundStart"))
                            $root.com.achlid.crash.game.PreRoundStart.encode(message.preRoundStart, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
                        if (message.newBetNotification != null && Object.hasOwnProperty.call(message, "newBetNotification"))
                            $root.com.achlid.crash.game.NewBetNotification.encode(message.newBetNotification, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.cashOutNotification != null && Object.hasOwnProperty.call(message, "cashOutNotification"))
                            $root.com.achlid.crash.game.CashOutNotification.encode(message.cashOutNotification, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
                        if (message.bigWinNotification != null && Object.hasOwnProperty.call(message, "bigWinNotification"))
                            $root.com.achlid.crash.game.BigWinNotification.encode(message.bigWinNotification, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
                        if (message.cancelBetNotification != null && Object.hasOwnProperty.call(message, "cancelBetNotification"))
                            $root.com.achlid.crash.game.CancelBetNotification.encode(message.cancelBetNotification, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
                        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                            $root.com.achlid.crash.game.ErrorMessage.encode(message.error, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
                        if (message.pong != null && Object.hasOwnProperty.call(message, "pong"))
                            $root.com.achlid.crash.game.PongResponse.encode(message.pong, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
                        if (message.gameState != null && Object.hasOwnProperty.call(message, "gameState"))
                            $root.com.achlid.crash.game.GameStateUpdate.encode(message.gameState, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
                        if (message.setAutoCashOut != null && Object.hasOwnProperty.call(message, "setAutoCashOut"))
                            $root.com.achlid.crash.game.SetAutoCashOutRequest.encode(message.setAutoCashOut, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                        if (message.autoCashOutResult != null && Object.hasOwnProperty.call(message, "autoCashOutResult"))
                            $root.com.achlid.crash.game.SetAutoCashOutResult.encode(message.autoCashOutResult, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
                        if (message.totalBetsCount != null && Object.hasOwnProperty.call(message, "totalBetsCount"))
                            $root.com.achlid.crash.game.TotalBetsCountUpdate.encode(message.totalBetsCount, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
                        if (message.getBetHistory != null && Object.hasOwnProperty.call(message, "getBetHistory"))
                            $root.com.achlid.crash.game.stateless.GetBetHistoryRequest.encode(message.getBetHistory, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
                        if (message.betHistoryResponse != null && Object.hasOwnProperty.call(message, "betHistoryResponse"))
                            $root.com.achlid.crash.game.stateless.BetHistoryResponse.encode(message.betHistoryResponse, writer.uint32(/* id 61, wireType 2 =*/490).fork()).ldelim();
                        if (message.getProvablyFairRound != null && Object.hasOwnProperty.call(message, "getProvablyFairRound"))
                            $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.encode(message.getProvablyFairRound, writer.uint32(/* id 62, wireType 2 =*/498).fork()).ldelim();
                        if (message.getProvablyFairBets != null && Object.hasOwnProperty.call(message, "getProvablyFairBets"))
                            $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.encode(message.getProvablyFairBets, writer.uint32(/* id 63, wireType 2 =*/506).fork()).ldelim();
                        if (message.provablyFairRoundResponse != null && Object.hasOwnProperty.call(message, "provablyFairRoundResponse"))
                            $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse.encode(message.provablyFairRoundResponse, writer.uint32(/* id 64, wireType 2 =*/514).fork()).ldelim();
                        if (message.provablyFairBetsResponse != null && Object.hasOwnProperty.call(message, "provablyFairBetsResponse"))
                            $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse.encode(message.provablyFairBetsResponse, writer.uint32(/* id 65, wireType 2 =*/522).fork()).ldelim();
                        if (message.getUserProfile != null && Object.hasOwnProperty.call(message, "getUserProfile"))
                            $root.com.achlid.crash.game.stateless.GetUserProfileRequest.encode(message.getUserProfile, writer.uint32(/* id 66, wireType 2 =*/530).fork()).ldelim();
                        if (message.updateUserProfile != null && Object.hasOwnProperty.call(message, "updateUserProfile"))
                            $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest.encode(message.updateUserProfile, writer.uint32(/* id 67, wireType 2 =*/538).fork()).ldelim();
                        if (message.userProfileResponse != null && Object.hasOwnProperty.call(message, "userProfileResponse"))
                            $root.com.achlid.crash.game.stateless.UserProfileResponse.encode(message.userProfileResponse, writer.uint32(/* id 68, wireType 2 =*/546).fork()).ldelim();
                        if (message.updateUserProfileResponse != null && Object.hasOwnProperty.call(message, "updateUserProfileResponse"))
                            $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse.encode(message.updateUserProfileResponse, writer.uint32(/* id 69, wireType 2 =*/554).fork()).ldelim();
                        if (message.yourClientSeed != null && Object.hasOwnProperty.call(message, "yourClientSeed"))
                            $root.com.achlid.crash.game.YourClientSeed.encode(message.yourClientSeed, writer.uint32(/* id 70, wireType 2 =*/562).fork()).ldelim();
                        if (message.walletUpdate != null && Object.hasOwnProperty.call(message, "walletUpdate"))
                            $root.com.achlid.crash.game.WalletUpdate.encode(message.walletUpdate, writer.uint32(/* id 71, wireType 2 =*/570).fork()).ldelim();
                        if (message.getFreebets != null && Object.hasOwnProperty.call(message, "getFreebets"))
                            $root.com.achlid.crash.game.stateless.GetFreebetsRequest.encode(message.getFreebets, writer.uint32(/* id 72, wireType 2 =*/578).fork()).ldelim();
                        if (message.freebetsResponse != null && Object.hasOwnProperty.call(message, "freebetsResponse"))
                            $root.com.achlid.crash.game.stateless.FreebetsResponse.encode(message.freebetsResponse, writer.uint32(/* id 73, wireType 2 =*/586).fork()).ldelim();
                        if (message.freebetGrantedNotification != null && Object.hasOwnProperty.call(message, "freebetGrantedNotification"))
                            $root.com.achlid.crash.game.FreebetGrantedNotification.encode(message.freebetGrantedNotification, writer.uint32(/* id 74, wireType 2 =*/594).fork()).ldelim();
                        if (message.freebetProgressEligibility != null && Object.hasOwnProperty.call(message, "freebetProgressEligibility"))
                            $root.com.achlid.crash.game.FreebetProgressEligibility.encode(message.freebetProgressEligibility, writer.uint32(/* id 75, wireType 2 =*/602).fork()).ldelim();
                        if (message.freebetProgressUpdate != null && Object.hasOwnProperty.call(message, "freebetProgressUpdate"))
                            $root.com.achlid.crash.game.FreebetProgressUpdate.encode(message.freebetProgressUpdate, writer.uint32(/* id 76, wireType 2 =*/610).fork()).ldelim();
                        if (message.sendChatMessage != null && Object.hasOwnProperty.call(message, "sendChatMessage"))
                            $root.com.achlid.crash.game.stateless.SendChatMessageRequest.encode(message.sendChatMessage, writer.uint32(/* id 77, wireType 2 =*/618).fork()).ldelim();
                        if (message.getChatHistory != null && Object.hasOwnProperty.call(message, "getChatHistory"))
                            $root.com.achlid.crash.game.stateless.GetChatHistoryRequest.encode(message.getChatHistory, writer.uint32(/* id 78, wireType 2 =*/626).fork()).ldelim();
                        if (message.chatSendResult != null && Object.hasOwnProperty.call(message, "chatSendResult"))
                            $root.com.achlid.crash.game.stateless.ChatSendResult.encode(message.chatSendResult, writer.uint32(/* id 79, wireType 2 =*/634).fork()).ldelim();
                        if (message.chatHistoryResponse != null && Object.hasOwnProperty.call(message, "chatHistoryResponse"))
                            $root.com.achlid.crash.game.stateless.ChatHistoryResponse.encode(message.chatHistoryResponse, writer.uint32(/* id 80, wireType 2 =*/642).fork()).ldelim();
                        if (message.chatMessage != null && Object.hasOwnProperty.call(message, "chatMessage"))
                            $root.com.achlid.crash.game.stateless.ChatMessage.encode(message.chatMessage, writer.uint32(/* id 81, wireType 2 =*/650).fork()).ldelim();
                        if (message.chatMessageDeleted != null && Object.hasOwnProperty.call(message, "chatMessageDeleted"))
                            $root.com.achlid.crash.game.stateless.ChatMessageDeleted.encode(message.chatMessageDeleted, writer.uint32(/* id 82, wireType 2 =*/658).fork()).ldelim();
                        if (message.getViewerAwareChatHistory != null && Object.hasOwnProperty.call(message, "getViewerAwareChatHistory"))
                            $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.encode(message.getViewerAwareChatHistory, writer.uint32(/* id 83, wireType 2 =*/666).fork()).ldelim();
                        if (message.viewerAwareChatHistoryResponse != null && Object.hasOwnProperty.call(message, "viewerAwareChatHistoryResponse"))
                            $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.encode(message.viewerAwareChatHistoryResponse, writer.uint32(/* id 84, wireType 2 =*/674).fork()).ldelim();
                        if (message.roomBetsNotification != null && Object.hasOwnProperty.call(message, "roomBetsNotification"))
                            $root.com.achlid.crash.game.RoomBetsNotification.encode(message.roomBetsNotification, writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
                        if (message.setForcedCrashPoint != null && Object.hasOwnProperty.call(message, "setForcedCrashPoint"))
                            $root.com.achlid.crash.game.SetForcedCrashPointRequest.encode(message.setForcedCrashPoint, writer.uint32(/* id 110, wireType 2 =*/882).fork()).ldelim();
                        if (message.forcedCrashPointResult != null && Object.hasOwnProperty.call(message, "forcedCrashPointResult"))
                            $root.com.achlid.crash.game.SetForcedCrashPointResult.encode(message.forcedCrashPointResult, writer.uint32(/* id 111, wireType 2 =*/890).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified GameMessage message, length delimited. Does not implicitly {@link com.achlid.crash.game.GameMessage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {com.achlid.crash.game.IGameMessage} message GameMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameMessage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GameMessage message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.GameMessage} GameMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameMessage.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.GameMessage();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.type = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.timestamp = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.messageId = reader.string();
                                    break;
                                }
                            case 10: {
                                    message.placeBet = $root.com.achlid.crash.game.PlaceBetRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 11: {
                                    message.cashOut = $root.com.achlid.crash.game.CashOutRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 12: {
                                    message.cancelBet = $root.com.achlid.crash.game.CancelBetRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 13: {
                                    message.autoPlay = $root.com.achlid.crash.game.AutoPlayRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 14: {
                                    message.stopAutoPlay = $root.com.achlid.crash.game.StopAutoPlayRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 50: {
                                    message.setAutoCashOut = $root.com.achlid.crash.game.SetAutoCashOutRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 16: {
                                    message.getWallet = $root.com.achlid.crash.game.stateless.GetWalletRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 17: {
                                    message.getLeaderboard = $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 60: {
                                    message.getBetHistory = $root.com.achlid.crash.game.stateless.GetBetHistoryRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 62: {
                                    message.getProvablyFairRound = $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 63: {
                                    message.getProvablyFairBets = $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 66: {
                                    message.getUserProfile = $root.com.achlid.crash.game.stateless.GetUserProfileRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 67: {
                                    message.updateUserProfile = $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 72: {
                                    message.getFreebets = $root.com.achlid.crash.game.stateless.GetFreebetsRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 77: {
                                    message.sendChatMessage = $root.com.achlid.crash.game.stateless.SendChatMessageRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 78: {
                                    message.getChatHistory = $root.com.achlid.crash.game.stateless.GetChatHistoryRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 83: {
                                    message.getViewerAwareChatHistory = $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 20: {
                                    message.connected = $root.com.achlid.crash.game.ConnectedResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 21: {
                                    message.betResult = $root.com.achlid.crash.game.BetResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 22: {
                                    message.cashOutResult = $root.com.achlid.crash.game.CashOutResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 23: {
                                    message.cancelBetResult = $root.com.achlid.crash.game.CancelBetResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 24: {
                                    message.autoPlayResult = $root.com.achlid.crash.game.AutoPlayResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 25: {
                                    message.autoPlayUpdate = $root.com.achlid.crash.game.AutoPlayUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 51: {
                                    message.autoCashOutResult = $root.com.achlid.crash.game.SetAutoCashOutResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 70: {
                                    message.yourClientSeed = $root.com.achlid.crash.game.YourClientSeed.decode(reader, reader.uint32());
                                    break;
                                }
                            case 71: {
                                    message.walletUpdate = $root.com.achlid.crash.game.WalletUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 26: {
                                    message.walletResponse = $root.com.achlid.crash.game.stateless.WalletResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 27: {
                                    message.leaderboardResponse = $root.com.achlid.crash.game.stateless.LeaderboardResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 61: {
                                    message.betHistoryResponse = $root.com.achlid.crash.game.stateless.BetHistoryResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 64: {
                                    message.provablyFairRoundResponse = $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 65: {
                                    message.provablyFairBetsResponse = $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 68: {
                                    message.userProfileResponse = $root.com.achlid.crash.game.stateless.UserProfileResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 69: {
                                    message.updateUserProfileResponse = $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 73: {
                                    message.freebetsResponse = $root.com.achlid.crash.game.stateless.FreebetsResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 79: {
                                    message.chatSendResult = $root.com.achlid.crash.game.stateless.ChatSendResult.decode(reader, reader.uint32());
                                    break;
                                }
                            case 80: {
                                    message.chatHistoryResponse = $root.com.achlid.crash.game.stateless.ChatHistoryResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 84: {
                                    message.viewerAwareChatHistoryResponse = $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 30: {
                                    message.multiplierUpdate = $root.com.achlid.crash.game.MultiplierUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 31: {
                                    message.roundCrash = $root.com.achlid.crash.game.RoundCrash.decode(reader, reader.uint32());
                                    break;
                                }
                            case 32: {
                                    message.roundStart = $root.com.achlid.crash.game.RoundStart.decode(reader, reader.uint32());
                                    break;
                                }
                            case 33: {
                                    message.preRoundStart = $root.com.achlid.crash.game.PreRoundStart.decode(reader, reader.uint32());
                                    break;
                                }
                            case 34: {
                                    message.newBetNotification = $root.com.achlid.crash.game.NewBetNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 35: {
                                    message.cashOutNotification = $root.com.achlid.crash.game.CashOutNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 36: {
                                    message.bigWinNotification = $root.com.achlid.crash.game.BigWinNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 37: {
                                    message.cancelBetNotification = $root.com.achlid.crash.game.CancelBetNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 103: {
                                    message.roomBetsNotification = $root.com.achlid.crash.game.RoomBetsNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 52: {
                                    message.totalBetsCount = $root.com.achlid.crash.game.TotalBetsCountUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 74: {
                                    message.freebetGrantedNotification = $root.com.achlid.crash.game.FreebetGrantedNotification.decode(reader, reader.uint32());
                                    break;
                                }
                            case 75: {
                                    message.freebetProgressEligibility = $root.com.achlid.crash.game.FreebetProgressEligibility.decode(reader, reader.uint32());
                                    break;
                                }
                            case 76: {
                                    message.freebetProgressUpdate = $root.com.achlid.crash.game.FreebetProgressUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 81: {
                                    message.chatMessage = $root.com.achlid.crash.game.stateless.ChatMessage.decode(reader, reader.uint32());
                                    break;
                                }
                            case 82: {
                                    message.chatMessageDeleted = $root.com.achlid.crash.game.stateless.ChatMessageDeleted.decode(reader, reader.uint32());
                                    break;
                                }
                            case 40: {
                                    message.error = $root.com.achlid.crash.game.ErrorMessage.decode(reader, reader.uint32());
                                    break;
                                }
                            case 41: {
                                    message.pong = $root.com.achlid.crash.game.PongResponse.decode(reader, reader.uint32());
                                    break;
                                }
                            case 42: {
                                    message.gameState = $root.com.achlid.crash.game.GameStateUpdate.decode(reader, reader.uint32());
                                    break;
                                }
                            case 15: {
                                    message.ping = $root.com.achlid.crash.game.PingRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 110: {
                                    message.setForcedCrashPoint = $root.com.achlid.crash.game.SetForcedCrashPointRequest.decode(reader, reader.uint32());
                                    break;
                                }
                            case 111: {
                                    message.forcedCrashPointResult = $root.com.achlid.crash.game.SetForcedCrashPointResult.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GameMessage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.GameMessage} GameMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameMessage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GameMessage message.
                     * @function verify
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GameMessage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        let properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 28:
                            case 6:
                            case 7:
                            case 8:
                            case 60:
                            case 62:
                            case 63:
                            case 66:
                            case 67:
                            case 72:
                            case 77:
                            case 78:
                            case 83:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 29:
                            case 71:
                            case 16:
                            case 17:
                            case 61:
                            case 64:
                            case 65:
                            case 68:
                            case 69:
                            case 70:
                            case 73:
                            case 74:
                            case 75:
                            case 76:
                            case 79:
                            case 80:
                            case 82:
                            case 84:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 81:
                            case 103:
                            case 33:
                            case 30:
                            case 31:
                            case 32:
                            case 100:
                            case 101:
                                break;
                            }
                        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                return "timestamp: integer|Long expected";
                        if (message.messageId != null && message.hasOwnProperty("messageId"))
                            if (!$util.isString(message.messageId))
                                return "messageId: string expected";
                        if (message.placeBet != null && message.hasOwnProperty("placeBet")) {
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.PlaceBetRequest.verify(message.placeBet);
                                if (error)
                                    return "placeBet." + error;
                            }
                        }
                        if (message.cashOut != null && message.hasOwnProperty("cashOut")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CashOutRequest.verify(message.cashOut);
                                if (error)
                                    return "cashOut." + error;
                            }
                        }
                        if (message.cancelBet != null && message.hasOwnProperty("cancelBet")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CancelBetRequest.verify(message.cancelBet);
                                if (error)
                                    return "cancelBet." + error;
                            }
                        }
                        if (message.autoPlay != null && message.hasOwnProperty("autoPlay")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.AutoPlayRequest.verify(message.autoPlay);
                                if (error)
                                    return "autoPlay." + error;
                            }
                        }
                        if (message.stopAutoPlay != null && message.hasOwnProperty("stopAutoPlay")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.StopAutoPlayRequest.verify(message.stopAutoPlay);
                                if (error)
                                    return "stopAutoPlay." + error;
                            }
                        }
                        if (message.setAutoCashOut != null && message.hasOwnProperty("setAutoCashOut")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.SetAutoCashOutRequest.verify(message.setAutoCashOut);
                                if (error)
                                    return "setAutoCashOut." + error;
                            }
                        }
                        if (message.getWallet != null && message.hasOwnProperty("getWallet")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetWalletRequest.verify(message.getWallet);
                                if (error)
                                    return "getWallet." + error;
                            }
                        }
                        if (message.getLeaderboard != null && message.hasOwnProperty("getLeaderboard")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.verify(message.getLeaderboard);
                                if (error)
                                    return "getLeaderboard." + error;
                            }
                        }
                        if (message.getBetHistory != null && message.hasOwnProperty("getBetHistory")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetBetHistoryRequest.verify(message.getBetHistory);
                                if (error)
                                    return "getBetHistory." + error;
                            }
                        }
                        if (message.getProvablyFairRound != null && message.hasOwnProperty("getProvablyFairRound")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.verify(message.getProvablyFairRound);
                                if (error)
                                    return "getProvablyFairRound." + error;
                            }
                        }
                        if (message.getProvablyFairBets != null && message.hasOwnProperty("getProvablyFairBets")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.verify(message.getProvablyFairBets);
                                if (error)
                                    return "getProvablyFairBets." + error;
                            }
                        }
                        if (message.getUserProfile != null && message.hasOwnProperty("getUserProfile")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetUserProfileRequest.verify(message.getUserProfile);
                                if (error)
                                    return "getUserProfile." + error;
                            }
                        }
                        if (message.updateUserProfile != null && message.hasOwnProperty("updateUserProfile")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest.verify(message.updateUserProfile);
                                if (error)
                                    return "updateUserProfile." + error;
                            }
                        }
                        if (message.getFreebets != null && message.hasOwnProperty("getFreebets")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetFreebetsRequest.verify(message.getFreebets);
                                if (error)
                                    return "getFreebets." + error;
                            }
                        }
                        if (message.sendChatMessage != null && message.hasOwnProperty("sendChatMessage")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.SendChatMessageRequest.verify(message.sendChatMessage);
                                if (error)
                                    return "sendChatMessage." + error;
                            }
                        }
                        if (message.getChatHistory != null && message.hasOwnProperty("getChatHistory")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetChatHistoryRequest.verify(message.getChatHistory);
                                if (error)
                                    return "getChatHistory." + error;
                            }
                        }
                        if (message.getViewerAwareChatHistory != null && message.hasOwnProperty("getViewerAwareChatHistory")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.verify(message.getViewerAwareChatHistory);
                                if (error)
                                    return "getViewerAwareChatHistory." + error;
                            }
                        }
                        if (message.connected != null && message.hasOwnProperty("connected")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.ConnectedResponse.verify(message.connected);
                                if (error)
                                    return "connected." + error;
                            }
                        }
                        if (message.betResult != null && message.hasOwnProperty("betResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.BetResult.verify(message.betResult);
                                if (error)
                                    return "betResult." + error;
                            }
                        }
                        if (message.cashOutResult != null && message.hasOwnProperty("cashOutResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CashOutResult.verify(message.cashOutResult);
                                if (error)
                                    return "cashOutResult." + error;
                            }
                        }
                        if (message.cancelBetResult != null && message.hasOwnProperty("cancelBetResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CancelBetResult.verify(message.cancelBetResult);
                                if (error)
                                    return "cancelBetResult." + error;
                            }
                        }
                        if (message.autoPlayResult != null && message.hasOwnProperty("autoPlayResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.AutoPlayResult.verify(message.autoPlayResult);
                                if (error)
                                    return "autoPlayResult." + error;
                            }
                        }
                        if (message.autoPlayUpdate != null && message.hasOwnProperty("autoPlayUpdate")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.AutoPlayUpdate.verify(message.autoPlayUpdate);
                                if (error)
                                    return "autoPlayUpdate." + error;
                            }
                        }
                        if (message.autoCashOutResult != null && message.hasOwnProperty("autoCashOutResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.SetAutoCashOutResult.verify(message.autoCashOutResult);
                                if (error)
                                    return "autoCashOutResult." + error;
                            }
                        }
                        if (message.yourClientSeed != null && message.hasOwnProperty("yourClientSeed")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.YourClientSeed.verify(message.yourClientSeed);
                                if (error)
                                    return "yourClientSeed." + error;
                            }
                        }
                        if (message.walletUpdate != null && message.hasOwnProperty("walletUpdate")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.WalletUpdate.verify(message.walletUpdate);
                                if (error)
                                    return "walletUpdate." + error;
                            }
                        }
                        if (message.walletResponse != null && message.hasOwnProperty("walletResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.WalletResponse.verify(message.walletResponse);
                                if (error)
                                    return "walletResponse." + error;
                            }
                        }
                        if (message.leaderboardResponse != null && message.hasOwnProperty("leaderboardResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.LeaderboardResponse.verify(message.leaderboardResponse);
                                if (error)
                                    return "leaderboardResponse." + error;
                            }
                        }
                        if (message.betHistoryResponse != null && message.hasOwnProperty("betHistoryResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.BetHistoryResponse.verify(message.betHistoryResponse);
                                if (error)
                                    return "betHistoryResponse." + error;
                            }
                        }
                        if (message.provablyFairRoundResponse != null && message.hasOwnProperty("provablyFairRoundResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse.verify(message.provablyFairRoundResponse);
                                if (error)
                                    return "provablyFairRoundResponse." + error;
                            }
                        }
                        if (message.provablyFairBetsResponse != null && message.hasOwnProperty("provablyFairBetsResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse.verify(message.provablyFairBetsResponse);
                                if (error)
                                    return "provablyFairBetsResponse." + error;
                            }
                        }
                        if (message.userProfileResponse != null && message.hasOwnProperty("userProfileResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.UserProfileResponse.verify(message.userProfileResponse);
                                if (error)
                                    return "userProfileResponse." + error;
                            }
                        }
                        if (message.updateUserProfileResponse != null && message.hasOwnProperty("updateUserProfileResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse.verify(message.updateUserProfileResponse);
                                if (error)
                                    return "updateUserProfileResponse." + error;
                            }
                        }
                        if (message.freebetsResponse != null && message.hasOwnProperty("freebetsResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.FreebetsResponse.verify(message.freebetsResponse);
                                if (error)
                                    return "freebetsResponse." + error;
                            }
                        }
                        if (message.chatSendResult != null && message.hasOwnProperty("chatSendResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ChatSendResult.verify(message.chatSendResult);
                                if (error)
                                    return "chatSendResult." + error;
                            }
                        }
                        if (message.chatHistoryResponse != null && message.hasOwnProperty("chatHistoryResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ChatHistoryResponse.verify(message.chatHistoryResponse);
                                if (error)
                                    return "chatHistoryResponse." + error;
                            }
                        }
                        if (message.viewerAwareChatHistoryResponse != null && message.hasOwnProperty("viewerAwareChatHistoryResponse")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.verify(message.viewerAwareChatHistoryResponse);
                                if (error)
                                    return "viewerAwareChatHistoryResponse." + error;
                            }
                        }
                        if (message.multiplierUpdate != null && message.hasOwnProperty("multiplierUpdate")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.MultiplierUpdate.verify(message.multiplierUpdate);
                                if (error)
                                    return "multiplierUpdate." + error;
                            }
                        }
                        if (message.roundCrash != null && message.hasOwnProperty("roundCrash")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.RoundCrash.verify(message.roundCrash);
                                if (error)
                                    return "roundCrash." + error;
                            }
                        }
                        if (message.roundStart != null && message.hasOwnProperty("roundStart")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.RoundStart.verify(message.roundStart);
                                if (error)
                                    return "roundStart." + error;
                            }
                        }
                        if (message.preRoundStart != null && message.hasOwnProperty("preRoundStart")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.PreRoundStart.verify(message.preRoundStart);
                                if (error)
                                    return "preRoundStart." + error;
                            }
                        }
                        if (message.newBetNotification != null && message.hasOwnProperty("newBetNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.NewBetNotification.verify(message.newBetNotification);
                                if (error)
                                    return "newBetNotification." + error;
                            }
                        }
                        if (message.cashOutNotification != null && message.hasOwnProperty("cashOutNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CashOutNotification.verify(message.cashOutNotification);
                                if (error)
                                    return "cashOutNotification." + error;
                            }
                        }
                        if (message.bigWinNotification != null && message.hasOwnProperty("bigWinNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.BigWinNotification.verify(message.bigWinNotification);
                                if (error)
                                    return "bigWinNotification." + error;
                            }
                        }
                        if (message.cancelBetNotification != null && message.hasOwnProperty("cancelBetNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.CancelBetNotification.verify(message.cancelBetNotification);
                                if (error)
                                    return "cancelBetNotification." + error;
                            }
                        }
                        if (message.roomBetsNotification != null && message.hasOwnProperty("roomBetsNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.RoomBetsNotification.verify(message.roomBetsNotification);
                                if (error)
                                    return "roomBetsNotification." + error;
                            }
                        }
                        if (message.totalBetsCount != null && message.hasOwnProperty("totalBetsCount")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.TotalBetsCountUpdate.verify(message.totalBetsCount);
                                if (error)
                                    return "totalBetsCount." + error;
                            }
                        }
                        if (message.freebetGrantedNotification != null && message.hasOwnProperty("freebetGrantedNotification")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.FreebetGrantedNotification.verify(message.freebetGrantedNotification);
                                if (error)
                                    return "freebetGrantedNotification." + error;
                            }
                        }
                        if (message.freebetProgressEligibility != null && message.hasOwnProperty("freebetProgressEligibility")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.FreebetProgressEligibility.verify(message.freebetProgressEligibility);
                                if (error)
                                    return "freebetProgressEligibility." + error;
                            }
                        }
                        if (message.freebetProgressUpdate != null && message.hasOwnProperty("freebetProgressUpdate")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.FreebetProgressUpdate.verify(message.freebetProgressUpdate);
                                if (error)
                                    return "freebetProgressUpdate." + error;
                            }
                        }
                        if (message.chatMessage != null && message.hasOwnProperty("chatMessage")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ChatMessage.verify(message.chatMessage);
                                if (error)
                                    return "chatMessage." + error;
                            }
                        }
                        if (message.chatMessageDeleted != null && message.hasOwnProperty("chatMessageDeleted")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.stateless.ChatMessageDeleted.verify(message.chatMessageDeleted);
                                if (error)
                                    return "chatMessageDeleted." + error;
                            }
                        }
                        if (message.error != null && message.hasOwnProperty("error")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.ErrorMessage.verify(message.error);
                                if (error)
                                    return "error." + error;
                            }
                        }
                        if (message.pong != null && message.hasOwnProperty("pong")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.PongResponse.verify(message.pong);
                                if (error)
                                    return "pong." + error;
                            }
                        }
                        if (message.gameState != null && message.hasOwnProperty("gameState")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.GameStateUpdate.verify(message.gameState);
                                if (error)
                                    return "gameState." + error;
                            }
                        }
                        if (message.ping != null && message.hasOwnProperty("ping")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.PingRequest.verify(message.ping);
                                if (error)
                                    return "ping." + error;
                            }
                        }
                        if (message.setForcedCrashPoint != null && message.hasOwnProperty("setForcedCrashPoint")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.SetForcedCrashPointRequest.verify(message.setForcedCrashPoint);
                                if (error)
                                    return "setForcedCrashPoint." + error;
                            }
                        }
                        if (message.forcedCrashPointResult != null && message.hasOwnProperty("forcedCrashPointResult")) {
                            if (properties.payload === 1)
                                return "payload: multiple values";
                            properties.payload = 1;
                            {
                                let error = $root.com.achlid.crash.game.SetForcedCrashPointResult.verify(message.forcedCrashPointResult);
                                if (error)
                                    return "forcedCrashPointResult." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a GameMessage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.GameMessage} GameMessage
                     */
                    GameMessage.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.GameMessage)
                            return object;
                        let message = new $root.com.achlid.crash.game.GameMessage();
                        switch (object.type) {
                        default:
                            if (typeof object.type === "number") {
                                message.type = object.type;
                                break;
                            }
                            break;
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "PLACE_BET":
                        case 1:
                            message.type = 1;
                            break;
                        case "CASH_OUT":
                        case 2:
                            message.type = 2;
                            break;
                        case "CANCEL_BET":
                        case 3:
                            message.type = 3;
                            break;
                        case "AUTO_PLAY":
                        case 4:
                            message.type = 4;
                            break;
                        case "STOP_AUTO_PLAY":
                        case 5:
                            message.type = 5;
                            break;
                        case "SET_AUTO_CASH_OUT":
                        case 28:
                            message.type = 28;
                            break;
                        case "PING":
                        case 6:
                            message.type = 6;
                            break;
                        case "GET_WALLET":
                        case 7:
                            message.type = 7;
                            break;
                        case "GET_LEADERBOARD":
                        case 8:
                            message.type = 8;
                            break;
                        case "GET_BET_HISTORY":
                        case 60:
                            message.type = 60;
                            break;
                        case "GET_PROVABLY_FAIR_ROUND":
                        case 62:
                            message.type = 62;
                            break;
                        case "GET_PROVABLY_FAIR_BETS":
                        case 63:
                            message.type = 63;
                            break;
                        case "GET_USER_PROFILE":
                        case 66:
                            message.type = 66;
                            break;
                        case "UPDATE_USER_PROFILE":
                        case 67:
                            message.type = 67;
                            break;
                        case "GET_FREEBETS":
                        case 72:
                            message.type = 72;
                            break;
                        case "SEND_CHAT_MESSAGE":
                        case 77:
                            message.type = 77;
                            break;
                        case "GET_CHAT_HISTORY":
                        case 78:
                            message.type = 78;
                            break;
                        case "GET_VIEWER_AWARE_CHAT_HISTORY":
                        case 83:
                            message.type = 83;
                            break;
                        case "CONNECTED":
                        case 10:
                            message.type = 10;
                            break;
                        case "BET_RESULT":
                        case 11:
                            message.type = 11;
                            break;
                        case "CASH_OUT_RESULT":
                        case 12:
                            message.type = 12;
                            break;
                        case "CANCEL_BET_RESULT":
                        case 13:
                            message.type = 13;
                            break;
                        case "AUTO_PLAY_RESULT":
                        case 14:
                            message.type = 14;
                            break;
                        case "AUTOPLAY_UPDATE":
                        case 15:
                            message.type = 15;
                            break;
                        case "AUTO_CASH_OUT_RESULT":
                        case 29:
                            message.type = 29;
                            break;
                        case "WALLET_UPDATE":
                        case 71:
                            message.type = 71;
                            break;
                        case "WALLET_RESPONSE":
                        case 16:
                            message.type = 16;
                            break;
                        case "LEADERBOARD_RESPONSE":
                        case 17:
                            message.type = 17;
                            break;
                        case "BET_HISTORY_RESPONSE":
                        case 61:
                            message.type = 61;
                            break;
                        case "PROVABLY_FAIR_ROUND_RESPONSE":
                        case 64:
                            message.type = 64;
                            break;
                        case "PROVABLY_FAIR_BETS_RESPONSE":
                        case 65:
                            message.type = 65;
                            break;
                        case "USER_PROFILE_RESPONSE":
                        case 68:
                            message.type = 68;
                            break;
                        case "UPDATE_USER_PROFILE_RESPONSE":
                        case 69:
                            message.type = 69;
                            break;
                        case "YOUR_CLIENT_SEED":
                        case 70:
                            message.type = 70;
                            break;
                        case "FREEBETS_RESPONSE":
                        case 73:
                            message.type = 73;
                            break;
                        case "FREEBET_GRANTED_NOTIFICATION":
                        case 74:
                            message.type = 74;
                            break;
                        case "FREEBET_PROGRESS_ELIGIBILITY":
                        case 75:
                            message.type = 75;
                            break;
                        case "FREEBET_PROGRESS_UPDATE":
                        case 76:
                            message.type = 76;
                            break;
                        case "CHAT_SEND_RESULT":
                        case 79:
                            message.type = 79;
                            break;
                        case "CHAT_HISTORY_RESPONSE":
                        case 80:
                            message.type = 80;
                            break;
                        case "CHAT_MESSAGE_DELETED":
                        case 82:
                            message.type = 82;
                            break;
                        case "VIEWER_AWARE_CHAT_HISTORY_RESPONSE":
                        case 84:
                            message.type = 84;
                            break;
                        case "MULTIPLIER_UPDATE":
                        case 20:
                            message.type = 20;
                            break;
                        case "ROUND_CRASH":
                        case 21:
                            message.type = 21;
                            break;
                        case "ROUND_START":
                        case 22:
                            message.type = 22;
                            break;
                        case "PRE_ROUND_START":
                        case 23:
                            message.type = 23;
                            break;
                        case "NEW_BET_NOTIFICATION":
                        case 24:
                            message.type = 24;
                            break;
                        case "CASH_OUT_NOTIFICATION":
                        case 25:
                            message.type = 25;
                            break;
                        case "BIG_WIN_NOTIFICATION":
                        case 26:
                            message.type = 26;
                            break;
                        case "CANCEL_BET_NOTIFICATION":
                        case 27:
                            message.type = 27;
                            break;
                        case "CHAT_MESSAGE":
                        case 81:
                            message.type = 81;
                            break;
                        case "ROOM_BETS_NOTIFICATION":
                        case 103:
                            message.type = 103;
                            break;
                        case "TOTAL_BETS_COUNT_UPDATE":
                        case 33:
                            message.type = 33;
                            break;
                        case "ERROR":
                        case 30:
                            message.type = 30;
                            break;
                        case "PONG":
                        case 31:
                            message.type = 31;
                            break;
                        case "GAME_STATE":
                        case 32:
                            message.type = 32;
                            break;
                        case "SET_FORCED_CRASH_POINT":
                        case 100:
                            message.type = 100;
                            break;
                        case "FORCED_CRASH_POINT_RESULT":
                        case 101:
                            message.type = 101;
                            break;
                        }
                        if (object.timestamp != null)
                            if ($util.Long)
                                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                            else if (typeof object.timestamp === "string")
                                message.timestamp = parseInt(object.timestamp, 10);
                            else if (typeof object.timestamp === "number")
                                message.timestamp = object.timestamp;
                            else if (typeof object.timestamp === "object")
                                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                        if (object.messageId != null)
                            message.messageId = String(object.messageId);
                        if (object.placeBet != null) {
                            if (typeof object.placeBet !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.placeBet: object expected");
                            message.placeBet = $root.com.achlid.crash.game.PlaceBetRequest.fromObject(object.placeBet);
                        }
                        if (object.cashOut != null) {
                            if (typeof object.cashOut !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cashOut: object expected");
                            message.cashOut = $root.com.achlid.crash.game.CashOutRequest.fromObject(object.cashOut);
                        }
                        if (object.cancelBet != null) {
                            if (typeof object.cancelBet !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cancelBet: object expected");
                            message.cancelBet = $root.com.achlid.crash.game.CancelBetRequest.fromObject(object.cancelBet);
                        }
                        if (object.autoPlay != null) {
                            if (typeof object.autoPlay !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.autoPlay: object expected");
                            message.autoPlay = $root.com.achlid.crash.game.AutoPlayRequest.fromObject(object.autoPlay);
                        }
                        if (object.stopAutoPlay != null) {
                            if (typeof object.stopAutoPlay !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.stopAutoPlay: object expected");
                            message.stopAutoPlay = $root.com.achlid.crash.game.StopAutoPlayRequest.fromObject(object.stopAutoPlay);
                        }
                        if (object.setAutoCashOut != null) {
                            if (typeof object.setAutoCashOut !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.setAutoCashOut: object expected");
                            message.setAutoCashOut = $root.com.achlid.crash.game.SetAutoCashOutRequest.fromObject(object.setAutoCashOut);
                        }
                        if (object.getWallet != null) {
                            if (typeof object.getWallet !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getWallet: object expected");
                            message.getWallet = $root.com.achlid.crash.game.stateless.GetWalletRequest.fromObject(object.getWallet);
                        }
                        if (object.getLeaderboard != null) {
                            if (typeof object.getLeaderboard !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getLeaderboard: object expected");
                            message.getLeaderboard = $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.fromObject(object.getLeaderboard);
                        }
                        if (object.getBetHistory != null) {
                            if (typeof object.getBetHistory !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getBetHistory: object expected");
                            message.getBetHistory = $root.com.achlid.crash.game.stateless.GetBetHistoryRequest.fromObject(object.getBetHistory);
                        }
                        if (object.getProvablyFairRound != null) {
                            if (typeof object.getProvablyFairRound !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getProvablyFairRound: object expected");
                            message.getProvablyFairRound = $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.fromObject(object.getProvablyFairRound);
                        }
                        if (object.getProvablyFairBets != null) {
                            if (typeof object.getProvablyFairBets !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getProvablyFairBets: object expected");
                            message.getProvablyFairBets = $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.fromObject(object.getProvablyFairBets);
                        }
                        if (object.getUserProfile != null) {
                            if (typeof object.getUserProfile !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getUserProfile: object expected");
                            message.getUserProfile = $root.com.achlid.crash.game.stateless.GetUserProfileRequest.fromObject(object.getUserProfile);
                        }
                        if (object.updateUserProfile != null) {
                            if (typeof object.updateUserProfile !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.updateUserProfile: object expected");
                            message.updateUserProfile = $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest.fromObject(object.updateUserProfile);
                        }
                        if (object.getFreebets != null) {
                            if (typeof object.getFreebets !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getFreebets: object expected");
                            message.getFreebets = $root.com.achlid.crash.game.stateless.GetFreebetsRequest.fromObject(object.getFreebets);
                        }
                        if (object.sendChatMessage != null) {
                            if (typeof object.sendChatMessage !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.sendChatMessage: object expected");
                            message.sendChatMessage = $root.com.achlid.crash.game.stateless.SendChatMessageRequest.fromObject(object.sendChatMessage);
                        }
                        if (object.getChatHistory != null) {
                            if (typeof object.getChatHistory !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getChatHistory: object expected");
                            message.getChatHistory = $root.com.achlid.crash.game.stateless.GetChatHistoryRequest.fromObject(object.getChatHistory);
                        }
                        if (object.getViewerAwareChatHistory != null) {
                            if (typeof object.getViewerAwareChatHistory !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.getViewerAwareChatHistory: object expected");
                            message.getViewerAwareChatHistory = $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.fromObject(object.getViewerAwareChatHistory);
                        }
                        if (object.connected != null) {
                            if (typeof object.connected !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.connected: object expected");
                            message.connected = $root.com.achlid.crash.game.ConnectedResponse.fromObject(object.connected);
                        }
                        if (object.betResult != null) {
                            if (typeof object.betResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.betResult: object expected");
                            message.betResult = $root.com.achlid.crash.game.BetResult.fromObject(object.betResult);
                        }
                        if (object.cashOutResult != null) {
                            if (typeof object.cashOutResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cashOutResult: object expected");
                            message.cashOutResult = $root.com.achlid.crash.game.CashOutResult.fromObject(object.cashOutResult);
                        }
                        if (object.cancelBetResult != null) {
                            if (typeof object.cancelBetResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cancelBetResult: object expected");
                            message.cancelBetResult = $root.com.achlid.crash.game.CancelBetResult.fromObject(object.cancelBetResult);
                        }
                        if (object.autoPlayResult != null) {
                            if (typeof object.autoPlayResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.autoPlayResult: object expected");
                            message.autoPlayResult = $root.com.achlid.crash.game.AutoPlayResult.fromObject(object.autoPlayResult);
                        }
                        if (object.autoPlayUpdate != null) {
                            if (typeof object.autoPlayUpdate !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.autoPlayUpdate: object expected");
                            message.autoPlayUpdate = $root.com.achlid.crash.game.AutoPlayUpdate.fromObject(object.autoPlayUpdate);
                        }
                        if (object.autoCashOutResult != null) {
                            if (typeof object.autoCashOutResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.autoCashOutResult: object expected");
                            message.autoCashOutResult = $root.com.achlid.crash.game.SetAutoCashOutResult.fromObject(object.autoCashOutResult);
                        }
                        if (object.yourClientSeed != null) {
                            if (typeof object.yourClientSeed !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.yourClientSeed: object expected");
                            message.yourClientSeed = $root.com.achlid.crash.game.YourClientSeed.fromObject(object.yourClientSeed);
                        }
                        if (object.walletUpdate != null) {
                            if (typeof object.walletUpdate !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.walletUpdate: object expected");
                            message.walletUpdate = $root.com.achlid.crash.game.WalletUpdate.fromObject(object.walletUpdate);
                        }
                        if (object.walletResponse != null) {
                            if (typeof object.walletResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.walletResponse: object expected");
                            message.walletResponse = $root.com.achlid.crash.game.stateless.WalletResponse.fromObject(object.walletResponse);
                        }
                        if (object.leaderboardResponse != null) {
                            if (typeof object.leaderboardResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.leaderboardResponse: object expected");
                            message.leaderboardResponse = $root.com.achlid.crash.game.stateless.LeaderboardResponse.fromObject(object.leaderboardResponse);
                        }
                        if (object.betHistoryResponse != null) {
                            if (typeof object.betHistoryResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.betHistoryResponse: object expected");
                            message.betHistoryResponse = $root.com.achlid.crash.game.stateless.BetHistoryResponse.fromObject(object.betHistoryResponse);
                        }
                        if (object.provablyFairRoundResponse != null) {
                            if (typeof object.provablyFairRoundResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.provablyFairRoundResponse: object expected");
                            message.provablyFairRoundResponse = $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse.fromObject(object.provablyFairRoundResponse);
                        }
                        if (object.provablyFairBetsResponse != null) {
                            if (typeof object.provablyFairBetsResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.provablyFairBetsResponse: object expected");
                            message.provablyFairBetsResponse = $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse.fromObject(object.provablyFairBetsResponse);
                        }
                        if (object.userProfileResponse != null) {
                            if (typeof object.userProfileResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.userProfileResponse: object expected");
                            message.userProfileResponse = $root.com.achlid.crash.game.stateless.UserProfileResponse.fromObject(object.userProfileResponse);
                        }
                        if (object.updateUserProfileResponse != null) {
                            if (typeof object.updateUserProfileResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.updateUserProfileResponse: object expected");
                            message.updateUserProfileResponse = $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse.fromObject(object.updateUserProfileResponse);
                        }
                        if (object.freebetsResponse != null) {
                            if (typeof object.freebetsResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.freebetsResponse: object expected");
                            message.freebetsResponse = $root.com.achlid.crash.game.stateless.FreebetsResponse.fromObject(object.freebetsResponse);
                        }
                        if (object.chatSendResult != null) {
                            if (typeof object.chatSendResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.chatSendResult: object expected");
                            message.chatSendResult = $root.com.achlid.crash.game.stateless.ChatSendResult.fromObject(object.chatSendResult);
                        }
                        if (object.chatHistoryResponse != null) {
                            if (typeof object.chatHistoryResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.chatHistoryResponse: object expected");
                            message.chatHistoryResponse = $root.com.achlid.crash.game.stateless.ChatHistoryResponse.fromObject(object.chatHistoryResponse);
                        }
                        if (object.viewerAwareChatHistoryResponse != null) {
                            if (typeof object.viewerAwareChatHistoryResponse !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.viewerAwareChatHistoryResponse: object expected");
                            message.viewerAwareChatHistoryResponse = $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.fromObject(object.viewerAwareChatHistoryResponse);
                        }
                        if (object.multiplierUpdate != null) {
                            if (typeof object.multiplierUpdate !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.multiplierUpdate: object expected");
                            message.multiplierUpdate = $root.com.achlid.crash.game.MultiplierUpdate.fromObject(object.multiplierUpdate);
                        }
                        if (object.roundCrash != null) {
                            if (typeof object.roundCrash !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.roundCrash: object expected");
                            message.roundCrash = $root.com.achlid.crash.game.RoundCrash.fromObject(object.roundCrash);
                        }
                        if (object.roundStart != null) {
                            if (typeof object.roundStart !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.roundStart: object expected");
                            message.roundStart = $root.com.achlid.crash.game.RoundStart.fromObject(object.roundStart);
                        }
                        if (object.preRoundStart != null) {
                            if (typeof object.preRoundStart !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.preRoundStart: object expected");
                            message.preRoundStart = $root.com.achlid.crash.game.PreRoundStart.fromObject(object.preRoundStart);
                        }
                        if (object.newBetNotification != null) {
                            if (typeof object.newBetNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.newBetNotification: object expected");
                            message.newBetNotification = $root.com.achlid.crash.game.NewBetNotification.fromObject(object.newBetNotification);
                        }
                        if (object.cashOutNotification != null) {
                            if (typeof object.cashOutNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cashOutNotification: object expected");
                            message.cashOutNotification = $root.com.achlid.crash.game.CashOutNotification.fromObject(object.cashOutNotification);
                        }
                        if (object.bigWinNotification != null) {
                            if (typeof object.bigWinNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.bigWinNotification: object expected");
                            message.bigWinNotification = $root.com.achlid.crash.game.BigWinNotification.fromObject(object.bigWinNotification);
                        }
                        if (object.cancelBetNotification != null) {
                            if (typeof object.cancelBetNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.cancelBetNotification: object expected");
                            message.cancelBetNotification = $root.com.achlid.crash.game.CancelBetNotification.fromObject(object.cancelBetNotification);
                        }
                        if (object.roomBetsNotification != null) {
                            if (typeof object.roomBetsNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.roomBetsNotification: object expected");
                            message.roomBetsNotification = $root.com.achlid.crash.game.RoomBetsNotification.fromObject(object.roomBetsNotification);
                        }
                        if (object.totalBetsCount != null) {
                            if (typeof object.totalBetsCount !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.totalBetsCount: object expected");
                            message.totalBetsCount = $root.com.achlid.crash.game.TotalBetsCountUpdate.fromObject(object.totalBetsCount);
                        }
                        if (object.freebetGrantedNotification != null) {
                            if (typeof object.freebetGrantedNotification !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.freebetGrantedNotification: object expected");
                            message.freebetGrantedNotification = $root.com.achlid.crash.game.FreebetGrantedNotification.fromObject(object.freebetGrantedNotification);
                        }
                        if (object.freebetProgressEligibility != null) {
                            if (typeof object.freebetProgressEligibility !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.freebetProgressEligibility: object expected");
                            message.freebetProgressEligibility = $root.com.achlid.crash.game.FreebetProgressEligibility.fromObject(object.freebetProgressEligibility);
                        }
                        if (object.freebetProgressUpdate != null) {
                            if (typeof object.freebetProgressUpdate !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.freebetProgressUpdate: object expected");
                            message.freebetProgressUpdate = $root.com.achlid.crash.game.FreebetProgressUpdate.fromObject(object.freebetProgressUpdate);
                        }
                        if (object.chatMessage != null) {
                            if (typeof object.chatMessage !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.chatMessage: object expected");
                            message.chatMessage = $root.com.achlid.crash.game.stateless.ChatMessage.fromObject(object.chatMessage);
                        }
                        if (object.chatMessageDeleted != null) {
                            if (typeof object.chatMessageDeleted !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.chatMessageDeleted: object expected");
                            message.chatMessageDeleted = $root.com.achlid.crash.game.stateless.ChatMessageDeleted.fromObject(object.chatMessageDeleted);
                        }
                        if (object.error != null) {
                            if (typeof object.error !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.error: object expected");
                            message.error = $root.com.achlid.crash.game.ErrorMessage.fromObject(object.error);
                        }
                        if (object.pong != null) {
                            if (typeof object.pong !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.pong: object expected");
                            message.pong = $root.com.achlid.crash.game.PongResponse.fromObject(object.pong);
                        }
                        if (object.gameState != null) {
                            if (typeof object.gameState !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.gameState: object expected");
                            message.gameState = $root.com.achlid.crash.game.GameStateUpdate.fromObject(object.gameState);
                        }
                        if (object.ping != null) {
                            if (typeof object.ping !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.ping: object expected");
                            message.ping = $root.com.achlid.crash.game.PingRequest.fromObject(object.ping);
                        }
                        if (object.setForcedCrashPoint != null) {
                            if (typeof object.setForcedCrashPoint !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.setForcedCrashPoint: object expected");
                            message.setForcedCrashPoint = $root.com.achlid.crash.game.SetForcedCrashPointRequest.fromObject(object.setForcedCrashPoint);
                        }
                        if (object.forcedCrashPointResult != null) {
                            if (typeof object.forcedCrashPointResult !== "object")
                                throw TypeError(".com.achlid.crash.game.GameMessage.forcedCrashPointResult: object expected");
                            message.forcedCrashPointResult = $root.com.achlid.crash.game.SetForcedCrashPointResult.fromObject(object.forcedCrashPointResult);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GameMessage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {com.achlid.crash.game.GameMessage} message GameMessage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GameMessage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timestamp = options.longs === String ? "0" : 0;
                            object.messageId = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.com.achlid.crash.game.GameMessage.MessageType[message.type] === undefined ? message.type : $root.com.achlid.crash.game.GameMessage.MessageType[message.type] : message.type;
                        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                            if (typeof message.timestamp === "number")
                                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                            else
                                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                        if (message.messageId != null && message.hasOwnProperty("messageId"))
                            object.messageId = message.messageId;
                        if (message.placeBet != null && message.hasOwnProperty("placeBet")) {
                            object.placeBet = $root.com.achlid.crash.game.PlaceBetRequest.toObject(message.placeBet, options);
                            if (options.oneofs)
                                object.payload = "placeBet";
                        }
                        if (message.cashOut != null && message.hasOwnProperty("cashOut")) {
                            object.cashOut = $root.com.achlid.crash.game.CashOutRequest.toObject(message.cashOut, options);
                            if (options.oneofs)
                                object.payload = "cashOut";
                        }
                        if (message.cancelBet != null && message.hasOwnProperty("cancelBet")) {
                            object.cancelBet = $root.com.achlid.crash.game.CancelBetRequest.toObject(message.cancelBet, options);
                            if (options.oneofs)
                                object.payload = "cancelBet";
                        }
                        if (message.autoPlay != null && message.hasOwnProperty("autoPlay")) {
                            object.autoPlay = $root.com.achlid.crash.game.AutoPlayRequest.toObject(message.autoPlay, options);
                            if (options.oneofs)
                                object.payload = "autoPlay";
                        }
                        if (message.stopAutoPlay != null && message.hasOwnProperty("stopAutoPlay")) {
                            object.stopAutoPlay = $root.com.achlid.crash.game.StopAutoPlayRequest.toObject(message.stopAutoPlay, options);
                            if (options.oneofs)
                                object.payload = "stopAutoPlay";
                        }
                        if (message.ping != null && message.hasOwnProperty("ping")) {
                            object.ping = $root.com.achlid.crash.game.PingRequest.toObject(message.ping, options);
                            if (options.oneofs)
                                object.payload = "ping";
                        }
                        if (message.getWallet != null && message.hasOwnProperty("getWallet")) {
                            object.getWallet = $root.com.achlid.crash.game.stateless.GetWalletRequest.toObject(message.getWallet, options);
                            if (options.oneofs)
                                object.payload = "getWallet";
                        }
                        if (message.getLeaderboard != null && message.hasOwnProperty("getLeaderboard")) {
                            object.getLeaderboard = $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.toObject(message.getLeaderboard, options);
                            if (options.oneofs)
                                object.payload = "getLeaderboard";
                        }
                        if (message.connected != null && message.hasOwnProperty("connected")) {
                            object.connected = $root.com.achlid.crash.game.ConnectedResponse.toObject(message.connected, options);
                            if (options.oneofs)
                                object.payload = "connected";
                        }
                        if (message.betResult != null && message.hasOwnProperty("betResult")) {
                            object.betResult = $root.com.achlid.crash.game.BetResult.toObject(message.betResult, options);
                            if (options.oneofs)
                                object.payload = "betResult";
                        }
                        if (message.cashOutResult != null && message.hasOwnProperty("cashOutResult")) {
                            object.cashOutResult = $root.com.achlid.crash.game.CashOutResult.toObject(message.cashOutResult, options);
                            if (options.oneofs)
                                object.payload = "cashOutResult";
                        }
                        if (message.cancelBetResult != null && message.hasOwnProperty("cancelBetResult")) {
                            object.cancelBetResult = $root.com.achlid.crash.game.CancelBetResult.toObject(message.cancelBetResult, options);
                            if (options.oneofs)
                                object.payload = "cancelBetResult";
                        }
                        if (message.autoPlayResult != null && message.hasOwnProperty("autoPlayResult")) {
                            object.autoPlayResult = $root.com.achlid.crash.game.AutoPlayResult.toObject(message.autoPlayResult, options);
                            if (options.oneofs)
                                object.payload = "autoPlayResult";
                        }
                        if (message.autoPlayUpdate != null && message.hasOwnProperty("autoPlayUpdate")) {
                            object.autoPlayUpdate = $root.com.achlid.crash.game.AutoPlayUpdate.toObject(message.autoPlayUpdate, options);
                            if (options.oneofs)
                                object.payload = "autoPlayUpdate";
                        }
                        if (message.walletResponse != null && message.hasOwnProperty("walletResponse")) {
                            object.walletResponse = $root.com.achlid.crash.game.stateless.WalletResponse.toObject(message.walletResponse, options);
                            if (options.oneofs)
                                object.payload = "walletResponse";
                        }
                        if (message.leaderboardResponse != null && message.hasOwnProperty("leaderboardResponse")) {
                            object.leaderboardResponse = $root.com.achlid.crash.game.stateless.LeaderboardResponse.toObject(message.leaderboardResponse, options);
                            if (options.oneofs)
                                object.payload = "leaderboardResponse";
                        }
                        if (message.multiplierUpdate != null && message.hasOwnProperty("multiplierUpdate")) {
                            object.multiplierUpdate = $root.com.achlid.crash.game.MultiplierUpdate.toObject(message.multiplierUpdate, options);
                            if (options.oneofs)
                                object.payload = "multiplierUpdate";
                        }
                        if (message.roundCrash != null && message.hasOwnProperty("roundCrash")) {
                            object.roundCrash = $root.com.achlid.crash.game.RoundCrash.toObject(message.roundCrash, options);
                            if (options.oneofs)
                                object.payload = "roundCrash";
                        }
                        if (message.roundStart != null && message.hasOwnProperty("roundStart")) {
                            object.roundStart = $root.com.achlid.crash.game.RoundStart.toObject(message.roundStart, options);
                            if (options.oneofs)
                                object.payload = "roundStart";
                        }
                        if (message.preRoundStart != null && message.hasOwnProperty("preRoundStart")) {
                            object.preRoundStart = $root.com.achlid.crash.game.PreRoundStart.toObject(message.preRoundStart, options);
                            if (options.oneofs)
                                object.payload = "preRoundStart";
                        }
                        if (message.newBetNotification != null && message.hasOwnProperty("newBetNotification")) {
                            object.newBetNotification = $root.com.achlid.crash.game.NewBetNotification.toObject(message.newBetNotification, options);
                            if (options.oneofs)
                                object.payload = "newBetNotification";
                        }
                        if (message.cashOutNotification != null && message.hasOwnProperty("cashOutNotification")) {
                            object.cashOutNotification = $root.com.achlid.crash.game.CashOutNotification.toObject(message.cashOutNotification, options);
                            if (options.oneofs)
                                object.payload = "cashOutNotification";
                        }
                        if (message.bigWinNotification != null && message.hasOwnProperty("bigWinNotification")) {
                            object.bigWinNotification = $root.com.achlid.crash.game.BigWinNotification.toObject(message.bigWinNotification, options);
                            if (options.oneofs)
                                object.payload = "bigWinNotification";
                        }
                        if (message.cancelBetNotification != null && message.hasOwnProperty("cancelBetNotification")) {
                            object.cancelBetNotification = $root.com.achlid.crash.game.CancelBetNotification.toObject(message.cancelBetNotification, options);
                            if (options.oneofs)
                                object.payload = "cancelBetNotification";
                        }
                        if (message.error != null && message.hasOwnProperty("error")) {
                            object.error = $root.com.achlid.crash.game.ErrorMessage.toObject(message.error, options);
                            if (options.oneofs)
                                object.payload = "error";
                        }
                        if (message.pong != null && message.hasOwnProperty("pong")) {
                            object.pong = $root.com.achlid.crash.game.PongResponse.toObject(message.pong, options);
                            if (options.oneofs)
                                object.payload = "pong";
                        }
                        if (message.gameState != null && message.hasOwnProperty("gameState")) {
                            object.gameState = $root.com.achlid.crash.game.GameStateUpdate.toObject(message.gameState, options);
                            if (options.oneofs)
                                object.payload = "gameState";
                        }
                        if (message.setAutoCashOut != null && message.hasOwnProperty("setAutoCashOut")) {
                            object.setAutoCashOut = $root.com.achlid.crash.game.SetAutoCashOutRequest.toObject(message.setAutoCashOut, options);
                            if (options.oneofs)
                                object.payload = "setAutoCashOut";
                        }
                        if (message.autoCashOutResult != null && message.hasOwnProperty("autoCashOutResult")) {
                            object.autoCashOutResult = $root.com.achlid.crash.game.SetAutoCashOutResult.toObject(message.autoCashOutResult, options);
                            if (options.oneofs)
                                object.payload = "autoCashOutResult";
                        }
                        if (message.totalBetsCount != null && message.hasOwnProperty("totalBetsCount")) {
                            object.totalBetsCount = $root.com.achlid.crash.game.TotalBetsCountUpdate.toObject(message.totalBetsCount, options);
                            if (options.oneofs)
                                object.payload = "totalBetsCount";
                        }
                        if (message.getBetHistory != null && message.hasOwnProperty("getBetHistory")) {
                            object.getBetHistory = $root.com.achlid.crash.game.stateless.GetBetHistoryRequest.toObject(message.getBetHistory, options);
                            if (options.oneofs)
                                object.payload = "getBetHistory";
                        }
                        if (message.betHistoryResponse != null && message.hasOwnProperty("betHistoryResponse")) {
                            object.betHistoryResponse = $root.com.achlid.crash.game.stateless.BetHistoryResponse.toObject(message.betHistoryResponse, options);
                            if (options.oneofs)
                                object.payload = "betHistoryResponse";
                        }
                        if (message.getProvablyFairRound != null && message.hasOwnProperty("getProvablyFairRound")) {
                            object.getProvablyFairRound = $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.toObject(message.getProvablyFairRound, options);
                            if (options.oneofs)
                                object.payload = "getProvablyFairRound";
                        }
                        if (message.getProvablyFairBets != null && message.hasOwnProperty("getProvablyFairBets")) {
                            object.getProvablyFairBets = $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.toObject(message.getProvablyFairBets, options);
                            if (options.oneofs)
                                object.payload = "getProvablyFairBets";
                        }
                        if (message.provablyFairRoundResponse != null && message.hasOwnProperty("provablyFairRoundResponse")) {
                            object.provablyFairRoundResponse = $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse.toObject(message.provablyFairRoundResponse, options);
                            if (options.oneofs)
                                object.payload = "provablyFairRoundResponse";
                        }
                        if (message.provablyFairBetsResponse != null && message.hasOwnProperty("provablyFairBetsResponse")) {
                            object.provablyFairBetsResponse = $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse.toObject(message.provablyFairBetsResponse, options);
                            if (options.oneofs)
                                object.payload = "provablyFairBetsResponse";
                        }
                        if (message.getUserProfile != null && message.hasOwnProperty("getUserProfile")) {
                            object.getUserProfile = $root.com.achlid.crash.game.stateless.GetUserProfileRequest.toObject(message.getUserProfile, options);
                            if (options.oneofs)
                                object.payload = "getUserProfile";
                        }
                        if (message.updateUserProfile != null && message.hasOwnProperty("updateUserProfile")) {
                            object.updateUserProfile = $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest.toObject(message.updateUserProfile, options);
                            if (options.oneofs)
                                object.payload = "updateUserProfile";
                        }
                        if (message.userProfileResponse != null && message.hasOwnProperty("userProfileResponse")) {
                            object.userProfileResponse = $root.com.achlid.crash.game.stateless.UserProfileResponse.toObject(message.userProfileResponse, options);
                            if (options.oneofs)
                                object.payload = "userProfileResponse";
                        }
                        if (message.updateUserProfileResponse != null && message.hasOwnProperty("updateUserProfileResponse")) {
                            object.updateUserProfileResponse = $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse.toObject(message.updateUserProfileResponse, options);
                            if (options.oneofs)
                                object.payload = "updateUserProfileResponse";
                        }
                        if (message.yourClientSeed != null && message.hasOwnProperty("yourClientSeed")) {
                            object.yourClientSeed = $root.com.achlid.crash.game.YourClientSeed.toObject(message.yourClientSeed, options);
                            if (options.oneofs)
                                object.payload = "yourClientSeed";
                        }
                        if (message.walletUpdate != null && message.hasOwnProperty("walletUpdate")) {
                            object.walletUpdate = $root.com.achlid.crash.game.WalletUpdate.toObject(message.walletUpdate, options);
                            if (options.oneofs)
                                object.payload = "walletUpdate";
                        }
                        if (message.getFreebets != null && message.hasOwnProperty("getFreebets")) {
                            object.getFreebets = $root.com.achlid.crash.game.stateless.GetFreebetsRequest.toObject(message.getFreebets, options);
                            if (options.oneofs)
                                object.payload = "getFreebets";
                        }
                        if (message.freebetsResponse != null && message.hasOwnProperty("freebetsResponse")) {
                            object.freebetsResponse = $root.com.achlid.crash.game.stateless.FreebetsResponse.toObject(message.freebetsResponse, options);
                            if (options.oneofs)
                                object.payload = "freebetsResponse";
                        }
                        if (message.freebetGrantedNotification != null && message.hasOwnProperty("freebetGrantedNotification")) {
                            object.freebetGrantedNotification = $root.com.achlid.crash.game.FreebetGrantedNotification.toObject(message.freebetGrantedNotification, options);
                            if (options.oneofs)
                                object.payload = "freebetGrantedNotification";
                        }
                        if (message.freebetProgressEligibility != null && message.hasOwnProperty("freebetProgressEligibility")) {
                            object.freebetProgressEligibility = $root.com.achlid.crash.game.FreebetProgressEligibility.toObject(message.freebetProgressEligibility, options);
                            if (options.oneofs)
                                object.payload = "freebetProgressEligibility";
                        }
                        if (message.freebetProgressUpdate != null && message.hasOwnProperty("freebetProgressUpdate")) {
                            object.freebetProgressUpdate = $root.com.achlid.crash.game.FreebetProgressUpdate.toObject(message.freebetProgressUpdate, options);
                            if (options.oneofs)
                                object.payload = "freebetProgressUpdate";
                        }
                        if (message.sendChatMessage != null && message.hasOwnProperty("sendChatMessage")) {
                            object.sendChatMessage = $root.com.achlid.crash.game.stateless.SendChatMessageRequest.toObject(message.sendChatMessage, options);
                            if (options.oneofs)
                                object.payload = "sendChatMessage";
                        }
                        if (message.getChatHistory != null && message.hasOwnProperty("getChatHistory")) {
                            object.getChatHistory = $root.com.achlid.crash.game.stateless.GetChatHistoryRequest.toObject(message.getChatHistory, options);
                            if (options.oneofs)
                                object.payload = "getChatHistory";
                        }
                        if (message.chatSendResult != null && message.hasOwnProperty("chatSendResult")) {
                            object.chatSendResult = $root.com.achlid.crash.game.stateless.ChatSendResult.toObject(message.chatSendResult, options);
                            if (options.oneofs)
                                object.payload = "chatSendResult";
                        }
                        if (message.chatHistoryResponse != null && message.hasOwnProperty("chatHistoryResponse")) {
                            object.chatHistoryResponse = $root.com.achlid.crash.game.stateless.ChatHistoryResponse.toObject(message.chatHistoryResponse, options);
                            if (options.oneofs)
                                object.payload = "chatHistoryResponse";
                        }
                        if (message.chatMessage != null && message.hasOwnProperty("chatMessage")) {
                            object.chatMessage = $root.com.achlid.crash.game.stateless.ChatMessage.toObject(message.chatMessage, options);
                            if (options.oneofs)
                                object.payload = "chatMessage";
                        }
                        if (message.chatMessageDeleted != null && message.hasOwnProperty("chatMessageDeleted")) {
                            object.chatMessageDeleted = $root.com.achlid.crash.game.stateless.ChatMessageDeleted.toObject(message.chatMessageDeleted, options);
                            if (options.oneofs)
                                object.payload = "chatMessageDeleted";
                        }
                        if (message.getViewerAwareChatHistory != null && message.hasOwnProperty("getViewerAwareChatHistory")) {
                            object.getViewerAwareChatHistory = $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.toObject(message.getViewerAwareChatHistory, options);
                            if (options.oneofs)
                                object.payload = "getViewerAwareChatHistory";
                        }
                        if (message.viewerAwareChatHistoryResponse != null && message.hasOwnProperty("viewerAwareChatHistoryResponse")) {
                            object.viewerAwareChatHistoryResponse = $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.toObject(message.viewerAwareChatHistoryResponse, options);
                            if (options.oneofs)
                                object.payload = "viewerAwareChatHistoryResponse";
                        }
                        if (message.roomBetsNotification != null && message.hasOwnProperty("roomBetsNotification")) {
                            object.roomBetsNotification = $root.com.achlid.crash.game.RoomBetsNotification.toObject(message.roomBetsNotification, options);
                            if (options.oneofs)
                                object.payload = "roomBetsNotification";
                        }
                        if (message.setForcedCrashPoint != null && message.hasOwnProperty("setForcedCrashPoint")) {
                            object.setForcedCrashPoint = $root.com.achlid.crash.game.SetForcedCrashPointRequest.toObject(message.setForcedCrashPoint, options);
                            if (options.oneofs)
                                object.payload = "setForcedCrashPoint";
                        }
                        if (message.forcedCrashPointResult != null && message.hasOwnProperty("forcedCrashPointResult")) {
                            object.forcedCrashPointResult = $root.com.achlid.crash.game.SetForcedCrashPointResult.toObject(message.forcedCrashPointResult, options);
                            if (options.oneofs)
                                object.payload = "forcedCrashPointResult";
                        }
                        return object;
                    };

                    /**
                     * Converts this GameMessage to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.GameMessage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GameMessage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GameMessage
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.GameMessage
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GameMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.GameMessage";
                    };

                    /**
                     * MessageType enum.
                     * @name com.achlid.crash.game.GameMessage.MessageType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} PLACE_BET=1 PLACE_BET value
                     * @property {number} CASH_OUT=2 CASH_OUT value
                     * @property {number} CANCEL_BET=3 CANCEL_BET value
                     * @property {number} AUTO_PLAY=4 AUTO_PLAY value
                     * @property {number} STOP_AUTO_PLAY=5 STOP_AUTO_PLAY value
                     * @property {number} SET_AUTO_CASH_OUT=28 SET_AUTO_CASH_OUT value
                     * @property {number} PING=6 PING value
                     * @property {number} GET_WALLET=7 GET_WALLET value
                     * @property {number} GET_LEADERBOARD=8 GET_LEADERBOARD value
                     * @property {number} GET_BET_HISTORY=60 GET_BET_HISTORY value
                     * @property {number} GET_PROVABLY_FAIR_ROUND=62 GET_PROVABLY_FAIR_ROUND value
                     * @property {number} GET_PROVABLY_FAIR_BETS=63 GET_PROVABLY_FAIR_BETS value
                     * @property {number} GET_USER_PROFILE=66 GET_USER_PROFILE value
                     * @property {number} UPDATE_USER_PROFILE=67 UPDATE_USER_PROFILE value
                     * @property {number} GET_FREEBETS=72 GET_FREEBETS value
                     * @property {number} SEND_CHAT_MESSAGE=77 SEND_CHAT_MESSAGE value
                     * @property {number} GET_CHAT_HISTORY=78 GET_CHAT_HISTORY value
                     * @property {number} GET_VIEWER_AWARE_CHAT_HISTORY=83 GET_VIEWER_AWARE_CHAT_HISTORY value
                     * @property {number} CONNECTED=10 CONNECTED value
                     * @property {number} BET_RESULT=11 BET_RESULT value
                     * @property {number} CASH_OUT_RESULT=12 CASH_OUT_RESULT value
                     * @property {number} CANCEL_BET_RESULT=13 CANCEL_BET_RESULT value
                     * @property {number} AUTO_PLAY_RESULT=14 AUTO_PLAY_RESULT value
                     * @property {number} AUTOPLAY_UPDATE=15 AUTOPLAY_UPDATE value
                     * @property {number} AUTO_CASH_OUT_RESULT=29 AUTO_CASH_OUT_RESULT value
                     * @property {number} WALLET_UPDATE=71 WALLET_UPDATE value
                     * @property {number} WALLET_RESPONSE=16 WALLET_RESPONSE value
                     * @property {number} LEADERBOARD_RESPONSE=17 LEADERBOARD_RESPONSE value
                     * @property {number} BET_HISTORY_RESPONSE=61 BET_HISTORY_RESPONSE value
                     * @property {number} PROVABLY_FAIR_ROUND_RESPONSE=64 PROVABLY_FAIR_ROUND_RESPONSE value
                     * @property {number} PROVABLY_FAIR_BETS_RESPONSE=65 PROVABLY_FAIR_BETS_RESPONSE value
                     * @property {number} USER_PROFILE_RESPONSE=68 USER_PROFILE_RESPONSE value
                     * @property {number} UPDATE_USER_PROFILE_RESPONSE=69 UPDATE_USER_PROFILE_RESPONSE value
                     * @property {number} YOUR_CLIENT_SEED=70 YOUR_CLIENT_SEED value
                     * @property {number} FREEBETS_RESPONSE=73 FREEBETS_RESPONSE value
                     * @property {number} FREEBET_GRANTED_NOTIFICATION=74 FREEBET_GRANTED_NOTIFICATION value
                     * @property {number} FREEBET_PROGRESS_ELIGIBILITY=75 FREEBET_PROGRESS_ELIGIBILITY value
                     * @property {number} FREEBET_PROGRESS_UPDATE=76 FREEBET_PROGRESS_UPDATE value
                     * @property {number} CHAT_SEND_RESULT=79 CHAT_SEND_RESULT value
                     * @property {number} CHAT_HISTORY_RESPONSE=80 CHAT_HISTORY_RESPONSE value
                     * @property {number} CHAT_MESSAGE_DELETED=82 CHAT_MESSAGE_DELETED value
                     * @property {number} VIEWER_AWARE_CHAT_HISTORY_RESPONSE=84 VIEWER_AWARE_CHAT_HISTORY_RESPONSE value
                     * @property {number} MULTIPLIER_UPDATE=20 MULTIPLIER_UPDATE value
                     * @property {number} ROUND_CRASH=21 ROUND_CRASH value
                     * @property {number} ROUND_START=22 ROUND_START value
                     * @property {number} PRE_ROUND_START=23 PRE_ROUND_START value
                     * @property {number} NEW_BET_NOTIFICATION=24 NEW_BET_NOTIFICATION value
                     * @property {number} CASH_OUT_NOTIFICATION=25 CASH_OUT_NOTIFICATION value
                     * @property {number} BIG_WIN_NOTIFICATION=26 BIG_WIN_NOTIFICATION value
                     * @property {number} CANCEL_BET_NOTIFICATION=27 CANCEL_BET_NOTIFICATION value
                     * @property {number} CHAT_MESSAGE=81 CHAT_MESSAGE value
                     * @property {number} ROOM_BETS_NOTIFICATION=103 ROOM_BETS_NOTIFICATION value
                     * @property {number} TOTAL_BETS_COUNT_UPDATE=33 TOTAL_BETS_COUNT_UPDATE value
                     * @property {number} ERROR=30 ERROR value
                     * @property {number} PONG=31 PONG value
                     * @property {number} GAME_STATE=32 GAME_STATE value
                     * @property {number} SET_FORCED_CRASH_POINT=100 SET_FORCED_CRASH_POINT value
                     * @property {number} FORCED_CRASH_POINT_RESULT=101 FORCED_CRASH_POINT_RESULT value
                     */
                    GameMessage.MessageType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "PLACE_BET"] = 1;
                        values[valuesById[2] = "CASH_OUT"] = 2;
                        values[valuesById[3] = "CANCEL_BET"] = 3;
                        values[valuesById[4] = "AUTO_PLAY"] = 4;
                        values[valuesById[5] = "STOP_AUTO_PLAY"] = 5;
                        values[valuesById[28] = "SET_AUTO_CASH_OUT"] = 28;
                        values[valuesById[6] = "PING"] = 6;
                        values[valuesById[7] = "GET_WALLET"] = 7;
                        values[valuesById[8] = "GET_LEADERBOARD"] = 8;
                        values[valuesById[60] = "GET_BET_HISTORY"] = 60;
                        values[valuesById[62] = "GET_PROVABLY_FAIR_ROUND"] = 62;
                        values[valuesById[63] = "GET_PROVABLY_FAIR_BETS"] = 63;
                        values[valuesById[66] = "GET_USER_PROFILE"] = 66;
                        values[valuesById[67] = "UPDATE_USER_PROFILE"] = 67;
                        values[valuesById[72] = "GET_FREEBETS"] = 72;
                        values[valuesById[77] = "SEND_CHAT_MESSAGE"] = 77;
                        values[valuesById[78] = "GET_CHAT_HISTORY"] = 78;
                        values[valuesById[83] = "GET_VIEWER_AWARE_CHAT_HISTORY"] = 83;
                        values[valuesById[10] = "CONNECTED"] = 10;
                        values[valuesById[11] = "BET_RESULT"] = 11;
                        values[valuesById[12] = "CASH_OUT_RESULT"] = 12;
                        values[valuesById[13] = "CANCEL_BET_RESULT"] = 13;
                        values[valuesById[14] = "AUTO_PLAY_RESULT"] = 14;
                        values[valuesById[15] = "AUTOPLAY_UPDATE"] = 15;
                        values[valuesById[29] = "AUTO_CASH_OUT_RESULT"] = 29;
                        values[valuesById[71] = "WALLET_UPDATE"] = 71;
                        values[valuesById[16] = "WALLET_RESPONSE"] = 16;
                        values[valuesById[17] = "LEADERBOARD_RESPONSE"] = 17;
                        values[valuesById[61] = "BET_HISTORY_RESPONSE"] = 61;
                        values[valuesById[64] = "PROVABLY_FAIR_ROUND_RESPONSE"] = 64;
                        values[valuesById[65] = "PROVABLY_FAIR_BETS_RESPONSE"] = 65;
                        values[valuesById[68] = "USER_PROFILE_RESPONSE"] = 68;
                        values[valuesById[69] = "UPDATE_USER_PROFILE_RESPONSE"] = 69;
                        values[valuesById[70] = "YOUR_CLIENT_SEED"] = 70;
                        values[valuesById[73] = "FREEBETS_RESPONSE"] = 73;
                        values[valuesById[74] = "FREEBET_GRANTED_NOTIFICATION"] = 74;
                        values[valuesById[75] = "FREEBET_PROGRESS_ELIGIBILITY"] = 75;
                        values[valuesById[76] = "FREEBET_PROGRESS_UPDATE"] = 76;
                        values[valuesById[79] = "CHAT_SEND_RESULT"] = 79;
                        values[valuesById[80] = "CHAT_HISTORY_RESPONSE"] = 80;
                        values[valuesById[82] = "CHAT_MESSAGE_DELETED"] = 82;
                        values[valuesById[84] = "VIEWER_AWARE_CHAT_HISTORY_RESPONSE"] = 84;
                        values[valuesById[20] = "MULTIPLIER_UPDATE"] = 20;
                        values[valuesById[21] = "ROUND_CRASH"] = 21;
                        values[valuesById[22] = "ROUND_START"] = 22;
                        values[valuesById[23] = "PRE_ROUND_START"] = 23;
                        values[valuesById[24] = "NEW_BET_NOTIFICATION"] = 24;
                        values[valuesById[25] = "CASH_OUT_NOTIFICATION"] = 25;
                        values[valuesById[26] = "BIG_WIN_NOTIFICATION"] = 26;
                        values[valuesById[27] = "CANCEL_BET_NOTIFICATION"] = 27;
                        values[valuesById[81] = "CHAT_MESSAGE"] = 81;
                        values[valuesById[103] = "ROOM_BETS_NOTIFICATION"] = 103;
                        values[valuesById[33] = "TOTAL_BETS_COUNT_UPDATE"] = 33;
                        values[valuesById[30] = "ERROR"] = 30;
                        values[valuesById[31] = "PONG"] = 31;
                        values[valuesById[32] = "GAME_STATE"] = 32;
                        values[valuesById[100] = "SET_FORCED_CRASH_POINT"] = 100;
                        values[valuesById[101] = "FORCED_CRASH_POINT_RESULT"] = 101;
                        return values;
                    })();

                    return GameMessage;
                })();

                game.PlaceBetRequest = (function() {

                    /**
                     * Properties of a PlaceBetRequest.
                     * @memberof com.achlid.crash.game
                     * @interface IPlaceBetRequest
                     * @property {number|null} [slotId] PlaceBetRequest slotId
                     * @property {number|null} [amount] PlaceBetRequest amount
                     * @property {number|null} [autoCashout] PlaceBetRequest autoCashout
                     * @property {number|Long|null} [roundId] PlaceBetRequest roundId
                     */

                    /**
                     * Constructs a new PlaceBetRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a PlaceBetRequest.
                     * @implements IPlaceBetRequest
                     * @constructor
                     * @param {com.achlid.crash.game.IPlaceBetRequest=} [properties] Properties to set
                     */
                    function PlaceBetRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlaceBetRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @instance
                     */
                    PlaceBetRequest.prototype.slotId = 0;

                    /**
                     * PlaceBetRequest amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @instance
                     */
                    PlaceBetRequest.prototype.amount = 0;

                    /**
                     * PlaceBetRequest autoCashout.
                     * @member {number} autoCashout
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @instance
                     */
                    PlaceBetRequest.prototype.autoCashout = 0;

                    /**
                     * PlaceBetRequest roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @instance
                     */
                    PlaceBetRequest.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new PlaceBetRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {com.achlid.crash.game.IPlaceBetRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.PlaceBetRequest} PlaceBetRequest instance
                     */
                    PlaceBetRequest.create = function create(properties) {
                        return new PlaceBetRequest(properties);
                    };

                    /**
                     * Encodes the specified PlaceBetRequest message. Does not implicitly {@link com.achlid.crash.game.PlaceBetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {com.achlid.crash.game.IPlaceBetRequest} message PlaceBetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlaceBetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.amount);
                        if (message.autoCashout != null && Object.hasOwnProperty.call(message, "autoCashout"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.autoCashout);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.roundId);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlaceBetRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.PlaceBetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {com.achlid.crash.game.IPlaceBetRequest} message PlaceBetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlaceBetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlaceBetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.PlaceBetRequest} PlaceBetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlaceBetRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.PlaceBetRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.autoCashout = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlaceBetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.PlaceBetRequest} PlaceBetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlaceBetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlaceBetRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlaceBetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.autoCashout != null && message.hasOwnProperty("autoCashout"))
                            if (typeof message.autoCashout !== "number")
                                return "autoCashout: number expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a PlaceBetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.PlaceBetRequest} PlaceBetRequest
                     */
                    PlaceBetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.PlaceBetRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.PlaceBetRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.autoCashout != null)
                            message.autoCashout = Number(object.autoCashout);
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlaceBetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {com.achlid.crash.game.PlaceBetRequest} message PlaceBetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlaceBetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            object.amount = 0;
                            object.autoCashout = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.autoCashout != null && message.hasOwnProperty("autoCashout"))
                            object.autoCashout = options.json && !isFinite(message.autoCashout) ? String(message.autoCashout) : message.autoCashout;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        return object;
                    };

                    /**
                     * Converts this PlaceBetRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlaceBetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlaceBetRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.PlaceBetRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlaceBetRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.PlaceBetRequest";
                    };

                    return PlaceBetRequest;
                })();

                game.CashOutRequest = (function() {

                    /**
                     * Properties of a CashOutRequest.
                     * @memberof com.achlid.crash.game
                     * @interface ICashOutRequest
                     * @property {number|null} [slotId] CashOutRequest slotId
                     * @property {number|Long|null} [roundId] CashOutRequest roundId
                     */

                    /**
                     * Constructs a new CashOutRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CashOutRequest.
                     * @implements ICashOutRequest
                     * @constructor
                     * @param {com.achlid.crash.game.ICashOutRequest=} [properties] Properties to set
                     */
                    function CashOutRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CashOutRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @instance
                     */
                    CashOutRequest.prototype.slotId = 0;

                    /**
                     * CashOutRequest roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @instance
                     */
                    CashOutRequest.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new CashOutRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ICashOutRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CashOutRequest} CashOutRequest instance
                     */
                    CashOutRequest.create = function create(properties) {
                        return new CashOutRequest(properties);
                    };

                    /**
                     * Encodes the specified CashOutRequest message. Does not implicitly {@link com.achlid.crash.game.CashOutRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ICashOutRequest} message CashOutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roundId);
                        return writer;
                    };

                    /**
                     * Encodes the specified CashOutRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.CashOutRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ICashOutRequest} message CashOutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CashOutRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CashOutRequest} CashOutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CashOutRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CashOutRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CashOutRequest} CashOutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CashOutRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CashOutRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a CashOutRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CashOutRequest} CashOutRequest
                     */
                    CashOutRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CashOutRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.CashOutRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a CashOutRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.CashOutRequest} message CashOutRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CashOutRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        return object;
                    };

                    /**
                     * Converts this CashOutRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CashOutRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CashOutRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CashOutRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CashOutRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CashOutRequest";
                    };

                    return CashOutRequest;
                })();

                game.CancelBetRequest = (function() {

                    /**
                     * Properties of a CancelBetRequest.
                     * @memberof com.achlid.crash.game
                     * @interface ICancelBetRequest
                     * @property {number|null} [slotId] CancelBetRequest slotId
                     * @property {number|Long|null} [roundId] CancelBetRequest roundId
                     */

                    /**
                     * Constructs a new CancelBetRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CancelBetRequest.
                     * @implements ICancelBetRequest
                     * @constructor
                     * @param {com.achlid.crash.game.ICancelBetRequest=} [properties] Properties to set
                     */
                    function CancelBetRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CancelBetRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @instance
                     */
                    CancelBetRequest.prototype.slotId = 0;

                    /**
                     * CancelBetRequest roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @instance
                     */
                    CancelBetRequest.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new CancelBetRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CancelBetRequest} CancelBetRequest instance
                     */
                    CancelBetRequest.create = function create(properties) {
                        return new CancelBetRequest(properties);
                    };

                    /**
                     * Encodes the specified CancelBetRequest message. Does not implicitly {@link com.achlid.crash.game.CancelBetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetRequest} message CancelBetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roundId);
                        return writer;
                    };

                    /**
                     * Encodes the specified CancelBetRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.CancelBetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetRequest} message CancelBetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CancelBetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CancelBetRequest} CancelBetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CancelBetRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CancelBetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CancelBetRequest} CancelBetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CancelBetRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CancelBetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a CancelBetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CancelBetRequest} CancelBetRequest
                     */
                    CancelBetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CancelBetRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.CancelBetRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a CancelBetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {com.achlid.crash.game.CancelBetRequest} message CancelBetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CancelBetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        return object;
                    };

                    /**
                     * Converts this CancelBetRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CancelBetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CancelBetRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CancelBetRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CancelBetRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CancelBetRequest";
                    };

                    return CancelBetRequest;
                })();

                game.AutoPlayRequest = (function() {

                    /**
                     * Properties of an AutoPlayRequest.
                     * @memberof com.achlid.crash.game
                     * @interface IAutoPlayRequest
                     * @property {number|null} [slotId] AutoPlayRequest slotId
                     * @property {number|null} [betAmount] AutoPlayRequest betAmount
                     * @property {number|null} [rounds] AutoPlayRequest rounds
                     * @property {number|null} [stopOnLoss] AutoPlayRequest stopOnLoss
                     * @property {number|null} [stopOnProfit] AutoPlayRequest stopOnProfit
                     * @property {number|null} [stopOnSingleWin] AutoPlayRequest stopOnSingleWin
                     * @property {number|null} [autoCashoutLevel] AutoPlayRequest autoCashoutLevel
                     */

                    /**
                     * Constructs a new AutoPlayRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents an AutoPlayRequest.
                     * @implements IAutoPlayRequest
                     * @constructor
                     * @param {com.achlid.crash.game.IAutoPlayRequest=} [properties] Properties to set
                     */
                    function AutoPlayRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AutoPlayRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.slotId = 0;

                    /**
                     * AutoPlayRequest betAmount.
                     * @member {number} betAmount
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.betAmount = 0;

                    /**
                     * AutoPlayRequest rounds.
                     * @member {number} rounds
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.rounds = 0;

                    /**
                     * AutoPlayRequest stopOnLoss.
                     * @member {number} stopOnLoss
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.stopOnLoss = 0;

                    /**
                     * AutoPlayRequest stopOnProfit.
                     * @member {number} stopOnProfit
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.stopOnProfit = 0;

                    /**
                     * AutoPlayRequest stopOnSingleWin.
                     * @member {number} stopOnSingleWin
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.stopOnSingleWin = 0;

                    /**
                     * AutoPlayRequest autoCashoutLevel.
                     * @member {number} autoCashoutLevel
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     */
                    AutoPlayRequest.prototype.autoCashoutLevel = 0;

                    /**
                     * Creates a new AutoPlayRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.AutoPlayRequest} AutoPlayRequest instance
                     */
                    AutoPlayRequest.create = function create(properties) {
                        return new AutoPlayRequest(properties);
                    };

                    /**
                     * Encodes the specified AutoPlayRequest message. Does not implicitly {@link com.achlid.crash.game.AutoPlayRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayRequest} message AutoPlayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.betAmount != null && Object.hasOwnProperty.call(message, "betAmount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.betAmount);
                        if (message.rounds != null && Object.hasOwnProperty.call(message, "rounds"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.rounds);
                        if (message.stopOnLoss != null && Object.hasOwnProperty.call(message, "stopOnLoss"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.stopOnLoss);
                        if (message.stopOnProfit != null && Object.hasOwnProperty.call(message, "stopOnProfit"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.stopOnProfit);
                        if (message.stopOnSingleWin != null && Object.hasOwnProperty.call(message, "stopOnSingleWin"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.stopOnSingleWin);
                        if (message.autoCashoutLevel != null && Object.hasOwnProperty.call(message, "autoCashoutLevel"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.autoCashoutLevel);
                        return writer;
                    };

                    /**
                     * Encodes the specified AutoPlayRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.AutoPlayRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayRequest} message AutoPlayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AutoPlayRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.AutoPlayRequest} AutoPlayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.AutoPlayRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.betAmount = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.rounds = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.stopOnLoss = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.stopOnProfit = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.stopOnSingleWin = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.autoCashoutLevel = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AutoPlayRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.AutoPlayRequest} AutoPlayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AutoPlayRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AutoPlayRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                            if (typeof message.betAmount !== "number")
                                return "betAmount: number expected";
                        if (message.rounds != null && message.hasOwnProperty("rounds"))
                            if (!$util.isInteger(message.rounds))
                                return "rounds: integer expected";
                        if (message.stopOnLoss != null && message.hasOwnProperty("stopOnLoss"))
                            if (typeof message.stopOnLoss !== "number")
                                return "stopOnLoss: number expected";
                        if (message.stopOnProfit != null && message.hasOwnProperty("stopOnProfit"))
                            if (typeof message.stopOnProfit !== "number")
                                return "stopOnProfit: number expected";
                        if (message.stopOnSingleWin != null && message.hasOwnProperty("stopOnSingleWin"))
                            if (typeof message.stopOnSingleWin !== "number")
                                return "stopOnSingleWin: number expected";
                        if (message.autoCashoutLevel != null && message.hasOwnProperty("autoCashoutLevel"))
                            if (typeof message.autoCashoutLevel !== "number")
                                return "autoCashoutLevel: number expected";
                        return null;
                    };

                    /**
                     * Creates an AutoPlayRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.AutoPlayRequest} AutoPlayRequest
                     */
                    AutoPlayRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.AutoPlayRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.AutoPlayRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.betAmount != null)
                            message.betAmount = Number(object.betAmount);
                        if (object.rounds != null)
                            message.rounds = object.rounds | 0;
                        if (object.stopOnLoss != null)
                            message.stopOnLoss = Number(object.stopOnLoss);
                        if (object.stopOnProfit != null)
                            message.stopOnProfit = Number(object.stopOnProfit);
                        if (object.stopOnSingleWin != null)
                            message.stopOnSingleWin = Number(object.stopOnSingleWin);
                        if (object.autoCashoutLevel != null)
                            message.autoCashoutLevel = Number(object.autoCashoutLevel);
                        return message;
                    };

                    /**
                     * Creates a plain object from an AutoPlayRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.AutoPlayRequest} message AutoPlayRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AutoPlayRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            object.betAmount = 0;
                            object.rounds = 0;
                            object.stopOnLoss = 0;
                            object.stopOnProfit = 0;
                            object.stopOnSingleWin = 0;
                            object.autoCashoutLevel = 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                            object.betAmount = options.json && !isFinite(message.betAmount) ? String(message.betAmount) : message.betAmount;
                        if (message.rounds != null && message.hasOwnProperty("rounds"))
                            object.rounds = message.rounds;
                        if (message.stopOnLoss != null && message.hasOwnProperty("stopOnLoss"))
                            object.stopOnLoss = options.json && !isFinite(message.stopOnLoss) ? String(message.stopOnLoss) : message.stopOnLoss;
                        if (message.stopOnProfit != null && message.hasOwnProperty("stopOnProfit"))
                            object.stopOnProfit = options.json && !isFinite(message.stopOnProfit) ? String(message.stopOnProfit) : message.stopOnProfit;
                        if (message.stopOnSingleWin != null && message.hasOwnProperty("stopOnSingleWin"))
                            object.stopOnSingleWin = options.json && !isFinite(message.stopOnSingleWin) ? String(message.stopOnSingleWin) : message.stopOnSingleWin;
                        if (message.autoCashoutLevel != null && message.hasOwnProperty("autoCashoutLevel"))
                            object.autoCashoutLevel = options.json && !isFinite(message.autoCashoutLevel) ? String(message.autoCashoutLevel) : message.autoCashoutLevel;
                        return object;
                    };

                    /**
                     * Converts this AutoPlayRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AutoPlayRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AutoPlayRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.AutoPlayRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AutoPlayRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.AutoPlayRequest";
                    };

                    return AutoPlayRequest;
                })();

                game.StopAutoPlayRequest = (function() {

                    /**
                     * Properties of a StopAutoPlayRequest.
                     * @memberof com.achlid.crash.game
                     * @interface IStopAutoPlayRequest
                     * @property {number|null} [slotId] StopAutoPlayRequest slotId
                     */

                    /**
                     * Constructs a new StopAutoPlayRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a StopAutoPlayRequest.
                     * @implements IStopAutoPlayRequest
                     * @constructor
                     * @param {com.achlid.crash.game.IStopAutoPlayRequest=} [properties] Properties to set
                     */
                    function StopAutoPlayRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * StopAutoPlayRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @instance
                     */
                    StopAutoPlayRequest.prototype.slotId = 0;

                    /**
                     * Creates a new StopAutoPlayRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IStopAutoPlayRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.StopAutoPlayRequest} StopAutoPlayRequest instance
                     */
                    StopAutoPlayRequest.create = function create(properties) {
                        return new StopAutoPlayRequest(properties);
                    };

                    /**
                     * Encodes the specified StopAutoPlayRequest message. Does not implicitly {@link com.achlid.crash.game.StopAutoPlayRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IStopAutoPlayRequest} message StopAutoPlayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StopAutoPlayRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        return writer;
                    };

                    /**
                     * Encodes the specified StopAutoPlayRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.StopAutoPlayRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.IStopAutoPlayRequest} message StopAutoPlayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StopAutoPlayRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a StopAutoPlayRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.StopAutoPlayRequest} StopAutoPlayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StopAutoPlayRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.StopAutoPlayRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a StopAutoPlayRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.StopAutoPlayRequest} StopAutoPlayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StopAutoPlayRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a StopAutoPlayRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StopAutoPlayRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a StopAutoPlayRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.StopAutoPlayRequest} StopAutoPlayRequest
                     */
                    StopAutoPlayRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.StopAutoPlayRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.StopAutoPlayRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a StopAutoPlayRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {com.achlid.crash.game.StopAutoPlayRequest} message StopAutoPlayRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StopAutoPlayRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.slotId = 0;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        return object;
                    };

                    /**
                     * Converts this StopAutoPlayRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StopAutoPlayRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for StopAutoPlayRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.StopAutoPlayRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    StopAutoPlayRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.StopAutoPlayRequest";
                    };

                    return StopAutoPlayRequest;
                })();

                game.AutoPlayUpdate = (function() {

                    /**
                     * Properties of an AutoPlayUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface IAutoPlayUpdate
                     * @property {number|null} [slotId] AutoPlayUpdate slotId
                     * @property {number|null} [roundsPlayed] AutoPlayUpdate roundsPlayed
                     * @property {number|null} [roundsRemaining] AutoPlayUpdate roundsRemaining
                     * @property {number|null} [totalRounds] AutoPlayUpdate totalRounds
                     * @property {number|null} [totalWagered] AutoPlayUpdate totalWagered
                     * @property {number|null} [totalWon] AutoPlayUpdate totalWon
                     * @property {number|null} [netProfit] AutoPlayUpdate netProfit
                     * @property {boolean|null} [isActive] AutoPlayUpdate isActive
                     * @property {number|Long|null} [roundId] AutoPlayUpdate roundId
                     */

                    /**
                     * Constructs a new AutoPlayUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents an AutoPlayUpdate.
                     * @implements IAutoPlayUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.IAutoPlayUpdate=} [properties] Properties to set
                     */
                    function AutoPlayUpdate(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AutoPlayUpdate slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.slotId = 0;

                    /**
                     * AutoPlayUpdate roundsPlayed.
                     * @member {number} roundsPlayed
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.roundsPlayed = 0;

                    /**
                     * AutoPlayUpdate roundsRemaining.
                     * @member {number} roundsRemaining
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.roundsRemaining = 0;

                    /**
                     * AutoPlayUpdate totalRounds.
                     * @member {number} totalRounds
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.totalRounds = 0;

                    /**
                     * AutoPlayUpdate totalWagered.
                     * @member {number} totalWagered
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.totalWagered = 0;

                    /**
                     * AutoPlayUpdate totalWon.
                     * @member {number} totalWon
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.totalWon = 0;

                    /**
                     * AutoPlayUpdate netProfit.
                     * @member {number} netProfit
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.netProfit = 0;

                    /**
                     * AutoPlayUpdate isActive.
                     * @member {boolean} isActive
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.isActive = false;

                    /**
                     * AutoPlayUpdate roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     */
                    AutoPlayUpdate.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new AutoPlayUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.AutoPlayUpdate} AutoPlayUpdate instance
                     */
                    AutoPlayUpdate.create = function create(properties) {
                        return new AutoPlayUpdate(properties);
                    };

                    /**
                     * Encodes the specified AutoPlayUpdate message. Does not implicitly {@link com.achlid.crash.game.AutoPlayUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayUpdate} message AutoPlayUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.roundsPlayed != null && Object.hasOwnProperty.call(message, "roundsPlayed"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roundsPlayed);
                        if (message.roundsRemaining != null && Object.hasOwnProperty.call(message, "roundsRemaining"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.roundsRemaining);
                        if (message.totalRounds != null && Object.hasOwnProperty.call(message, "totalRounds"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.totalRounds);
                        if (message.totalWagered != null && Object.hasOwnProperty.call(message, "totalWagered"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalWagered);
                        if (message.totalWon != null && Object.hasOwnProperty.call(message, "totalWon"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.totalWon);
                        if (message.netProfit != null && Object.hasOwnProperty.call(message, "netProfit"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.netProfit);
                        if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isActive);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.roundId);
                        return writer;
                    };

                    /**
                     * Encodes the specified AutoPlayUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.AutoPlayUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayUpdate} message AutoPlayUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AutoPlayUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.AutoPlayUpdate} AutoPlayUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.AutoPlayUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.roundsPlayed = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.roundsRemaining = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.totalRounds = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.totalWagered = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.totalWon = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.netProfit = reader.double();
                                    break;
                                }
                            case 8: {
                                    message.isActive = reader.bool();
                                    break;
                                }
                            case 9: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AutoPlayUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.AutoPlayUpdate} AutoPlayUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AutoPlayUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AutoPlayUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundsPlayed != null && message.hasOwnProperty("roundsPlayed"))
                            if (!$util.isInteger(message.roundsPlayed))
                                return "roundsPlayed: integer expected";
                        if (message.roundsRemaining != null && message.hasOwnProperty("roundsRemaining"))
                            if (!$util.isInteger(message.roundsRemaining))
                                return "roundsRemaining: integer expected";
                        if (message.totalRounds != null && message.hasOwnProperty("totalRounds"))
                            if (!$util.isInteger(message.totalRounds))
                                return "totalRounds: integer expected";
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            if (typeof message.totalWagered !== "number")
                                return "totalWagered: number expected";
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            if (typeof message.totalWon !== "number")
                                return "totalWon: number expected";
                        if (message.netProfit != null && message.hasOwnProperty("netProfit"))
                            if (typeof message.netProfit !== "number")
                                return "netProfit: number expected";
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            if (typeof message.isActive !== "boolean")
                                return "isActive: boolean expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates an AutoPlayUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.AutoPlayUpdate} AutoPlayUpdate
                     */
                    AutoPlayUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.AutoPlayUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.AutoPlayUpdate();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundsPlayed != null)
                            message.roundsPlayed = object.roundsPlayed | 0;
                        if (object.roundsRemaining != null)
                            message.roundsRemaining = object.roundsRemaining | 0;
                        if (object.totalRounds != null)
                            message.totalRounds = object.totalRounds | 0;
                        if (object.totalWagered != null)
                            message.totalWagered = Number(object.totalWagered);
                        if (object.totalWon != null)
                            message.totalWon = Number(object.totalWon);
                        if (object.netProfit != null)
                            message.netProfit = Number(object.netProfit);
                        if (object.isActive != null)
                            message.isActive = Boolean(object.isActive);
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from an AutoPlayUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {com.achlid.crash.game.AutoPlayUpdate} message AutoPlayUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AutoPlayUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            object.roundsPlayed = 0;
                            object.roundsRemaining = 0;
                            object.totalRounds = 0;
                            object.totalWagered = 0;
                            object.totalWon = 0;
                            object.netProfit = 0;
                            object.isActive = false;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundsPlayed != null && message.hasOwnProperty("roundsPlayed"))
                            object.roundsPlayed = message.roundsPlayed;
                        if (message.roundsRemaining != null && message.hasOwnProperty("roundsRemaining"))
                            object.roundsRemaining = message.roundsRemaining;
                        if (message.totalRounds != null && message.hasOwnProperty("totalRounds"))
                            object.totalRounds = message.totalRounds;
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            object.totalWagered = options.json && !isFinite(message.totalWagered) ? String(message.totalWagered) : message.totalWagered;
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            object.totalWon = options.json && !isFinite(message.totalWon) ? String(message.totalWon) : message.totalWon;
                        if (message.netProfit != null && message.hasOwnProperty("netProfit"))
                            object.netProfit = options.json && !isFinite(message.netProfit) ? String(message.netProfit) : message.netProfit;
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            object.isActive = message.isActive;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        return object;
                    };

                    /**
                     * Converts this AutoPlayUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AutoPlayUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AutoPlayUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.AutoPlayUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AutoPlayUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.AutoPlayUpdate";
                    };

                    return AutoPlayUpdate;
                })();

                game.PingRequest = (function() {

                    /**
                     * Properties of a PingRequest.
                     * @memberof com.achlid.crash.game
                     * @interface IPingRequest
                     * @property {number|Long|null} [clientTime] PingRequest clientTime
                     */

                    /**
                     * Constructs a new PingRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a PingRequest.
                     * @implements IPingRequest
                     * @constructor
                     * @param {com.achlid.crash.game.IPingRequest=} [properties] Properties to set
                     */
                    function PingRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PingRequest clientTime.
                     * @member {number|Long} clientTime
                     * @memberof com.achlid.crash.game.PingRequest
                     * @instance
                     */
                    PingRequest.prototype.clientTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new PingRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {com.achlid.crash.game.IPingRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.PingRequest} PingRequest instance
                     */
                    PingRequest.create = function create(properties) {
                        return new PingRequest(properties);
                    };

                    /**
                     * Encodes the specified PingRequest message. Does not implicitly {@link com.achlid.crash.game.PingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {com.achlid.crash.game.IPingRequest} message PingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.clientTime != null && Object.hasOwnProperty.call(message, "clientTime"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.clientTime);
                        return writer;
                    };

                    /**
                     * Encodes the specified PingRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.PingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {com.achlid.crash.game.IPingRequest} message PingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.PingRequest} PingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PingRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.PingRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.clientTime = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.PingRequest} PingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PingRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.clientTime != null && message.hasOwnProperty("clientTime"))
                            if (!$util.isInteger(message.clientTime) && !(message.clientTime && $util.isInteger(message.clientTime.low) && $util.isInteger(message.clientTime.high)))
                                return "clientTime: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a PingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.PingRequest} PingRequest
                     */
                    PingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.PingRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.PingRequest();
                        if (object.clientTime != null)
                            if ($util.Long)
                                (message.clientTime = $util.Long.fromValue(object.clientTime)).unsigned = false;
                            else if (typeof object.clientTime === "string")
                                message.clientTime = parseInt(object.clientTime, 10);
                            else if (typeof object.clientTime === "number")
                                message.clientTime = object.clientTime;
                            else if (typeof object.clientTime === "object")
                                message.clientTime = new $util.LongBits(object.clientTime.low >>> 0, object.clientTime.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a PingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {com.achlid.crash.game.PingRequest} message PingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.clientTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.clientTime = options.longs === String ? "0" : 0;
                        if (message.clientTime != null && message.hasOwnProperty("clientTime"))
                            if (typeof message.clientTime === "number")
                                object.clientTime = options.longs === String ? String(message.clientTime) : message.clientTime;
                            else
                                object.clientTime = options.longs === String ? $util.Long.prototype.toString.call(message.clientTime) : options.longs === Number ? new $util.LongBits(message.clientTime.low >>> 0, message.clientTime.high >>> 0).toNumber() : message.clientTime;
                        return object;
                    };

                    /**
                     * Converts this PingRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.PingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PingRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.PingRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PingRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.PingRequest";
                    };

                    return PingRequest;
                })();

                game.YourClientSeed = (function() {

                    /**
                     * Properties of a YourClientSeed.
                     * @memberof com.achlid.crash.game
                     * @interface IYourClientSeed
                     * @property {number|Long|null} [roundId] YourClientSeed roundId
                     * @property {string|null} [clientSeed] YourClientSeed clientSeed
                     */

                    /**
                     * Constructs a new YourClientSeed.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a YourClientSeed.
                     * @implements IYourClientSeed
                     * @constructor
                     * @param {com.achlid.crash.game.IYourClientSeed=} [properties] Properties to set
                     */
                    function YourClientSeed(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * YourClientSeed roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @instance
                     */
                    YourClientSeed.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * YourClientSeed clientSeed.
                     * @member {string} clientSeed
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @instance
                     */
                    YourClientSeed.prototype.clientSeed = "";

                    /**
                     * Creates a new YourClientSeed instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {com.achlid.crash.game.IYourClientSeed=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.YourClientSeed} YourClientSeed instance
                     */
                    YourClientSeed.create = function create(properties) {
                        return new YourClientSeed(properties);
                    };

                    /**
                     * Encodes the specified YourClientSeed message. Does not implicitly {@link com.achlid.crash.game.YourClientSeed.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {com.achlid.crash.game.IYourClientSeed} message YourClientSeed message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    YourClientSeed.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.clientSeed != null && Object.hasOwnProperty.call(message, "clientSeed"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.clientSeed);
                        return writer;
                    };

                    /**
                     * Encodes the specified YourClientSeed message, length delimited. Does not implicitly {@link com.achlid.crash.game.YourClientSeed.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {com.achlid.crash.game.IYourClientSeed} message YourClientSeed message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    YourClientSeed.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a YourClientSeed message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.YourClientSeed} YourClientSeed
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    YourClientSeed.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.YourClientSeed();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.clientSeed = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a YourClientSeed message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.YourClientSeed} YourClientSeed
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    YourClientSeed.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a YourClientSeed message.
                     * @function verify
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    YourClientSeed.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.clientSeed != null && message.hasOwnProperty("clientSeed"))
                            if (!$util.isString(message.clientSeed))
                                return "clientSeed: string expected";
                        return null;
                    };

                    /**
                     * Creates a YourClientSeed message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.YourClientSeed} YourClientSeed
                     */
                    YourClientSeed.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.YourClientSeed)
                            return object;
                        let message = new $root.com.achlid.crash.game.YourClientSeed();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.clientSeed != null)
                            message.clientSeed = String(object.clientSeed);
                        return message;
                    };

                    /**
                     * Creates a plain object from a YourClientSeed message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {com.achlid.crash.game.YourClientSeed} message YourClientSeed
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    YourClientSeed.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.clientSeed = "";
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.clientSeed != null && message.hasOwnProperty("clientSeed"))
                            object.clientSeed = message.clientSeed;
                        return object;
                    };

                    /**
                     * Converts this YourClientSeed to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    YourClientSeed.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for YourClientSeed
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.YourClientSeed
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    YourClientSeed.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.YourClientSeed";
                    };

                    return YourClientSeed;
                })();

                game.WalletUpdate = (function() {

                    /**
                     * Properties of a WalletUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface IWalletUpdate
                     * @property {number|null} [balance] WalletUpdate balance
                     * @property {number|null} [reserved] WalletUpdate reserved
                     * @property {string|null} [reason] WalletUpdate reason
                     * @property {boolean|null} [hasPendingOperations] WalletUpdate hasPendingOperations
                     * @property {number|null} [pendingAvailableDelta] WalletUpdate pendingAvailableDelta
                     * @property {number|null} [pendingReservedDelta] WalletUpdate pendingReservedDelta
                     * @property {string|null} [walletOperationId] WalletUpdate walletOperationId
                     */

                    /**
                     * Constructs a new WalletUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a WalletUpdate.
                     * @implements IWalletUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.IWalletUpdate=} [properties] Properties to set
                     */
                    function WalletUpdate(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * WalletUpdate balance.
                     * @member {number} balance
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.balance = 0;

                    /**
                     * WalletUpdate reserved.
                     * @member {number} reserved
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.reserved = 0;

                    /**
                     * WalletUpdate reason.
                     * @member {string} reason
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.reason = "";

                    /**
                     * WalletUpdate hasPendingOperations.
                     * @member {boolean} hasPendingOperations
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.hasPendingOperations = false;

                    /**
                     * WalletUpdate pendingAvailableDelta.
                     * @member {number} pendingAvailableDelta
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.pendingAvailableDelta = 0;

                    /**
                     * WalletUpdate pendingReservedDelta.
                     * @member {number} pendingReservedDelta
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.pendingReservedDelta = 0;

                    /**
                     * WalletUpdate walletOperationId.
                     * @member {string} walletOperationId
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     */
                    WalletUpdate.prototype.walletOperationId = "";

                    /**
                     * Creates a new WalletUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {com.achlid.crash.game.IWalletUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.WalletUpdate} WalletUpdate instance
                     */
                    WalletUpdate.create = function create(properties) {
                        return new WalletUpdate(properties);
                    };

                    /**
                     * Encodes the specified WalletUpdate message. Does not implicitly {@link com.achlid.crash.game.WalletUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {com.achlid.crash.game.IWalletUpdate} message WalletUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WalletUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.balance);
                        if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.reserved);
                        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.reason);
                        if (message.hasPendingOperations != null && Object.hasOwnProperty.call(message, "hasPendingOperations"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hasPendingOperations);
                        if (message.pendingAvailableDelta != null && Object.hasOwnProperty.call(message, "pendingAvailableDelta"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.pendingAvailableDelta);
                        if (message.pendingReservedDelta != null && Object.hasOwnProperty.call(message, "pendingReservedDelta"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.pendingReservedDelta);
                        if (message.walletOperationId != null && Object.hasOwnProperty.call(message, "walletOperationId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.walletOperationId);
                        return writer;
                    };

                    /**
                     * Encodes the specified WalletUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.WalletUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {com.achlid.crash.game.IWalletUpdate} message WalletUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WalletUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a WalletUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.WalletUpdate} WalletUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WalletUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.WalletUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.balance = reader.double();
                                    break;
                                }
                            case 2: {
                                    message.reserved = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.reason = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.hasPendingOperations = reader.bool();
                                    break;
                                }
                            case 5: {
                                    message.pendingAvailableDelta = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.pendingReservedDelta = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.walletOperationId = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a WalletUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.WalletUpdate} WalletUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WalletUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a WalletUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WalletUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            if (typeof message.balance !== "number")
                                return "balance: number expected";
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            if (typeof message.reserved !== "number")
                                return "reserved: number expected";
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            if (!$util.isString(message.reason))
                                return "reason: string expected";
                        if (message.hasPendingOperations != null && message.hasOwnProperty("hasPendingOperations"))
                            if (typeof message.hasPendingOperations !== "boolean")
                                return "hasPendingOperations: boolean expected";
                        if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                            if (typeof message.pendingAvailableDelta !== "number")
                                return "pendingAvailableDelta: number expected";
                        if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                            if (typeof message.pendingReservedDelta !== "number")
                                return "pendingReservedDelta: number expected";
                        if (message.walletOperationId != null && message.hasOwnProperty("walletOperationId"))
                            if (!$util.isString(message.walletOperationId))
                                return "walletOperationId: string expected";
                        return null;
                    };

                    /**
                     * Creates a WalletUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.WalletUpdate} WalletUpdate
                     */
                    WalletUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.WalletUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.WalletUpdate();
                        if (object.balance != null)
                            message.balance = Number(object.balance);
                        if (object.reserved != null)
                            message.reserved = Number(object.reserved);
                        if (object.reason != null)
                            message.reason = String(object.reason);
                        if (object.hasPendingOperations != null)
                            message.hasPendingOperations = Boolean(object.hasPendingOperations);
                        if (object.pendingAvailableDelta != null)
                            message.pendingAvailableDelta = Number(object.pendingAvailableDelta);
                        if (object.pendingReservedDelta != null)
                            message.pendingReservedDelta = Number(object.pendingReservedDelta);
                        if (object.walletOperationId != null)
                            message.walletOperationId = String(object.walletOperationId);
                        return message;
                    };

                    /**
                     * Creates a plain object from a WalletUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {com.achlid.crash.game.WalletUpdate} message WalletUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WalletUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.balance = 0;
                            object.reserved = 0;
                            object.reason = "";
                            object.hasPendingOperations = false;
                            object.pendingAvailableDelta = 0;
                            object.pendingReservedDelta = 0;
                            object.walletOperationId = "";
                        }
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            object.reason = message.reason;
                        if (message.hasPendingOperations != null && message.hasOwnProperty("hasPendingOperations"))
                            object.hasPendingOperations = message.hasPendingOperations;
                        if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                            object.pendingAvailableDelta = options.json && !isFinite(message.pendingAvailableDelta) ? String(message.pendingAvailableDelta) : message.pendingAvailableDelta;
                        if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                            object.pendingReservedDelta = options.json && !isFinite(message.pendingReservedDelta) ? String(message.pendingReservedDelta) : message.pendingReservedDelta;
                        if (message.walletOperationId != null && message.hasOwnProperty("walletOperationId"))
                            object.walletOperationId = message.walletOperationId;
                        return object;
                    };

                    /**
                     * Converts this WalletUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WalletUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for WalletUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.WalletUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    WalletUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.WalletUpdate";
                    };

                    return WalletUpdate;
                })();

                game.ChatCapabilities = (function() {

                    /**
                     * Properties of a ChatCapabilities.
                     * @memberof com.achlid.crash.game
                     * @interface IChatCapabilities
                     * @property {com.achlid.crash.game.ChatCapabilities.Mode|null} [mode] ChatCapabilities mode
                     */

                    /**
                     * Constructs a new ChatCapabilities.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a ChatCapabilities.
                     * @implements IChatCapabilities
                     * @constructor
                     * @param {com.achlid.crash.game.IChatCapabilities=} [properties] Properties to set
                     */
                    function ChatCapabilities(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ChatCapabilities mode.
                     * @member {com.achlid.crash.game.ChatCapabilities.Mode} mode
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @instance
                     */
                    ChatCapabilities.prototype.mode = 0;

                    /**
                     * Creates a new ChatCapabilities instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {com.achlid.crash.game.IChatCapabilities=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.ChatCapabilities} ChatCapabilities instance
                     */
                    ChatCapabilities.create = function create(properties) {
                        return new ChatCapabilities(properties);
                    };

                    /**
                     * Encodes the specified ChatCapabilities message. Does not implicitly {@link com.achlid.crash.game.ChatCapabilities.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {com.achlid.crash.game.IChatCapabilities} message ChatCapabilities message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChatCapabilities.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
                        return writer;
                    };

                    /**
                     * Encodes the specified ChatCapabilities message, length delimited. Does not implicitly {@link com.achlid.crash.game.ChatCapabilities.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {com.achlid.crash.game.IChatCapabilities} message ChatCapabilities message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChatCapabilities.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ChatCapabilities message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.ChatCapabilities} ChatCapabilities
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChatCapabilities.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.ChatCapabilities();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.mode = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ChatCapabilities message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.ChatCapabilities} ChatCapabilities
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChatCapabilities.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ChatCapabilities message.
                     * @function verify
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ChatCapabilities.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            switch (message.mode) {
                            default:
                                return "mode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };

                    /**
                     * Creates a ChatCapabilities message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.ChatCapabilities} ChatCapabilities
                     */
                    ChatCapabilities.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.ChatCapabilities)
                            return object;
                        let message = new $root.com.achlid.crash.game.ChatCapabilities();
                        switch (object.mode) {
                        default:
                            if (typeof object.mode === "number") {
                                message.mode = object.mode;
                                break;
                            }
                            break;
                        case "CHAT_MODE_NONE":
                        case 0:
                            message.mode = 0;
                            break;
                        case "CHAT_MODE_PUBLIC":
                        case 1:
                            message.mode = 1;
                            break;
                        case "CHAT_MODE_VIEWER_AWARE":
                        case 2:
                            message.mode = 2;
                            break;
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ChatCapabilities message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {com.achlid.crash.game.ChatCapabilities} message ChatCapabilities
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ChatCapabilities.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.mode = options.enums === String ? "CHAT_MODE_NONE" : 0;
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            object.mode = options.enums === String ? $root.com.achlid.crash.game.ChatCapabilities.Mode[message.mode] === undefined ? message.mode : $root.com.achlid.crash.game.ChatCapabilities.Mode[message.mode] : message.mode;
                        return object;
                    };

                    /**
                     * Converts this ChatCapabilities to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ChatCapabilities.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ChatCapabilities
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.ChatCapabilities
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ChatCapabilities.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.ChatCapabilities";
                    };

                    /**
                     * Mode enum.
                     * @name com.achlid.crash.game.ChatCapabilities.Mode
                     * @enum {number}
                     * @property {number} CHAT_MODE_NONE=0 CHAT_MODE_NONE value
                     * @property {number} CHAT_MODE_PUBLIC=1 CHAT_MODE_PUBLIC value
                     * @property {number} CHAT_MODE_VIEWER_AWARE=2 CHAT_MODE_VIEWER_AWARE value
                     */
                    ChatCapabilities.Mode = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "CHAT_MODE_NONE"] = 0;
                        values[valuesById[1] = "CHAT_MODE_PUBLIC"] = 1;
                        values[valuesById[2] = "CHAT_MODE_VIEWER_AWARE"] = 2;
                        return values;
                    })();

                    return ChatCapabilities;
                })();

                game.ConnectedResponse = (function() {

                    /**
                     * Properties of a ConnectedResponse.
                     * @memberof com.achlid.crash.game
                     * @interface IConnectedResponse
                     * @property {number|Long|null} [userId] ConnectedResponse userId
                     * @property {number|Long|null} [roomId] ConnectedResponse roomId
                     * @property {string|null} [sessionId] ConnectedResponse sessionId
                     * @property {com.achlid.crash.game.IGameConfig|null} [config] ConnectedResponse config
                     * @property {com.achlid.crash.game.IChatCapabilities|null} [chatCapabilities] ConnectedResponse chatCapabilities
                     */

                    /**
                     * Constructs a new ConnectedResponse.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a ConnectedResponse.
                     * @implements IConnectedResponse
                     * @constructor
                     * @param {com.achlid.crash.game.IConnectedResponse=} [properties] Properties to set
                     */
                    function ConnectedResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ConnectedResponse userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     */
                    ConnectedResponse.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ConnectedResponse roomId.
                     * @member {number|Long} roomId
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     */
                    ConnectedResponse.prototype.roomId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ConnectedResponse sessionId.
                     * @member {string} sessionId
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     */
                    ConnectedResponse.prototype.sessionId = "";

                    /**
                     * ConnectedResponse config.
                     * @member {com.achlid.crash.game.IGameConfig|null|undefined} config
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     */
                    ConnectedResponse.prototype.config = null;

                    /**
                     * ConnectedResponse chatCapabilities.
                     * @member {com.achlid.crash.game.IChatCapabilities|null|undefined} chatCapabilities
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     */
                    ConnectedResponse.prototype.chatCapabilities = null;

                    /**
                     * Creates a new ConnectedResponse instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {com.achlid.crash.game.IConnectedResponse=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.ConnectedResponse} ConnectedResponse instance
                     */
                    ConnectedResponse.create = function create(properties) {
                        return new ConnectedResponse(properties);
                    };

                    /**
                     * Encodes the specified ConnectedResponse message. Does not implicitly {@link com.achlid.crash.game.ConnectedResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {com.achlid.crash.game.IConnectedResponse} message ConnectedResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConnectedResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                        if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roomId);
                        if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.sessionId);
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.com.achlid.crash.game.GameConfig.encode(message.config, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.chatCapabilities != null && Object.hasOwnProperty.call(message, "chatCapabilities"))
                            $root.com.achlid.crash.game.ChatCapabilities.encode(message.chatCapabilities, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified ConnectedResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.ConnectedResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {com.achlid.crash.game.IConnectedResponse} message ConnectedResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConnectedResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ConnectedResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.ConnectedResponse} ConnectedResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConnectedResponse.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.ConnectedResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.roomId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.sessionId = reader.string();
                                    break;
                                }
                            case 4: {
                                    message.config = $root.com.achlid.crash.game.GameConfig.decode(reader, reader.uint32());
                                    break;
                                }
                            case 5: {
                                    message.chatCapabilities = $root.com.achlid.crash.game.ChatCapabilities.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ConnectedResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.ConnectedResponse} ConnectedResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConnectedResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ConnectedResponse message.
                     * @function verify
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ConnectedResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.roomId != null && message.hasOwnProperty("roomId"))
                            if (!$util.isInteger(message.roomId) && !(message.roomId && $util.isInteger(message.roomId.low) && $util.isInteger(message.roomId.high)))
                                return "roomId: integer|Long expected";
                        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                            if (!$util.isString(message.sessionId))
                                return "sessionId: string expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            let error = $root.com.achlid.crash.game.GameConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.chatCapabilities != null && message.hasOwnProperty("chatCapabilities")) {
                            let error = $root.com.achlid.crash.game.ChatCapabilities.verify(message.chatCapabilities);
                            if (error)
                                return "chatCapabilities." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a ConnectedResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.ConnectedResponse} ConnectedResponse
                     */
                    ConnectedResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.ConnectedResponse)
                            return object;
                        let message = new $root.com.achlid.crash.game.ConnectedResponse();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.roomId != null)
                            if ($util.Long)
                                (message.roomId = $util.Long.fromValue(object.roomId)).unsigned = false;
                            else if (typeof object.roomId === "string")
                                message.roomId = parseInt(object.roomId, 10);
                            else if (typeof object.roomId === "number")
                                message.roomId = object.roomId;
                            else if (typeof object.roomId === "object")
                                message.roomId = new $util.LongBits(object.roomId.low >>> 0, object.roomId.high >>> 0).toNumber();
                        if (object.sessionId != null)
                            message.sessionId = String(object.sessionId);
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".com.achlid.crash.game.ConnectedResponse.config: object expected");
                            message.config = $root.com.achlid.crash.game.GameConfig.fromObject(object.config);
                        }
                        if (object.chatCapabilities != null) {
                            if (typeof object.chatCapabilities !== "object")
                                throw TypeError(".com.achlid.crash.game.ConnectedResponse.chatCapabilities: object expected");
                            message.chatCapabilities = $root.com.achlid.crash.game.ChatCapabilities.fromObject(object.chatCapabilities);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a ConnectedResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {com.achlid.crash.game.ConnectedResponse} message ConnectedResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ConnectedResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roomId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roomId = options.longs === String ? "0" : 0;
                            object.sessionId = "";
                            object.config = null;
                            object.chatCapabilities = null;
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.roomId != null && message.hasOwnProperty("roomId"))
                            if (typeof message.roomId === "number")
                                object.roomId = options.longs === String ? String(message.roomId) : message.roomId;
                            else
                                object.roomId = options.longs === String ? $util.Long.prototype.toString.call(message.roomId) : options.longs === Number ? new $util.LongBits(message.roomId.low >>> 0, message.roomId.high >>> 0).toNumber() : message.roomId;
                        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
                            object.sessionId = message.sessionId;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.com.achlid.crash.game.GameConfig.toObject(message.config, options);
                        if (message.chatCapabilities != null && message.hasOwnProperty("chatCapabilities"))
                            object.chatCapabilities = $root.com.achlid.crash.game.ChatCapabilities.toObject(message.chatCapabilities, options);
                        return object;
                    };

                    /**
                     * Converts this ConnectedResponse to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ConnectedResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ConnectedResponse
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.ConnectedResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ConnectedResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.ConnectedResponse";
                    };

                    return ConnectedResponse;
                })();

                game.BetResult = (function() {

                    /**
                     * Properties of a BetResult.
                     * @memberof com.achlid.crash.game
                     * @interface IBetResult
                     * @property {boolean|null} [success] BetResult success
                     * @property {number|null} [slotId] BetResult slotId
                     * @property {number|null} [amount] BetResult amount
                     * @property {number|Long|null} [roundId] BetResult roundId
                     * @property {string|null} [errorMessage] BetResult errorMessage
                     * @property {number|null} [balance] BetResult balance
                     * @property {number|null} [reserved] BetResult reserved
                     * @property {boolean|null} [isFreebet] BetResult isFreebet
                     */

                    /**
                     * Constructs a new BetResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a BetResult.
                     * @implements IBetResult
                     * @constructor
                     * @param {com.achlid.crash.game.IBetResult=} [properties] Properties to set
                     */
                    function BetResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BetResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.success = false;

                    /**
                     * BetResult slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.slotId = 0;

                    /**
                     * BetResult amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.amount = 0;

                    /**
                     * BetResult roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * BetResult errorMessage.
                     * @member {string} errorMessage
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.errorMessage = "";

                    /**
                     * BetResult balance.
                     * @member {number} balance
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.balance = 0;

                    /**
                     * BetResult reserved.
                     * @member {number} reserved
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.reserved = 0;

                    /**
                     * BetResult isFreebet.
                     * @member {boolean} isFreebet
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     */
                    BetResult.prototype.isFreebet = false;

                    /**
                     * Creates a new BetResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {com.achlid.crash.game.IBetResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.BetResult} BetResult instance
                     */
                    BetResult.create = function create(properties) {
                        return new BetResult(properties);
                    };

                    /**
                     * Encodes the specified BetResult message. Does not implicitly {@link com.achlid.crash.game.BetResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {com.achlid.crash.game.IBetResult} message BetResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BetResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.amount);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.roundId);
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.errorMessage);
                        if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.balance);
                        if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.reserved);
                        if (message.isFreebet != null && Object.hasOwnProperty.call(message, "isFreebet"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isFreebet);
                        return writer;
                    };

                    /**
                     * Encodes the specified BetResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.BetResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {com.achlid.crash.game.IBetResult} message BetResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BetResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BetResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.BetResult} BetResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BetResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.BetResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.errorMessage = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.balance = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.reserved = reader.double();
                                    break;
                                }
                            case 8: {
                                    message.isFreebet = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BetResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.BetResult} BetResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BetResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BetResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BetResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            if (typeof message.balance !== "number")
                                return "balance: number expected";
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            if (typeof message.reserved !== "number")
                                return "reserved: number expected";
                        if (message.isFreebet != null && message.hasOwnProperty("isFreebet"))
                            if (typeof message.isFreebet !== "boolean")
                                return "isFreebet: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a BetResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.BetResult} BetResult
                     */
                    BetResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.BetResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.BetResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        if (object.balance != null)
                            message.balance = Number(object.balance);
                        if (object.reserved != null)
                            message.reserved = Number(object.reserved);
                        if (object.isFreebet != null)
                            message.isFreebet = Boolean(object.isFreebet);
                        return message;
                    };

                    /**
                     * Creates a plain object from a BetResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {com.achlid.crash.game.BetResult} message BetResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BetResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.slotId = 0;
                            object.amount = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.errorMessage = "";
                            object.balance = 0;
                            object.reserved = 0;
                            object.isFreebet = false;
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                        if (message.isFreebet != null && message.hasOwnProperty("isFreebet"))
                            object.isFreebet = message.isFreebet;
                        return object;
                    };

                    /**
                     * Converts this BetResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.BetResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BetResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BetResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.BetResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BetResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.BetResult";
                    };

                    return BetResult;
                })();

                game.CashOutResult = (function() {

                    /**
                     * Properties of a CashOutResult.
                     * @memberof com.achlid.crash.game
                     * @interface ICashOutResult
                     * @property {boolean|null} [success] CashOutResult success
                     * @property {number|null} [slotId] CashOutResult slotId
                     * @property {number|null} [multiplier] CashOutResult multiplier
                     * @property {number|null} [payout] CashOutResult payout
                     * @property {number|Long|null} [roundId] CashOutResult roundId
                     * @property {string|null} [errorMessage] CashOutResult errorMessage
                     * @property {number|null} [balance] CashOutResult balance
                     * @property {number|null} [reserved] CashOutResult reserved
                     * @property {boolean|null} [isFreebet] CashOutResult isFreebet
                     * @property {boolean|null} [walletPending] CashOutResult walletPending
                     * @property {string|null} [walletOperationId] CashOutResult walletOperationId
                     * @property {number|null} [pendingAvailableDelta] CashOutResult pendingAvailableDelta
                     * @property {number|null} [pendingReservedDelta] CashOutResult pendingReservedDelta
                     */

                    /**
                     * Constructs a new CashOutResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CashOutResult.
                     * @implements ICashOutResult
                     * @constructor
                     * @param {com.achlid.crash.game.ICashOutResult=} [properties] Properties to set
                     */
                    function CashOutResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CashOutResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.success = false;

                    /**
                     * CashOutResult slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.slotId = 0;

                    /**
                     * CashOutResult multiplier.
                     * @member {number} multiplier
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.multiplier = 0;

                    /**
                     * CashOutResult payout.
                     * @member {number} payout
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.payout = 0;

                    /**
                     * CashOutResult roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CashOutResult errorMessage.
                     * @member {string} errorMessage
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.errorMessage = "";

                    /**
                     * CashOutResult balance.
                     * @member {number} balance
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.balance = 0;

                    /**
                     * CashOutResult reserved.
                     * @member {number} reserved
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.reserved = 0;

                    /**
                     * CashOutResult isFreebet.
                     * @member {boolean} isFreebet
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.isFreebet = false;

                    /**
                     * CashOutResult walletPending.
                     * @member {boolean} walletPending
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.walletPending = false;

                    /**
                     * CashOutResult walletOperationId.
                     * @member {string} walletOperationId
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.walletOperationId = "";

                    /**
                     * CashOutResult pendingAvailableDelta.
                     * @member {number} pendingAvailableDelta
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.pendingAvailableDelta = 0;

                    /**
                     * CashOutResult pendingReservedDelta.
                     * @member {number} pendingReservedDelta
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     */
                    CashOutResult.prototype.pendingReservedDelta = 0;

                    /**
                     * Creates a new CashOutResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ICashOutResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CashOutResult} CashOutResult instance
                     */
                    CashOutResult.create = function create(properties) {
                        return new CashOutResult(properties);
                    };

                    /**
                     * Encodes the specified CashOutResult message. Does not implicitly {@link com.achlid.crash.game.CashOutResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ICashOutResult} message CashOutResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.multiplier);
                        if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.payout);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.roundId);
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.errorMessage);
                        if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.balance);
                        if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                            writer.uint32(/* id 8, wireType 1 =*/65).double(message.reserved);
                        if (message.isFreebet != null && Object.hasOwnProperty.call(message, "isFreebet"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isFreebet);
                        if (message.walletPending != null && Object.hasOwnProperty.call(message, "walletPending"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.walletPending);
                        if (message.walletOperationId != null && Object.hasOwnProperty.call(message, "walletOperationId"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.walletOperationId);
                        if (message.pendingAvailableDelta != null && Object.hasOwnProperty.call(message, "pendingAvailableDelta"))
                            writer.uint32(/* id 12, wireType 1 =*/97).double(message.pendingAvailableDelta);
                        if (message.pendingReservedDelta != null && Object.hasOwnProperty.call(message, "pendingReservedDelta"))
                            writer.uint32(/* id 13, wireType 1 =*/105).double(message.pendingReservedDelta);
                        return writer;
                    };

                    /**
                     * Encodes the specified CashOutResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.CashOutResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ICashOutResult} message CashOutResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CashOutResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CashOutResult} CashOutResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CashOutResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.multiplier = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.payout = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 6: {
                                    message.errorMessage = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.balance = reader.double();
                                    break;
                                }
                            case 8: {
                                    message.reserved = reader.double();
                                    break;
                                }
                            case 9: {
                                    message.isFreebet = reader.bool();
                                    break;
                                }
                            case 10: {
                                    message.walletPending = reader.bool();
                                    break;
                                }
                            case 11: {
                                    message.walletOperationId = reader.string();
                                    break;
                                }
                            case 12: {
                                    message.pendingAvailableDelta = reader.double();
                                    break;
                                }
                            case 13: {
                                    message.pendingReservedDelta = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CashOutResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CashOutResult} CashOutResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CashOutResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CashOutResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        if (message.payout != null && message.hasOwnProperty("payout"))
                            if (typeof message.payout !== "number")
                                return "payout: number expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            if (typeof message.balance !== "number")
                                return "balance: number expected";
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            if (typeof message.reserved !== "number")
                                return "reserved: number expected";
                        if (message.isFreebet != null && message.hasOwnProperty("isFreebet"))
                            if (typeof message.isFreebet !== "boolean")
                                return "isFreebet: boolean expected";
                        if (message.walletPending != null && message.hasOwnProperty("walletPending"))
                            if (typeof message.walletPending !== "boolean")
                                return "walletPending: boolean expected";
                        if (message.walletOperationId != null && message.hasOwnProperty("walletOperationId"))
                            if (!$util.isString(message.walletOperationId))
                                return "walletOperationId: string expected";
                        if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                            if (typeof message.pendingAvailableDelta !== "number")
                                return "pendingAvailableDelta: number expected";
                        if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                            if (typeof message.pendingReservedDelta !== "number")
                                return "pendingReservedDelta: number expected";
                        return null;
                    };

                    /**
                     * Creates a CashOutResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CashOutResult} CashOutResult
                     */
                    CashOutResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CashOutResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.CashOutResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.payout != null)
                            message.payout = Number(object.payout);
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        if (object.balance != null)
                            message.balance = Number(object.balance);
                        if (object.reserved != null)
                            message.reserved = Number(object.reserved);
                        if (object.isFreebet != null)
                            message.isFreebet = Boolean(object.isFreebet);
                        if (object.walletPending != null)
                            message.walletPending = Boolean(object.walletPending);
                        if (object.walletOperationId != null)
                            message.walletOperationId = String(object.walletOperationId);
                        if (object.pendingAvailableDelta != null)
                            message.pendingAvailableDelta = Number(object.pendingAvailableDelta);
                        if (object.pendingReservedDelta != null)
                            message.pendingReservedDelta = Number(object.pendingReservedDelta);
                        return message;
                    };

                    /**
                     * Creates a plain object from a CashOutResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {com.achlid.crash.game.CashOutResult} message CashOutResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CashOutResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.slotId = 0;
                            object.multiplier = 0;
                            object.payout = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.errorMessage = "";
                            object.balance = 0;
                            object.reserved = 0;
                            object.isFreebet = false;
                            object.walletPending = false;
                            object.walletOperationId = "";
                            object.pendingAvailableDelta = 0;
                            object.pendingReservedDelta = 0;
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                        if (message.payout != null && message.hasOwnProperty("payout"))
                            object.payout = options.json && !isFinite(message.payout) ? String(message.payout) : message.payout;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                        if (message.isFreebet != null && message.hasOwnProperty("isFreebet"))
                            object.isFreebet = message.isFreebet;
                        if (message.walletPending != null && message.hasOwnProperty("walletPending"))
                            object.walletPending = message.walletPending;
                        if (message.walletOperationId != null && message.hasOwnProperty("walletOperationId"))
                            object.walletOperationId = message.walletOperationId;
                        if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                            object.pendingAvailableDelta = options.json && !isFinite(message.pendingAvailableDelta) ? String(message.pendingAvailableDelta) : message.pendingAvailableDelta;
                        if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                            object.pendingReservedDelta = options.json && !isFinite(message.pendingReservedDelta) ? String(message.pendingReservedDelta) : message.pendingReservedDelta;
                        return object;
                    };

                    /**
                     * Converts this CashOutResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CashOutResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CashOutResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CashOutResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CashOutResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CashOutResult";
                    };

                    return CashOutResult;
                })();

                game.CancelBetResult = (function() {

                    /**
                     * Properties of a CancelBetResult.
                     * @memberof com.achlid.crash.game
                     * @interface ICancelBetResult
                     * @property {boolean|null} [success] CancelBetResult success
                     * @property {number|null} [slotId] CancelBetResult slotId
                     * @property {number|null} [refundAmount] CancelBetResult refundAmount
                     * @property {string|null} [errorMessage] CancelBetResult errorMessage
                     * @property {number|null} [balance] CancelBetResult balance
                     * @property {number|null} [reserved] CancelBetResult reserved
                     */

                    /**
                     * Constructs a new CancelBetResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CancelBetResult.
                     * @implements ICancelBetResult
                     * @constructor
                     * @param {com.achlid.crash.game.ICancelBetResult=} [properties] Properties to set
                     */
                    function CancelBetResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CancelBetResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.success = false;

                    /**
                     * CancelBetResult slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.slotId = 0;

                    /**
                     * CancelBetResult refundAmount.
                     * @member {number} refundAmount
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.refundAmount = 0;

                    /**
                     * CancelBetResult errorMessage.
                     * @member {string} errorMessage
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.errorMessage = "";

                    /**
                     * CancelBetResult balance.
                     * @member {number} balance
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.balance = 0;

                    /**
                     * CancelBetResult reserved.
                     * @member {number} reserved
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     */
                    CancelBetResult.prototype.reserved = 0;

                    /**
                     * Creates a new CancelBetResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CancelBetResult} CancelBetResult instance
                     */
                    CancelBetResult.create = function create(properties) {
                        return new CancelBetResult(properties);
                    };

                    /**
                     * Encodes the specified CancelBetResult message. Does not implicitly {@link com.achlid.crash.game.CancelBetResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetResult} message CancelBetResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.refundAmount != null && Object.hasOwnProperty.call(message, "refundAmount"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.refundAmount);
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.errorMessage);
                        if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.balance);
                        if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.reserved);
                        return writer;
                    };

                    /**
                     * Encodes the specified CancelBetResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.CancelBetResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetResult} message CancelBetResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CancelBetResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CancelBetResult} CancelBetResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CancelBetResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.refundAmount = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.errorMessage = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.balance = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.reserved = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CancelBetResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CancelBetResult} CancelBetResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CancelBetResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CancelBetResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.refundAmount != null && message.hasOwnProperty("refundAmount"))
                            if (typeof message.refundAmount !== "number")
                                return "refundAmount: number expected";
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            if (typeof message.balance !== "number")
                                return "balance: number expected";
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            if (typeof message.reserved !== "number")
                                return "reserved: number expected";
                        return null;
                    };

                    /**
                     * Creates a CancelBetResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CancelBetResult} CancelBetResult
                     */
                    CancelBetResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CancelBetResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.CancelBetResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.refundAmount != null)
                            message.refundAmount = Number(object.refundAmount);
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        if (object.balance != null)
                            message.balance = Number(object.balance);
                        if (object.reserved != null)
                            message.reserved = Number(object.reserved);
                        return message;
                    };

                    /**
                     * Creates a plain object from a CancelBetResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {com.achlid.crash.game.CancelBetResult} message CancelBetResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CancelBetResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.slotId = 0;
                            object.refundAmount = 0;
                            object.errorMessage = "";
                            object.balance = 0;
                            object.reserved = 0;
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.refundAmount != null && message.hasOwnProperty("refundAmount"))
                            object.refundAmount = options.json && !isFinite(message.refundAmount) ? String(message.refundAmount) : message.refundAmount;
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        if (message.balance != null && message.hasOwnProperty("balance"))
                            object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                        if (message.reserved != null && message.hasOwnProperty("reserved"))
                            object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                        return object;
                    };

                    /**
                     * Converts this CancelBetResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CancelBetResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CancelBetResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CancelBetResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CancelBetResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CancelBetResult";
                    };

                    return CancelBetResult;
                })();

                game.AutoPlayResult = (function() {

                    /**
                     * Properties of an AutoPlayResult.
                     * @memberof com.achlid.crash.game
                     * @interface IAutoPlayResult
                     * @property {boolean|null} [success] AutoPlayResult success
                     * @property {number|null} [slotId] AutoPlayResult slotId
                     * @property {number|null} [roundsPlayed] AutoPlayResult roundsPlayed
                     * @property {number|null} [totalWagered] AutoPlayResult totalWagered
                     * @property {number|null} [totalWon] AutoPlayResult totalWon
                     * @property {string|null} [stopReason] AutoPlayResult stopReason
                     */

                    /**
                     * Constructs a new AutoPlayResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents an AutoPlayResult.
                     * @implements IAutoPlayResult
                     * @constructor
                     * @param {com.achlid.crash.game.IAutoPlayResult=} [properties] Properties to set
                     */
                    function AutoPlayResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * AutoPlayResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.success = false;

                    /**
                     * AutoPlayResult slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.slotId = 0;

                    /**
                     * AutoPlayResult roundsPlayed.
                     * @member {number} roundsPlayed
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.roundsPlayed = 0;

                    /**
                     * AutoPlayResult totalWagered.
                     * @member {number} totalWagered
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.totalWagered = 0;

                    /**
                     * AutoPlayResult totalWon.
                     * @member {number} totalWon
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.totalWon = 0;

                    /**
                     * AutoPlayResult stopReason.
                     * @member {string} stopReason
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     */
                    AutoPlayResult.prototype.stopReason = "";

                    /**
                     * Creates a new AutoPlayResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.AutoPlayResult} AutoPlayResult instance
                     */
                    AutoPlayResult.create = function create(properties) {
                        return new AutoPlayResult(properties);
                    };

                    /**
                     * Encodes the specified AutoPlayResult message. Does not implicitly {@link com.achlid.crash.game.AutoPlayResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayResult} message AutoPlayResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.roundsPlayed != null && Object.hasOwnProperty.call(message, "roundsPlayed"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.roundsPlayed);
                        if (message.totalWagered != null && Object.hasOwnProperty.call(message, "totalWagered"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.totalWagered);
                        if (message.totalWon != null && Object.hasOwnProperty.call(message, "totalWon"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalWon);
                        if (message.stopReason != null && Object.hasOwnProperty.call(message, "stopReason"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.stopReason);
                        return writer;
                    };

                    /**
                     * Encodes the specified AutoPlayResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.AutoPlayResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {com.achlid.crash.game.IAutoPlayResult} message AutoPlayResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoPlayResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an AutoPlayResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.AutoPlayResult} AutoPlayResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.AutoPlayResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.roundsPlayed = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.totalWagered = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.totalWon = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.stopReason = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an AutoPlayResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.AutoPlayResult} AutoPlayResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoPlayResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an AutoPlayResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AutoPlayResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundsPlayed != null && message.hasOwnProperty("roundsPlayed"))
                            if (!$util.isInteger(message.roundsPlayed))
                                return "roundsPlayed: integer expected";
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            if (typeof message.totalWagered !== "number")
                                return "totalWagered: number expected";
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            if (typeof message.totalWon !== "number")
                                return "totalWon: number expected";
                        if (message.stopReason != null && message.hasOwnProperty("stopReason"))
                            if (!$util.isString(message.stopReason))
                                return "stopReason: string expected";
                        return null;
                    };

                    /**
                     * Creates an AutoPlayResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.AutoPlayResult} AutoPlayResult
                     */
                    AutoPlayResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.AutoPlayResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.AutoPlayResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundsPlayed != null)
                            message.roundsPlayed = object.roundsPlayed | 0;
                        if (object.totalWagered != null)
                            message.totalWagered = Number(object.totalWagered);
                        if (object.totalWon != null)
                            message.totalWon = Number(object.totalWon);
                        if (object.stopReason != null)
                            message.stopReason = String(object.stopReason);
                        return message;
                    };

                    /**
                     * Creates a plain object from an AutoPlayResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {com.achlid.crash.game.AutoPlayResult} message AutoPlayResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AutoPlayResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.slotId = 0;
                            object.roundsPlayed = 0;
                            object.totalWagered = 0;
                            object.totalWon = 0;
                            object.stopReason = "";
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundsPlayed != null && message.hasOwnProperty("roundsPlayed"))
                            object.roundsPlayed = message.roundsPlayed;
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            object.totalWagered = options.json && !isFinite(message.totalWagered) ? String(message.totalWagered) : message.totalWagered;
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            object.totalWon = options.json && !isFinite(message.totalWon) ? String(message.totalWon) : message.totalWon;
                        if (message.stopReason != null && message.hasOwnProperty("stopReason"))
                            object.stopReason = message.stopReason;
                        return object;
                    };

                    /**
                     * Converts this AutoPlayResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AutoPlayResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for AutoPlayResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.AutoPlayResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    AutoPlayResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.AutoPlayResult";
                    };

                    return AutoPlayResult;
                })();

                game.FreebetGrantedNotification = (function() {

                    /**
                     * Properties of a FreebetGrantedNotification.
                     * @memberof com.achlid.crash.game
                     * @interface IFreebetGrantedNotification
                     * @property {string|null} [freebetId] FreebetGrantedNotification freebetId
                     * @property {number|null} [amount] FreebetGrantedNotification amount
                     * @property {number|Long|null} [expiresAt] FreebetGrantedNotification expiresAt
                     * @property {string|null} [reason] FreebetGrantedNotification reason
                     * @property {number|null} [targetSlotId] FreebetGrantedNotification targetSlotId
                     */

                    /**
                     * Constructs a new FreebetGrantedNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a FreebetGrantedNotification.
                     * @implements IFreebetGrantedNotification
                     * @constructor
                     * @param {com.achlid.crash.game.IFreebetGrantedNotification=} [properties] Properties to set
                     */
                    function FreebetGrantedNotification(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FreebetGrantedNotification freebetId.
                     * @member {string} freebetId
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     */
                    FreebetGrantedNotification.prototype.freebetId = "";

                    /**
                     * FreebetGrantedNotification amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     */
                    FreebetGrantedNotification.prototype.amount = 0;

                    /**
                     * FreebetGrantedNotification expiresAt.
                     * @member {number|Long} expiresAt
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     */
                    FreebetGrantedNotification.prototype.expiresAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * FreebetGrantedNotification reason.
                     * @member {string} reason
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     */
                    FreebetGrantedNotification.prototype.reason = "";

                    /**
                     * FreebetGrantedNotification targetSlotId.
                     * @member {number} targetSlotId
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     */
                    FreebetGrantedNotification.prototype.targetSlotId = 0;

                    /**
                     * Creates a new FreebetGrantedNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {com.achlid.crash.game.IFreebetGrantedNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.FreebetGrantedNotification} FreebetGrantedNotification instance
                     */
                    FreebetGrantedNotification.create = function create(properties) {
                        return new FreebetGrantedNotification(properties);
                    };

                    /**
                     * Encodes the specified FreebetGrantedNotification message. Does not implicitly {@link com.achlid.crash.game.FreebetGrantedNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {com.achlid.crash.game.IFreebetGrantedNotification} message FreebetGrantedNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetGrantedNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.freebetId != null && Object.hasOwnProperty.call(message, "freebetId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.freebetId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.amount);
                        if (message.expiresAt != null && Object.hasOwnProperty.call(message, "expiresAt"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.expiresAt);
                        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.reason);
                        if (message.targetSlotId != null && Object.hasOwnProperty.call(message, "targetSlotId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.targetSlotId);
                        return writer;
                    };

                    /**
                     * Encodes the specified FreebetGrantedNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.FreebetGrantedNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {com.achlid.crash.game.IFreebetGrantedNotification} message FreebetGrantedNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetGrantedNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FreebetGrantedNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.FreebetGrantedNotification} FreebetGrantedNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetGrantedNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.FreebetGrantedNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.freebetId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.expiresAt = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.reason = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.targetSlotId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FreebetGrantedNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.FreebetGrantedNotification} FreebetGrantedNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetGrantedNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FreebetGrantedNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FreebetGrantedNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.freebetId != null && message.hasOwnProperty("freebetId"))
                            if (!$util.isString(message.freebetId))
                                return "freebetId: string expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                            if (!$util.isInteger(message.expiresAt) && !(message.expiresAt && $util.isInteger(message.expiresAt.low) && $util.isInteger(message.expiresAt.high)))
                                return "expiresAt: integer|Long expected";
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            if (!$util.isString(message.reason))
                                return "reason: string expected";
                        if (message.targetSlotId != null && message.hasOwnProperty("targetSlotId"))
                            if (!$util.isInteger(message.targetSlotId))
                                return "targetSlotId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a FreebetGrantedNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.FreebetGrantedNotification} FreebetGrantedNotification
                     */
                    FreebetGrantedNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.FreebetGrantedNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.FreebetGrantedNotification();
                        if (object.freebetId != null)
                            message.freebetId = String(object.freebetId);
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.expiresAt != null)
                            if ($util.Long)
                                (message.expiresAt = $util.Long.fromValue(object.expiresAt)).unsigned = false;
                            else if (typeof object.expiresAt === "string")
                                message.expiresAt = parseInt(object.expiresAt, 10);
                            else if (typeof object.expiresAt === "number")
                                message.expiresAt = object.expiresAt;
                            else if (typeof object.expiresAt === "object")
                                message.expiresAt = new $util.LongBits(object.expiresAt.low >>> 0, object.expiresAt.high >>> 0).toNumber();
                        if (object.reason != null)
                            message.reason = String(object.reason);
                        if (object.targetSlotId != null)
                            message.targetSlotId = object.targetSlotId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a FreebetGrantedNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {com.achlid.crash.game.FreebetGrantedNotification} message FreebetGrantedNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FreebetGrantedNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.freebetId = "";
                            object.amount = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.expiresAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.expiresAt = options.longs === String ? "0" : 0;
                            object.reason = "";
                            object.targetSlotId = 0;
                        }
                        if (message.freebetId != null && message.hasOwnProperty("freebetId"))
                            object.freebetId = message.freebetId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                            if (typeof message.expiresAt === "number")
                                object.expiresAt = options.longs === String ? String(message.expiresAt) : message.expiresAt;
                            else
                                object.expiresAt = options.longs === String ? $util.Long.prototype.toString.call(message.expiresAt) : options.longs === Number ? new $util.LongBits(message.expiresAt.low >>> 0, message.expiresAt.high >>> 0).toNumber() : message.expiresAt;
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            object.reason = message.reason;
                        if (message.targetSlotId != null && message.hasOwnProperty("targetSlotId"))
                            object.targetSlotId = message.targetSlotId;
                        return object;
                    };

                    /**
                     * Converts this FreebetGrantedNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FreebetGrantedNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FreebetGrantedNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.FreebetGrantedNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FreebetGrantedNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.FreebetGrantedNotification";
                    };

                    return FreebetGrantedNotification;
                })();

                game.FreebetProgressEligibility = (function() {

                    /**
                     * Properties of a FreebetProgressEligibility.
                     * @memberof com.achlid.crash.game
                     * @interface IFreebetProgressEligibility
                     * @property {number|Long|null} [roundId] FreebetProgressEligibility roundId
                     * @property {boolean|null} [slot1Eligible] FreebetProgressEligibility slot1Eligible
                     * @property {boolean|null} [slot2Eligible] FreebetProgressEligibility slot2Eligible
                     */

                    /**
                     * Constructs a new FreebetProgressEligibility.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a FreebetProgressEligibility.
                     * @implements IFreebetProgressEligibility
                     * @constructor
                     * @param {com.achlid.crash.game.IFreebetProgressEligibility=} [properties] Properties to set
                     */
                    function FreebetProgressEligibility(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FreebetProgressEligibility roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @instance
                     */
                    FreebetProgressEligibility.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * FreebetProgressEligibility slot1Eligible.
                     * @member {boolean} slot1Eligible
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @instance
                     */
                    FreebetProgressEligibility.prototype.slot1Eligible = false;

                    /**
                     * FreebetProgressEligibility slot2Eligible.
                     * @member {boolean} slot2Eligible
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @instance
                     */
                    FreebetProgressEligibility.prototype.slot2Eligible = false;

                    /**
                     * Creates a new FreebetProgressEligibility instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressEligibility=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.FreebetProgressEligibility} FreebetProgressEligibility instance
                     */
                    FreebetProgressEligibility.create = function create(properties) {
                        return new FreebetProgressEligibility(properties);
                    };

                    /**
                     * Encodes the specified FreebetProgressEligibility message. Does not implicitly {@link com.achlid.crash.game.FreebetProgressEligibility.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressEligibility} message FreebetProgressEligibility message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetProgressEligibility.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.slot1Eligible != null && Object.hasOwnProperty.call(message, "slot1Eligible"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.slot1Eligible);
                        if (message.slot2Eligible != null && Object.hasOwnProperty.call(message, "slot2Eligible"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.slot2Eligible);
                        return writer;
                    };

                    /**
                     * Encodes the specified FreebetProgressEligibility message, length delimited. Does not implicitly {@link com.achlid.crash.game.FreebetProgressEligibility.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressEligibility} message FreebetProgressEligibility message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetProgressEligibility.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FreebetProgressEligibility message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.FreebetProgressEligibility} FreebetProgressEligibility
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetProgressEligibility.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.FreebetProgressEligibility();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.slot1Eligible = reader.bool();
                                    break;
                                }
                            case 3: {
                                    message.slot2Eligible = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FreebetProgressEligibility message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.FreebetProgressEligibility} FreebetProgressEligibility
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetProgressEligibility.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FreebetProgressEligibility message.
                     * @function verify
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FreebetProgressEligibility.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.slot1Eligible != null && message.hasOwnProperty("slot1Eligible"))
                            if (typeof message.slot1Eligible !== "boolean")
                                return "slot1Eligible: boolean expected";
                        if (message.slot2Eligible != null && message.hasOwnProperty("slot2Eligible"))
                            if (typeof message.slot2Eligible !== "boolean")
                                return "slot2Eligible: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a FreebetProgressEligibility message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.FreebetProgressEligibility} FreebetProgressEligibility
                     */
                    FreebetProgressEligibility.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.FreebetProgressEligibility)
                            return object;
                        let message = new $root.com.achlid.crash.game.FreebetProgressEligibility();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.slot1Eligible != null)
                            message.slot1Eligible = Boolean(object.slot1Eligible);
                        if (object.slot2Eligible != null)
                            message.slot2Eligible = Boolean(object.slot2Eligible);
                        return message;
                    };

                    /**
                     * Creates a plain object from a FreebetProgressEligibility message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {com.achlid.crash.game.FreebetProgressEligibility} message FreebetProgressEligibility
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FreebetProgressEligibility.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.slot1Eligible = false;
                            object.slot2Eligible = false;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.slot1Eligible != null && message.hasOwnProperty("slot1Eligible"))
                            object.slot1Eligible = message.slot1Eligible;
                        if (message.slot2Eligible != null && message.hasOwnProperty("slot2Eligible"))
                            object.slot2Eligible = message.slot2Eligible;
                        return object;
                    };

                    /**
                     * Converts this FreebetProgressEligibility to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FreebetProgressEligibility.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FreebetProgressEligibility
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.FreebetProgressEligibility
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FreebetProgressEligibility.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.FreebetProgressEligibility";
                    };

                    return FreebetProgressEligibility;
                })();

                game.FreebetProgressUpdate = (function() {

                    /**
                     * Properties of a FreebetProgressUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface IFreebetProgressUpdate
                     * @property {number|Long|null} [roundId] FreebetProgressUpdate roundId
                     * @property {number|null} [slotId] FreebetProgressUpdate slotId
                     * @property {boolean|null} [hit] FreebetProgressUpdate hit
                     * @property {number|null} [currentProgress] FreebetProgressUpdate currentProgress
                     * @property {number|null} [requiredForFreebet] FreebetProgressUpdate requiredForFreebet
                     * @property {number|null} [trackedAmount] FreebetProgressUpdate trackedAmount
                     * @property {boolean|null} [freebetGranted] FreebetProgressUpdate freebetGranted
                     */

                    /**
                     * Constructs a new FreebetProgressUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a FreebetProgressUpdate.
                     * @implements IFreebetProgressUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.IFreebetProgressUpdate=} [properties] Properties to set
                     */
                    function FreebetProgressUpdate(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * FreebetProgressUpdate roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * FreebetProgressUpdate slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.slotId = 0;

                    /**
                     * FreebetProgressUpdate hit.
                     * @member {boolean} hit
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.hit = false;

                    /**
                     * FreebetProgressUpdate currentProgress.
                     * @member {number} currentProgress
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.currentProgress = 0;

                    /**
                     * FreebetProgressUpdate requiredForFreebet.
                     * @member {number} requiredForFreebet
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.requiredForFreebet = 0;

                    /**
                     * FreebetProgressUpdate trackedAmount.
                     * @member {number} trackedAmount
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.trackedAmount = 0;

                    /**
                     * FreebetProgressUpdate freebetGranted.
                     * @member {boolean} freebetGranted
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     */
                    FreebetProgressUpdate.prototype.freebetGranted = false;

                    /**
                     * Creates a new FreebetProgressUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.FreebetProgressUpdate} FreebetProgressUpdate instance
                     */
                    FreebetProgressUpdate.create = function create(properties) {
                        return new FreebetProgressUpdate(properties);
                    };

                    /**
                     * Encodes the specified FreebetProgressUpdate message. Does not implicitly {@link com.achlid.crash.game.FreebetProgressUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressUpdate} message FreebetProgressUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetProgressUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.hit != null && Object.hasOwnProperty.call(message, "hit"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hit);
                        if (message.currentProgress != null && Object.hasOwnProperty.call(message, "currentProgress"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.currentProgress);
                        if (message.requiredForFreebet != null && Object.hasOwnProperty.call(message, "requiredForFreebet"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.requiredForFreebet);
                        if (message.trackedAmount != null && Object.hasOwnProperty.call(message, "trackedAmount"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.trackedAmount);
                        if (message.freebetGranted != null && Object.hasOwnProperty.call(message, "freebetGranted"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.freebetGranted);
                        return writer;
                    };

                    /**
                     * Encodes the specified FreebetProgressUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.FreebetProgressUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {com.achlid.crash.game.IFreebetProgressUpdate} message FreebetProgressUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FreebetProgressUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a FreebetProgressUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.FreebetProgressUpdate} FreebetProgressUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetProgressUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.FreebetProgressUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.hit = reader.bool();
                                    break;
                                }
                            case 4: {
                                    message.currentProgress = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.requiredForFreebet = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.trackedAmount = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.freebetGranted = reader.bool();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a FreebetProgressUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.FreebetProgressUpdate} FreebetProgressUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FreebetProgressUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a FreebetProgressUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FreebetProgressUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.hit != null && message.hasOwnProperty("hit"))
                            if (typeof message.hit !== "boolean")
                                return "hit: boolean expected";
                        if (message.currentProgress != null && message.hasOwnProperty("currentProgress"))
                            if (!$util.isInteger(message.currentProgress))
                                return "currentProgress: integer expected";
                        if (message.requiredForFreebet != null && message.hasOwnProperty("requiredForFreebet"))
                            if (!$util.isInteger(message.requiredForFreebet))
                                return "requiredForFreebet: integer expected";
                        if (message.trackedAmount != null && message.hasOwnProperty("trackedAmount"))
                            if (typeof message.trackedAmount !== "number")
                                return "trackedAmount: number expected";
                        if (message.freebetGranted != null && message.hasOwnProperty("freebetGranted"))
                            if (typeof message.freebetGranted !== "boolean")
                                return "freebetGranted: boolean expected";
                        return null;
                    };

                    /**
                     * Creates a FreebetProgressUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.FreebetProgressUpdate} FreebetProgressUpdate
                     */
                    FreebetProgressUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.FreebetProgressUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.FreebetProgressUpdate();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.hit != null)
                            message.hit = Boolean(object.hit);
                        if (object.currentProgress != null)
                            message.currentProgress = object.currentProgress | 0;
                        if (object.requiredForFreebet != null)
                            message.requiredForFreebet = object.requiredForFreebet | 0;
                        if (object.trackedAmount != null)
                            message.trackedAmount = Number(object.trackedAmount);
                        if (object.freebetGranted != null)
                            message.freebetGranted = Boolean(object.freebetGranted);
                        return message;
                    };

                    /**
                     * Creates a plain object from a FreebetProgressUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {com.achlid.crash.game.FreebetProgressUpdate} message FreebetProgressUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FreebetProgressUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.slotId = 0;
                            object.hit = false;
                            object.currentProgress = 0;
                            object.requiredForFreebet = 0;
                            object.trackedAmount = 0;
                            object.freebetGranted = false;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.hit != null && message.hasOwnProperty("hit"))
                            object.hit = message.hit;
                        if (message.currentProgress != null && message.hasOwnProperty("currentProgress"))
                            object.currentProgress = message.currentProgress;
                        if (message.requiredForFreebet != null && message.hasOwnProperty("requiredForFreebet"))
                            object.requiredForFreebet = message.requiredForFreebet;
                        if (message.trackedAmount != null && message.hasOwnProperty("trackedAmount"))
                            object.trackedAmount = options.json && !isFinite(message.trackedAmount) ? String(message.trackedAmount) : message.trackedAmount;
                        if (message.freebetGranted != null && message.hasOwnProperty("freebetGranted"))
                            object.freebetGranted = message.freebetGranted;
                        return object;
                    };

                    /**
                     * Converts this FreebetProgressUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FreebetProgressUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for FreebetProgressUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.FreebetProgressUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    FreebetProgressUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.FreebetProgressUpdate";
                    };

                    return FreebetProgressUpdate;
                })();

                game.BatchNewBets = (function() {

                    /**
                     * Properties of a BatchNewBets.
                     * @memberof com.achlid.crash.game
                     * @interface IBatchNewBets
                     * @property {Array.<com.achlid.crash.game.INewBetNotification>|null} [bets] BatchNewBets bets
                     */

                    /**
                     * Constructs a new BatchNewBets.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a BatchNewBets.
                     * @implements IBatchNewBets
                     * @constructor
                     * @param {com.achlid.crash.game.IBatchNewBets=} [properties] Properties to set
                     */
                    function BatchNewBets(properties) {
                        this.bets = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BatchNewBets bets.
                     * @member {Array.<com.achlid.crash.game.INewBetNotification>} bets
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @instance
                     */
                    BatchNewBets.prototype.bets = $util.emptyArray;

                    /**
                     * Creates a new BatchNewBets instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchNewBets=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.BatchNewBets} BatchNewBets instance
                     */
                    BatchNewBets.create = function create(properties) {
                        return new BatchNewBets(properties);
                    };

                    /**
                     * Encodes the specified BatchNewBets message. Does not implicitly {@link com.achlid.crash.game.BatchNewBets.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchNewBets} message BatchNewBets message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchNewBets.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.bets != null && message.bets.length)
                            for (let i = 0; i < message.bets.length; ++i)
                                $root.com.achlid.crash.game.NewBetNotification.encode(message.bets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BatchNewBets message, length delimited. Does not implicitly {@link com.achlid.crash.game.BatchNewBets.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchNewBets} message BatchNewBets message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchNewBets.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BatchNewBets message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.BatchNewBets} BatchNewBets
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchNewBets.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.BatchNewBets();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.bets && message.bets.length))
                                        message.bets = [];
                                    message.bets.push($root.com.achlid.crash.game.NewBetNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BatchNewBets message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.BatchNewBets} BatchNewBets
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchNewBets.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BatchNewBets message.
                     * @function verify
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchNewBets.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.bets != null && message.hasOwnProperty("bets")) {
                            if (!Array.isArray(message.bets))
                                return "bets: array expected";
                            for (let i = 0; i < message.bets.length; ++i) {
                                let error = $root.com.achlid.crash.game.NewBetNotification.verify(message.bets[i]);
                                if (error)
                                    return "bets." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a BatchNewBets message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.BatchNewBets} BatchNewBets
                     */
                    BatchNewBets.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.BatchNewBets)
                            return object;
                        let message = new $root.com.achlid.crash.game.BatchNewBets();
                        if (object.bets) {
                            if (!Array.isArray(object.bets))
                                throw TypeError(".com.achlid.crash.game.BatchNewBets.bets: array expected");
                            message.bets = [];
                            for (let i = 0; i < object.bets.length; ++i) {
                                if (typeof object.bets[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.BatchNewBets.bets: object expected");
                                message.bets[i] = $root.com.achlid.crash.game.NewBetNotification.fromObject(object.bets[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BatchNewBets message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {com.achlid.crash.game.BatchNewBets} message BatchNewBets
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchNewBets.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.bets = [];
                        if (message.bets && message.bets.length) {
                            object.bets = [];
                            for (let j = 0; j < message.bets.length; ++j)
                                object.bets[j] = $root.com.achlid.crash.game.NewBetNotification.toObject(message.bets[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this BatchNewBets to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchNewBets.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BatchNewBets
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.BatchNewBets
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BatchNewBets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.BatchNewBets";
                    };

                    return BatchNewBets;
                })();

                game.BatchCancelBets = (function() {

                    /**
                     * Properties of a BatchCancelBets.
                     * @memberof com.achlid.crash.game
                     * @interface IBatchCancelBets
                     * @property {Array.<com.achlid.crash.game.ICancelBetNotification>|null} [cancels] BatchCancelBets cancels
                     */

                    /**
                     * Constructs a new BatchCancelBets.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a BatchCancelBets.
                     * @implements IBatchCancelBets
                     * @constructor
                     * @param {com.achlid.crash.game.IBatchCancelBets=} [properties] Properties to set
                     */
                    function BatchCancelBets(properties) {
                        this.cancels = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BatchCancelBets cancels.
                     * @member {Array.<com.achlid.crash.game.ICancelBetNotification>} cancels
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @instance
                     */
                    BatchCancelBets.prototype.cancels = $util.emptyArray;

                    /**
                     * Creates a new BatchCancelBets instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchCancelBets=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.BatchCancelBets} BatchCancelBets instance
                     */
                    BatchCancelBets.create = function create(properties) {
                        return new BatchCancelBets(properties);
                    };

                    /**
                     * Encodes the specified BatchCancelBets message. Does not implicitly {@link com.achlid.crash.game.BatchCancelBets.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchCancelBets} message BatchCancelBets message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCancelBets.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cancels != null && message.cancels.length)
                            for (let i = 0; i < message.cancels.length; ++i)
                                $root.com.achlid.crash.game.CancelBetNotification.encode(message.cancels[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BatchCancelBets message, length delimited. Does not implicitly {@link com.achlid.crash.game.BatchCancelBets.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {com.achlid.crash.game.IBatchCancelBets} message BatchCancelBets message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCancelBets.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BatchCancelBets message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.BatchCancelBets} BatchCancelBets
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCancelBets.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.BatchCancelBets();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.cancels && message.cancels.length))
                                        message.cancels = [];
                                    message.cancels.push($root.com.achlid.crash.game.CancelBetNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BatchCancelBets message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.BatchCancelBets} BatchCancelBets
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCancelBets.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BatchCancelBets message.
                     * @function verify
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCancelBets.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cancels != null && message.hasOwnProperty("cancels")) {
                            if (!Array.isArray(message.cancels))
                                return "cancels: array expected";
                            for (let i = 0; i < message.cancels.length; ++i) {
                                let error = $root.com.achlid.crash.game.CancelBetNotification.verify(message.cancels[i]);
                                if (error)
                                    return "cancels." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a BatchCancelBets message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.BatchCancelBets} BatchCancelBets
                     */
                    BatchCancelBets.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.BatchCancelBets)
                            return object;
                        let message = new $root.com.achlid.crash.game.BatchCancelBets();
                        if (object.cancels) {
                            if (!Array.isArray(object.cancels))
                                throw TypeError(".com.achlid.crash.game.BatchCancelBets.cancels: array expected");
                            message.cancels = [];
                            for (let i = 0; i < object.cancels.length; ++i) {
                                if (typeof object.cancels[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.BatchCancelBets.cancels: object expected");
                                message.cancels[i] = $root.com.achlid.crash.game.CancelBetNotification.fromObject(object.cancels[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BatchCancelBets message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {com.achlid.crash.game.BatchCancelBets} message BatchCancelBets
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCancelBets.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.cancels = [];
                        if (message.cancels && message.cancels.length) {
                            object.cancels = [];
                            for (let j = 0; j < message.cancels.length; ++j)
                                object.cancels[j] = $root.com.achlid.crash.game.CancelBetNotification.toObject(message.cancels[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this BatchCancelBets to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCancelBets.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BatchCancelBets
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.BatchCancelBets
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BatchCancelBets.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.BatchCancelBets";
                    };

                    return BatchCancelBets;
                })();

                game.BatchCashouts = (function() {

                    /**
                     * Properties of a BatchCashouts.
                     * @memberof com.achlid.crash.game
                     * @interface IBatchCashouts
                     * @property {Array.<com.achlid.crash.game.ICashOutNotification>|null} [cashouts] BatchCashouts cashouts
                     */

                    /**
                     * Constructs a new BatchCashouts.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a BatchCashouts.
                     * @implements IBatchCashouts
                     * @constructor
                     * @param {com.achlid.crash.game.IBatchCashouts=} [properties] Properties to set
                     */
                    function BatchCashouts(properties) {
                        this.cashouts = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BatchCashouts cashouts.
                     * @member {Array.<com.achlid.crash.game.ICashOutNotification>} cashouts
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @instance
                     */
                    BatchCashouts.prototype.cashouts = $util.emptyArray;

                    /**
                     * Creates a new BatchCashouts instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {com.achlid.crash.game.IBatchCashouts=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.BatchCashouts} BatchCashouts instance
                     */
                    BatchCashouts.create = function create(properties) {
                        return new BatchCashouts(properties);
                    };

                    /**
                     * Encodes the specified BatchCashouts message. Does not implicitly {@link com.achlid.crash.game.BatchCashouts.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {com.achlid.crash.game.IBatchCashouts} message BatchCashouts message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCashouts.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cashouts != null && message.cashouts.length)
                            for (let i = 0; i < message.cashouts.length; ++i)
                                $root.com.achlid.crash.game.CashOutNotification.encode(message.cashouts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified BatchCashouts message, length delimited. Does not implicitly {@link com.achlid.crash.game.BatchCashouts.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {com.achlid.crash.game.IBatchCashouts} message BatchCashouts message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCashouts.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BatchCashouts message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.BatchCashouts} BatchCashouts
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCashouts.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.BatchCashouts();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.cashouts && message.cashouts.length))
                                        message.cashouts = [];
                                    message.cashouts.push($root.com.achlid.crash.game.CashOutNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BatchCashouts message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.BatchCashouts} BatchCashouts
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCashouts.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BatchCashouts message.
                     * @function verify
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCashouts.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cashouts != null && message.hasOwnProperty("cashouts")) {
                            if (!Array.isArray(message.cashouts))
                                return "cashouts: array expected";
                            for (let i = 0; i < message.cashouts.length; ++i) {
                                let error = $root.com.achlid.crash.game.CashOutNotification.verify(message.cashouts[i]);
                                if (error)
                                    return "cashouts." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a BatchCashouts message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.BatchCashouts} BatchCashouts
                     */
                    BatchCashouts.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.BatchCashouts)
                            return object;
                        let message = new $root.com.achlid.crash.game.BatchCashouts();
                        if (object.cashouts) {
                            if (!Array.isArray(object.cashouts))
                                throw TypeError(".com.achlid.crash.game.BatchCashouts.cashouts: array expected");
                            message.cashouts = [];
                            for (let i = 0; i < object.cashouts.length; ++i) {
                                if (typeof object.cashouts[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.BatchCashouts.cashouts: object expected");
                                message.cashouts[i] = $root.com.achlid.crash.game.CashOutNotification.fromObject(object.cashouts[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a BatchCashouts message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {com.achlid.crash.game.BatchCashouts} message BatchCashouts
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCashouts.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.cashouts = [];
                        if (message.cashouts && message.cashouts.length) {
                            object.cashouts = [];
                            for (let j = 0; j < message.cashouts.length; ++j)
                                object.cashouts[j] = $root.com.achlid.crash.game.CashOutNotification.toObject(message.cashouts[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this BatchCashouts to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCashouts.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BatchCashouts
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.BatchCashouts
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BatchCashouts.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.BatchCashouts";
                    };

                    return BatchCashouts;
                })();

                game.RoomBetsNotification = (function() {

                    /**
                     * Properties of a RoomBetsNotification.
                     * @memberof com.achlid.crash.game
                     * @interface IRoomBetsNotification
                     * @property {Array.<com.achlid.crash.game.INewBetNotification>|null} [newBets] RoomBetsNotification newBets
                     * @property {Array.<com.achlid.crash.game.ICancelBetNotification>|null} [cancelledBets] RoomBetsNotification cancelledBets
                     * @property {Array.<com.achlid.crash.game.ICashOutNotification>|null} [cashouts] RoomBetsNotification cashouts
                     */

                    /**
                     * Constructs a new RoomBetsNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a RoomBetsNotification.
                     * @implements IRoomBetsNotification
                     * @constructor
                     * @param {com.achlid.crash.game.IRoomBetsNotification=} [properties] Properties to set
                     */
                    function RoomBetsNotification(properties) {
                        this.newBets = [];
                        this.cancelledBets = [];
                        this.cashouts = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoomBetsNotification newBets.
                     * @member {Array.<com.achlid.crash.game.INewBetNotification>} newBets
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @instance
                     */
                    RoomBetsNotification.prototype.newBets = $util.emptyArray;

                    /**
                     * RoomBetsNotification cancelledBets.
                     * @member {Array.<com.achlid.crash.game.ICancelBetNotification>} cancelledBets
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @instance
                     */
                    RoomBetsNotification.prototype.cancelledBets = $util.emptyArray;

                    /**
                     * RoomBetsNotification cashouts.
                     * @member {Array.<com.achlid.crash.game.ICashOutNotification>} cashouts
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @instance
                     */
                    RoomBetsNotification.prototype.cashouts = $util.emptyArray;

                    /**
                     * Creates a new RoomBetsNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {com.achlid.crash.game.IRoomBetsNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.RoomBetsNotification} RoomBetsNotification instance
                     */
                    RoomBetsNotification.create = function create(properties) {
                        return new RoomBetsNotification(properties);
                    };

                    /**
                     * Encodes the specified RoomBetsNotification message. Does not implicitly {@link com.achlid.crash.game.RoomBetsNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {com.achlid.crash.game.IRoomBetsNotification} message RoomBetsNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomBetsNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.newBets != null && message.newBets.length)
                            for (let i = 0; i < message.newBets.length; ++i)
                                $root.com.achlid.crash.game.NewBetNotification.encode(message.newBets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.cancelledBets != null && message.cancelledBets.length)
                            for (let i = 0; i < message.cancelledBets.length; ++i)
                                $root.com.achlid.crash.game.CancelBetNotification.encode(message.cancelledBets[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.cashouts != null && message.cashouts.length)
                            for (let i = 0; i < message.cashouts.length; ++i)
                                $root.com.achlid.crash.game.CashOutNotification.encode(message.cashouts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified RoomBetsNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.RoomBetsNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {com.achlid.crash.game.IRoomBetsNotification} message RoomBetsNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoomBetsNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoomBetsNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.RoomBetsNotification} RoomBetsNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomBetsNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.RoomBetsNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.newBets && message.newBets.length))
                                        message.newBets = [];
                                    message.newBets.push($root.com.achlid.crash.game.NewBetNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 2: {
                                    if (!(message.cancelledBets && message.cancelledBets.length))
                                        message.cancelledBets = [];
                                    message.cancelledBets.push($root.com.achlid.crash.game.CancelBetNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            case 3: {
                                    if (!(message.cashouts && message.cashouts.length))
                                        message.cashouts = [];
                                    message.cashouts.push($root.com.achlid.crash.game.CashOutNotification.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoomBetsNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.RoomBetsNotification} RoomBetsNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoomBetsNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoomBetsNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoomBetsNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.newBets != null && message.hasOwnProperty("newBets")) {
                            if (!Array.isArray(message.newBets))
                                return "newBets: array expected";
                            for (let i = 0; i < message.newBets.length; ++i) {
                                let error = $root.com.achlid.crash.game.NewBetNotification.verify(message.newBets[i]);
                                if (error)
                                    return "newBets." + error;
                            }
                        }
                        if (message.cancelledBets != null && message.hasOwnProperty("cancelledBets")) {
                            if (!Array.isArray(message.cancelledBets))
                                return "cancelledBets: array expected";
                            for (let i = 0; i < message.cancelledBets.length; ++i) {
                                let error = $root.com.achlid.crash.game.CancelBetNotification.verify(message.cancelledBets[i]);
                                if (error)
                                    return "cancelledBets." + error;
                            }
                        }
                        if (message.cashouts != null && message.hasOwnProperty("cashouts")) {
                            if (!Array.isArray(message.cashouts))
                                return "cashouts: array expected";
                            for (let i = 0; i < message.cashouts.length; ++i) {
                                let error = $root.com.achlid.crash.game.CashOutNotification.verify(message.cashouts[i]);
                                if (error)
                                    return "cashouts." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a RoomBetsNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.RoomBetsNotification} RoomBetsNotification
                     */
                    RoomBetsNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.RoomBetsNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.RoomBetsNotification();
                        if (object.newBets) {
                            if (!Array.isArray(object.newBets))
                                throw TypeError(".com.achlid.crash.game.RoomBetsNotification.newBets: array expected");
                            message.newBets = [];
                            for (let i = 0; i < object.newBets.length; ++i) {
                                if (typeof object.newBets[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.RoomBetsNotification.newBets: object expected");
                                message.newBets[i] = $root.com.achlid.crash.game.NewBetNotification.fromObject(object.newBets[i]);
                            }
                        }
                        if (object.cancelledBets) {
                            if (!Array.isArray(object.cancelledBets))
                                throw TypeError(".com.achlid.crash.game.RoomBetsNotification.cancelledBets: array expected");
                            message.cancelledBets = [];
                            for (let i = 0; i < object.cancelledBets.length; ++i) {
                                if (typeof object.cancelledBets[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.RoomBetsNotification.cancelledBets: object expected");
                                message.cancelledBets[i] = $root.com.achlid.crash.game.CancelBetNotification.fromObject(object.cancelledBets[i]);
                            }
                        }
                        if (object.cashouts) {
                            if (!Array.isArray(object.cashouts))
                                throw TypeError(".com.achlid.crash.game.RoomBetsNotification.cashouts: array expected");
                            message.cashouts = [];
                            for (let i = 0; i < object.cashouts.length; ++i) {
                                if (typeof object.cashouts[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.RoomBetsNotification.cashouts: object expected");
                                message.cashouts[i] = $root.com.achlid.crash.game.CashOutNotification.fromObject(object.cashouts[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoomBetsNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {com.achlid.crash.game.RoomBetsNotification} message RoomBetsNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoomBetsNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.newBets = [];
                            object.cancelledBets = [];
                            object.cashouts = [];
                        }
                        if (message.newBets && message.newBets.length) {
                            object.newBets = [];
                            for (let j = 0; j < message.newBets.length; ++j)
                                object.newBets[j] = $root.com.achlid.crash.game.NewBetNotification.toObject(message.newBets[j], options);
                        }
                        if (message.cancelledBets && message.cancelledBets.length) {
                            object.cancelledBets = [];
                            for (let j = 0; j < message.cancelledBets.length; ++j)
                                object.cancelledBets[j] = $root.com.achlid.crash.game.CancelBetNotification.toObject(message.cancelledBets[j], options);
                        }
                        if (message.cashouts && message.cashouts.length) {
                            object.cashouts = [];
                            for (let j = 0; j < message.cashouts.length; ++j)
                                object.cashouts[j] = $root.com.achlid.crash.game.CashOutNotification.toObject(message.cashouts[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this RoomBetsNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoomBetsNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RoomBetsNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.RoomBetsNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RoomBetsNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.RoomBetsNotification";
                    };

                    return RoomBetsNotification;
                })();

                game.SetAutoCashOutRequest = (function() {

                    /**
                     * Properties of a SetAutoCashOutRequest.
                     * @memberof com.achlid.crash.game
                     * @interface ISetAutoCashOutRequest
                     * @property {number|null} [slotId] SetAutoCashOutRequest slotId
                     * @property {number|null} [level] SetAutoCashOutRequest level
                     */

                    /**
                     * Constructs a new SetAutoCashOutRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a SetAutoCashOutRequest.
                     * @implements ISetAutoCashOutRequest
                     * @constructor
                     * @param {com.achlid.crash.game.ISetAutoCashOutRequest=} [properties] Properties to set
                     */
                    function SetAutoCashOutRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SetAutoCashOutRequest slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @instance
                     */
                    SetAutoCashOutRequest.prototype.slotId = 0;

                    /**
                     * SetAutoCashOutRequest level.
                     * @member {number} level
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @instance
                     */
                    SetAutoCashOutRequest.prototype.level = 0;

                    /**
                     * Creates a new SetAutoCashOutRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.SetAutoCashOutRequest} SetAutoCashOutRequest instance
                     */
                    SetAutoCashOutRequest.create = function create(properties) {
                        return new SetAutoCashOutRequest(properties);
                    };

                    /**
                     * Encodes the specified SetAutoCashOutRequest message. Does not implicitly {@link com.achlid.crash.game.SetAutoCashOutRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutRequest} message SetAutoCashOutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetAutoCashOutRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.slotId);
                        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.level);
                        return writer;
                    };

                    /**
                     * Encodes the specified SetAutoCashOutRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.SetAutoCashOutRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutRequest} message SetAutoCashOutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetAutoCashOutRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SetAutoCashOutRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.SetAutoCashOutRequest} SetAutoCashOutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetAutoCashOutRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.SetAutoCashOutRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.level = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SetAutoCashOutRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.SetAutoCashOutRequest} SetAutoCashOutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetAutoCashOutRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SetAutoCashOutRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SetAutoCashOutRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.level != null && message.hasOwnProperty("level"))
                            if (typeof message.level !== "number")
                                return "level: number expected";
                        return null;
                    };

                    /**
                     * Creates a SetAutoCashOutRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.SetAutoCashOutRequest} SetAutoCashOutRequest
                     */
                    SetAutoCashOutRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.SetAutoCashOutRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.SetAutoCashOutRequest();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.level != null)
                            message.level = Number(object.level);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SetAutoCashOutRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {com.achlid.crash.game.SetAutoCashOutRequest} message SetAutoCashOutRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SetAutoCashOutRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.slotId = 0;
                            object.level = 0;
                        }
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.level != null && message.hasOwnProperty("level"))
                            object.level = options.json && !isFinite(message.level) ? String(message.level) : message.level;
                        return object;
                    };

                    /**
                     * Converts this SetAutoCashOutRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SetAutoCashOutRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SetAutoCashOutRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.SetAutoCashOutRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SetAutoCashOutRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.SetAutoCashOutRequest";
                    };

                    return SetAutoCashOutRequest;
                })();

                game.SetAutoCashOutResult = (function() {

                    /**
                     * Properties of a SetAutoCashOutResult.
                     * @memberof com.achlid.crash.game
                     * @interface ISetAutoCashOutResult
                     * @property {boolean|null} [success] SetAutoCashOutResult success
                     * @property {number|null} [slotId] SetAutoCashOutResult slotId
                     * @property {number|null} [level] SetAutoCashOutResult level
                     * @property {string|null} [errorMessage] SetAutoCashOutResult errorMessage
                     */

                    /**
                     * Constructs a new SetAutoCashOutResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a SetAutoCashOutResult.
                     * @implements ISetAutoCashOutResult
                     * @constructor
                     * @param {com.achlid.crash.game.ISetAutoCashOutResult=} [properties] Properties to set
                     */
                    function SetAutoCashOutResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SetAutoCashOutResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @instance
                     */
                    SetAutoCashOutResult.prototype.success = false;

                    /**
                     * SetAutoCashOutResult slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @instance
                     */
                    SetAutoCashOutResult.prototype.slotId = 0;

                    /**
                     * SetAutoCashOutResult level.
                     * @member {number} level
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @instance
                     */
                    SetAutoCashOutResult.prototype.level = 0;

                    /**
                     * SetAutoCashOutResult errorMessage.
                     * @member {string} errorMessage
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @instance
                     */
                    SetAutoCashOutResult.prototype.errorMessage = "";

                    /**
                     * Creates a new SetAutoCashOutResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.SetAutoCashOutResult} SetAutoCashOutResult instance
                     */
                    SetAutoCashOutResult.create = function create(properties) {
                        return new SetAutoCashOutResult(properties);
                    };

                    /**
                     * Encodes the specified SetAutoCashOutResult message. Does not implicitly {@link com.achlid.crash.game.SetAutoCashOutResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutResult} message SetAutoCashOutResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetAutoCashOutResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.slotId);
                        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.level);
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.errorMessage);
                        return writer;
                    };

                    /**
                     * Encodes the specified SetAutoCashOutResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.SetAutoCashOutResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {com.achlid.crash.game.ISetAutoCashOutResult} message SetAutoCashOutResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetAutoCashOutResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SetAutoCashOutResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.SetAutoCashOutResult} SetAutoCashOutResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetAutoCashOutResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.SetAutoCashOutResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.level = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.errorMessage = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SetAutoCashOutResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.SetAutoCashOutResult} SetAutoCashOutResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetAutoCashOutResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SetAutoCashOutResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SetAutoCashOutResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.level != null && message.hasOwnProperty("level"))
                            if (typeof message.level !== "number")
                                return "level: number expected";
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        return null;
                    };

                    /**
                     * Creates a SetAutoCashOutResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.SetAutoCashOutResult} SetAutoCashOutResult
                     */
                    SetAutoCashOutResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.SetAutoCashOutResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.SetAutoCashOutResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.level != null)
                            message.level = Number(object.level);
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SetAutoCashOutResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {com.achlid.crash.game.SetAutoCashOutResult} message SetAutoCashOutResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SetAutoCashOutResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.slotId = 0;
                            object.level = 0;
                            object.errorMessage = "";
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.level != null && message.hasOwnProperty("level"))
                            object.level = options.json && !isFinite(message.level) ? String(message.level) : message.level;
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        return object;
                    };

                    /**
                     * Converts this SetAutoCashOutResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SetAutoCashOutResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SetAutoCashOutResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.SetAutoCashOutResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SetAutoCashOutResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.SetAutoCashOutResult";
                    };

                    return SetAutoCashOutResult;
                })();

                game.MultiplierUpdate = (function() {

                    /**
                     * Properties of a MultiplierUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface IMultiplierUpdate
                     * @property {number|Long|null} [roundId] MultiplierUpdate roundId
                     * @property {number|null} [multiplier] MultiplierUpdate multiplier
                     * @property {number|Long|null} [elapsedMs] MultiplierUpdate elapsedMs
                     * @property {number|null} [activePlayers] MultiplierUpdate activePlayers
                     */

                    /**
                     * Constructs a new MultiplierUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a MultiplierUpdate.
                     * @implements IMultiplierUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.IMultiplierUpdate=} [properties] Properties to set
                     */
                    function MultiplierUpdate(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * MultiplierUpdate roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @instance
                     */
                    MultiplierUpdate.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * MultiplierUpdate multiplier.
                     * @member {number} multiplier
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @instance
                     */
                    MultiplierUpdate.prototype.multiplier = 0;

                    /**
                     * MultiplierUpdate elapsedMs.
                     * @member {number|Long} elapsedMs
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @instance
                     */
                    MultiplierUpdate.prototype.elapsedMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * MultiplierUpdate activePlayers.
                     * @member {number} activePlayers
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @instance
                     */
                    MultiplierUpdate.prototype.activePlayers = 0;

                    /**
                     * Creates a new MultiplierUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {com.achlid.crash.game.IMultiplierUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.MultiplierUpdate} MultiplierUpdate instance
                     */
                    MultiplierUpdate.create = function create(properties) {
                        return new MultiplierUpdate(properties);
                    };

                    /**
                     * Encodes the specified MultiplierUpdate message. Does not implicitly {@link com.achlid.crash.game.MultiplierUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {com.achlid.crash.game.IMultiplierUpdate} message MultiplierUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MultiplierUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.multiplier);
                        if (message.elapsedMs != null && Object.hasOwnProperty.call(message, "elapsedMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.elapsedMs);
                        if (message.activePlayers != null && Object.hasOwnProperty.call(message, "activePlayers"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.activePlayers);
                        return writer;
                    };

                    /**
                     * Encodes the specified MultiplierUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.MultiplierUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {com.achlid.crash.game.IMultiplierUpdate} message MultiplierUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MultiplierUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a MultiplierUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.MultiplierUpdate} MultiplierUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MultiplierUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.MultiplierUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.multiplier = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.elapsedMs = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.activePlayers = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a MultiplierUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.MultiplierUpdate} MultiplierUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MultiplierUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a MultiplierUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MultiplierUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        if (message.elapsedMs != null && message.hasOwnProperty("elapsedMs"))
                            if (!$util.isInteger(message.elapsedMs) && !(message.elapsedMs && $util.isInteger(message.elapsedMs.low) && $util.isInteger(message.elapsedMs.high)))
                                return "elapsedMs: integer|Long expected";
                        if (message.activePlayers != null && message.hasOwnProperty("activePlayers"))
                            if (!$util.isInteger(message.activePlayers))
                                return "activePlayers: integer expected";
                        return null;
                    };

                    /**
                     * Creates a MultiplierUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.MultiplierUpdate} MultiplierUpdate
                     */
                    MultiplierUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.MultiplierUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.MultiplierUpdate();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.elapsedMs != null)
                            if ($util.Long)
                                (message.elapsedMs = $util.Long.fromValue(object.elapsedMs)).unsigned = false;
                            else if (typeof object.elapsedMs === "string")
                                message.elapsedMs = parseInt(object.elapsedMs, 10);
                            else if (typeof object.elapsedMs === "number")
                                message.elapsedMs = object.elapsedMs;
                            else if (typeof object.elapsedMs === "object")
                                message.elapsedMs = new $util.LongBits(object.elapsedMs.low >>> 0, object.elapsedMs.high >>> 0).toNumber();
                        if (object.activePlayers != null)
                            message.activePlayers = object.activePlayers | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a MultiplierUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {com.achlid.crash.game.MultiplierUpdate} message MultiplierUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MultiplierUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.multiplier = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.elapsedMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.elapsedMs = options.longs === String ? "0" : 0;
                            object.activePlayers = 0;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                        if (message.elapsedMs != null && message.hasOwnProperty("elapsedMs"))
                            if (typeof message.elapsedMs === "number")
                                object.elapsedMs = options.longs === String ? String(message.elapsedMs) : message.elapsedMs;
                            else
                                object.elapsedMs = options.longs === String ? $util.Long.prototype.toString.call(message.elapsedMs) : options.longs === Number ? new $util.LongBits(message.elapsedMs.low >>> 0, message.elapsedMs.high >>> 0).toNumber() : message.elapsedMs;
                        if (message.activePlayers != null && message.hasOwnProperty("activePlayers"))
                            object.activePlayers = message.activePlayers;
                        return object;
                    };

                    /**
                     * Converts this MultiplierUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MultiplierUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for MultiplierUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.MultiplierUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    MultiplierUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.MultiplierUpdate";
                    };

                    return MultiplierUpdate;
                })();

                game.RoundCrash = (function() {

                    /**
                     * Properties of a RoundCrash.
                     * @memberof com.achlid.crash.game
                     * @interface IRoundCrash
                     * @property {number|Long|null} [roundId] RoundCrash roundId
                     * @property {number|null} [crashPoint] RoundCrash crashPoint
                     * @property {number|null} [totalPlayers] RoundCrash totalPlayers
                     * @property {number|null} [winners] RoundCrash winners
                     * @property {number|null} [totalPayout] RoundCrash totalPayout
                     */

                    /**
                     * Constructs a new RoundCrash.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a RoundCrash.
                     * @implements IRoundCrash
                     * @constructor
                     * @param {com.achlid.crash.game.IRoundCrash=} [properties] Properties to set
                     */
                    function RoundCrash(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoundCrash roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     */
                    RoundCrash.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * RoundCrash crashPoint.
                     * @member {number} crashPoint
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     */
                    RoundCrash.prototype.crashPoint = 0;

                    /**
                     * RoundCrash totalPlayers.
                     * @member {number} totalPlayers
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     */
                    RoundCrash.prototype.totalPlayers = 0;

                    /**
                     * RoundCrash winners.
                     * @member {number} winners
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     */
                    RoundCrash.prototype.winners = 0;

                    /**
                     * RoundCrash totalPayout.
                     * @member {number} totalPayout
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     */
                    RoundCrash.prototype.totalPayout = 0;

                    /**
                     * Creates a new RoundCrash instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {com.achlid.crash.game.IRoundCrash=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.RoundCrash} RoundCrash instance
                     */
                    RoundCrash.create = function create(properties) {
                        return new RoundCrash(properties);
                    };

                    /**
                     * Encodes the specified RoundCrash message. Does not implicitly {@link com.achlid.crash.game.RoundCrash.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {com.achlid.crash.game.IRoundCrash} message RoundCrash message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundCrash.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.crashPoint);
                        if (message.totalPlayers != null && Object.hasOwnProperty.call(message, "totalPlayers"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalPlayers);
                        if (message.winners != null && Object.hasOwnProperty.call(message, "winners"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.winners);
                        if (message.totalPayout != null && Object.hasOwnProperty.call(message, "totalPayout"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalPayout);
                        return writer;
                    };

                    /**
                     * Encodes the specified RoundCrash message, length delimited. Does not implicitly {@link com.achlid.crash.game.RoundCrash.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {com.achlid.crash.game.IRoundCrash} message RoundCrash message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundCrash.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoundCrash message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.RoundCrash} RoundCrash
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundCrash.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.RoundCrash();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.crashPoint = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.totalPlayers = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.winners = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.totalPayout = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoundCrash message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.RoundCrash} RoundCrash
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundCrash.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoundCrash message.
                     * @function verify
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoundCrash.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            if (typeof message.crashPoint !== "number")
                                return "crashPoint: number expected";
                        if (message.totalPlayers != null && message.hasOwnProperty("totalPlayers"))
                            if (!$util.isInteger(message.totalPlayers))
                                return "totalPlayers: integer expected";
                        if (message.winners != null && message.hasOwnProperty("winners"))
                            if (!$util.isInteger(message.winners))
                                return "winners: integer expected";
                        if (message.totalPayout != null && message.hasOwnProperty("totalPayout"))
                            if (typeof message.totalPayout !== "number")
                                return "totalPayout: number expected";
                        return null;
                    };

                    /**
                     * Creates a RoundCrash message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.RoundCrash} RoundCrash
                     */
                    RoundCrash.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.RoundCrash)
                            return object;
                        let message = new $root.com.achlid.crash.game.RoundCrash();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.crashPoint != null)
                            message.crashPoint = Number(object.crashPoint);
                        if (object.totalPlayers != null)
                            message.totalPlayers = object.totalPlayers | 0;
                        if (object.winners != null)
                            message.winners = object.winners | 0;
                        if (object.totalPayout != null)
                            message.totalPayout = Number(object.totalPayout);
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoundCrash message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {com.achlid.crash.game.RoundCrash} message RoundCrash
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoundCrash.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.crashPoint = 0;
                            object.totalPlayers = 0;
                            object.winners = 0;
                            object.totalPayout = 0;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                        if (message.totalPlayers != null && message.hasOwnProperty("totalPlayers"))
                            object.totalPlayers = message.totalPlayers;
                        if (message.winners != null && message.hasOwnProperty("winners"))
                            object.winners = message.winners;
                        if (message.totalPayout != null && message.hasOwnProperty("totalPayout"))
                            object.totalPayout = options.json && !isFinite(message.totalPayout) ? String(message.totalPayout) : message.totalPayout;
                        return object;
                    };

                    /**
                     * Converts this RoundCrash to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoundCrash.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RoundCrash
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.RoundCrash
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RoundCrash.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.RoundCrash";
                    };

                    return RoundCrash;
                })();

                game.RoundStart = (function() {

                    /**
                     * Properties of a RoundStart.
                     * @memberof com.achlid.crash.game
                     * @interface IRoundStart
                     * @property {number|Long|null} [roundId] RoundStart roundId
                     * @property {string|null} [publicHash] RoundStart publicHash
                     * @property {number|Long|null} [startTime] RoundStart startTime
                     */

                    /**
                     * Constructs a new RoundStart.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a RoundStart.
                     * @implements IRoundStart
                     * @constructor
                     * @param {com.achlid.crash.game.IRoundStart=} [properties] Properties to set
                     */
                    function RoundStart(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoundStart roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.RoundStart
                     * @instance
                     */
                    RoundStart.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * RoundStart publicHash.
                     * @member {string} publicHash
                     * @memberof com.achlid.crash.game.RoundStart
                     * @instance
                     */
                    RoundStart.prototype.publicHash = "";

                    /**
                     * RoundStart startTime.
                     * @member {number|Long} startTime
                     * @memberof com.achlid.crash.game.RoundStart
                     * @instance
                     */
                    RoundStart.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new RoundStart instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {com.achlid.crash.game.IRoundStart=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.RoundStart} RoundStart instance
                     */
                    RoundStart.create = function create(properties) {
                        return new RoundStart(properties);
                    };

                    /**
                     * Encodes the specified RoundStart message. Does not implicitly {@link com.achlid.crash.game.RoundStart.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {com.achlid.crash.game.IRoundStart} message RoundStart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundStart.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.publicHash != null && Object.hasOwnProperty.call(message, "publicHash"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.publicHash);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startTime);
                        return writer;
                    };

                    /**
                     * Encodes the specified RoundStart message, length delimited. Does not implicitly {@link com.achlid.crash.game.RoundStart.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {com.achlid.crash.game.IRoundStart} message RoundStart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundStart.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoundStart message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.RoundStart} RoundStart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundStart.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.RoundStart();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.publicHash = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.startTime = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoundStart message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.RoundStart} RoundStart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundStart.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoundStart message.
                     * @function verify
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoundStart.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                            if (!$util.isString(message.publicHash))
                                return "publicHash: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                return "startTime: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a RoundStart message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.RoundStart} RoundStart
                     */
                    RoundStart.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.RoundStart)
                            return object;
                        let message = new $root.com.achlid.crash.game.RoundStart();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.publicHash != null)
                            message.publicHash = String(object.publicHash);
                        if (object.startTime != null)
                            if ($util.Long)
                                (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                            else if (typeof object.startTime === "string")
                                message.startTime = parseInt(object.startTime, 10);
                            else if (typeof object.startTime === "number")
                                message.startTime = object.startTime;
                            else if (typeof object.startTime === "object")
                                message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoundStart message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {com.achlid.crash.game.RoundStart} message RoundStart
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoundStart.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.publicHash = "";
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startTime = options.longs === String ? "0" : 0;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                            object.publicHash = message.publicHash;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (typeof message.startTime === "number")
                                object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                            else
                                object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                        return object;
                    };

                    /**
                     * Converts this RoundStart to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.RoundStart
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoundStart.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RoundStart
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.RoundStart
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RoundStart.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.RoundStart";
                    };

                    return RoundStart;
                })();

                game.PreRoundStart = (function() {

                    /**
                     * Properties of a PreRoundStart.
                     * @memberof com.achlid.crash.game
                     * @interface IPreRoundStart
                     * @property {number|Long|null} [roundId] PreRoundStart roundId
                     * @property {number|null} [durationMs] PreRoundStart durationMs
                     * @property {number|Long|null} [startTime] PreRoundStart startTime
                     * @property {string|null} [publicHash] PreRoundStart publicHash
                     */

                    /**
                     * Constructs a new PreRoundStart.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a PreRoundStart.
                     * @implements IPreRoundStart
                     * @constructor
                     * @param {com.achlid.crash.game.IPreRoundStart=} [properties] Properties to set
                     */
                    function PreRoundStart(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PreRoundStart roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @instance
                     */
                    PreRoundStart.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PreRoundStart durationMs.
                     * @member {number} durationMs
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @instance
                     */
                    PreRoundStart.prototype.durationMs = 0;

                    /**
                     * PreRoundStart startTime.
                     * @member {number|Long} startTime
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @instance
                     */
                    PreRoundStart.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PreRoundStart publicHash.
                     * @member {string} publicHash
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @instance
                     */
                    PreRoundStart.prototype.publicHash = "";

                    /**
                     * Creates a new PreRoundStart instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {com.achlid.crash.game.IPreRoundStart=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.PreRoundStart} PreRoundStart instance
                     */
                    PreRoundStart.create = function create(properties) {
                        return new PreRoundStart(properties);
                    };

                    /**
                     * Encodes the specified PreRoundStart message. Does not implicitly {@link com.achlid.crash.game.PreRoundStart.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {com.achlid.crash.game.IPreRoundStart} message PreRoundStart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreRoundStart.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.durationMs);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startTime);
                        if (message.publicHash != null && Object.hasOwnProperty.call(message, "publicHash"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.publicHash);
                        return writer;
                    };

                    /**
                     * Encodes the specified PreRoundStart message, length delimited. Does not implicitly {@link com.achlid.crash.game.PreRoundStart.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {com.achlid.crash.game.IPreRoundStart} message PreRoundStart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreRoundStart.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PreRoundStart message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.PreRoundStart} PreRoundStart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreRoundStart.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.PreRoundStart();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.durationMs = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.startTime = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.publicHash = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PreRoundStart message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.PreRoundStart} PreRoundStart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreRoundStart.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PreRoundStart message.
                     * @function verify
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PreRoundStart.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.durationMs != null && message.hasOwnProperty("durationMs"))
                            if (!$util.isInteger(message.durationMs))
                                return "durationMs: integer expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                                return "startTime: integer|Long expected";
                        if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                            if (!$util.isString(message.publicHash))
                                return "publicHash: string expected";
                        return null;
                    };

                    /**
                     * Creates a PreRoundStart message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.PreRoundStart} PreRoundStart
                     */
                    PreRoundStart.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.PreRoundStart)
                            return object;
                        let message = new $root.com.achlid.crash.game.PreRoundStart();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.durationMs != null)
                            message.durationMs = object.durationMs | 0;
                        if (object.startTime != null)
                            if ($util.Long)
                                (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                            else if (typeof object.startTime === "string")
                                message.startTime = parseInt(object.startTime, 10);
                            else if (typeof object.startTime === "number")
                                message.startTime = object.startTime;
                            else if (typeof object.startTime === "object")
                                message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                        if (object.publicHash != null)
                            message.publicHash = String(object.publicHash);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PreRoundStart message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {com.achlid.crash.game.PreRoundStart} message PreRoundStart
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PreRoundStart.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.durationMs = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startTime = options.longs === String ? "0" : 0;
                            object.publicHash = "";
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.durationMs != null && message.hasOwnProperty("durationMs"))
                            object.durationMs = message.durationMs;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (typeof message.startTime === "number")
                                object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                            else
                                object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                        if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                            object.publicHash = message.publicHash;
                        return object;
                    };

                    /**
                     * Converts this PreRoundStart to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PreRoundStart.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PreRoundStart
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.PreRoundStart
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PreRoundStart.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.PreRoundStart";
                    };

                    return PreRoundStart;
                })();

                game.NewBetNotification = (function() {

                    /**
                     * Properties of a NewBetNotification.
                     * @memberof com.achlid.crash.game
                     * @interface INewBetNotification
                     * @property {number|Long|null} [userId] NewBetNotification userId
                     * @property {number|null} [amount] NewBetNotification amount
                     * @property {number|null} [slotId] NewBetNotification slotId
                     * @property {number|Long|null} [roundId] NewBetNotification roundId
                     * @property {string|null} [nickname] NewBetNotification nickname
                     * @property {string|null} [avatar] NewBetNotification avatar
                     */

                    /**
                     * Constructs a new NewBetNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a NewBetNotification.
                     * @implements INewBetNotification
                     * @constructor
                     * @param {com.achlid.crash.game.INewBetNotification=} [properties] Properties to set
                     */
                    function NewBetNotification(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * NewBetNotification userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * NewBetNotification amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.amount = 0;

                    /**
                     * NewBetNotification slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.slotId = 0;

                    /**
                     * NewBetNotification roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * NewBetNotification nickname.
                     * @member {string} nickname
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.nickname = "";

                    /**
                     * NewBetNotification avatar.
                     * @member {string} avatar
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     */
                    NewBetNotification.prototype.avatar = "";

                    /**
                     * Creates a new NewBetNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {com.achlid.crash.game.INewBetNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.NewBetNotification} NewBetNotification instance
                     */
                    NewBetNotification.create = function create(properties) {
                        return new NewBetNotification(properties);
                    };

                    /**
                     * Encodes the specified NewBetNotification message. Does not implicitly {@link com.achlid.crash.game.NewBetNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {com.achlid.crash.game.INewBetNotification} message NewBetNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewBetNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.amount);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.slotId);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.roundId);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
                        if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
                        return writer;
                    };

                    /**
                     * Encodes the specified NewBetNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.NewBetNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {com.achlid.crash.game.INewBetNotification} message NewBetNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NewBetNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a NewBetNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.NewBetNotification} NewBetNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewBetNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.NewBetNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.avatar = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a NewBetNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.NewBetNotification} NewBetNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NewBetNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a NewBetNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NewBetNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            if (!$util.isString(message.avatar))
                                return "avatar: string expected";
                        return null;
                    };

                    /**
                     * Creates a NewBetNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.NewBetNotification} NewBetNotification
                     */
                    NewBetNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.NewBetNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.NewBetNotification();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.avatar != null)
                            message.avatar = String(object.avatar);
                        return message;
                    };

                    /**
                     * Creates a plain object from a NewBetNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {com.achlid.crash.game.NewBetNotification} message NewBetNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NewBetNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.amount = 0;
                            object.slotId = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.nickname = "";
                            object.avatar = "";
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            object.avatar = message.avatar;
                        return object;
                    };

                    /**
                     * Converts this NewBetNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NewBetNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for NewBetNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.NewBetNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    NewBetNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.NewBetNotification";
                    };

                    return NewBetNotification;
                })();

                game.CashOutNotification = (function() {

                    /**
                     * Properties of a CashOutNotification.
                     * @memberof com.achlid.crash.game
                     * @interface ICashOutNotification
                     * @property {number|Long|null} [userId] CashOutNotification userId
                     * @property {number|null} [multiplier] CashOutNotification multiplier
                     * @property {number|null} [payout] CashOutNotification payout
                     * @property {number|null} [slotId] CashOutNotification slotId
                     * @property {number|Long|null} [roundId] CashOutNotification roundId
                     * @property {string|null} [nickname] CashOutNotification nickname
                     * @property {string|null} [avatar] CashOutNotification avatar
                     * @property {number|null} [betAmount] CashOutNotification betAmount
                     */

                    /**
                     * Constructs a new CashOutNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CashOutNotification.
                     * @implements ICashOutNotification
                     * @constructor
                     * @param {com.achlid.crash.game.ICashOutNotification=} [properties] Properties to set
                     */
                    function CashOutNotification(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CashOutNotification userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CashOutNotification multiplier.
                     * @member {number} multiplier
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.multiplier = 0;

                    /**
                     * CashOutNotification payout.
                     * @member {number} payout
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.payout = 0;

                    /**
                     * CashOutNotification slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.slotId = 0;

                    /**
                     * CashOutNotification roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CashOutNotification nickname.
                     * @member {string} nickname
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.nickname = "";

                    /**
                     * CashOutNotification avatar.
                     * @member {string} avatar
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.avatar = "";

                    /**
                     * CashOutNotification betAmount.
                     * @member {number} betAmount
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     */
                    CashOutNotification.prototype.betAmount = 0;

                    /**
                     * Creates a new CashOutNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {com.achlid.crash.game.ICashOutNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CashOutNotification} CashOutNotification instance
                     */
                    CashOutNotification.create = function create(properties) {
                        return new CashOutNotification(properties);
                    };

                    /**
                     * Encodes the specified CashOutNotification message. Does not implicitly {@link com.achlid.crash.game.CashOutNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {com.achlid.crash.game.ICashOutNotification} message CashOutNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.multiplier);
                        if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.payout);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.slotId);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.roundId);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.nickname);
                        if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.avatar);
                        if (message.betAmount != null && Object.hasOwnProperty.call(message, "betAmount"))
                            writer.uint32(/* id 8, wireType 1 =*/65).double(message.betAmount);
                        return writer;
                    };

                    /**
                     * Encodes the specified CashOutNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.CashOutNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {com.achlid.crash.game.ICashOutNotification} message CashOutNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashOutNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CashOutNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CashOutNotification} CashOutNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CashOutNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.multiplier = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.payout = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 6: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.avatar = reader.string();
                                    break;
                                }
                            case 8: {
                                    message.betAmount = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CashOutNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CashOutNotification} CashOutNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashOutNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CashOutNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CashOutNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        if (message.payout != null && message.hasOwnProperty("payout"))
                            if (typeof message.payout !== "number")
                                return "payout: number expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            if (!$util.isString(message.avatar))
                                return "avatar: string expected";
                        if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                            if (typeof message.betAmount !== "number")
                                return "betAmount: number expected";
                        return null;
                    };

                    /**
                     * Creates a CashOutNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CashOutNotification} CashOutNotification
                     */
                    CashOutNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CashOutNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.CashOutNotification();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.payout != null)
                            message.payout = Number(object.payout);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.avatar != null)
                            message.avatar = String(object.avatar);
                        if (object.betAmount != null)
                            message.betAmount = Number(object.betAmount);
                        return message;
                    };

                    /**
                     * Creates a plain object from a CashOutNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {com.achlid.crash.game.CashOutNotification} message CashOutNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CashOutNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.multiplier = 0;
                            object.payout = 0;
                            object.slotId = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.nickname = "";
                            object.avatar = "";
                            object.betAmount = 0;
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                        if (message.payout != null && message.hasOwnProperty("payout"))
                            object.payout = options.json && !isFinite(message.payout) ? String(message.payout) : message.payout;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            object.avatar = message.avatar;
                        if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                            object.betAmount = options.json && !isFinite(message.betAmount) ? String(message.betAmount) : message.betAmount;
                        return object;
                    };

                    /**
                     * Converts this CashOutNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CashOutNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CashOutNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CashOutNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CashOutNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CashOutNotification";
                    };

                    return CashOutNotification;
                })();

                game.BigWinNotification = (function() {

                    /**
                     * Properties of a BigWinNotification.
                     * @memberof com.achlid.crash.game
                     * @interface IBigWinNotification
                     * @property {string|null} [playerName] BigWinNotification playerName
                     * @property {number|null} [multiplier] BigWinNotification multiplier
                     * @property {number|null} [amount] BigWinNotification amount
                     * @property {number|Long|null} [roundId] BigWinNotification roundId
                     * @property {string|null} [avatar] BigWinNotification avatar
                     * @property {number|null} [slotId] BigWinNotification slotId
                     */

                    /**
                     * Constructs a new BigWinNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a BigWinNotification.
                     * @implements IBigWinNotification
                     * @constructor
                     * @param {com.achlid.crash.game.IBigWinNotification=} [properties] Properties to set
                     */
                    function BigWinNotification(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * BigWinNotification playerName.
                     * @member {string} playerName
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.playerName = "";

                    /**
                     * BigWinNotification multiplier.
                     * @member {number} multiplier
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.multiplier = 0;

                    /**
                     * BigWinNotification amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.amount = 0;

                    /**
                     * BigWinNotification roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * BigWinNotification avatar.
                     * @member {string} avatar
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.avatar = "";

                    /**
                     * BigWinNotification slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     */
                    BigWinNotification.prototype.slotId = 0;

                    /**
                     * Creates a new BigWinNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {com.achlid.crash.game.IBigWinNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.BigWinNotification} BigWinNotification instance
                     */
                    BigWinNotification.create = function create(properties) {
                        return new BigWinNotification(properties);
                    };

                    /**
                     * Encodes the specified BigWinNotification message. Does not implicitly {@link com.achlid.crash.game.BigWinNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {com.achlid.crash.game.IBigWinNotification} message BigWinNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BigWinNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.playerName != null && Object.hasOwnProperty.call(message, "playerName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.playerName);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.multiplier);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.amount);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.roundId);
                        if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.avatar);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.slotId);
                        return writer;
                    };

                    /**
                     * Encodes the specified BigWinNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.BigWinNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {com.achlid.crash.game.IBigWinNotification} message BigWinNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BigWinNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a BigWinNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.BigWinNotification} BigWinNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BigWinNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.BigWinNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.playerName = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.multiplier = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 4: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.avatar = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a BigWinNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.BigWinNotification} BigWinNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BigWinNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a BigWinNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BigWinNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.playerName != null && message.hasOwnProperty("playerName"))
                            if (!$util.isString(message.playerName))
                                return "playerName: string expected";
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            if (!$util.isString(message.avatar))
                                return "avatar: string expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        return null;
                    };

                    /**
                     * Creates a BigWinNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.BigWinNotification} BigWinNotification
                     */
                    BigWinNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.BigWinNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.BigWinNotification();
                        if (object.playerName != null)
                            message.playerName = String(object.playerName);
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.avatar != null)
                            message.avatar = String(object.avatar);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a BigWinNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {com.achlid.crash.game.BigWinNotification} message BigWinNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BigWinNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.playerName = "";
                            object.multiplier = 0;
                            object.amount = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.avatar = "";
                            object.slotId = 0;
                        }
                        if (message.playerName != null && message.hasOwnProperty("playerName"))
                            object.playerName = message.playerName;
                        if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            object.avatar = message.avatar;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        return object;
                    };

                    /**
                     * Converts this BigWinNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BigWinNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for BigWinNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.BigWinNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    BigWinNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.BigWinNotification";
                    };

                    return BigWinNotification;
                })();

                game.CancelBetNotification = (function() {

                    /**
                     * Properties of a CancelBetNotification.
                     * @memberof com.achlid.crash.game
                     * @interface ICancelBetNotification
                     * @property {number|Long|null} [roundId] CancelBetNotification roundId
                     * @property {number|Long|null} [userId] CancelBetNotification userId
                     * @property {number|null} [slotId] CancelBetNotification slotId
                     * @property {number|null} [amount] CancelBetNotification amount
                     * @property {string|null} [nickname] CancelBetNotification nickname
                     * @property {string|null} [avatar] CancelBetNotification avatar
                     */

                    /**
                     * Constructs a new CancelBetNotification.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a CancelBetNotification.
                     * @implements ICancelBetNotification
                     * @constructor
                     * @param {com.achlid.crash.game.ICancelBetNotification=} [properties] Properties to set
                     */
                    function CancelBetNotification(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * CancelBetNotification roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CancelBetNotification userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * CancelBetNotification slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.slotId = 0;

                    /**
                     * CancelBetNotification amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.amount = 0;

                    /**
                     * CancelBetNotification nickname.
                     * @member {string} nickname
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.nickname = "";

                    /**
                     * CancelBetNotification avatar.
                     * @member {string} avatar
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     */
                    CancelBetNotification.prototype.avatar = "";

                    /**
                     * Creates a new CancelBetNotification instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetNotification=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.CancelBetNotification} CancelBetNotification instance
                     */
                    CancelBetNotification.create = function create(properties) {
                        return new CancelBetNotification(properties);
                    };

                    /**
                     * Encodes the specified CancelBetNotification message. Does not implicitly {@link com.achlid.crash.game.CancelBetNotification.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetNotification} message CancelBetNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.userId);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.slotId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.amount);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
                        if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
                        return writer;
                    };

                    /**
                     * Encodes the specified CancelBetNotification message, length delimited. Does not implicitly {@link com.achlid.crash.game.CancelBetNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {com.achlid.crash.game.ICancelBetNotification} message CancelBetNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelBetNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a CancelBetNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.CancelBetNotification} CancelBetNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetNotification.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.CancelBetNotification();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.avatar = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a CancelBetNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.CancelBetNotification} CancelBetNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelBetNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a CancelBetNotification message.
                     * @function verify
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CancelBetNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            if (!$util.isString(message.avatar))
                                return "avatar: string expected";
                        return null;
                    };

                    /**
                     * Creates a CancelBetNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.CancelBetNotification} CancelBetNotification
                     */
                    CancelBetNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.CancelBetNotification)
                            return object;
                        let message = new $root.com.achlid.crash.game.CancelBetNotification();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.avatar != null)
                            message.avatar = String(object.avatar);
                        return message;
                    };

                    /**
                     * Creates a plain object from a CancelBetNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {com.achlid.crash.game.CancelBetNotification} message CancelBetNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CancelBetNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.slotId = 0;
                            object.amount = 0;
                            object.nickname = "";
                            object.avatar = "";
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            object.avatar = message.avatar;
                        return object;
                    };

                    /**
                     * Converts this CancelBetNotification to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CancelBetNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for CancelBetNotification
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.CancelBetNotification
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    CancelBetNotification.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.CancelBetNotification";
                    };

                    return CancelBetNotification;
                })();

                game.ActiveBet = (function() {

                    /**
                     * Properties of an ActiveBet.
                     * @memberof com.achlid.crash.game
                     * @interface IActiveBet
                     * @property {number|Long|null} [userId] ActiveBet userId
                     * @property {number|null} [amount] ActiveBet amount
                     * @property {number|null} [slotId] ActiveBet slotId
                     * @property {number|Long|null} [roundId] ActiveBet roundId
                     * @property {string|null} [nickname] ActiveBet nickname
                     * @property {string|null} [avatar] ActiveBet avatar
                     * @property {number|null} [autoCashoutLevel] ActiveBet autoCashoutLevel
                     * @property {number|null} [multiplier] ActiveBet multiplier
                     * @property {number|null} [payout] ActiveBet payout
                     */

                    /**
                     * Constructs a new ActiveBet.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents an ActiveBet.
                     * @implements IActiveBet
                     * @constructor
                     * @param {com.achlid.crash.game.IActiveBet=} [properties] Properties to set
                     */
                    function ActiveBet(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ActiveBet userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ActiveBet amount.
                     * @member {number} amount
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.amount = 0;

                    /**
                     * ActiveBet slotId.
                     * @member {number} slotId
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.slotId = 0;

                    /**
                     * ActiveBet roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * ActiveBet nickname.
                     * @member {string} nickname
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.nickname = "";

                    /**
                     * ActiveBet avatar.
                     * @member {string} avatar
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.avatar = "";

                    /**
                     * ActiveBet autoCashoutLevel.
                     * @member {number|null|undefined} autoCashoutLevel
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.autoCashoutLevel = null;

                    /**
                     * ActiveBet multiplier.
                     * @member {number|null|undefined} multiplier
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.multiplier = null;

                    /**
                     * ActiveBet payout.
                     * @member {number|null|undefined} payout
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    ActiveBet.prototype.payout = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * ActiveBet _autoCashoutLevel.
                     * @member {"autoCashoutLevel"|undefined} _autoCashoutLevel
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    Object.defineProperty(ActiveBet.prototype, "_autoCashoutLevel", {
                        get: $util.oneOfGetter($oneOfFields = ["autoCashoutLevel"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * ActiveBet _multiplier.
                     * @member {"multiplier"|undefined} _multiplier
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    Object.defineProperty(ActiveBet.prototype, "_multiplier", {
                        get: $util.oneOfGetter($oneOfFields = ["multiplier"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * ActiveBet _payout.
                     * @member {"payout"|undefined} _payout
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     */
                    Object.defineProperty(ActiveBet.prototype, "_payout", {
                        get: $util.oneOfGetter($oneOfFields = ["payout"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Creates a new ActiveBet instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {com.achlid.crash.game.IActiveBet=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.ActiveBet} ActiveBet instance
                     */
                    ActiveBet.create = function create(properties) {
                        return new ActiveBet(properties);
                    };

                    /**
                     * Encodes the specified ActiveBet message. Does not implicitly {@link com.achlid.crash.game.ActiveBet.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {com.achlid.crash.game.IActiveBet} message ActiveBet message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ActiveBet.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.amount);
                        if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.slotId);
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.roundId);
                        if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
                        if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
                        if (message.autoCashoutLevel != null && Object.hasOwnProperty.call(message, "autoCashoutLevel"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.autoCashoutLevel);
                        if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                            writer.uint32(/* id 8, wireType 1 =*/65).double(message.multiplier);
                        if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                            writer.uint32(/* id 9, wireType 1 =*/73).double(message.payout);
                        return writer;
                    };

                    /**
                     * Encodes the specified ActiveBet message, length delimited. Does not implicitly {@link com.achlid.crash.game.ActiveBet.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {com.achlid.crash.game.IActiveBet} message ActiveBet message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ActiveBet.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ActiveBet message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.ActiveBet} ActiveBet
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ActiveBet.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.ActiveBet();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.amount = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.slotId = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 5: {
                                    message.nickname = reader.string();
                                    break;
                                }
                            case 6: {
                                    message.avatar = reader.string();
                                    break;
                                }
                            case 7: {
                                    message.autoCashoutLevel = reader.double();
                                    break;
                                }
                            case 8: {
                                    message.multiplier = reader.double();
                                    break;
                                }
                            case 9: {
                                    message.payout = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ActiveBet message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.ActiveBet} ActiveBet
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ActiveBet.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ActiveBet message.
                     * @function verify
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ActiveBet.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        let properties = {};
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            if (!$util.isInteger(message.slotId))
                                return "slotId: integer expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            if (!$util.isString(message.nickname))
                                return "nickname: string expected";
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            if (!$util.isString(message.avatar))
                                return "avatar: string expected";
                        if (message.autoCashoutLevel != null && message.hasOwnProperty("autoCashoutLevel")) {
                            properties._autoCashoutLevel = 1;
                            if (typeof message.autoCashoutLevel !== "number")
                                return "autoCashoutLevel: number expected";
                        }
                        if (message.multiplier != null && message.hasOwnProperty("multiplier")) {
                            properties._multiplier = 1;
                            if (typeof message.multiplier !== "number")
                                return "multiplier: number expected";
                        }
                        if (message.payout != null && message.hasOwnProperty("payout")) {
                            properties._payout = 1;
                            if (typeof message.payout !== "number")
                                return "payout: number expected";
                        }
                        return null;
                    };

                    /**
                     * Creates an ActiveBet message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.ActiveBet} ActiveBet
                     */
                    ActiveBet.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.ActiveBet)
                            return object;
                        let message = new $root.com.achlid.crash.game.ActiveBet();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.slotId != null)
                            message.slotId = object.slotId | 0;
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.nickname != null)
                            message.nickname = String(object.nickname);
                        if (object.avatar != null)
                            message.avatar = String(object.avatar);
                        if (object.autoCashoutLevel != null)
                            message.autoCashoutLevel = Number(object.autoCashoutLevel);
                        if (object.multiplier != null)
                            message.multiplier = Number(object.multiplier);
                        if (object.payout != null)
                            message.payout = Number(object.payout);
                        return message;
                    };

                    /**
                     * Creates a plain object from an ActiveBet message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {com.achlid.crash.game.ActiveBet} message ActiveBet
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ActiveBet.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.amount = 0;
                            object.slotId = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.nickname = "";
                            object.avatar = "";
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.slotId != null && message.hasOwnProperty("slotId"))
                            object.slotId = message.slotId;
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.nickname != null && message.hasOwnProperty("nickname"))
                            object.nickname = message.nickname;
                        if (message.avatar != null && message.hasOwnProperty("avatar"))
                            object.avatar = message.avatar;
                        if (message.autoCashoutLevel != null && message.hasOwnProperty("autoCashoutLevel")) {
                            object.autoCashoutLevel = options.json && !isFinite(message.autoCashoutLevel) ? String(message.autoCashoutLevel) : message.autoCashoutLevel;
                            if (options.oneofs)
                                object._autoCashoutLevel = "autoCashoutLevel";
                        }
                        if (message.multiplier != null && message.hasOwnProperty("multiplier")) {
                            object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                            if (options.oneofs)
                                object._multiplier = "multiplier";
                        }
                        if (message.payout != null && message.hasOwnProperty("payout")) {
                            object.payout = options.json && !isFinite(message.payout) ? String(message.payout) : message.payout;
                            if (options.oneofs)
                                object._payout = "payout";
                        }
                        return object;
                    };

                    /**
                     * Converts this ActiveBet to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ActiveBet.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ActiveBet
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.ActiveBet
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ActiveBet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.ActiveBet";
                    };

                    return ActiveBet;
                })();

                game.TotalBetsCountUpdate = (function() {

                    /**
                     * Properties of a TotalBetsCountUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface ITotalBetsCountUpdate
                     * @property {number|Long|null} [roundId] TotalBetsCountUpdate roundId
                     * @property {number|null} [activeBetsCount] TotalBetsCountUpdate activeBetsCount
                     * @property {number|null} [cashedOutCount] TotalBetsCountUpdate cashedOutCount
                     * @property {number|null} [totalCount] TotalBetsCountUpdate totalCount
                     * @property {number|null} [totalCashedOutAmount] TotalBetsCountUpdate totalCashedOutAmount
                     */

                    /**
                     * Constructs a new TotalBetsCountUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a TotalBetsCountUpdate.
                     * @implements ITotalBetsCountUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.ITotalBetsCountUpdate=} [properties] Properties to set
                     */
                    function TotalBetsCountUpdate(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * TotalBetsCountUpdate roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     */
                    TotalBetsCountUpdate.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * TotalBetsCountUpdate activeBetsCount.
                     * @member {number} activeBetsCount
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     */
                    TotalBetsCountUpdate.prototype.activeBetsCount = 0;

                    /**
                     * TotalBetsCountUpdate cashedOutCount.
                     * @member {number} cashedOutCount
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     */
                    TotalBetsCountUpdate.prototype.cashedOutCount = 0;

                    /**
                     * TotalBetsCountUpdate totalCount.
                     * @member {number} totalCount
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     */
                    TotalBetsCountUpdate.prototype.totalCount = 0;

                    /**
                     * TotalBetsCountUpdate totalCashedOutAmount.
                     * @member {number} totalCashedOutAmount
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     */
                    TotalBetsCountUpdate.prototype.totalCashedOutAmount = 0;

                    /**
                     * Creates a new TotalBetsCountUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {com.achlid.crash.game.ITotalBetsCountUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.TotalBetsCountUpdate} TotalBetsCountUpdate instance
                     */
                    TotalBetsCountUpdate.create = function create(properties) {
                        return new TotalBetsCountUpdate(properties);
                    };

                    /**
                     * Encodes the specified TotalBetsCountUpdate message. Does not implicitly {@link com.achlid.crash.game.TotalBetsCountUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {com.achlid.crash.game.ITotalBetsCountUpdate} message TotalBetsCountUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TotalBetsCountUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.activeBetsCount != null && Object.hasOwnProperty.call(message, "activeBetsCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.activeBetsCount);
                        if (message.cashedOutCount != null && Object.hasOwnProperty.call(message, "cashedOutCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.cashedOutCount);
                        if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.totalCount);
                        if (message.totalCashedOutAmount != null && Object.hasOwnProperty.call(message, "totalCashedOutAmount"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalCashedOutAmount);
                        return writer;
                    };

                    /**
                     * Encodes the specified TotalBetsCountUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.TotalBetsCountUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {com.achlid.crash.game.ITotalBetsCountUpdate} message TotalBetsCountUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TotalBetsCountUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a TotalBetsCountUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.TotalBetsCountUpdate} TotalBetsCountUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TotalBetsCountUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.TotalBetsCountUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.activeBetsCount = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.cashedOutCount = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.totalCount = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.totalCashedOutAmount = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a TotalBetsCountUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.TotalBetsCountUpdate} TotalBetsCountUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TotalBetsCountUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a TotalBetsCountUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TotalBetsCountUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.activeBetsCount != null && message.hasOwnProperty("activeBetsCount"))
                            if (!$util.isInteger(message.activeBetsCount))
                                return "activeBetsCount: integer expected";
                        if (message.cashedOutCount != null && message.hasOwnProperty("cashedOutCount"))
                            if (!$util.isInteger(message.cashedOutCount))
                                return "cashedOutCount: integer expected";
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            if (!$util.isInteger(message.totalCount))
                                return "totalCount: integer expected";
                        if (message.totalCashedOutAmount != null && message.hasOwnProperty("totalCashedOutAmount"))
                            if (typeof message.totalCashedOutAmount !== "number")
                                return "totalCashedOutAmount: number expected";
                        return null;
                    };

                    /**
                     * Creates a TotalBetsCountUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.TotalBetsCountUpdate} TotalBetsCountUpdate
                     */
                    TotalBetsCountUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.TotalBetsCountUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.TotalBetsCountUpdate();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.activeBetsCount != null)
                            message.activeBetsCount = object.activeBetsCount | 0;
                        if (object.cashedOutCount != null)
                            message.cashedOutCount = object.cashedOutCount | 0;
                        if (object.totalCount != null)
                            message.totalCount = object.totalCount | 0;
                        if (object.totalCashedOutAmount != null)
                            message.totalCashedOutAmount = Number(object.totalCashedOutAmount);
                        return message;
                    };

                    /**
                     * Creates a plain object from a TotalBetsCountUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {com.achlid.crash.game.TotalBetsCountUpdate} message TotalBetsCountUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TotalBetsCountUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.activeBetsCount = 0;
                            object.cashedOutCount = 0;
                            object.totalCount = 0;
                            object.totalCashedOutAmount = 0;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.activeBetsCount != null && message.hasOwnProperty("activeBetsCount"))
                            object.activeBetsCount = message.activeBetsCount;
                        if (message.cashedOutCount != null && message.hasOwnProperty("cashedOutCount"))
                            object.cashedOutCount = message.cashedOutCount;
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            object.totalCount = message.totalCount;
                        if (message.totalCashedOutAmount != null && message.hasOwnProperty("totalCashedOutAmount"))
                            object.totalCashedOutAmount = options.json && !isFinite(message.totalCashedOutAmount) ? String(message.totalCashedOutAmount) : message.totalCashedOutAmount;
                        return object;
                    };

                    /**
                     * Converts this TotalBetsCountUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TotalBetsCountUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for TotalBetsCountUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.TotalBetsCountUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    TotalBetsCountUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.TotalBetsCountUpdate";
                    };

                    return TotalBetsCountUpdate;
                })();

                game.ErrorMessage = (function() {

                    /**
                     * Properties of an ErrorMessage.
                     * @memberof com.achlid.crash.game
                     * @interface IErrorMessage
                     * @property {string|null} [code] ErrorMessage code
                     * @property {string|null} [message] ErrorMessage message
                     * @property {string|null} [details] ErrorMessage details
                     */

                    /**
                     * Constructs a new ErrorMessage.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents an ErrorMessage.
                     * @implements IErrorMessage
                     * @constructor
                     * @param {com.achlid.crash.game.IErrorMessage=} [properties] Properties to set
                     */
                    function ErrorMessage(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ErrorMessage code.
                     * @member {string} code
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @instance
                     */
                    ErrorMessage.prototype.code = "";

                    /**
                     * ErrorMessage message.
                     * @member {string} message
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @instance
                     */
                    ErrorMessage.prototype.message = "";

                    /**
                     * ErrorMessage details.
                     * @member {string} details
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @instance
                     */
                    ErrorMessage.prototype.details = "";

                    /**
                     * Creates a new ErrorMessage instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {com.achlid.crash.game.IErrorMessage=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.ErrorMessage} ErrorMessage instance
                     */
                    ErrorMessage.create = function create(properties) {
                        return new ErrorMessage(properties);
                    };

                    /**
                     * Encodes the specified ErrorMessage message. Does not implicitly {@link com.achlid.crash.game.ErrorMessage.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {com.achlid.crash.game.IErrorMessage} message ErrorMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ErrorMessage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.code);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.details);
                        return writer;
                    };

                    /**
                     * Encodes the specified ErrorMessage message, length delimited. Does not implicitly {@link com.achlid.crash.game.ErrorMessage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {com.achlid.crash.game.IErrorMessage} message ErrorMessage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ErrorMessage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an ErrorMessage message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.ErrorMessage} ErrorMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ErrorMessage.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.ErrorMessage();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.code = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.message = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.details = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an ErrorMessage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.ErrorMessage} ErrorMessage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ErrorMessage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an ErrorMessage message.
                     * @function verify
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ErrorMessage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.details != null && message.hasOwnProperty("details"))
                            if (!$util.isString(message.details))
                                return "details: string expected";
                        return null;
                    };

                    /**
                     * Creates an ErrorMessage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.ErrorMessage} ErrorMessage
                     */
                    ErrorMessage.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.ErrorMessage)
                            return object;
                        let message = new $root.com.achlid.crash.game.ErrorMessage();
                        if (object.code != null)
                            message.code = String(object.code);
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.details != null)
                            message.details = String(object.details);
                        return message;
                    };

                    /**
                     * Creates a plain object from an ErrorMessage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {com.achlid.crash.game.ErrorMessage} message ErrorMessage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ErrorMessage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.code = "";
                            object.message = "";
                            object.details = "";
                        }
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.details != null && message.hasOwnProperty("details"))
                            object.details = message.details;
                        return object;
                    };

                    /**
                     * Converts this ErrorMessage to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ErrorMessage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ErrorMessage
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.ErrorMessage
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ErrorMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.ErrorMessage";
                    };

                    return ErrorMessage;
                })();

                game.PongResponse = (function() {

                    /**
                     * Properties of a PongResponse.
                     * @memberof com.achlid.crash.game
                     * @interface IPongResponse
                     * @property {number|Long|null} [serverTime] PongResponse serverTime
                     * @property {number|Long|null} [clientTime] PongResponse clientTime
                     * @property {number|null} [latencyMs] PongResponse latencyMs
                     */

                    /**
                     * Constructs a new PongResponse.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a PongResponse.
                     * @implements IPongResponse
                     * @constructor
                     * @param {com.achlid.crash.game.IPongResponse=} [properties] Properties to set
                     */
                    function PongResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PongResponse serverTime.
                     * @member {number|Long} serverTime
                     * @memberof com.achlid.crash.game.PongResponse
                     * @instance
                     */
                    PongResponse.prototype.serverTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PongResponse clientTime.
                     * @member {number|Long} clientTime
                     * @memberof com.achlid.crash.game.PongResponse
                     * @instance
                     */
                    PongResponse.prototype.clientTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PongResponse latencyMs.
                     * @member {number} latencyMs
                     * @memberof com.achlid.crash.game.PongResponse
                     * @instance
                     */
                    PongResponse.prototype.latencyMs = 0;

                    /**
                     * Creates a new PongResponse instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {com.achlid.crash.game.IPongResponse=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.PongResponse} PongResponse instance
                     */
                    PongResponse.create = function create(properties) {
                        return new PongResponse(properties);
                    };

                    /**
                     * Encodes the specified PongResponse message. Does not implicitly {@link com.achlid.crash.game.PongResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {com.achlid.crash.game.IPongResponse} message PongResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PongResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.serverTime != null && Object.hasOwnProperty.call(message, "serverTime"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.serverTime);
                        if (message.clientTime != null && Object.hasOwnProperty.call(message, "clientTime"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.clientTime);
                        if (message.latencyMs != null && Object.hasOwnProperty.call(message, "latencyMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.latencyMs);
                        return writer;
                    };

                    /**
                     * Encodes the specified PongResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.PongResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {com.achlid.crash.game.IPongResponse} message PongResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PongResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PongResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.PongResponse} PongResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PongResponse.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.PongResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.serverTime = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.clientTime = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.latencyMs = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PongResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.PongResponse} PongResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PongResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PongResponse message.
                     * @function verify
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PongResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.serverTime != null && message.hasOwnProperty("serverTime"))
                            if (!$util.isInteger(message.serverTime) && !(message.serverTime && $util.isInteger(message.serverTime.low) && $util.isInteger(message.serverTime.high)))
                                return "serverTime: integer|Long expected";
                        if (message.clientTime != null && message.hasOwnProperty("clientTime"))
                            if (!$util.isInteger(message.clientTime) && !(message.clientTime && $util.isInteger(message.clientTime.low) && $util.isInteger(message.clientTime.high)))
                                return "clientTime: integer|Long expected";
                        if (message.latencyMs != null && message.hasOwnProperty("latencyMs"))
                            if (!$util.isInteger(message.latencyMs))
                                return "latencyMs: integer expected";
                        return null;
                    };

                    /**
                     * Creates a PongResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.PongResponse} PongResponse
                     */
                    PongResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.PongResponse)
                            return object;
                        let message = new $root.com.achlid.crash.game.PongResponse();
                        if (object.serverTime != null)
                            if ($util.Long)
                                (message.serverTime = $util.Long.fromValue(object.serverTime)).unsigned = false;
                            else if (typeof object.serverTime === "string")
                                message.serverTime = parseInt(object.serverTime, 10);
                            else if (typeof object.serverTime === "number")
                                message.serverTime = object.serverTime;
                            else if (typeof object.serverTime === "object")
                                message.serverTime = new $util.LongBits(object.serverTime.low >>> 0, object.serverTime.high >>> 0).toNumber();
                        if (object.clientTime != null)
                            if ($util.Long)
                                (message.clientTime = $util.Long.fromValue(object.clientTime)).unsigned = false;
                            else if (typeof object.clientTime === "string")
                                message.clientTime = parseInt(object.clientTime, 10);
                            else if (typeof object.clientTime === "number")
                                message.clientTime = object.clientTime;
                            else if (typeof object.clientTime === "object")
                                message.clientTime = new $util.LongBits(object.clientTime.low >>> 0, object.clientTime.high >>> 0).toNumber();
                        if (object.latencyMs != null)
                            message.latencyMs = object.latencyMs | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a PongResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {com.achlid.crash.game.PongResponse} message PongResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PongResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.serverTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.serverTime = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.clientTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.clientTime = options.longs === String ? "0" : 0;
                            object.latencyMs = 0;
                        }
                        if (message.serverTime != null && message.hasOwnProperty("serverTime"))
                            if (typeof message.serverTime === "number")
                                object.serverTime = options.longs === String ? String(message.serverTime) : message.serverTime;
                            else
                                object.serverTime = options.longs === String ? $util.Long.prototype.toString.call(message.serverTime) : options.longs === Number ? new $util.LongBits(message.serverTime.low >>> 0, message.serverTime.high >>> 0).toNumber() : message.serverTime;
                        if (message.clientTime != null && message.hasOwnProperty("clientTime"))
                            if (typeof message.clientTime === "number")
                                object.clientTime = options.longs === String ? String(message.clientTime) : message.clientTime;
                            else
                                object.clientTime = options.longs === String ? $util.Long.prototype.toString.call(message.clientTime) : options.longs === Number ? new $util.LongBits(message.clientTime.low >>> 0, message.clientTime.high >>> 0).toNumber() : message.clientTime;
                        if (message.latencyMs != null && message.hasOwnProperty("latencyMs"))
                            object.latencyMs = message.latencyMs;
                        return object;
                    };

                    /**
                     * Converts this PongResponse to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.PongResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PongResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PongResponse
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.PongResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PongResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.PongResponse";
                    };

                    return PongResponse;
                })();

                game.GameStateUpdate = (function() {

                    /**
                     * Properties of a GameStateUpdate.
                     * @memberof com.achlid.crash.game
                     * @interface IGameStateUpdate
                     * @property {com.achlid.crash.game.GameStateUpdate.Phase|null} [currentPhase] GameStateUpdate currentPhase
                     * @property {number|Long|null} [currentRoundId] GameStateUpdate currentRoundId
                     * @property {number|Long|null} [nextRoundId] GameStateUpdate nextRoundId
                     * @property {number|null} [currentMultiplier] GameStateUpdate currentMultiplier
                     * @property {number|null} [activePlayers] GameStateUpdate activePlayers
                     * @property {Array.<number>|null} [history] GameStateUpdate history
                     * @property {number|Long|null} [phaseStartTime] GameStateUpdate phaseStartTime
                     * @property {number|Long|null} [phaseDurationMs] GameStateUpdate phaseDurationMs
                     * @property {Array.<com.achlid.crash.game.IActiveBet>|null} [activeBets] GameStateUpdate activeBets
                     */

                    /**
                     * Constructs a new GameStateUpdate.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a GameStateUpdate.
                     * @implements IGameStateUpdate
                     * @constructor
                     * @param {com.achlid.crash.game.IGameStateUpdate=} [properties] Properties to set
                     */
                    function GameStateUpdate(properties) {
                        this.history = [];
                        this.activeBets = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GameStateUpdate currentPhase.
                     * @member {com.achlid.crash.game.GameStateUpdate.Phase} currentPhase
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.currentPhase = 0;

                    /**
                     * GameStateUpdate currentRoundId.
                     * @member {number|Long} currentRoundId
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.currentRoundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * GameStateUpdate nextRoundId.
                     * @member {number|Long} nextRoundId
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.nextRoundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * GameStateUpdate currentMultiplier.
                     * @member {number} currentMultiplier
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.currentMultiplier = 0;

                    /**
                     * GameStateUpdate activePlayers.
                     * @member {number} activePlayers
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.activePlayers = 0;

                    /**
                     * GameStateUpdate history.
                     * @member {Array.<number>} history
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.history = $util.emptyArray;

                    /**
                     * GameStateUpdate phaseStartTime.
                     * @member {number|Long} phaseStartTime
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.phaseStartTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * GameStateUpdate phaseDurationMs.
                     * @member {number|Long} phaseDurationMs
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.phaseDurationMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * GameStateUpdate activeBets.
                     * @member {Array.<com.achlid.crash.game.IActiveBet>} activeBets
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     */
                    GameStateUpdate.prototype.activeBets = $util.emptyArray;

                    /**
                     * Creates a new GameStateUpdate instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {com.achlid.crash.game.IGameStateUpdate=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.GameStateUpdate} GameStateUpdate instance
                     */
                    GameStateUpdate.create = function create(properties) {
                        return new GameStateUpdate(properties);
                    };

                    /**
                     * Encodes the specified GameStateUpdate message. Does not implicitly {@link com.achlid.crash.game.GameStateUpdate.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {com.achlid.crash.game.IGameStateUpdate} message GameStateUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameStateUpdate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.currentPhase != null && Object.hasOwnProperty.call(message, "currentPhase"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.currentPhase);
                        if (message.currentRoundId != null && Object.hasOwnProperty.call(message, "currentRoundId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.currentRoundId);
                        if (message.nextRoundId != null && Object.hasOwnProperty.call(message, "nextRoundId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.nextRoundId);
                        if (message.currentMultiplier != null && Object.hasOwnProperty.call(message, "currentMultiplier"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.currentMultiplier);
                        if (message.activePlayers != null && Object.hasOwnProperty.call(message, "activePlayers"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.activePlayers);
                        if (message.history != null && message.history.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (let i = 0; i < message.history.length; ++i)
                                writer.double(message.history[i]);
                            writer.ldelim();
                        }
                        if (message.phaseStartTime != null && Object.hasOwnProperty.call(message, "phaseStartTime"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.phaseStartTime);
                        if (message.phaseDurationMs != null && Object.hasOwnProperty.call(message, "phaseDurationMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.phaseDurationMs);
                        if (message.activeBets != null && message.activeBets.length)
                            for (let i = 0; i < message.activeBets.length; ++i)
                                $root.com.achlid.crash.game.ActiveBet.encode(message.activeBets[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified GameStateUpdate message, length delimited. Does not implicitly {@link com.achlid.crash.game.GameStateUpdate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {com.achlid.crash.game.IGameStateUpdate} message GameStateUpdate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameStateUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GameStateUpdate message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.GameStateUpdate} GameStateUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameStateUpdate.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.GameStateUpdate();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.currentPhase = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.currentRoundId = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.nextRoundId = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.currentMultiplier = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.activePlayers = reader.int32();
                                    break;
                                }
                            case 6: {
                                    if (!(message.history && message.history.length))
                                        message.history = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.history.push(reader.double());
                                    } else
                                        message.history.push(reader.double());
                                    break;
                                }
                            case 7: {
                                    message.phaseStartTime = reader.int64();
                                    break;
                                }
                            case 8: {
                                    message.phaseDurationMs = reader.int64();
                                    break;
                                }
                            case 9: {
                                    if (!(message.activeBets && message.activeBets.length))
                                        message.activeBets = [];
                                    message.activeBets.push($root.com.achlid.crash.game.ActiveBet.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GameStateUpdate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.GameStateUpdate} GameStateUpdate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameStateUpdate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GameStateUpdate message.
                     * @function verify
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GameStateUpdate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.currentPhase != null && message.hasOwnProperty("currentPhase"))
                            switch (message.currentPhase) {
                            default:
                                return "currentPhase: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.currentRoundId != null && message.hasOwnProperty("currentRoundId"))
                            if (!$util.isInteger(message.currentRoundId) && !(message.currentRoundId && $util.isInteger(message.currentRoundId.low) && $util.isInteger(message.currentRoundId.high)))
                                return "currentRoundId: integer|Long expected";
                        if (message.nextRoundId != null && message.hasOwnProperty("nextRoundId"))
                            if (!$util.isInteger(message.nextRoundId) && !(message.nextRoundId && $util.isInteger(message.nextRoundId.low) && $util.isInteger(message.nextRoundId.high)))
                                return "nextRoundId: integer|Long expected";
                        if (message.currentMultiplier != null && message.hasOwnProperty("currentMultiplier"))
                            if (typeof message.currentMultiplier !== "number")
                                return "currentMultiplier: number expected";
                        if (message.activePlayers != null && message.hasOwnProperty("activePlayers"))
                            if (!$util.isInteger(message.activePlayers))
                                return "activePlayers: integer expected";
                        if (message.history != null && message.hasOwnProperty("history")) {
                            if (!Array.isArray(message.history))
                                return "history: array expected";
                            for (let i = 0; i < message.history.length; ++i)
                                if (typeof message.history[i] !== "number")
                                    return "history: number[] expected";
                        }
                        if (message.phaseStartTime != null && message.hasOwnProperty("phaseStartTime"))
                            if (!$util.isInteger(message.phaseStartTime) && !(message.phaseStartTime && $util.isInteger(message.phaseStartTime.low) && $util.isInteger(message.phaseStartTime.high)))
                                return "phaseStartTime: integer|Long expected";
                        if (message.phaseDurationMs != null && message.hasOwnProperty("phaseDurationMs"))
                            if (!$util.isInteger(message.phaseDurationMs) && !(message.phaseDurationMs && $util.isInteger(message.phaseDurationMs.low) && $util.isInteger(message.phaseDurationMs.high)))
                                return "phaseDurationMs: integer|Long expected";
                        if (message.activeBets != null && message.hasOwnProperty("activeBets")) {
                            if (!Array.isArray(message.activeBets))
                                return "activeBets: array expected";
                            for (let i = 0; i < message.activeBets.length; ++i) {
                                let error = $root.com.achlid.crash.game.ActiveBet.verify(message.activeBets[i]);
                                if (error)
                                    return "activeBets." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a GameStateUpdate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.GameStateUpdate} GameStateUpdate
                     */
                    GameStateUpdate.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.GameStateUpdate)
                            return object;
                        let message = new $root.com.achlid.crash.game.GameStateUpdate();
                        switch (object.currentPhase) {
                        default:
                            if (typeof object.currentPhase === "number") {
                                message.currentPhase = object.currentPhase;
                                break;
                            }
                            break;
                        case "PRE_ROUND":
                        case 0:
                            message.currentPhase = 0;
                            break;
                        case "STARTING":
                        case 1:
                            message.currentPhase = 1;
                            break;
                        case "IN_PROGRESS":
                        case 2:
                            message.currentPhase = 2;
                            break;
                        case "ENDING":
                        case 3:
                            message.currentPhase = 3;
                            break;
                        }
                        if (object.currentRoundId != null)
                            if ($util.Long)
                                (message.currentRoundId = $util.Long.fromValue(object.currentRoundId)).unsigned = false;
                            else if (typeof object.currentRoundId === "string")
                                message.currentRoundId = parseInt(object.currentRoundId, 10);
                            else if (typeof object.currentRoundId === "number")
                                message.currentRoundId = object.currentRoundId;
                            else if (typeof object.currentRoundId === "object")
                                message.currentRoundId = new $util.LongBits(object.currentRoundId.low >>> 0, object.currentRoundId.high >>> 0).toNumber();
                        if (object.nextRoundId != null)
                            if ($util.Long)
                                (message.nextRoundId = $util.Long.fromValue(object.nextRoundId)).unsigned = false;
                            else if (typeof object.nextRoundId === "string")
                                message.nextRoundId = parseInt(object.nextRoundId, 10);
                            else if (typeof object.nextRoundId === "number")
                                message.nextRoundId = object.nextRoundId;
                            else if (typeof object.nextRoundId === "object")
                                message.nextRoundId = new $util.LongBits(object.nextRoundId.low >>> 0, object.nextRoundId.high >>> 0).toNumber();
                        if (object.currentMultiplier != null)
                            message.currentMultiplier = Number(object.currentMultiplier);
                        if (object.activePlayers != null)
                            message.activePlayers = object.activePlayers | 0;
                        if (object.history) {
                            if (!Array.isArray(object.history))
                                throw TypeError(".com.achlid.crash.game.GameStateUpdate.history: array expected");
                            message.history = [];
                            for (let i = 0; i < object.history.length; ++i)
                                message.history[i] = Number(object.history[i]);
                        }
                        if (object.phaseStartTime != null)
                            if ($util.Long)
                                (message.phaseStartTime = $util.Long.fromValue(object.phaseStartTime)).unsigned = false;
                            else if (typeof object.phaseStartTime === "string")
                                message.phaseStartTime = parseInt(object.phaseStartTime, 10);
                            else if (typeof object.phaseStartTime === "number")
                                message.phaseStartTime = object.phaseStartTime;
                            else if (typeof object.phaseStartTime === "object")
                                message.phaseStartTime = new $util.LongBits(object.phaseStartTime.low >>> 0, object.phaseStartTime.high >>> 0).toNumber();
                        if (object.phaseDurationMs != null)
                            if ($util.Long)
                                (message.phaseDurationMs = $util.Long.fromValue(object.phaseDurationMs)).unsigned = false;
                            else if (typeof object.phaseDurationMs === "string")
                                message.phaseDurationMs = parseInt(object.phaseDurationMs, 10);
                            else if (typeof object.phaseDurationMs === "number")
                                message.phaseDurationMs = object.phaseDurationMs;
                            else if (typeof object.phaseDurationMs === "object")
                                message.phaseDurationMs = new $util.LongBits(object.phaseDurationMs.low >>> 0, object.phaseDurationMs.high >>> 0).toNumber();
                        if (object.activeBets) {
                            if (!Array.isArray(object.activeBets))
                                throw TypeError(".com.achlid.crash.game.GameStateUpdate.activeBets: array expected");
                            message.activeBets = [];
                            for (let i = 0; i < object.activeBets.length; ++i) {
                                if (typeof object.activeBets[i] !== "object")
                                    throw TypeError(".com.achlid.crash.game.GameStateUpdate.activeBets: object expected");
                                message.activeBets[i] = $root.com.achlid.crash.game.ActiveBet.fromObject(object.activeBets[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GameStateUpdate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {com.achlid.crash.game.GameStateUpdate} message GameStateUpdate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GameStateUpdate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.history = [];
                            object.activeBets = [];
                        }
                        if (options.defaults) {
                            object.currentPhase = options.enums === String ? "PRE_ROUND" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.currentRoundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.currentRoundId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.nextRoundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.nextRoundId = options.longs === String ? "0" : 0;
                            object.currentMultiplier = 0;
                            object.activePlayers = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.phaseStartTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.phaseStartTime = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.phaseDurationMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.phaseDurationMs = options.longs === String ? "0" : 0;
                        }
                        if (message.currentPhase != null && message.hasOwnProperty("currentPhase"))
                            object.currentPhase = options.enums === String ? $root.com.achlid.crash.game.GameStateUpdate.Phase[message.currentPhase] === undefined ? message.currentPhase : $root.com.achlid.crash.game.GameStateUpdate.Phase[message.currentPhase] : message.currentPhase;
                        if (message.currentRoundId != null && message.hasOwnProperty("currentRoundId"))
                            if (typeof message.currentRoundId === "number")
                                object.currentRoundId = options.longs === String ? String(message.currentRoundId) : message.currentRoundId;
                            else
                                object.currentRoundId = options.longs === String ? $util.Long.prototype.toString.call(message.currentRoundId) : options.longs === Number ? new $util.LongBits(message.currentRoundId.low >>> 0, message.currentRoundId.high >>> 0).toNumber() : message.currentRoundId;
                        if (message.nextRoundId != null && message.hasOwnProperty("nextRoundId"))
                            if (typeof message.nextRoundId === "number")
                                object.nextRoundId = options.longs === String ? String(message.nextRoundId) : message.nextRoundId;
                            else
                                object.nextRoundId = options.longs === String ? $util.Long.prototype.toString.call(message.nextRoundId) : options.longs === Number ? new $util.LongBits(message.nextRoundId.low >>> 0, message.nextRoundId.high >>> 0).toNumber() : message.nextRoundId;
                        if (message.currentMultiplier != null && message.hasOwnProperty("currentMultiplier"))
                            object.currentMultiplier = options.json && !isFinite(message.currentMultiplier) ? String(message.currentMultiplier) : message.currentMultiplier;
                        if (message.activePlayers != null && message.hasOwnProperty("activePlayers"))
                            object.activePlayers = message.activePlayers;
                        if (message.history && message.history.length) {
                            object.history = [];
                            for (let j = 0; j < message.history.length; ++j)
                                object.history[j] = options.json && !isFinite(message.history[j]) ? String(message.history[j]) : message.history[j];
                        }
                        if (message.phaseStartTime != null && message.hasOwnProperty("phaseStartTime"))
                            if (typeof message.phaseStartTime === "number")
                                object.phaseStartTime = options.longs === String ? String(message.phaseStartTime) : message.phaseStartTime;
                            else
                                object.phaseStartTime = options.longs === String ? $util.Long.prototype.toString.call(message.phaseStartTime) : options.longs === Number ? new $util.LongBits(message.phaseStartTime.low >>> 0, message.phaseStartTime.high >>> 0).toNumber() : message.phaseStartTime;
                        if (message.phaseDurationMs != null && message.hasOwnProperty("phaseDurationMs"))
                            if (typeof message.phaseDurationMs === "number")
                                object.phaseDurationMs = options.longs === String ? String(message.phaseDurationMs) : message.phaseDurationMs;
                            else
                                object.phaseDurationMs = options.longs === String ? $util.Long.prototype.toString.call(message.phaseDurationMs) : options.longs === Number ? new $util.LongBits(message.phaseDurationMs.low >>> 0, message.phaseDurationMs.high >>> 0).toNumber() : message.phaseDurationMs;
                        if (message.activeBets && message.activeBets.length) {
                            object.activeBets = [];
                            for (let j = 0; j < message.activeBets.length; ++j)
                                object.activeBets[j] = $root.com.achlid.crash.game.ActiveBet.toObject(message.activeBets[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this GameStateUpdate to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GameStateUpdate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GameStateUpdate
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.GameStateUpdate
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GameStateUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.GameStateUpdate";
                    };

                    /**
                     * Phase enum.
                     * @name com.achlid.crash.game.GameStateUpdate.Phase
                     * @enum {number}
                     * @property {number} PRE_ROUND=0 PRE_ROUND value
                     * @property {number} STARTING=1 STARTING value
                     * @property {number} IN_PROGRESS=2 IN_PROGRESS value
                     * @property {number} ENDING=3 ENDING value
                     */
                    GameStateUpdate.Phase = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PRE_ROUND"] = 0;
                        values[valuesById[1] = "STARTING"] = 1;
                        values[valuesById[2] = "IN_PROGRESS"] = 2;
                        values[valuesById[3] = "ENDING"] = 3;
                        return values;
                    })();

                    return GameStateUpdate;
                })();

                game.GameConfig = (function() {

                    /**
                     * Properties of a GameConfig.
                     * @memberof com.achlid.crash.game
                     * @interface IGameConfig
                     * @property {number|null} [preRoundDurationMs] GameConfig preRoundDurationMs
                     * @property {number|null} [inProgressMaxDurationMs] GameConfig inProgressMaxDurationMs
                     * @property {number|null} [endingDurationMs] GameConfig endingDurationMs
                     * @property {number|null} [tickIntervalMs] GameConfig tickIntervalMs
                     * @property {number|null} [maxMultiplier] GameConfig maxMultiplier
                     * @property {number|null} [minBet] GameConfig minBet
                     * @property {number|null} [maxBet] GameConfig maxBet
                     * @property {Array.<number>|null} [quickBetPresets] GameConfig quickBetPresets
                     */

                    /**
                     * Constructs a new GameConfig.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a GameConfig.
                     * @implements IGameConfig
                     * @constructor
                     * @param {com.achlid.crash.game.IGameConfig=} [properties] Properties to set
                     */
                    function GameConfig(properties) {
                        this.quickBetPresets = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GameConfig preRoundDurationMs.
                     * @member {number} preRoundDurationMs
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.preRoundDurationMs = 0;

                    /**
                     * GameConfig inProgressMaxDurationMs.
                     * @member {number} inProgressMaxDurationMs
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.inProgressMaxDurationMs = 0;

                    /**
                     * GameConfig endingDurationMs.
                     * @member {number} endingDurationMs
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.endingDurationMs = 0;

                    /**
                     * GameConfig tickIntervalMs.
                     * @member {number} tickIntervalMs
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.tickIntervalMs = 0;

                    /**
                     * GameConfig maxMultiplier.
                     * @member {number} maxMultiplier
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.maxMultiplier = 0;

                    /**
                     * GameConfig minBet.
                     * @member {number} minBet
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.minBet = 0;

                    /**
                     * GameConfig maxBet.
                     * @member {number} maxBet
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.maxBet = 0;

                    /**
                     * GameConfig quickBetPresets.
                     * @member {Array.<number>} quickBetPresets
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     */
                    GameConfig.prototype.quickBetPresets = $util.emptyArray;

                    /**
                     * Creates a new GameConfig instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {com.achlid.crash.game.IGameConfig=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.GameConfig} GameConfig instance
                     */
                    GameConfig.create = function create(properties) {
                        return new GameConfig(properties);
                    };

                    /**
                     * Encodes the specified GameConfig message. Does not implicitly {@link com.achlid.crash.game.GameConfig.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {com.achlid.crash.game.IGameConfig} message GameConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.preRoundDurationMs != null && Object.hasOwnProperty.call(message, "preRoundDurationMs"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.preRoundDurationMs);
                        if (message.inProgressMaxDurationMs != null && Object.hasOwnProperty.call(message, "inProgressMaxDurationMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.inProgressMaxDurationMs);
                        if (message.endingDurationMs != null && Object.hasOwnProperty.call(message, "endingDurationMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endingDurationMs);
                        if (message.tickIntervalMs != null && Object.hasOwnProperty.call(message, "tickIntervalMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tickIntervalMs);
                        if (message.maxMultiplier != null && Object.hasOwnProperty.call(message, "maxMultiplier"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.maxMultiplier);
                        if (message.minBet != null && Object.hasOwnProperty.call(message, "minBet"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.minBet);
                        if (message.maxBet != null && Object.hasOwnProperty.call(message, "maxBet"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.maxBet);
                        if (message.quickBetPresets != null && message.quickBetPresets.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (let i = 0; i < message.quickBetPresets.length; ++i)
                                writer.double(message.quickBetPresets[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };

                    /**
                     * Encodes the specified GameConfig message, length delimited. Does not implicitly {@link com.achlid.crash.game.GameConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {com.achlid.crash.game.IGameConfig} message GameConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GameConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GameConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.GameConfig} GameConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameConfig.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.GameConfig();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.preRoundDurationMs = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.inProgressMaxDurationMs = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.endingDurationMs = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.tickIntervalMs = reader.int32();
                                    break;
                                }
                            case 5: {
                                    message.maxMultiplier = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.minBet = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.maxBet = reader.double();
                                    break;
                                }
                            case 8: {
                                    if (!(message.quickBetPresets && message.quickBetPresets.length))
                                        message.quickBetPresets = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.quickBetPresets.push(reader.double());
                                    } else
                                        message.quickBetPresets.push(reader.double());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GameConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.GameConfig} GameConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GameConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GameConfig message.
                     * @function verify
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GameConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.preRoundDurationMs != null && message.hasOwnProperty("preRoundDurationMs"))
                            if (!$util.isInteger(message.preRoundDurationMs))
                                return "preRoundDurationMs: integer expected";
                        if (message.inProgressMaxDurationMs != null && message.hasOwnProperty("inProgressMaxDurationMs"))
                            if (!$util.isInteger(message.inProgressMaxDurationMs))
                                return "inProgressMaxDurationMs: integer expected";
                        if (message.endingDurationMs != null && message.hasOwnProperty("endingDurationMs"))
                            if (!$util.isInteger(message.endingDurationMs))
                                return "endingDurationMs: integer expected";
                        if (message.tickIntervalMs != null && message.hasOwnProperty("tickIntervalMs"))
                            if (!$util.isInteger(message.tickIntervalMs))
                                return "tickIntervalMs: integer expected";
                        if (message.maxMultiplier != null && message.hasOwnProperty("maxMultiplier"))
                            if (typeof message.maxMultiplier !== "number")
                                return "maxMultiplier: number expected";
                        if (message.minBet != null && message.hasOwnProperty("minBet"))
                            if (typeof message.minBet !== "number")
                                return "minBet: number expected";
                        if (message.maxBet != null && message.hasOwnProperty("maxBet"))
                            if (typeof message.maxBet !== "number")
                                return "maxBet: number expected";
                        if (message.quickBetPresets != null && message.hasOwnProperty("quickBetPresets")) {
                            if (!Array.isArray(message.quickBetPresets))
                                return "quickBetPresets: array expected";
                            for (let i = 0; i < message.quickBetPresets.length; ++i)
                                if (typeof message.quickBetPresets[i] !== "number")
                                    return "quickBetPresets: number[] expected";
                        }
                        return null;
                    };

                    /**
                     * Creates a GameConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.GameConfig} GameConfig
                     */
                    GameConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.GameConfig)
                            return object;
                        let message = new $root.com.achlid.crash.game.GameConfig();
                        if (object.preRoundDurationMs != null)
                            message.preRoundDurationMs = object.preRoundDurationMs | 0;
                        if (object.inProgressMaxDurationMs != null)
                            message.inProgressMaxDurationMs = object.inProgressMaxDurationMs | 0;
                        if (object.endingDurationMs != null)
                            message.endingDurationMs = object.endingDurationMs | 0;
                        if (object.tickIntervalMs != null)
                            message.tickIntervalMs = object.tickIntervalMs | 0;
                        if (object.maxMultiplier != null)
                            message.maxMultiplier = Number(object.maxMultiplier);
                        if (object.minBet != null)
                            message.minBet = Number(object.minBet);
                        if (object.maxBet != null)
                            message.maxBet = Number(object.maxBet);
                        if (object.quickBetPresets) {
                            if (!Array.isArray(object.quickBetPresets))
                                throw TypeError(".com.achlid.crash.game.GameConfig.quickBetPresets: array expected");
                            message.quickBetPresets = [];
                            for (let i = 0; i < object.quickBetPresets.length; ++i)
                                message.quickBetPresets[i] = Number(object.quickBetPresets[i]);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GameConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {com.achlid.crash.game.GameConfig} message GameConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GameConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.quickBetPresets = [];
                        if (options.defaults) {
                            object.preRoundDurationMs = 0;
                            object.inProgressMaxDurationMs = 0;
                            object.endingDurationMs = 0;
                            object.tickIntervalMs = 0;
                            object.maxMultiplier = 0;
                            object.minBet = 0;
                            object.maxBet = 0;
                        }
                        if (message.preRoundDurationMs != null && message.hasOwnProperty("preRoundDurationMs"))
                            object.preRoundDurationMs = message.preRoundDurationMs;
                        if (message.inProgressMaxDurationMs != null && message.hasOwnProperty("inProgressMaxDurationMs"))
                            object.inProgressMaxDurationMs = message.inProgressMaxDurationMs;
                        if (message.endingDurationMs != null && message.hasOwnProperty("endingDurationMs"))
                            object.endingDurationMs = message.endingDurationMs;
                        if (message.tickIntervalMs != null && message.hasOwnProperty("tickIntervalMs"))
                            object.tickIntervalMs = message.tickIntervalMs;
                        if (message.maxMultiplier != null && message.hasOwnProperty("maxMultiplier"))
                            object.maxMultiplier = options.json && !isFinite(message.maxMultiplier) ? String(message.maxMultiplier) : message.maxMultiplier;
                        if (message.minBet != null && message.hasOwnProperty("minBet"))
                            object.minBet = options.json && !isFinite(message.minBet) ? String(message.minBet) : message.minBet;
                        if (message.maxBet != null && message.hasOwnProperty("maxBet"))
                            object.maxBet = options.json && !isFinite(message.maxBet) ? String(message.maxBet) : message.maxBet;
                        if (message.quickBetPresets && message.quickBetPresets.length) {
                            object.quickBetPresets = [];
                            for (let j = 0; j < message.quickBetPresets.length; ++j)
                                object.quickBetPresets[j] = options.json && !isFinite(message.quickBetPresets[j]) ? String(message.quickBetPresets[j]) : message.quickBetPresets[j];
                        }
                        return object;
                    };

                    /**
                     * Converts this GameConfig to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.GameConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GameConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GameConfig
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.GameConfig
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GameConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.GameConfig";
                    };

                    return GameConfig;
                })();

                game.RoundHistory = (function() {

                    /**
                     * Properties of a RoundHistory.
                     * @memberof com.achlid.crash.game
                     * @interface IRoundHistory
                     * @property {number|Long|null} [roundId] RoundHistory roundId
                     * @property {number|null} [crashPoint] RoundHistory crashPoint
                     * @property {number|Long|null} [timestamp] RoundHistory timestamp
                     */

                    /**
                     * Constructs a new RoundHistory.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a RoundHistory.
                     * @implements IRoundHistory
                     * @constructor
                     * @param {com.achlid.crash.game.IRoundHistory=} [properties] Properties to set
                     */
                    function RoundHistory(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RoundHistory roundId.
                     * @member {number|Long} roundId
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @instance
                     */
                    RoundHistory.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * RoundHistory crashPoint.
                     * @member {number} crashPoint
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @instance
                     */
                    RoundHistory.prototype.crashPoint = 0;

                    /**
                     * RoundHistory timestamp.
                     * @member {number|Long} timestamp
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @instance
                     */
                    RoundHistory.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * Creates a new RoundHistory instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {com.achlid.crash.game.IRoundHistory=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.RoundHistory} RoundHistory instance
                     */
                    RoundHistory.create = function create(properties) {
                        return new RoundHistory(properties);
                    };

                    /**
                     * Encodes the specified RoundHistory message. Does not implicitly {@link com.achlid.crash.game.RoundHistory.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {com.achlid.crash.game.IRoundHistory} message RoundHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundHistory.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                        if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.crashPoint);
                        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.timestamp);
                        return writer;
                    };

                    /**
                     * Encodes the specified RoundHistory message, length delimited. Does not implicitly {@link com.achlid.crash.game.RoundHistory.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {com.achlid.crash.game.IRoundHistory} message RoundHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RoundHistory.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RoundHistory message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.RoundHistory} RoundHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundHistory.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.RoundHistory();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.roundId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.crashPoint = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.timestamp = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RoundHistory message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.RoundHistory} RoundHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RoundHistory.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RoundHistory message.
                     * @function verify
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RoundHistory.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                return "roundId: integer|Long expected";
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            if (typeof message.crashPoint !== "number")
                                return "crashPoint: number expected";
                        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                return "timestamp: integer|Long expected";
                        return null;
                    };

                    /**
                     * Creates a RoundHistory message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.RoundHistory} RoundHistory
                     */
                    RoundHistory.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.RoundHistory)
                            return object;
                        let message = new $root.com.achlid.crash.game.RoundHistory();
                        if (object.roundId != null)
                            if ($util.Long)
                                (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                            else if (typeof object.roundId === "string")
                                message.roundId = parseInt(object.roundId, 10);
                            else if (typeof object.roundId === "number")
                                message.roundId = object.roundId;
                            else if (typeof object.roundId === "object")
                                message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                        if (object.crashPoint != null)
                            message.crashPoint = Number(object.crashPoint);
                        if (object.timestamp != null)
                            if ($util.Long)
                                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                            else if (typeof object.timestamp === "string")
                                message.timestamp = parseInt(object.timestamp, 10);
                            else if (typeof object.timestamp === "number")
                                message.timestamp = object.timestamp;
                            else if (typeof object.timestamp === "object")
                                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a RoundHistory message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {com.achlid.crash.game.RoundHistory} message RoundHistory
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RoundHistory.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.roundId = options.longs === String ? "0" : 0;
                            object.crashPoint = 0;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timestamp = options.longs === String ? "0" : 0;
                        }
                        if (message.roundId != null && message.hasOwnProperty("roundId"))
                            if (typeof message.roundId === "number")
                                object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                            else
                                object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                            if (typeof message.timestamp === "number")
                                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                            else
                                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                        return object;
                    };

                    /**
                     * Converts this RoundHistory to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RoundHistory.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RoundHistory
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.RoundHistory
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RoundHistory.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.RoundHistory";
                    };

                    return RoundHistory;
                })();

                game.SetForcedCrashPointRequest = (function() {

                    /**
                     * Properties of a SetForcedCrashPointRequest.
                     * @memberof com.achlid.crash.game
                     * @interface ISetForcedCrashPointRequest
                     * @property {number|null} [crashPoint] SetForcedCrashPointRequest crashPoint
                     */

                    /**
                     * Constructs a new SetForcedCrashPointRequest.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a SetForcedCrashPointRequest.
                     * @implements ISetForcedCrashPointRequest
                     * @constructor
                     * @param {com.achlid.crash.game.ISetForcedCrashPointRequest=} [properties] Properties to set
                     */
                    function SetForcedCrashPointRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SetForcedCrashPointRequest crashPoint.
                     * @member {number} crashPoint
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @instance
                     */
                    SetForcedCrashPointRequest.prototype.crashPoint = 0;

                    /**
                     * Creates a new SetForcedCrashPointRequest instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointRequest=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.SetForcedCrashPointRequest} SetForcedCrashPointRequest instance
                     */
                    SetForcedCrashPointRequest.create = function create(properties) {
                        return new SetForcedCrashPointRequest(properties);
                    };

                    /**
                     * Encodes the specified SetForcedCrashPointRequest message. Does not implicitly {@link com.achlid.crash.game.SetForcedCrashPointRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointRequest} message SetForcedCrashPointRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetForcedCrashPointRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.crashPoint);
                        return writer;
                    };

                    /**
                     * Encodes the specified SetForcedCrashPointRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.SetForcedCrashPointRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointRequest} message SetForcedCrashPointRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetForcedCrashPointRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SetForcedCrashPointRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.SetForcedCrashPointRequest} SetForcedCrashPointRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetForcedCrashPointRequest.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.SetForcedCrashPointRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.crashPoint = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SetForcedCrashPointRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.SetForcedCrashPointRequest} SetForcedCrashPointRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetForcedCrashPointRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SetForcedCrashPointRequest message.
                     * @function verify
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SetForcedCrashPointRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            if (typeof message.crashPoint !== "number")
                                return "crashPoint: number expected";
                        return null;
                    };

                    /**
                     * Creates a SetForcedCrashPointRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.SetForcedCrashPointRequest} SetForcedCrashPointRequest
                     */
                    SetForcedCrashPointRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.SetForcedCrashPointRequest)
                            return object;
                        let message = new $root.com.achlid.crash.game.SetForcedCrashPointRequest();
                        if (object.crashPoint != null)
                            message.crashPoint = Number(object.crashPoint);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SetForcedCrashPointRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {com.achlid.crash.game.SetForcedCrashPointRequest} message SetForcedCrashPointRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SetForcedCrashPointRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.crashPoint = 0;
                        if (message.crashPoint != null && message.hasOwnProperty("crashPoint"))
                            object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                        return object;
                    };

                    /**
                     * Converts this SetForcedCrashPointRequest to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SetForcedCrashPointRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SetForcedCrashPointRequest
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.SetForcedCrashPointRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SetForcedCrashPointRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.SetForcedCrashPointRequest";
                    };

                    return SetForcedCrashPointRequest;
                })();

                game.SetForcedCrashPointResult = (function() {

                    /**
                     * Properties of a SetForcedCrashPointResult.
                     * @memberof com.achlid.crash.game
                     * @interface ISetForcedCrashPointResult
                     * @property {boolean|null} [success] SetForcedCrashPointResult success
                     * @property {number|null} [currentForcedCrashPoint] SetForcedCrashPointResult currentForcedCrashPoint
                     * @property {string|null} [message] SetForcedCrashPointResult message
                     */

                    /**
                     * Constructs a new SetForcedCrashPointResult.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a SetForcedCrashPointResult.
                     * @implements ISetForcedCrashPointResult
                     * @constructor
                     * @param {com.achlid.crash.game.ISetForcedCrashPointResult=} [properties] Properties to set
                     */
                    function SetForcedCrashPointResult(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SetForcedCrashPointResult success.
                     * @member {boolean} success
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @instance
                     */
                    SetForcedCrashPointResult.prototype.success = false;

                    /**
                     * SetForcedCrashPointResult currentForcedCrashPoint.
                     * @member {number} currentForcedCrashPoint
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @instance
                     */
                    SetForcedCrashPointResult.prototype.currentForcedCrashPoint = 0;

                    /**
                     * SetForcedCrashPointResult message.
                     * @member {string} message
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @instance
                     */
                    SetForcedCrashPointResult.prototype.message = "";

                    /**
                     * Creates a new SetForcedCrashPointResult instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointResult=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.SetForcedCrashPointResult} SetForcedCrashPointResult instance
                     */
                    SetForcedCrashPointResult.create = function create(properties) {
                        return new SetForcedCrashPointResult(properties);
                    };

                    /**
                     * Encodes the specified SetForcedCrashPointResult message. Does not implicitly {@link com.achlid.crash.game.SetForcedCrashPointResult.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointResult} message SetForcedCrashPointResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetForcedCrashPointResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                        if (message.currentForcedCrashPoint != null && Object.hasOwnProperty.call(message, "currentForcedCrashPoint"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.currentForcedCrashPoint);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
                        return writer;
                    };

                    /**
                     * Encodes the specified SetForcedCrashPointResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.SetForcedCrashPointResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {com.achlid.crash.game.ISetForcedCrashPointResult} message SetForcedCrashPointResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SetForcedCrashPointResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a SetForcedCrashPointResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.SetForcedCrashPointResult} SetForcedCrashPointResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetForcedCrashPointResult.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.SetForcedCrashPointResult();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.success = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.currentForcedCrashPoint = reader.double();
                                    break;
                                }
                            case 3: {
                                    message.message = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a SetForcedCrashPointResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.SetForcedCrashPointResult} SetForcedCrashPointResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SetForcedCrashPointResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a SetForcedCrashPointResult message.
                     * @function verify
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SetForcedCrashPointResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        if (message.currentForcedCrashPoint != null && message.hasOwnProperty("currentForcedCrashPoint"))
                            if (typeof message.currentForcedCrashPoint !== "number")
                                return "currentForcedCrashPoint: number expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };

                    /**
                     * Creates a SetForcedCrashPointResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.SetForcedCrashPointResult} SetForcedCrashPointResult
                     */
                    SetForcedCrashPointResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.SetForcedCrashPointResult)
                            return object;
                        let message = new $root.com.achlid.crash.game.SetForcedCrashPointResult();
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        if (object.currentForcedCrashPoint != null)
                            message.currentForcedCrashPoint = Number(object.currentForcedCrashPoint);
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };

                    /**
                     * Creates a plain object from a SetForcedCrashPointResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {com.achlid.crash.game.SetForcedCrashPointResult} message SetForcedCrashPointResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SetForcedCrashPointResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.success = false;
                            object.currentForcedCrashPoint = 0;
                            object.message = "";
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        if (message.currentForcedCrashPoint != null && message.hasOwnProperty("currentForcedCrashPoint"))
                            object.currentForcedCrashPoint = options.json && !isFinite(message.currentForcedCrashPoint) ? String(message.currentForcedCrashPoint) : message.currentForcedCrashPoint;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };

                    /**
                     * Converts this SetForcedCrashPointResult to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SetForcedCrashPointResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SetForcedCrashPointResult
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.SetForcedCrashPointResult
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SetForcedCrashPointResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.SetForcedCrashPointResult";
                    };

                    return SetForcedCrashPointResult;
                })();

                game.PlayerStats = (function() {

                    /**
                     * Properties of a PlayerStats.
                     * @memberof com.achlid.crash.game
                     * @interface IPlayerStats
                     * @property {number|Long|null} [userId] PlayerStats userId
                     * @property {number|null} [totalGames] PlayerStats totalGames
                     * @property {number|null} [totalWins] PlayerStats totalWins
                     * @property {number|null} [totalWagered] PlayerStats totalWagered
                     * @property {number|null} [totalWon] PlayerStats totalWon
                     * @property {number|null} [biggestWin] PlayerStats biggestWin
                     * @property {number|null} [biggestMultiplier] PlayerStats biggestMultiplier
                     */

                    /**
                     * Constructs a new PlayerStats.
                     * @memberof com.achlid.crash.game
                     * @classdesc Represents a PlayerStats.
                     * @implements IPlayerStats
                     * @constructor
                     * @param {com.achlid.crash.game.IPlayerStats=} [properties] Properties to set
                     */
                    function PlayerStats(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * PlayerStats userId.
                     * @member {number|Long} userId
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * PlayerStats totalGames.
                     * @member {number} totalGames
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.totalGames = 0;

                    /**
                     * PlayerStats totalWins.
                     * @member {number} totalWins
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.totalWins = 0;

                    /**
                     * PlayerStats totalWagered.
                     * @member {number} totalWagered
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.totalWagered = 0;

                    /**
                     * PlayerStats totalWon.
                     * @member {number} totalWon
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.totalWon = 0;

                    /**
                     * PlayerStats biggestWin.
                     * @member {number} biggestWin
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.biggestWin = 0;

                    /**
                     * PlayerStats biggestMultiplier.
                     * @member {number} biggestMultiplier
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     */
                    PlayerStats.prototype.biggestMultiplier = 0;

                    /**
                     * Creates a new PlayerStats instance using the specified properties.
                     * @function create
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {com.achlid.crash.game.IPlayerStats=} [properties] Properties to set
                     * @returns {com.achlid.crash.game.PlayerStats} PlayerStats instance
                     */
                    PlayerStats.create = function create(properties) {
                        return new PlayerStats(properties);
                    };

                    /**
                     * Encodes the specified PlayerStats message. Does not implicitly {@link com.achlid.crash.game.PlayerStats.verify|verify} messages.
                     * @function encode
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {com.achlid.crash.game.IPlayerStats} message PlayerStats message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerStats.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                        if (message.totalGames != null && Object.hasOwnProperty.call(message, "totalGames"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalGames);
                        if (message.totalWins != null && Object.hasOwnProperty.call(message, "totalWins"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalWins);
                        if (message.totalWagered != null && Object.hasOwnProperty.call(message, "totalWagered"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.totalWagered);
                        if (message.totalWon != null && Object.hasOwnProperty.call(message, "totalWon"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalWon);
                        if (message.biggestWin != null && Object.hasOwnProperty.call(message, "biggestWin"))
                            writer.uint32(/* id 6, wireType 1 =*/49).double(message.biggestWin);
                        if (message.biggestMultiplier != null && Object.hasOwnProperty.call(message, "biggestMultiplier"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.biggestMultiplier);
                        return writer;
                    };

                    /**
                     * Encodes the specified PlayerStats message, length delimited. Does not implicitly {@link com.achlid.crash.game.PlayerStats.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {com.achlid.crash.game.IPlayerStats} message PlayerStats message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PlayerStats.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a PlayerStats message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.achlid.crash.game.PlayerStats} PlayerStats
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerStats.decode = function decode(reader, length, error) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.PlayerStats();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.totalGames = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.totalWins = reader.int32();
                                    break;
                                }
                            case 4: {
                                    message.totalWagered = reader.double();
                                    break;
                                }
                            case 5: {
                                    message.totalWon = reader.double();
                                    break;
                                }
                            case 6: {
                                    message.biggestWin = reader.double();
                                    break;
                                }
                            case 7: {
                                    message.biggestMultiplier = reader.double();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a PlayerStats message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.achlid.crash.game.PlayerStats} PlayerStats
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PlayerStats.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a PlayerStats message.
                     * @function verify
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PlayerStats.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.totalGames != null && message.hasOwnProperty("totalGames"))
                            if (!$util.isInteger(message.totalGames))
                                return "totalGames: integer expected";
                        if (message.totalWins != null && message.hasOwnProperty("totalWins"))
                            if (!$util.isInteger(message.totalWins))
                                return "totalWins: integer expected";
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            if (typeof message.totalWagered !== "number")
                                return "totalWagered: number expected";
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            if (typeof message.totalWon !== "number")
                                return "totalWon: number expected";
                        if (message.biggestWin != null && message.hasOwnProperty("biggestWin"))
                            if (typeof message.biggestWin !== "number")
                                return "biggestWin: number expected";
                        if (message.biggestMultiplier != null && message.hasOwnProperty("biggestMultiplier"))
                            if (typeof message.biggestMultiplier !== "number")
                                return "biggestMultiplier: number expected";
                        return null;
                    };

                    /**
                     * Creates a PlayerStats message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.achlid.crash.game.PlayerStats} PlayerStats
                     */
                    PlayerStats.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.achlid.crash.game.PlayerStats)
                            return object;
                        let message = new $root.com.achlid.crash.game.PlayerStats();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.totalGames != null)
                            message.totalGames = object.totalGames | 0;
                        if (object.totalWins != null)
                            message.totalWins = object.totalWins | 0;
                        if (object.totalWagered != null)
                            message.totalWagered = Number(object.totalWagered);
                        if (object.totalWon != null)
                            message.totalWon = Number(object.totalWon);
                        if (object.biggestWin != null)
                            message.biggestWin = Number(object.biggestWin);
                        if (object.biggestMultiplier != null)
                            message.biggestMultiplier = Number(object.biggestMultiplier);
                        return message;
                    };

                    /**
                     * Creates a plain object from a PlayerStats message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {com.achlid.crash.game.PlayerStats} message PlayerStats
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PlayerStats.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.totalGames = 0;
                            object.totalWins = 0;
                            object.totalWagered = 0;
                            object.totalWon = 0;
                            object.biggestWin = 0;
                            object.biggestMultiplier = 0;
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.totalGames != null && message.hasOwnProperty("totalGames"))
                            object.totalGames = message.totalGames;
                        if (message.totalWins != null && message.hasOwnProperty("totalWins"))
                            object.totalWins = message.totalWins;
                        if (message.totalWagered != null && message.hasOwnProperty("totalWagered"))
                            object.totalWagered = options.json && !isFinite(message.totalWagered) ? String(message.totalWagered) : message.totalWagered;
                        if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                            object.totalWon = options.json && !isFinite(message.totalWon) ? String(message.totalWon) : message.totalWon;
                        if (message.biggestWin != null && message.hasOwnProperty("biggestWin"))
                            object.biggestWin = options.json && !isFinite(message.biggestWin) ? String(message.biggestWin) : message.biggestWin;
                        if (message.biggestMultiplier != null && message.hasOwnProperty("biggestMultiplier"))
                            object.biggestMultiplier = options.json && !isFinite(message.biggestMultiplier) ? String(message.biggestMultiplier) : message.biggestMultiplier;
                        return object;
                    };

                    /**
                     * Converts this PlayerStats to JSON.
                     * @function toJSON
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PlayerStats.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for PlayerStats
                     * @function getTypeUrl
                     * @memberof com.achlid.crash.game.PlayerStats
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    PlayerStats.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.achlid.crash.game.PlayerStats";
                    };

                    return PlayerStats;
                })();

                game.stateless = (function() {

                    /**
                     * Namespace stateless.
                     * @memberof com.achlid.crash.game
                     * @namespace
                     */
                    const stateless = {};

                    stateless.GetWalletRequest = (function() {

                        /**
                         * Properties of a GetWalletRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetWalletRequest
                         */

                        /**
                         * Constructs a new GetWalletRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetWalletRequest.
                         * @implements IGetWalletRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetWalletRequest=} [properties] Properties to set
                         */
                        function GetWalletRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Creates a new GetWalletRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetWalletRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetWalletRequest} GetWalletRequest instance
                         */
                        GetWalletRequest.create = function create(properties) {
                            return new GetWalletRequest(properties);
                        };

                        /**
                         * Encodes the specified GetWalletRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetWalletRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetWalletRequest} message GetWalletRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetWalletRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            return writer;
                        };

                        /**
                         * Encodes the specified GetWalletRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetWalletRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetWalletRequest} message GetWalletRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetWalletRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetWalletRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetWalletRequest} GetWalletRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetWalletRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetWalletRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetWalletRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetWalletRequest} GetWalletRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetWalletRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetWalletRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetWalletRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            return null;
                        };

                        /**
                         * Creates a GetWalletRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetWalletRequest} GetWalletRequest
                         */
                        GetWalletRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetWalletRequest)
                                return object;
                            return new $root.com.achlid.crash.game.stateless.GetWalletRequest();
                        };

                        /**
                         * Creates a plain object from a GetWalletRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetWalletRequest} message GetWalletRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetWalletRequest.toObject = function toObject() {
                            return {};
                        };

                        /**
                         * Converts this GetWalletRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetWalletRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetWalletRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetWalletRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetWalletRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetWalletRequest";
                        };

                        return GetWalletRequest;
                    })();

                    stateless.WalletResponse = (function() {

                        /**
                         * Properties of a WalletResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IWalletResponse
                         * @property {number|null} [balance] WalletResponse balance
                         * @property {number|null} [reserved] WalletResponse reserved
                         * @property {boolean|null} [hasPendingOperations] WalletResponse hasPendingOperations
                         * @property {number|null} [pendingAvailableDelta] WalletResponse pendingAvailableDelta
                         * @property {number|null} [pendingReservedDelta] WalletResponse pendingReservedDelta
                         */

                        /**
                         * Constructs a new WalletResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a WalletResponse.
                         * @implements IWalletResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IWalletResponse=} [properties] Properties to set
                         */
                        function WalletResponse(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * WalletResponse balance.
                         * @member {number} balance
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         */
                        WalletResponse.prototype.balance = 0;

                        /**
                         * WalletResponse reserved.
                         * @member {number} reserved
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         */
                        WalletResponse.prototype.reserved = 0;

                        /**
                         * WalletResponse hasPendingOperations.
                         * @member {boolean} hasPendingOperations
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         */
                        WalletResponse.prototype.hasPendingOperations = false;

                        /**
                         * WalletResponse pendingAvailableDelta.
                         * @member {number} pendingAvailableDelta
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         */
                        WalletResponse.prototype.pendingAvailableDelta = 0;

                        /**
                         * WalletResponse pendingReservedDelta.
                         * @member {number} pendingReservedDelta
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         */
                        WalletResponse.prototype.pendingReservedDelta = 0;

                        /**
                         * Creates a new WalletResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IWalletResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.WalletResponse} WalletResponse instance
                         */
                        WalletResponse.create = function create(properties) {
                            return new WalletResponse(properties);
                        };

                        /**
                         * Encodes the specified WalletResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.WalletResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IWalletResponse} message WalletResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        WalletResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                                writer.uint32(/* id 1, wireType 1 =*/9).double(message.balance);
                            if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                                writer.uint32(/* id 2, wireType 1 =*/17).double(message.reserved);
                            if (message.hasPendingOperations != null && Object.hasOwnProperty.call(message, "hasPendingOperations"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hasPendingOperations);
                            if (message.pendingAvailableDelta != null && Object.hasOwnProperty.call(message, "pendingAvailableDelta"))
                                writer.uint32(/* id 4, wireType 1 =*/33).double(message.pendingAvailableDelta);
                            if (message.pendingReservedDelta != null && Object.hasOwnProperty.call(message, "pendingReservedDelta"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.pendingReservedDelta);
                            return writer;
                        };

                        /**
                         * Encodes the specified WalletResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.WalletResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IWalletResponse} message WalletResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        WalletResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a WalletResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.WalletResponse} WalletResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        WalletResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.WalletResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.balance = reader.double();
                                        break;
                                    }
                                case 2: {
                                        message.reserved = reader.double();
                                        break;
                                    }
                                case 3: {
                                        message.hasPendingOperations = reader.bool();
                                        break;
                                    }
                                case 4: {
                                        message.pendingAvailableDelta = reader.double();
                                        break;
                                    }
                                case 5: {
                                        message.pendingReservedDelta = reader.double();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a WalletResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.WalletResponse} WalletResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        WalletResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a WalletResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        WalletResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.balance != null && message.hasOwnProperty("balance"))
                                if (typeof message.balance !== "number")
                                    return "balance: number expected";
                            if (message.reserved != null && message.hasOwnProperty("reserved"))
                                if (typeof message.reserved !== "number")
                                    return "reserved: number expected";
                            if (message.hasPendingOperations != null && message.hasOwnProperty("hasPendingOperations"))
                                if (typeof message.hasPendingOperations !== "boolean")
                                    return "hasPendingOperations: boolean expected";
                            if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                                if (typeof message.pendingAvailableDelta !== "number")
                                    return "pendingAvailableDelta: number expected";
                            if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                                if (typeof message.pendingReservedDelta !== "number")
                                    return "pendingReservedDelta: number expected";
                            return null;
                        };

                        /**
                         * Creates a WalletResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.WalletResponse} WalletResponse
                         */
                        WalletResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.WalletResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.WalletResponse();
                            if (object.balance != null)
                                message.balance = Number(object.balance);
                            if (object.reserved != null)
                                message.reserved = Number(object.reserved);
                            if (object.hasPendingOperations != null)
                                message.hasPendingOperations = Boolean(object.hasPendingOperations);
                            if (object.pendingAvailableDelta != null)
                                message.pendingAvailableDelta = Number(object.pendingAvailableDelta);
                            if (object.pendingReservedDelta != null)
                                message.pendingReservedDelta = Number(object.pendingReservedDelta);
                            return message;
                        };

                        /**
                         * Creates a plain object from a WalletResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.WalletResponse} message WalletResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        WalletResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.balance = 0;
                                object.reserved = 0;
                                object.hasPendingOperations = false;
                                object.pendingAvailableDelta = 0;
                                object.pendingReservedDelta = 0;
                            }
                            if (message.balance != null && message.hasOwnProperty("balance"))
                                object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                            if (message.reserved != null && message.hasOwnProperty("reserved"))
                                object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                            if (message.hasPendingOperations != null && message.hasOwnProperty("hasPendingOperations"))
                                object.hasPendingOperations = message.hasPendingOperations;
                            if (message.pendingAvailableDelta != null && message.hasOwnProperty("pendingAvailableDelta"))
                                object.pendingAvailableDelta = options.json && !isFinite(message.pendingAvailableDelta) ? String(message.pendingAvailableDelta) : message.pendingAvailableDelta;
                            if (message.pendingReservedDelta != null && message.hasOwnProperty("pendingReservedDelta"))
                                object.pendingReservedDelta = options.json && !isFinite(message.pendingReservedDelta) ? String(message.pendingReservedDelta) : message.pendingReservedDelta;
                            return object;
                        };

                        /**
                         * Converts this WalletResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        WalletResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for WalletResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.WalletResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        WalletResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.WalletResponse";
                        };

                        return WalletResponse;
                    })();

                    stateless.GetUserProfileRequest = (function() {

                        /**
                         * Properties of a GetUserProfileRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetUserProfileRequest
                         */

                        /**
                         * Constructs a new GetUserProfileRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetUserProfileRequest.
                         * @implements IGetUserProfileRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetUserProfileRequest=} [properties] Properties to set
                         */
                        function GetUserProfileRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Creates a new GetUserProfileRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetUserProfileRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetUserProfileRequest} GetUserProfileRequest instance
                         */
                        GetUserProfileRequest.create = function create(properties) {
                            return new GetUserProfileRequest(properties);
                        };

                        /**
                         * Encodes the specified GetUserProfileRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetUserProfileRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetUserProfileRequest} message GetUserProfileRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetUserProfileRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            return writer;
                        };

                        /**
                         * Encodes the specified GetUserProfileRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetUserProfileRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetUserProfileRequest} message GetUserProfileRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetUserProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetUserProfileRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetUserProfileRequest} GetUserProfileRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetUserProfileRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetUserProfileRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetUserProfileRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetUserProfileRequest} GetUserProfileRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetUserProfileRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetUserProfileRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetUserProfileRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            return null;
                        };

                        /**
                         * Creates a GetUserProfileRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetUserProfileRequest} GetUserProfileRequest
                         */
                        GetUserProfileRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetUserProfileRequest)
                                return object;
                            return new $root.com.achlid.crash.game.stateless.GetUserProfileRequest();
                        };

                        /**
                         * Creates a plain object from a GetUserProfileRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetUserProfileRequest} message GetUserProfileRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetUserProfileRequest.toObject = function toObject() {
                            return {};
                        };

                        /**
                         * Converts this GetUserProfileRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetUserProfileRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetUserProfileRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetUserProfileRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetUserProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetUserProfileRequest";
                        };

                        return GetUserProfileRequest;
                    })();

                    stateless.UserProfileResponse = (function() {

                        /**
                         * Properties of a UserProfileResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IUserProfileResponse
                         * @property {number|Long|null} [userId] UserProfileResponse userId
                         * @property {string|null} [nickname] UserProfileResponse nickname
                         * @property {string|null} [avatar] UserProfileResponse avatar
                         * @property {string|null} [backgroundSkin] UserProfileResponse backgroundSkin
                         * @property {string|null} [generalSkin] UserProfileResponse generalSkin
                         * @property {number|Long|null} [createdAt] UserProfileResponse createdAt
                         * @property {number|Long|null} [updatedAt] UserProfileResponse updatedAt
                         * @property {number|null} [balance] UserProfileResponse balance
                         * @property {number|null} [reserved] UserProfileResponse reserved
                         */

                        /**
                         * Constructs a new UserProfileResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a UserProfileResponse.
                         * @implements IUserProfileResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IUserProfileResponse=} [properties] Properties to set
                         */
                        function UserProfileResponse(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * UserProfileResponse userId.
                         * @member {number|Long} userId
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * UserProfileResponse nickname.
                         * @member {string} nickname
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.nickname = "";

                        /**
                         * UserProfileResponse avatar.
                         * @member {string} avatar
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.avatar = "";

                        /**
                         * UserProfileResponse backgroundSkin.
                         * @member {string} backgroundSkin
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.backgroundSkin = "";

                        /**
                         * UserProfileResponse generalSkin.
                         * @member {string} generalSkin
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.generalSkin = "";

                        /**
                         * UserProfileResponse createdAt.
                         * @member {number|Long} createdAt
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * UserProfileResponse updatedAt.
                         * @member {number|Long} updatedAt
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * UserProfileResponse balance.
                         * @member {number} balance
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.balance = 0;

                        /**
                         * UserProfileResponse reserved.
                         * @member {number} reserved
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         */
                        UserProfileResponse.prototype.reserved = 0;

                        /**
                         * Creates a new UserProfileResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUserProfileResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.UserProfileResponse} UserProfileResponse instance
                         */
                        UserProfileResponse.create = function create(properties) {
                            return new UserProfileResponse(properties);
                        };

                        /**
                         * Encodes the specified UserProfileResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.UserProfileResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUserProfileResponse} message UserProfileResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UserProfileResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.userId);
                            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
                            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
                            if (message.backgroundSkin != null && Object.hasOwnProperty.call(message, "backgroundSkin"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.backgroundSkin);
                            if (message.generalSkin != null && Object.hasOwnProperty.call(message, "generalSkin"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.generalSkin);
                            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdAt);
                            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updatedAt);
                            if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
                                writer.uint32(/* id 8, wireType 1 =*/65).double(message.balance);
                            if (message.reserved != null && Object.hasOwnProperty.call(message, "reserved"))
                                writer.uint32(/* id 9, wireType 1 =*/73).double(message.reserved);
                            return writer;
                        };

                        /**
                         * Encodes the specified UserProfileResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.UserProfileResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUserProfileResponse} message UserProfileResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UserProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a UserProfileResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.UserProfileResponse} UserProfileResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UserProfileResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.UserProfileResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.userId = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.nickname = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.avatar = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.backgroundSkin = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.generalSkin = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.createdAt = reader.int64();
                                        break;
                                    }
                                case 7: {
                                        message.updatedAt = reader.int64();
                                        break;
                                    }
                                case 8: {
                                        message.balance = reader.double();
                                        break;
                                    }
                                case 9: {
                                        message.reserved = reader.double();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a UserProfileResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.UserProfileResponse} UserProfileResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UserProfileResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a UserProfileResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        UserProfileResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.userId != null && message.hasOwnProperty("userId"))
                                if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                    return "userId: integer|Long expected";
                            if (message.nickname != null && message.hasOwnProperty("nickname"))
                                if (!$util.isString(message.nickname))
                                    return "nickname: string expected";
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                if (!$util.isString(message.avatar))
                                    return "avatar: string expected";
                            if (message.backgroundSkin != null && message.hasOwnProperty("backgroundSkin"))
                                if (!$util.isString(message.backgroundSkin))
                                    return "backgroundSkin: string expected";
                            if (message.generalSkin != null && message.hasOwnProperty("generalSkin"))
                                if (!$util.isString(message.generalSkin))
                                    return "generalSkin: string expected";
                            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                                    return "createdAt: integer|Long expected";
                            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                                    return "updatedAt: integer|Long expected";
                            if (message.balance != null && message.hasOwnProperty("balance"))
                                if (typeof message.balance !== "number")
                                    return "balance: number expected";
                            if (message.reserved != null && message.hasOwnProperty("reserved"))
                                if (typeof message.reserved !== "number")
                                    return "reserved: number expected";
                            return null;
                        };

                        /**
                         * Creates a UserProfileResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.UserProfileResponse} UserProfileResponse
                         */
                        UserProfileResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.UserProfileResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.UserProfileResponse();
                            if (object.userId != null)
                                if ($util.Long)
                                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                                else if (typeof object.userId === "string")
                                    message.userId = parseInt(object.userId, 10);
                                else if (typeof object.userId === "number")
                                    message.userId = object.userId;
                                else if (typeof object.userId === "object")
                                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                            if (object.nickname != null)
                                message.nickname = String(object.nickname);
                            if (object.avatar != null)
                                message.avatar = String(object.avatar);
                            if (object.backgroundSkin != null)
                                message.backgroundSkin = String(object.backgroundSkin);
                            if (object.generalSkin != null)
                                message.generalSkin = String(object.generalSkin);
                            if (object.createdAt != null)
                                if ($util.Long)
                                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                                else if (typeof object.createdAt === "string")
                                    message.createdAt = parseInt(object.createdAt, 10);
                                else if (typeof object.createdAt === "number")
                                    message.createdAt = object.createdAt;
                                else if (typeof object.createdAt === "object")
                                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
                            if (object.updatedAt != null)
                                if ($util.Long)
                                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                                else if (typeof object.updatedAt === "string")
                                    message.updatedAt = parseInt(object.updatedAt, 10);
                                else if (typeof object.updatedAt === "number")
                                    message.updatedAt = object.updatedAt;
                                else if (typeof object.updatedAt === "object")
                                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
                            if (object.balance != null)
                                message.balance = Number(object.balance);
                            if (object.reserved != null)
                                message.reserved = Number(object.reserved);
                            return message;
                        };

                        /**
                         * Creates a plain object from a UserProfileResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.UserProfileResponse} message UserProfileResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        UserProfileResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.userId = options.longs === String ? "0" : 0;
                                object.nickname = "";
                                object.avatar = "";
                                object.backgroundSkin = "";
                                object.generalSkin = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.createdAt = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.updatedAt = options.longs === String ? "0" : 0;
                                object.balance = 0;
                                object.reserved = 0;
                            }
                            if (message.userId != null && message.hasOwnProperty("userId"))
                                if (typeof message.userId === "number")
                                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                                else
                                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                            if (message.nickname != null && message.hasOwnProperty("nickname"))
                                object.nickname = message.nickname;
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                object.avatar = message.avatar;
                            if (message.backgroundSkin != null && message.hasOwnProperty("backgroundSkin"))
                                object.backgroundSkin = message.backgroundSkin;
                            if (message.generalSkin != null && message.hasOwnProperty("generalSkin"))
                                object.generalSkin = message.generalSkin;
                            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                                if (typeof message.createdAt === "number")
                                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                                else
                                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
                            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                                if (typeof message.updatedAt === "number")
                                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                                else
                                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
                            if (message.balance != null && message.hasOwnProperty("balance"))
                                object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
                            if (message.reserved != null && message.hasOwnProperty("reserved"))
                                object.reserved = options.json && !isFinite(message.reserved) ? String(message.reserved) : message.reserved;
                            return object;
                        };

                        /**
                         * Converts this UserProfileResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        UserProfileResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for UserProfileResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.UserProfileResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        UserProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.UserProfileResponse";
                        };

                        return UserProfileResponse;
                    })();

                    stateless.UpdateUserProfileRequest = (function() {

                        /**
                         * Properties of an UpdateUserProfileRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IUpdateUserProfileRequest
                         * @property {string|null} [nickname] UpdateUserProfileRequest nickname
                         * @property {string|null} [avatar] UpdateUserProfileRequest avatar
                         * @property {string|null} [backgroundSkin] UpdateUserProfileRequest backgroundSkin
                         * @property {string|null} [generalSkin] UpdateUserProfileRequest generalSkin
                         */

                        /**
                         * Constructs a new UpdateUserProfileRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents an UpdateUserProfileRequest.
                         * @implements IUpdateUserProfileRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileRequest=} [properties] Properties to set
                         */
                        function UpdateUserProfileRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * UpdateUserProfileRequest nickname.
                         * @member {string} nickname
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @instance
                         */
                        UpdateUserProfileRequest.prototype.nickname = "";

                        /**
                         * UpdateUserProfileRequest avatar.
                         * @member {string} avatar
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @instance
                         */
                        UpdateUserProfileRequest.prototype.avatar = "";

                        /**
                         * UpdateUserProfileRequest backgroundSkin.
                         * @member {string} backgroundSkin
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @instance
                         */
                        UpdateUserProfileRequest.prototype.backgroundSkin = "";

                        /**
                         * UpdateUserProfileRequest generalSkin.
                         * @member {string} generalSkin
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @instance
                         */
                        UpdateUserProfileRequest.prototype.generalSkin = "";

                        /**
                         * Creates a new UpdateUserProfileRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileRequest} UpdateUserProfileRequest instance
                         */
                        UpdateUserProfileRequest.create = function create(properties) {
                            return new UpdateUserProfileRequest(properties);
                        };

                        /**
                         * Encodes the specified UpdateUserProfileRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.UpdateUserProfileRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileRequest} message UpdateUserProfileRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateUserProfileRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.nickname);
                            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                            if (message.backgroundSkin != null && Object.hasOwnProperty.call(message, "backgroundSkin"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.backgroundSkin);
                            if (message.generalSkin != null && Object.hasOwnProperty.call(message, "generalSkin"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.generalSkin);
                            return writer;
                        };

                        /**
                         * Encodes the specified UpdateUserProfileRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.UpdateUserProfileRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileRequest} message UpdateUserProfileRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateUserProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an UpdateUserProfileRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileRequest} UpdateUserProfileRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateUserProfileRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.nickname = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.avatar = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.backgroundSkin = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.generalSkin = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an UpdateUserProfileRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileRequest} UpdateUserProfileRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateUserProfileRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an UpdateUserProfileRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        UpdateUserProfileRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.nickname != null && message.hasOwnProperty("nickname"))
                                if (!$util.isString(message.nickname))
                                    return "nickname: string expected";
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                if (!$util.isString(message.avatar))
                                    return "avatar: string expected";
                            if (message.backgroundSkin != null && message.hasOwnProperty("backgroundSkin"))
                                if (!$util.isString(message.backgroundSkin))
                                    return "backgroundSkin: string expected";
                            if (message.generalSkin != null && message.hasOwnProperty("generalSkin"))
                                if (!$util.isString(message.generalSkin))
                                    return "generalSkin: string expected";
                            return null;
                        };

                        /**
                         * Creates an UpdateUserProfileRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileRequest} UpdateUserProfileRequest
                         */
                        UpdateUserProfileRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.UpdateUserProfileRequest();
                            if (object.nickname != null)
                                message.nickname = String(object.nickname);
                            if (object.avatar != null)
                                message.avatar = String(object.avatar);
                            if (object.backgroundSkin != null)
                                message.backgroundSkin = String(object.backgroundSkin);
                            if (object.generalSkin != null)
                                message.generalSkin = String(object.generalSkin);
                            return message;
                        };

                        /**
                         * Creates a plain object from an UpdateUserProfileRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.UpdateUserProfileRequest} message UpdateUserProfileRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        UpdateUserProfileRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.nickname = "";
                                object.avatar = "";
                                object.backgroundSkin = "";
                                object.generalSkin = "";
                            }
                            if (message.nickname != null && message.hasOwnProperty("nickname"))
                                object.nickname = message.nickname;
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                object.avatar = message.avatar;
                            if (message.backgroundSkin != null && message.hasOwnProperty("backgroundSkin"))
                                object.backgroundSkin = message.backgroundSkin;
                            if (message.generalSkin != null && message.hasOwnProperty("generalSkin"))
                                object.generalSkin = message.generalSkin;
                            return object;
                        };

                        /**
                         * Converts this UpdateUserProfileRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        UpdateUserProfileRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for UpdateUserProfileRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        UpdateUserProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.UpdateUserProfileRequest";
                        };

                        return UpdateUserProfileRequest;
                    })();

                    stateless.UpdateUserProfileResponse = (function() {

                        /**
                         * Properties of an UpdateUserProfileResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IUpdateUserProfileResponse
                         * @property {boolean|null} [success] UpdateUserProfileResponse success
                         * @property {string|null} [errorMessage] UpdateUserProfileResponse errorMessage
                         * @property {com.achlid.crash.game.stateless.IUserProfileResponse|null} [profile] UpdateUserProfileResponse profile
                         */

                        /**
                         * Constructs a new UpdateUserProfileResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents an UpdateUserProfileResponse.
                         * @implements IUpdateUserProfileResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileResponse=} [properties] Properties to set
                         */
                        function UpdateUserProfileResponse(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * UpdateUserProfileResponse success.
                         * @member {boolean} success
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @instance
                         */
                        UpdateUserProfileResponse.prototype.success = false;

                        /**
                         * UpdateUserProfileResponse errorMessage.
                         * @member {string} errorMessage
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @instance
                         */
                        UpdateUserProfileResponse.prototype.errorMessage = "";

                        /**
                         * UpdateUserProfileResponse profile.
                         * @member {com.achlid.crash.game.stateless.IUserProfileResponse|null|undefined} profile
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @instance
                         */
                        UpdateUserProfileResponse.prototype.profile = null;

                        /**
                         * Creates a new UpdateUserProfileResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileResponse} UpdateUserProfileResponse instance
                         */
                        UpdateUserProfileResponse.create = function create(properties) {
                            return new UpdateUserProfileResponse(properties);
                        };

                        /**
                         * Encodes the specified UpdateUserProfileResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.UpdateUserProfileResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileResponse} message UpdateUserProfileResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateUserProfileResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                            if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorMessage);
                            if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
                                $root.com.achlid.crash.game.stateless.UserProfileResponse.encode(message.profile, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified UpdateUserProfileResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.UpdateUserProfileResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IUpdateUserProfileResponse} message UpdateUserProfileResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateUserProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes an UpdateUserProfileResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileResponse} UpdateUserProfileResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateUserProfileResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.success = reader.bool();
                                        break;
                                    }
                                case 2: {
                                        message.errorMessage = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.profile = $root.com.achlid.crash.game.stateless.UserProfileResponse.decode(reader, reader.uint32());
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes an UpdateUserProfileResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileResponse} UpdateUserProfileResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateUserProfileResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies an UpdateUserProfileResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        UpdateUserProfileResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.success != null && message.hasOwnProperty("success"))
                                if (typeof message.success !== "boolean")
                                    return "success: boolean expected";
                            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                                if (!$util.isString(message.errorMessage))
                                    return "errorMessage: string expected";
                            if (message.profile != null && message.hasOwnProperty("profile")) {
                                let error = $root.com.achlid.crash.game.stateless.UserProfileResponse.verify(message.profile);
                                if (error)
                                    return "profile." + error;
                            }
                            return null;
                        };

                        /**
                         * Creates an UpdateUserProfileResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.UpdateUserProfileResponse} UpdateUserProfileResponse
                         */
                        UpdateUserProfileResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.UpdateUserProfileResponse();
                            if (object.success != null)
                                message.success = Boolean(object.success);
                            if (object.errorMessage != null)
                                message.errorMessage = String(object.errorMessage);
                            if (object.profile != null) {
                                if (typeof object.profile !== "object")
                                    throw TypeError(".com.achlid.crash.game.stateless.UpdateUserProfileResponse.profile: object expected");
                                message.profile = $root.com.achlid.crash.game.stateless.UserProfileResponse.fromObject(object.profile);
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from an UpdateUserProfileResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.UpdateUserProfileResponse} message UpdateUserProfileResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        UpdateUserProfileResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.success = false;
                                object.errorMessage = "";
                                object.profile = null;
                            }
                            if (message.success != null && message.hasOwnProperty("success"))
                                object.success = message.success;
                            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                                object.errorMessage = message.errorMessage;
                            if (message.profile != null && message.hasOwnProperty("profile"))
                                object.profile = $root.com.achlid.crash.game.stateless.UserProfileResponse.toObject(message.profile, options);
                            return object;
                        };

                        /**
                         * Converts this UpdateUserProfileResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        UpdateUserProfileResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for UpdateUserProfileResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.UpdateUserProfileResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        UpdateUserProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.UpdateUserProfileResponse";
                        };

                        return UpdateUserProfileResponse;
                    })();

                    stateless.GetLeaderboardRequest = (function() {

                        /**
                         * Properties of a GetLeaderboardRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetLeaderboardRequest
                         * @property {com.achlid.crash.game.stateless.GetLeaderboardRequest.Type|null} [type] GetLeaderboardRequest type
                         * @property {com.achlid.crash.game.stateless.GetLeaderboardRequest.SortBy|null} [sortBy] GetLeaderboardRequest sortBy
                         * @property {number|null} [limit] GetLeaderboardRequest limit
                         */

                        /**
                         * Constructs a new GetLeaderboardRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetLeaderboardRequest.
                         * @implements IGetLeaderboardRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetLeaderboardRequest=} [properties] Properties to set
                         */
                        function GetLeaderboardRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetLeaderboardRequest type.
                         * @member {com.achlid.crash.game.stateless.GetLeaderboardRequest.Type} type
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @instance
                         */
                        GetLeaderboardRequest.prototype.type = 0;

                        /**
                         * GetLeaderboardRequest sortBy.
                         * @member {com.achlid.crash.game.stateless.GetLeaderboardRequest.SortBy} sortBy
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @instance
                         */
                        GetLeaderboardRequest.prototype.sortBy = 0;

                        /**
                         * GetLeaderboardRequest limit.
                         * @member {number} limit
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @instance
                         */
                        GetLeaderboardRequest.prototype.limit = 0;

                        /**
                         * Creates a new GetLeaderboardRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetLeaderboardRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetLeaderboardRequest} GetLeaderboardRequest instance
                         */
                        GetLeaderboardRequest.create = function create(properties) {
                            return new GetLeaderboardRequest(properties);
                        };

                        /**
                         * Encodes the specified GetLeaderboardRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetLeaderboardRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetLeaderboardRequest} message GetLeaderboardRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetLeaderboardRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.sortBy != null && Object.hasOwnProperty.call(message, "sortBy"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.sortBy);
                            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.limit);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetLeaderboardRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetLeaderboardRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetLeaderboardRequest} message GetLeaderboardRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetLeaderboardRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetLeaderboardRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetLeaderboardRequest} GetLeaderboardRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetLeaderboardRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetLeaderboardRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.sortBy = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.limit = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetLeaderboardRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetLeaderboardRequest} GetLeaderboardRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetLeaderboardRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetLeaderboardRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetLeaderboardRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.sortBy != null && message.hasOwnProperty("sortBy"))
                                switch (message.sortBy) {
                                default:
                                    return "sortBy: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                if (!$util.isInteger(message.limit))
                                    return "limit: integer expected";
                            return null;
                        };

                        /**
                         * Creates a GetLeaderboardRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetLeaderboardRequest} GetLeaderboardRequest
                         */
                        GetLeaderboardRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetLeaderboardRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetLeaderboardRequest();
                            switch (object.type) {
                            default:
                                if (typeof object.type === "number") {
                                    message.type = object.type;
                                    break;
                                }
                                break;
                            case "DAY":
                            case 0:
                                message.type = 0;
                                break;
                            case "MONTH":
                            case 1:
                                message.type = 1;
                                break;
                            case "YEAR":
                            case 2:
                                message.type = 2;
                                break;
                            }
                            switch (object.sortBy) {
                            default:
                                if (typeof object.sortBy === "number") {
                                    message.sortBy = object.sortBy;
                                    break;
                                }
                                break;
                            case "BY_MULTIPLIER":
                            case 0:
                                message.sortBy = 0;
                                break;
                            case "BY_WINS":
                            case 1:
                                message.sortBy = 1;
                                break;
                            case "BY_ROUNDS":
                            case 2:
                                message.sortBy = 2;
                                break;
                            }
                            if (object.limit != null)
                                message.limit = object.limit | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetLeaderboardRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetLeaderboardRequest} message GetLeaderboardRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetLeaderboardRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.type = options.enums === String ? "DAY" : 0;
                                object.sortBy = options.enums === String ? "BY_MULTIPLIER" : 0;
                                object.limit = 0;
                            }
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.Type[message.type] === undefined ? message.type : $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.Type[message.type] : message.type;
                            if (message.sortBy != null && message.hasOwnProperty("sortBy"))
                                object.sortBy = options.enums === String ? $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.SortBy[message.sortBy] === undefined ? message.sortBy : $root.com.achlid.crash.game.stateless.GetLeaderboardRequest.SortBy[message.sortBy] : message.sortBy;
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                object.limit = message.limit;
                            return object;
                        };

                        /**
                         * Converts this GetLeaderboardRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetLeaderboardRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetLeaderboardRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetLeaderboardRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetLeaderboardRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetLeaderboardRequest";
                        };

                        /**
                         * Type enum.
                         * @name com.achlid.crash.game.stateless.GetLeaderboardRequest.Type
                         * @enum {number}
                         * @property {number} DAY=0 DAY value
                         * @property {number} MONTH=1 MONTH value
                         * @property {number} YEAR=2 YEAR value
                         */
                        GetLeaderboardRequest.Type = (function() {
                            const valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "DAY"] = 0;
                            values[valuesById[1] = "MONTH"] = 1;
                            values[valuesById[2] = "YEAR"] = 2;
                            return values;
                        })();

                        /**
                         * SortBy enum.
                         * @name com.achlid.crash.game.stateless.GetLeaderboardRequest.SortBy
                         * @enum {number}
                         * @property {number} BY_MULTIPLIER=0 BY_MULTIPLIER value
                         * @property {number} BY_WINS=1 BY_WINS value
                         * @property {number} BY_ROUNDS=2 BY_ROUNDS value
                         */
                        GetLeaderboardRequest.SortBy = (function() {
                            const valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "BY_MULTIPLIER"] = 0;
                            values[valuesById[1] = "BY_WINS"] = 1;
                            values[valuesById[2] = "BY_ROUNDS"] = 2;
                            return values;
                        })();

                        return GetLeaderboardRequest;
                    })();

                    stateless.LeaderboardResponse = (function() {

                        /**
                         * Properties of a LeaderboardResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface ILeaderboardResponse
                         * @property {com.achlid.crash.game.stateless.LeaderboardResponse.Type|null} [type] LeaderboardResponse type
                         * @property {Array.<com.achlid.crash.game.stateless.ILeaderboardEntry>|null} [entries] LeaderboardResponse entries
                         * @property {number|Long|null} [lastUpdated] LeaderboardResponse lastUpdated
                         * @property {Array.<com.achlid.crash.game.stateless.ITopRoundEntry>|null} [topRounds] LeaderboardResponse topRounds
                         */

                        /**
                         * Constructs a new LeaderboardResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a LeaderboardResponse.
                         * @implements ILeaderboardResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.ILeaderboardResponse=} [properties] Properties to set
                         */
                        function LeaderboardResponse(properties) {
                            this.entries = [];
                            this.topRounds = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * LeaderboardResponse type.
                         * @member {com.achlid.crash.game.stateless.LeaderboardResponse.Type} type
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @instance
                         */
                        LeaderboardResponse.prototype.type = 0;

                        /**
                         * LeaderboardResponse entries.
                         * @member {Array.<com.achlid.crash.game.stateless.ILeaderboardEntry>} entries
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @instance
                         */
                        LeaderboardResponse.prototype.entries = $util.emptyArray;

                        /**
                         * LeaderboardResponse lastUpdated.
                         * @member {number|Long} lastUpdated
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @instance
                         */
                        LeaderboardResponse.prototype.lastUpdated = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardResponse topRounds.
                         * @member {Array.<com.achlid.crash.game.stateless.ITopRoundEntry>} topRounds
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @instance
                         */
                        LeaderboardResponse.prototype.topRounds = $util.emptyArray;

                        /**
                         * Creates a new LeaderboardResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.LeaderboardResponse} LeaderboardResponse instance
                         */
                        LeaderboardResponse.create = function create(properties) {
                            return new LeaderboardResponse(properties);
                        };

                        /**
                         * Encodes the specified LeaderboardResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.LeaderboardResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardResponse} message LeaderboardResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        LeaderboardResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.entries != null && message.entries.length)
                                for (let i = 0; i < message.entries.length; ++i)
                                    $root.com.achlid.crash.game.stateless.LeaderboardEntry.encode(message.entries[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.lastUpdated);
                            if (message.topRounds != null && message.topRounds.length)
                                for (let i = 0; i < message.topRounds.length; ++i)
                                    $root.com.achlid.crash.game.stateless.TopRoundEntry.encode(message.topRounds[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified LeaderboardResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.LeaderboardResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardResponse} message LeaderboardResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        LeaderboardResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a LeaderboardResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.LeaderboardResponse} LeaderboardResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        LeaderboardResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.LeaderboardResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.type = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        if (!(message.entries && message.entries.length))
                                            message.entries = [];
                                        message.entries.push($root.com.achlid.crash.game.stateless.LeaderboardEntry.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 3: {
                                        message.lastUpdated = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        if (!(message.topRounds && message.topRounds.length))
                                            message.topRounds = [];
                                        message.topRounds.push($root.com.achlid.crash.game.stateless.TopRoundEntry.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a LeaderboardResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.LeaderboardResponse} LeaderboardResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        LeaderboardResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a LeaderboardResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        LeaderboardResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.entries != null && message.hasOwnProperty("entries")) {
                                if (!Array.isArray(message.entries))
                                    return "entries: array expected";
                                for (let i = 0; i < message.entries.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.LeaderboardEntry.verify(message.entries[i]);
                                    if (error)
                                        return "entries." + error;
                                }
                            }
                            if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
                                if (!$util.isInteger(message.lastUpdated) && !(message.lastUpdated && $util.isInteger(message.lastUpdated.low) && $util.isInteger(message.lastUpdated.high)))
                                    return "lastUpdated: integer|Long expected";
                            if (message.topRounds != null && message.hasOwnProperty("topRounds")) {
                                if (!Array.isArray(message.topRounds))
                                    return "topRounds: array expected";
                                for (let i = 0; i < message.topRounds.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.TopRoundEntry.verify(message.topRounds[i]);
                                    if (error)
                                        return "topRounds." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates a LeaderboardResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.LeaderboardResponse} LeaderboardResponse
                         */
                        LeaderboardResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.LeaderboardResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.LeaderboardResponse();
                            switch (object.type) {
                            default:
                                if (typeof object.type === "number") {
                                    message.type = object.type;
                                    break;
                                }
                                break;
                            case "DAY":
                            case 0:
                                message.type = 0;
                                break;
                            case "MONTH":
                            case 1:
                                message.type = 1;
                                break;
                            case "YEAR":
                            case 2:
                                message.type = 2;
                                break;
                            }
                            if (object.entries) {
                                if (!Array.isArray(object.entries))
                                    throw TypeError(".com.achlid.crash.game.stateless.LeaderboardResponse.entries: array expected");
                                message.entries = [];
                                for (let i = 0; i < object.entries.length; ++i) {
                                    if (typeof object.entries[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.LeaderboardResponse.entries: object expected");
                                    message.entries[i] = $root.com.achlid.crash.game.stateless.LeaderboardEntry.fromObject(object.entries[i]);
                                }
                            }
                            if (object.lastUpdated != null)
                                if ($util.Long)
                                    (message.lastUpdated = $util.Long.fromValue(object.lastUpdated)).unsigned = false;
                                else if (typeof object.lastUpdated === "string")
                                    message.lastUpdated = parseInt(object.lastUpdated, 10);
                                else if (typeof object.lastUpdated === "number")
                                    message.lastUpdated = object.lastUpdated;
                                else if (typeof object.lastUpdated === "object")
                                    message.lastUpdated = new $util.LongBits(object.lastUpdated.low >>> 0, object.lastUpdated.high >>> 0).toNumber();
                            if (object.topRounds) {
                                if (!Array.isArray(object.topRounds))
                                    throw TypeError(".com.achlid.crash.game.stateless.LeaderboardResponse.topRounds: array expected");
                                message.topRounds = [];
                                for (let i = 0; i < object.topRounds.length; ++i) {
                                    if (typeof object.topRounds[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.LeaderboardResponse.topRounds: object expected");
                                    message.topRounds[i] = $root.com.achlid.crash.game.stateless.TopRoundEntry.fromObject(object.topRounds[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a LeaderboardResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.LeaderboardResponse} message LeaderboardResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        LeaderboardResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults) {
                                object.entries = [];
                                object.topRounds = [];
                            }
                            if (options.defaults) {
                                object.type = options.enums === String ? "DAY" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.lastUpdated = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.lastUpdated = options.longs === String ? "0" : 0;
                            }
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.com.achlid.crash.game.stateless.LeaderboardResponse.Type[message.type] === undefined ? message.type : $root.com.achlid.crash.game.stateless.LeaderboardResponse.Type[message.type] : message.type;
                            if (message.entries && message.entries.length) {
                                object.entries = [];
                                for (let j = 0; j < message.entries.length; ++j)
                                    object.entries[j] = $root.com.achlid.crash.game.stateless.LeaderboardEntry.toObject(message.entries[j], options);
                            }
                            if (message.lastUpdated != null && message.hasOwnProperty("lastUpdated"))
                                if (typeof message.lastUpdated === "number")
                                    object.lastUpdated = options.longs === String ? String(message.lastUpdated) : message.lastUpdated;
                                else
                                    object.lastUpdated = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdated) : options.longs === Number ? new $util.LongBits(message.lastUpdated.low >>> 0, message.lastUpdated.high >>> 0).toNumber() : message.lastUpdated;
                            if (message.topRounds && message.topRounds.length) {
                                object.topRounds = [];
                                for (let j = 0; j < message.topRounds.length; ++j)
                                    object.topRounds[j] = $root.com.achlid.crash.game.stateless.TopRoundEntry.toObject(message.topRounds[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this LeaderboardResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        LeaderboardResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for LeaderboardResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.LeaderboardResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        LeaderboardResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.LeaderboardResponse";
                        };

                        /**
                         * Type enum.
                         * @name com.achlid.crash.game.stateless.LeaderboardResponse.Type
                         * @enum {number}
                         * @property {number} DAY=0 DAY value
                         * @property {number} MONTH=1 MONTH value
                         * @property {number} YEAR=2 YEAR value
                         */
                        LeaderboardResponse.Type = (function() {
                            const valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "DAY"] = 0;
                            values[valuesById[1] = "MONTH"] = 1;
                            values[valuesById[2] = "YEAR"] = 2;
                            return values;
                        })();

                        return LeaderboardResponse;
                    })();

                    stateless.LeaderboardEntry = (function() {

                        /**
                         * Properties of a LeaderboardEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface ILeaderboardEntry
                         * @property {number|null} [rank] LeaderboardEntry rank
                         * @property {string|null} [playerName] LeaderboardEntry playerName
                         * @property {string|null} [avatar] LeaderboardEntry avatar
                         * @property {number|Long|null} [bestRoundId] LeaderboardEntry bestRoundId
                         * @property {number|null} [bestMultiplier] LeaderboardEntry bestMultiplier
                         * @property {number|Long|null} [bestWinTimestamp] LeaderboardEntry bestWinTimestamp
                         * @property {number|null} [bestBetAmount] LeaderboardEntry bestBetAmount
                         * @property {number|null} [bestWinAmount] LeaderboardEntry bestWinAmount
                         * @property {number|null} [totalWon] LeaderboardEntry totalWon
                         * @property {number|null} [totalRounds] LeaderboardEntry totalRounds
                         * @property {number|Long|null} [userId] LeaderboardEntry userId
                         * @property {number|Long|null} [biggestWinRoundId] LeaderboardEntry biggestWinRoundId
                         * @property {number|null} [biggestWinMultiplier] LeaderboardEntry biggestWinMultiplier
                         * @property {number|Long|null} [biggestWinTimestamp] LeaderboardEntry biggestWinTimestamp
                         * @property {number|null} [biggestWinBet] LeaderboardEntry biggestWinBet
                         * @property {number|null} [biggestWinAmount] LeaderboardEntry biggestWinAmount
                         * @property {number|null} [roundCrashPoint] LeaderboardEntry roundCrashPoint
                         */

                        /**
                         * Constructs a new LeaderboardEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a LeaderboardEntry.
                         * @implements ILeaderboardEntry
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.ILeaderboardEntry=} [properties] Properties to set
                         */
                        function LeaderboardEntry(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * LeaderboardEntry rank.
                         * @member {number} rank
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.rank = 0;

                        /**
                         * LeaderboardEntry playerName.
                         * @member {string} playerName
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.playerName = "";

                        /**
                         * LeaderboardEntry avatar.
                         * @member {string} avatar
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.avatar = "";

                        /**
                         * LeaderboardEntry bestRoundId.
                         * @member {number|Long} bestRoundId
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.bestRoundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardEntry bestMultiplier.
                         * @member {number} bestMultiplier
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.bestMultiplier = 0;

                        /**
                         * LeaderboardEntry bestWinTimestamp.
                         * @member {number|Long} bestWinTimestamp
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.bestWinTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardEntry bestBetAmount.
                         * @member {number} bestBetAmount
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.bestBetAmount = 0;

                        /**
                         * LeaderboardEntry bestWinAmount.
                         * @member {number} bestWinAmount
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.bestWinAmount = 0;

                        /**
                         * LeaderboardEntry totalWon.
                         * @member {number} totalWon
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.totalWon = 0;

                        /**
                         * LeaderboardEntry totalRounds.
                         * @member {number} totalRounds
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.totalRounds = 0;

                        /**
                         * LeaderboardEntry userId.
                         * @member {number|Long} userId
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardEntry biggestWinRoundId.
                         * @member {number|Long} biggestWinRoundId
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.biggestWinRoundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardEntry biggestWinMultiplier.
                         * @member {number} biggestWinMultiplier
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.biggestWinMultiplier = 0;

                        /**
                         * LeaderboardEntry biggestWinTimestamp.
                         * @member {number|Long} biggestWinTimestamp
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.biggestWinTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * LeaderboardEntry biggestWinBet.
                         * @member {number} biggestWinBet
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.biggestWinBet = 0;

                        /**
                         * LeaderboardEntry biggestWinAmount.
                         * @member {number} biggestWinAmount
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.biggestWinAmount = 0;

                        /**
                         * LeaderboardEntry roundCrashPoint.
                         * @member {number|null|undefined} roundCrashPoint
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        LeaderboardEntry.prototype.roundCrashPoint = null;

                        // OneOf field names bound to virtual getters and setters
                        let $oneOfFields;

                        /**
                         * LeaderboardEntry _roundCrashPoint.
                         * @member {"roundCrashPoint"|undefined} _roundCrashPoint
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         */
                        Object.defineProperty(LeaderboardEntry.prototype, "_roundCrashPoint", {
                            get: $util.oneOfGetter($oneOfFields = ["roundCrashPoint"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Creates a new LeaderboardEntry instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardEntry=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.LeaderboardEntry} LeaderboardEntry instance
                         */
                        LeaderboardEntry.create = function create(properties) {
                            return new LeaderboardEntry(properties);
                        };

                        /**
                         * Encodes the specified LeaderboardEntry message. Does not implicitly {@link com.achlid.crash.game.stateless.LeaderboardEntry.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardEntry} message LeaderboardEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        LeaderboardEntry.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rank);
                            if (message.playerName != null && Object.hasOwnProperty.call(message, "playerName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.playerName);
                            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
                            if (message.bestRoundId != null && Object.hasOwnProperty.call(message, "bestRoundId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.bestRoundId);
                            if (message.bestMultiplier != null && Object.hasOwnProperty.call(message, "bestMultiplier"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.bestMultiplier);
                            if (message.bestWinTimestamp != null && Object.hasOwnProperty.call(message, "bestWinTimestamp"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.bestWinTimestamp);
                            if (message.bestBetAmount != null && Object.hasOwnProperty.call(message, "bestBetAmount"))
                                writer.uint32(/* id 7, wireType 1 =*/57).double(message.bestBetAmount);
                            if (message.bestWinAmount != null && Object.hasOwnProperty.call(message, "bestWinAmount"))
                                writer.uint32(/* id 8, wireType 1 =*/65).double(message.bestWinAmount);
                            if (message.totalWon != null && Object.hasOwnProperty.call(message, "totalWon"))
                                writer.uint32(/* id 9, wireType 1 =*/73).double(message.totalWon);
                            if (message.totalRounds != null && Object.hasOwnProperty.call(message, "totalRounds"))
                                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.totalRounds);
                            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.userId);
                            if (message.biggestWinRoundId != null && Object.hasOwnProperty.call(message, "biggestWinRoundId"))
                                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.biggestWinRoundId);
                            if (message.biggestWinMultiplier != null && Object.hasOwnProperty.call(message, "biggestWinMultiplier"))
                                writer.uint32(/* id 13, wireType 1 =*/105).double(message.biggestWinMultiplier);
                            if (message.biggestWinTimestamp != null && Object.hasOwnProperty.call(message, "biggestWinTimestamp"))
                                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.biggestWinTimestamp);
                            if (message.biggestWinBet != null && Object.hasOwnProperty.call(message, "biggestWinBet"))
                                writer.uint32(/* id 15, wireType 1 =*/121).double(message.biggestWinBet);
                            if (message.biggestWinAmount != null && Object.hasOwnProperty.call(message, "biggestWinAmount"))
                                writer.uint32(/* id 16, wireType 1 =*/129).double(message.biggestWinAmount);
                            if (message.roundCrashPoint != null && Object.hasOwnProperty.call(message, "roundCrashPoint"))
                                writer.uint32(/* id 17, wireType 1 =*/137).double(message.roundCrashPoint);
                            return writer;
                        };

                        /**
                         * Encodes the specified LeaderboardEntry message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.LeaderboardEntry.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ILeaderboardEntry} message LeaderboardEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        LeaderboardEntry.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a LeaderboardEntry message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.LeaderboardEntry} LeaderboardEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        LeaderboardEntry.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.LeaderboardEntry();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.rank = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.playerName = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.avatar = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.bestRoundId = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.bestMultiplier = reader.double();
                                        break;
                                    }
                                case 6: {
                                        message.bestWinTimestamp = reader.int64();
                                        break;
                                    }
                                case 7: {
                                        message.bestBetAmount = reader.double();
                                        break;
                                    }
                                case 8: {
                                        message.bestWinAmount = reader.double();
                                        break;
                                    }
                                case 9: {
                                        message.totalWon = reader.double();
                                        break;
                                    }
                                case 10: {
                                        message.totalRounds = reader.int32();
                                        break;
                                    }
                                case 11: {
                                        message.userId = reader.int64();
                                        break;
                                    }
                                case 12: {
                                        message.biggestWinRoundId = reader.int64();
                                        break;
                                    }
                                case 13: {
                                        message.biggestWinMultiplier = reader.double();
                                        break;
                                    }
                                case 14: {
                                        message.biggestWinTimestamp = reader.int64();
                                        break;
                                    }
                                case 15: {
                                        message.biggestWinBet = reader.double();
                                        break;
                                    }
                                case 16: {
                                        message.biggestWinAmount = reader.double();
                                        break;
                                    }
                                case 17: {
                                        message.roundCrashPoint = reader.double();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a LeaderboardEntry message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.LeaderboardEntry} LeaderboardEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        LeaderboardEntry.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a LeaderboardEntry message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        LeaderboardEntry.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            let properties = {};
                            if (message.rank != null && message.hasOwnProperty("rank"))
                                if (!$util.isInteger(message.rank))
                                    return "rank: integer expected";
                            if (message.playerName != null && message.hasOwnProperty("playerName"))
                                if (!$util.isString(message.playerName))
                                    return "playerName: string expected";
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                if (!$util.isString(message.avatar))
                                    return "avatar: string expected";
                            if (message.bestRoundId != null && message.hasOwnProperty("bestRoundId"))
                                if (!$util.isInteger(message.bestRoundId) && !(message.bestRoundId && $util.isInteger(message.bestRoundId.low) && $util.isInteger(message.bestRoundId.high)))
                                    return "bestRoundId: integer|Long expected";
                            if (message.bestMultiplier != null && message.hasOwnProperty("bestMultiplier"))
                                if (typeof message.bestMultiplier !== "number")
                                    return "bestMultiplier: number expected";
                            if (message.bestWinTimestamp != null && message.hasOwnProperty("bestWinTimestamp"))
                                if (!$util.isInteger(message.bestWinTimestamp) && !(message.bestWinTimestamp && $util.isInteger(message.bestWinTimestamp.low) && $util.isInteger(message.bestWinTimestamp.high)))
                                    return "bestWinTimestamp: integer|Long expected";
                            if (message.bestBetAmount != null && message.hasOwnProperty("bestBetAmount"))
                                if (typeof message.bestBetAmount !== "number")
                                    return "bestBetAmount: number expected";
                            if (message.bestWinAmount != null && message.hasOwnProperty("bestWinAmount"))
                                if (typeof message.bestWinAmount !== "number")
                                    return "bestWinAmount: number expected";
                            if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                                if (typeof message.totalWon !== "number")
                                    return "totalWon: number expected";
                            if (message.totalRounds != null && message.hasOwnProperty("totalRounds"))
                                if (!$util.isInteger(message.totalRounds))
                                    return "totalRounds: integer expected";
                            if (message.userId != null && message.hasOwnProperty("userId"))
                                if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                    return "userId: integer|Long expected";
                            if (message.biggestWinRoundId != null && message.hasOwnProperty("biggestWinRoundId"))
                                if (!$util.isInteger(message.biggestWinRoundId) && !(message.biggestWinRoundId && $util.isInteger(message.biggestWinRoundId.low) && $util.isInteger(message.biggestWinRoundId.high)))
                                    return "biggestWinRoundId: integer|Long expected";
                            if (message.biggestWinMultiplier != null && message.hasOwnProperty("biggestWinMultiplier"))
                                if (typeof message.biggestWinMultiplier !== "number")
                                    return "biggestWinMultiplier: number expected";
                            if (message.biggestWinTimestamp != null && message.hasOwnProperty("biggestWinTimestamp"))
                                if (!$util.isInteger(message.biggestWinTimestamp) && !(message.biggestWinTimestamp && $util.isInteger(message.biggestWinTimestamp.low) && $util.isInteger(message.biggestWinTimestamp.high)))
                                    return "biggestWinTimestamp: integer|Long expected";
                            if (message.biggestWinBet != null && message.hasOwnProperty("biggestWinBet"))
                                if (typeof message.biggestWinBet !== "number")
                                    return "biggestWinBet: number expected";
                            if (message.biggestWinAmount != null && message.hasOwnProperty("biggestWinAmount"))
                                if (typeof message.biggestWinAmount !== "number")
                                    return "biggestWinAmount: number expected";
                            if (message.roundCrashPoint != null && message.hasOwnProperty("roundCrashPoint")) {
                                properties._roundCrashPoint = 1;
                                if (typeof message.roundCrashPoint !== "number")
                                    return "roundCrashPoint: number expected";
                            }
                            return null;
                        };

                        /**
                         * Creates a LeaderboardEntry message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.LeaderboardEntry} LeaderboardEntry
                         */
                        LeaderboardEntry.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.LeaderboardEntry)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.LeaderboardEntry();
                            if (object.rank != null)
                                message.rank = object.rank | 0;
                            if (object.playerName != null)
                                message.playerName = String(object.playerName);
                            if (object.avatar != null)
                                message.avatar = String(object.avatar);
                            if (object.bestRoundId != null)
                                if ($util.Long)
                                    (message.bestRoundId = $util.Long.fromValue(object.bestRoundId)).unsigned = false;
                                else if (typeof object.bestRoundId === "string")
                                    message.bestRoundId = parseInt(object.bestRoundId, 10);
                                else if (typeof object.bestRoundId === "number")
                                    message.bestRoundId = object.bestRoundId;
                                else if (typeof object.bestRoundId === "object")
                                    message.bestRoundId = new $util.LongBits(object.bestRoundId.low >>> 0, object.bestRoundId.high >>> 0).toNumber();
                            if (object.bestMultiplier != null)
                                message.bestMultiplier = Number(object.bestMultiplier);
                            if (object.bestWinTimestamp != null)
                                if ($util.Long)
                                    (message.bestWinTimestamp = $util.Long.fromValue(object.bestWinTimestamp)).unsigned = false;
                                else if (typeof object.bestWinTimestamp === "string")
                                    message.bestWinTimestamp = parseInt(object.bestWinTimestamp, 10);
                                else if (typeof object.bestWinTimestamp === "number")
                                    message.bestWinTimestamp = object.bestWinTimestamp;
                                else if (typeof object.bestWinTimestamp === "object")
                                    message.bestWinTimestamp = new $util.LongBits(object.bestWinTimestamp.low >>> 0, object.bestWinTimestamp.high >>> 0).toNumber();
                            if (object.bestBetAmount != null)
                                message.bestBetAmount = Number(object.bestBetAmount);
                            if (object.bestWinAmount != null)
                                message.bestWinAmount = Number(object.bestWinAmount);
                            if (object.totalWon != null)
                                message.totalWon = Number(object.totalWon);
                            if (object.totalRounds != null)
                                message.totalRounds = object.totalRounds | 0;
                            if (object.userId != null)
                                if ($util.Long)
                                    (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                                else if (typeof object.userId === "string")
                                    message.userId = parseInt(object.userId, 10);
                                else if (typeof object.userId === "number")
                                    message.userId = object.userId;
                                else if (typeof object.userId === "object")
                                    message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                            if (object.biggestWinRoundId != null)
                                if ($util.Long)
                                    (message.biggestWinRoundId = $util.Long.fromValue(object.biggestWinRoundId)).unsigned = false;
                                else if (typeof object.biggestWinRoundId === "string")
                                    message.biggestWinRoundId = parseInt(object.biggestWinRoundId, 10);
                                else if (typeof object.biggestWinRoundId === "number")
                                    message.biggestWinRoundId = object.biggestWinRoundId;
                                else if (typeof object.biggestWinRoundId === "object")
                                    message.biggestWinRoundId = new $util.LongBits(object.biggestWinRoundId.low >>> 0, object.biggestWinRoundId.high >>> 0).toNumber();
                            if (object.biggestWinMultiplier != null)
                                message.biggestWinMultiplier = Number(object.biggestWinMultiplier);
                            if (object.biggestWinTimestamp != null)
                                if ($util.Long)
                                    (message.biggestWinTimestamp = $util.Long.fromValue(object.biggestWinTimestamp)).unsigned = false;
                                else if (typeof object.biggestWinTimestamp === "string")
                                    message.biggestWinTimestamp = parseInt(object.biggestWinTimestamp, 10);
                                else if (typeof object.biggestWinTimestamp === "number")
                                    message.biggestWinTimestamp = object.biggestWinTimestamp;
                                else if (typeof object.biggestWinTimestamp === "object")
                                    message.biggestWinTimestamp = new $util.LongBits(object.biggestWinTimestamp.low >>> 0, object.biggestWinTimestamp.high >>> 0).toNumber();
                            if (object.biggestWinBet != null)
                                message.biggestWinBet = Number(object.biggestWinBet);
                            if (object.biggestWinAmount != null)
                                message.biggestWinAmount = Number(object.biggestWinAmount);
                            if (object.roundCrashPoint != null)
                                message.roundCrashPoint = Number(object.roundCrashPoint);
                            return message;
                        };

                        /**
                         * Creates a plain object from a LeaderboardEntry message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.LeaderboardEntry} message LeaderboardEntry
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        LeaderboardEntry.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.rank = 0;
                                object.playerName = "";
                                object.avatar = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.bestRoundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.bestRoundId = options.longs === String ? "0" : 0;
                                object.bestMultiplier = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.bestWinTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.bestWinTimestamp = options.longs === String ? "0" : 0;
                                object.bestBetAmount = 0;
                                object.bestWinAmount = 0;
                                object.totalWon = 0;
                                object.totalRounds = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.userId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.biggestWinRoundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.biggestWinRoundId = options.longs === String ? "0" : 0;
                                object.biggestWinMultiplier = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.biggestWinTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.biggestWinTimestamp = options.longs === String ? "0" : 0;
                                object.biggestWinBet = 0;
                                object.biggestWinAmount = 0;
                            }
                            if (message.rank != null && message.hasOwnProperty("rank"))
                                object.rank = message.rank;
                            if (message.playerName != null && message.hasOwnProperty("playerName"))
                                object.playerName = message.playerName;
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                object.avatar = message.avatar;
                            if (message.bestRoundId != null && message.hasOwnProperty("bestRoundId"))
                                if (typeof message.bestRoundId === "number")
                                    object.bestRoundId = options.longs === String ? String(message.bestRoundId) : message.bestRoundId;
                                else
                                    object.bestRoundId = options.longs === String ? $util.Long.prototype.toString.call(message.bestRoundId) : options.longs === Number ? new $util.LongBits(message.bestRoundId.low >>> 0, message.bestRoundId.high >>> 0).toNumber() : message.bestRoundId;
                            if (message.bestMultiplier != null && message.hasOwnProperty("bestMultiplier"))
                                object.bestMultiplier = options.json && !isFinite(message.bestMultiplier) ? String(message.bestMultiplier) : message.bestMultiplier;
                            if (message.bestWinTimestamp != null && message.hasOwnProperty("bestWinTimestamp"))
                                if (typeof message.bestWinTimestamp === "number")
                                    object.bestWinTimestamp = options.longs === String ? String(message.bestWinTimestamp) : message.bestWinTimestamp;
                                else
                                    object.bestWinTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.bestWinTimestamp) : options.longs === Number ? new $util.LongBits(message.bestWinTimestamp.low >>> 0, message.bestWinTimestamp.high >>> 0).toNumber() : message.bestWinTimestamp;
                            if (message.bestBetAmount != null && message.hasOwnProperty("bestBetAmount"))
                                object.bestBetAmount = options.json && !isFinite(message.bestBetAmount) ? String(message.bestBetAmount) : message.bestBetAmount;
                            if (message.bestWinAmount != null && message.hasOwnProperty("bestWinAmount"))
                                object.bestWinAmount = options.json && !isFinite(message.bestWinAmount) ? String(message.bestWinAmount) : message.bestWinAmount;
                            if (message.totalWon != null && message.hasOwnProperty("totalWon"))
                                object.totalWon = options.json && !isFinite(message.totalWon) ? String(message.totalWon) : message.totalWon;
                            if (message.totalRounds != null && message.hasOwnProperty("totalRounds"))
                                object.totalRounds = message.totalRounds;
                            if (message.userId != null && message.hasOwnProperty("userId"))
                                if (typeof message.userId === "number")
                                    object.userId = options.longs === String ? String(message.userId) : message.userId;
                                else
                                    object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                            if (message.biggestWinRoundId != null && message.hasOwnProperty("biggestWinRoundId"))
                                if (typeof message.biggestWinRoundId === "number")
                                    object.biggestWinRoundId = options.longs === String ? String(message.biggestWinRoundId) : message.biggestWinRoundId;
                                else
                                    object.biggestWinRoundId = options.longs === String ? $util.Long.prototype.toString.call(message.biggestWinRoundId) : options.longs === Number ? new $util.LongBits(message.biggestWinRoundId.low >>> 0, message.biggestWinRoundId.high >>> 0).toNumber() : message.biggestWinRoundId;
                            if (message.biggestWinMultiplier != null && message.hasOwnProperty("biggestWinMultiplier"))
                                object.biggestWinMultiplier = options.json && !isFinite(message.biggestWinMultiplier) ? String(message.biggestWinMultiplier) : message.biggestWinMultiplier;
                            if (message.biggestWinTimestamp != null && message.hasOwnProperty("biggestWinTimestamp"))
                                if (typeof message.biggestWinTimestamp === "number")
                                    object.biggestWinTimestamp = options.longs === String ? String(message.biggestWinTimestamp) : message.biggestWinTimestamp;
                                else
                                    object.biggestWinTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.biggestWinTimestamp) : options.longs === Number ? new $util.LongBits(message.biggestWinTimestamp.low >>> 0, message.biggestWinTimestamp.high >>> 0).toNumber() : message.biggestWinTimestamp;
                            if (message.biggestWinBet != null && message.hasOwnProperty("biggestWinBet"))
                                object.biggestWinBet = options.json && !isFinite(message.biggestWinBet) ? String(message.biggestWinBet) : message.biggestWinBet;
                            if (message.biggestWinAmount != null && message.hasOwnProperty("biggestWinAmount"))
                                object.biggestWinAmount = options.json && !isFinite(message.biggestWinAmount) ? String(message.biggestWinAmount) : message.biggestWinAmount;
                            if (message.roundCrashPoint != null && message.hasOwnProperty("roundCrashPoint")) {
                                object.roundCrashPoint = options.json && !isFinite(message.roundCrashPoint) ? String(message.roundCrashPoint) : message.roundCrashPoint;
                                if (options.oneofs)
                                    object._roundCrashPoint = "roundCrashPoint";
                            }
                            return object;
                        };

                        /**
                         * Converts this LeaderboardEntry to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        LeaderboardEntry.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for LeaderboardEntry
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.LeaderboardEntry
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        LeaderboardEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.LeaderboardEntry";
                        };

                        return LeaderboardEntry;
                    })();

                    stateless.TopRoundEntry = (function() {

                        /**
                         * Properties of a TopRoundEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface ITopRoundEntry
                         * @property {number|null} [rank] TopRoundEntry rank
                         * @property {number|Long|null} [roundId] TopRoundEntry roundId
                         * @property {number|null} [crashPoint] TopRoundEntry crashPoint
                         * @property {number|Long|null} [timestamp] TopRoundEntry timestamp
                         * @property {number|null} [totalWonAmount] TopRoundEntry totalWonAmount
                         * @property {number|null} [winnersCount] TopRoundEntry winnersCount
                         */

                        /**
                         * Constructs a new TopRoundEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a TopRoundEntry.
                         * @implements ITopRoundEntry
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.ITopRoundEntry=} [properties] Properties to set
                         */
                        function TopRoundEntry(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * TopRoundEntry rank.
                         * @member {number} rank
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.rank = 0;

                        /**
                         * TopRoundEntry roundId.
                         * @member {number|Long} roundId
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * TopRoundEntry crashPoint.
                         * @member {number|null|undefined} crashPoint
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.crashPoint = null;

                        /**
                         * TopRoundEntry timestamp.
                         * @member {number|Long} timestamp
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * TopRoundEntry totalWonAmount.
                         * @member {number} totalWonAmount
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.totalWonAmount = 0;

                        /**
                         * TopRoundEntry winnersCount.
                         * @member {number} winnersCount
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        TopRoundEntry.prototype.winnersCount = 0;

                        // OneOf field names bound to virtual getters and setters
                        let $oneOfFields;

                        /**
                         * TopRoundEntry _crashPoint.
                         * @member {"crashPoint"|undefined} _crashPoint
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         */
                        Object.defineProperty(TopRoundEntry.prototype, "_crashPoint", {
                            get: $util.oneOfGetter($oneOfFields = ["crashPoint"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Creates a new TopRoundEntry instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ITopRoundEntry=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.TopRoundEntry} TopRoundEntry instance
                         */
                        TopRoundEntry.create = function create(properties) {
                            return new TopRoundEntry(properties);
                        };

                        /**
                         * Encodes the specified TopRoundEntry message. Does not implicitly {@link com.achlid.crash.game.stateless.TopRoundEntry.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ITopRoundEntry} message TopRoundEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TopRoundEntry.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rank);
                            if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roundId);
                            if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                                writer.uint32(/* id 3, wireType 1 =*/25).double(message.crashPoint);
                            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.timestamp);
                            if (message.totalWonAmount != null && Object.hasOwnProperty.call(message, "totalWonAmount"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalWonAmount);
                            if (message.winnersCount != null && Object.hasOwnProperty.call(message, "winnersCount"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.winnersCount);
                            return writer;
                        };

                        /**
                         * Encodes the specified TopRoundEntry message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.TopRoundEntry.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ITopRoundEntry} message TopRoundEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TopRoundEntry.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a TopRoundEntry message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.TopRoundEntry} TopRoundEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TopRoundEntry.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.TopRoundEntry();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.rank = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.roundId = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.crashPoint = reader.double();
                                        break;
                                    }
                                case 4: {
                                        message.timestamp = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.totalWonAmount = reader.double();
                                        break;
                                    }
                                case 6: {
                                        message.winnersCount = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a TopRoundEntry message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.TopRoundEntry} TopRoundEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TopRoundEntry.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a TopRoundEntry message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TopRoundEntry.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            let properties = {};
                            if (message.rank != null && message.hasOwnProperty("rank"))
                                if (!$util.isInteger(message.rank))
                                    return "rank: integer expected";
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                    return "roundId: integer|Long expected";
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                properties._crashPoint = 1;
                                if (typeof message.crashPoint !== "number")
                                    return "crashPoint: number expected";
                            }
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                    return "timestamp: integer|Long expected";
                            if (message.totalWonAmount != null && message.hasOwnProperty("totalWonAmount"))
                                if (typeof message.totalWonAmount !== "number")
                                    return "totalWonAmount: number expected";
                            if (message.winnersCount != null && message.hasOwnProperty("winnersCount"))
                                if (!$util.isInteger(message.winnersCount))
                                    return "winnersCount: integer expected";
                            return null;
                        };

                        /**
                         * Creates a TopRoundEntry message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.TopRoundEntry} TopRoundEntry
                         */
                        TopRoundEntry.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.TopRoundEntry)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.TopRoundEntry();
                            if (object.rank != null)
                                message.rank = object.rank | 0;
                            if (object.roundId != null)
                                if ($util.Long)
                                    (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                                else if (typeof object.roundId === "string")
                                    message.roundId = parseInt(object.roundId, 10);
                                else if (typeof object.roundId === "number")
                                    message.roundId = object.roundId;
                                else if (typeof object.roundId === "object")
                                    message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                            if (object.crashPoint != null)
                                message.crashPoint = Number(object.crashPoint);
                            if (object.timestamp != null)
                                if ($util.Long)
                                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                                else if (typeof object.timestamp === "string")
                                    message.timestamp = parseInt(object.timestamp, 10);
                                else if (typeof object.timestamp === "number")
                                    message.timestamp = object.timestamp;
                                else if (typeof object.timestamp === "object")
                                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                            if (object.totalWonAmount != null)
                                message.totalWonAmount = Number(object.totalWonAmount);
                            if (object.winnersCount != null)
                                message.winnersCount = object.winnersCount | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a TopRoundEntry message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.TopRoundEntry} message TopRoundEntry
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TopRoundEntry.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.rank = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.roundId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.timestamp = options.longs === String ? "0" : 0;
                                object.totalWonAmount = 0;
                                object.winnersCount = 0;
                            }
                            if (message.rank != null && message.hasOwnProperty("rank"))
                                object.rank = message.rank;
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (typeof message.roundId === "number")
                                    object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                                else
                                    object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                                if (options.oneofs)
                                    object._crashPoint = "crashPoint";
                            }
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (typeof message.timestamp === "number")
                                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                                else
                                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                            if (message.totalWonAmount != null && message.hasOwnProperty("totalWonAmount"))
                                object.totalWonAmount = options.json && !isFinite(message.totalWonAmount) ? String(message.totalWonAmount) : message.totalWonAmount;
                            if (message.winnersCount != null && message.hasOwnProperty("winnersCount"))
                                object.winnersCount = message.winnersCount;
                            return object;
                        };

                        /**
                         * Converts this TopRoundEntry to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TopRoundEntry.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for TopRoundEntry
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.TopRoundEntry
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        TopRoundEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.TopRoundEntry";
                        };

                        return TopRoundEntry;
                    })();

                    stateless.GetBetHistoryRequest = (function() {

                        /**
                         * Properties of a GetBetHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetBetHistoryRequest
                         * @property {number|null} [page] GetBetHistoryRequest page
                         * @property {number|null} [pageSize] GetBetHistoryRequest pageSize
                         */

                        /**
                         * Constructs a new GetBetHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetBetHistoryRequest.
                         * @implements IGetBetHistoryRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetBetHistoryRequest=} [properties] Properties to set
                         */
                        function GetBetHistoryRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetBetHistoryRequest page.
                         * @member {number} page
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @instance
                         */
                        GetBetHistoryRequest.prototype.page = 0;

                        /**
                         * GetBetHistoryRequest pageSize.
                         * @member {number} pageSize
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @instance
                         */
                        GetBetHistoryRequest.prototype.pageSize = 0;

                        /**
                         * Creates a new GetBetHistoryRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetBetHistoryRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetBetHistoryRequest} GetBetHistoryRequest instance
                         */
                        GetBetHistoryRequest.create = function create(properties) {
                            return new GetBetHistoryRequest(properties);
                        };

                        /**
                         * Encodes the specified GetBetHistoryRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetBetHistoryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetBetHistoryRequest} message GetBetHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetBetHistoryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.page);
                            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetBetHistoryRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetBetHistoryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetBetHistoryRequest} message GetBetHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetBetHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetBetHistoryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetBetHistoryRequest} GetBetHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetBetHistoryRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetBetHistoryRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.page = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.pageSize = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetBetHistoryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetBetHistoryRequest} GetBetHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetBetHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetBetHistoryRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetBetHistoryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.page != null && message.hasOwnProperty("page"))
                                if (!$util.isInteger(message.page))
                                    return "page: integer expected";
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                if (!$util.isInteger(message.pageSize))
                                    return "pageSize: integer expected";
                            return null;
                        };

                        /**
                         * Creates a GetBetHistoryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetBetHistoryRequest} GetBetHistoryRequest
                         */
                        GetBetHistoryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetBetHistoryRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetBetHistoryRequest();
                            if (object.page != null)
                                message.page = object.page | 0;
                            if (object.pageSize != null)
                                message.pageSize = object.pageSize | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetBetHistoryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetBetHistoryRequest} message GetBetHistoryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetBetHistoryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.page = 0;
                                object.pageSize = 0;
                            }
                            if (message.page != null && message.hasOwnProperty("page"))
                                object.page = message.page;
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                object.pageSize = message.pageSize;
                            return object;
                        };

                        /**
                         * Converts this GetBetHistoryRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetBetHistoryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetBetHistoryRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetBetHistoryRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetBetHistoryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetBetHistoryRequest";
                        };

                        return GetBetHistoryRequest;
                    })();

                    stateless.BetHistoryResponse = (function() {

                        /**
                         * Properties of a BetHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IBetHistoryResponse
                         * @property {Array.<com.achlid.crash.game.stateless.IBetHistoryEntry>|null} [entries] BetHistoryResponse entries
                         * @property {number|null} [currentPage] BetHistoryResponse currentPage
                         * @property {number|null} [totalCount] BetHistoryResponse totalCount
                         * @property {boolean|null} [hasMore] BetHistoryResponse hasMore
                         */

                        /**
                         * Constructs a new BetHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a BetHistoryResponse.
                         * @implements IBetHistoryResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IBetHistoryResponse=} [properties] Properties to set
                         */
                        function BetHistoryResponse(properties) {
                            this.entries = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * BetHistoryResponse entries.
                         * @member {Array.<com.achlid.crash.game.stateless.IBetHistoryEntry>} entries
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @instance
                         */
                        BetHistoryResponse.prototype.entries = $util.emptyArray;

                        /**
                         * BetHistoryResponse currentPage.
                         * @member {number} currentPage
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @instance
                         */
                        BetHistoryResponse.prototype.currentPage = 0;

                        /**
                         * BetHistoryResponse totalCount.
                         * @member {number} totalCount
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @instance
                         */
                        BetHistoryResponse.prototype.totalCount = 0;

                        /**
                         * BetHistoryResponse hasMore.
                         * @member {boolean} hasMore
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @instance
                         */
                        BetHistoryResponse.prototype.hasMore = false;

                        /**
                         * Creates a new BetHistoryResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.BetHistoryResponse} BetHistoryResponse instance
                         */
                        BetHistoryResponse.create = function create(properties) {
                            return new BetHistoryResponse(properties);
                        };

                        /**
                         * Encodes the specified BetHistoryResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.BetHistoryResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryResponse} message BetHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BetHistoryResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.entries != null && message.entries.length)
                                for (let i = 0; i < message.entries.length; ++i)
                                    $root.com.achlid.crash.game.stateless.BetHistoryEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.currentPage != null && Object.hasOwnProperty.call(message, "currentPage"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.currentPage);
                            if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalCount);
                            if (message.hasMore != null && Object.hasOwnProperty.call(message, "hasMore"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.hasMore);
                            return writer;
                        };

                        /**
                         * Encodes the specified BetHistoryResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.BetHistoryResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryResponse} message BetHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BetHistoryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a BetHistoryResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.BetHistoryResponse} BetHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BetHistoryResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.BetHistoryResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        if (!(message.entries && message.entries.length))
                                            message.entries = [];
                                        message.entries.push($root.com.achlid.crash.game.stateless.BetHistoryEntry.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 2: {
                                        message.currentPage = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.totalCount = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.hasMore = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a BetHistoryResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.BetHistoryResponse} BetHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BetHistoryResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a BetHistoryResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BetHistoryResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.entries != null && message.hasOwnProperty("entries")) {
                                if (!Array.isArray(message.entries))
                                    return "entries: array expected";
                                for (let i = 0; i < message.entries.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.BetHistoryEntry.verify(message.entries[i]);
                                    if (error)
                                        return "entries." + error;
                                }
                            }
                            if (message.currentPage != null && message.hasOwnProperty("currentPage"))
                                if (!$util.isInteger(message.currentPage))
                                    return "currentPage: integer expected";
                            if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                                if (!$util.isInteger(message.totalCount))
                                    return "totalCount: integer expected";
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                if (typeof message.hasMore !== "boolean")
                                    return "hasMore: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a BetHistoryResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.BetHistoryResponse} BetHistoryResponse
                         */
                        BetHistoryResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.BetHistoryResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.BetHistoryResponse();
                            if (object.entries) {
                                if (!Array.isArray(object.entries))
                                    throw TypeError(".com.achlid.crash.game.stateless.BetHistoryResponse.entries: array expected");
                                message.entries = [];
                                for (let i = 0; i < object.entries.length; ++i) {
                                    if (typeof object.entries[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.BetHistoryResponse.entries: object expected");
                                    message.entries[i] = $root.com.achlid.crash.game.stateless.BetHistoryEntry.fromObject(object.entries[i]);
                                }
                            }
                            if (object.currentPage != null)
                                message.currentPage = object.currentPage | 0;
                            if (object.totalCount != null)
                                message.totalCount = object.totalCount | 0;
                            if (object.hasMore != null)
                                message.hasMore = Boolean(object.hasMore);
                            return message;
                        };

                        /**
                         * Creates a plain object from a BetHistoryResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.BetHistoryResponse} message BetHistoryResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BetHistoryResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.entries = [];
                            if (options.defaults) {
                                object.currentPage = 0;
                                object.totalCount = 0;
                                object.hasMore = false;
                            }
                            if (message.entries && message.entries.length) {
                                object.entries = [];
                                for (let j = 0; j < message.entries.length; ++j)
                                    object.entries[j] = $root.com.achlid.crash.game.stateless.BetHistoryEntry.toObject(message.entries[j], options);
                            }
                            if (message.currentPage != null && message.hasOwnProperty("currentPage"))
                                object.currentPage = message.currentPage;
                            if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                                object.totalCount = message.totalCount;
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                object.hasMore = message.hasMore;
                            return object;
                        };

                        /**
                         * Converts this BetHistoryResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BetHistoryResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for BetHistoryResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.BetHistoryResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        BetHistoryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.BetHistoryResponse";
                        };

                        return BetHistoryResponse;
                    })();

                    stateless.BetHistoryEntry = (function() {

                        /**
                         * Properties of a BetHistoryEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IBetHistoryEntry
                         * @property {number|Long|null} [betId] BetHistoryEntry betId
                         * @property {number|Long|null} [roundId] BetHistoryEntry roundId
                         * @property {number|null} [slotId] BetHistoryEntry slotId
                         * @property {number|null} [betAmount] BetHistoryEntry betAmount
                         * @property {number|null} [payout] BetHistoryEntry payout
                         * @property {number|null} [multiplier] BetHistoryEntry multiplier
                         * @property {string|null} [status] BetHistoryEntry status
                         * @property {number|Long|null} [timestamp] BetHistoryEntry timestamp
                         * @property {number|null} [crashPoint] BetHistoryEntry crashPoint
                         * @property {number|null} [netProfit] BetHistoryEntry netProfit
                         */

                        /**
                         * Constructs a new BetHistoryEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a BetHistoryEntry.
                         * @implements IBetHistoryEntry
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IBetHistoryEntry=} [properties] Properties to set
                         */
                        function BetHistoryEntry(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * BetHistoryEntry betId.
                         * @member {number|Long} betId
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.betId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BetHistoryEntry roundId.
                         * @member {number|Long} roundId
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BetHistoryEntry slotId.
                         * @member {number} slotId
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.slotId = 0;

                        /**
                         * BetHistoryEntry betAmount.
                         * @member {number} betAmount
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.betAmount = 0;

                        /**
                         * BetHistoryEntry payout.
                         * @member {number} payout
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.payout = 0;

                        /**
                         * BetHistoryEntry multiplier.
                         * @member {number} multiplier
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.multiplier = 0;

                        /**
                         * BetHistoryEntry status.
                         * @member {string} status
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.status = "";

                        /**
                         * BetHistoryEntry timestamp.
                         * @member {number|Long} timestamp
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * BetHistoryEntry crashPoint.
                         * @member {number|null|undefined} crashPoint
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.crashPoint = null;

                        /**
                         * BetHistoryEntry netProfit.
                         * @member {number} netProfit
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        BetHistoryEntry.prototype.netProfit = 0;

                        // OneOf field names bound to virtual getters and setters
                        let $oneOfFields;

                        /**
                         * BetHistoryEntry _crashPoint.
                         * @member {"crashPoint"|undefined} _crashPoint
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         */
                        Object.defineProperty(BetHistoryEntry.prototype, "_crashPoint", {
                            get: $util.oneOfGetter($oneOfFields = ["crashPoint"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Creates a new BetHistoryEntry instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryEntry=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.BetHistoryEntry} BetHistoryEntry instance
                         */
                        BetHistoryEntry.create = function create(properties) {
                            return new BetHistoryEntry(properties);
                        };

                        /**
                         * Encodes the specified BetHistoryEntry message. Does not implicitly {@link com.achlid.crash.game.stateless.BetHistoryEntry.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryEntry} message BetHistoryEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BetHistoryEntry.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.betId != null && Object.hasOwnProperty.call(message, "betId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.betId);
                            if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roundId);
                            if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.slotId);
                            if (message.betAmount != null && Object.hasOwnProperty.call(message, "betAmount"))
                                writer.uint32(/* id 4, wireType 1 =*/33).double(message.betAmount);
                            if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.payout);
                            if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                                writer.uint32(/* id 6, wireType 1 =*/49).double(message.multiplier);
                            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.timestamp);
                            if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                                writer.uint32(/* id 9, wireType 1 =*/73).double(message.crashPoint);
                            if (message.netProfit != null && Object.hasOwnProperty.call(message, "netProfit"))
                                writer.uint32(/* id 10, wireType 1 =*/81).double(message.netProfit);
                            return writer;
                        };

                        /**
                         * Encodes the specified BetHistoryEntry message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.BetHistoryEntry.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IBetHistoryEntry} message BetHistoryEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BetHistoryEntry.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a BetHistoryEntry message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.BetHistoryEntry} BetHistoryEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BetHistoryEntry.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.BetHistoryEntry();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.betId = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.roundId = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.slotId = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.betAmount = reader.double();
                                        break;
                                    }
                                case 5: {
                                        message.payout = reader.double();
                                        break;
                                    }
                                case 6: {
                                        message.multiplier = reader.double();
                                        break;
                                    }
                                case 7: {
                                        message.status = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.timestamp = reader.int64();
                                        break;
                                    }
                                case 9: {
                                        message.crashPoint = reader.double();
                                        break;
                                    }
                                case 10: {
                                        message.netProfit = reader.double();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a BetHistoryEntry message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.BetHistoryEntry} BetHistoryEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BetHistoryEntry.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a BetHistoryEntry message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BetHistoryEntry.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            let properties = {};
                            if (message.betId != null && message.hasOwnProperty("betId"))
                                if (!$util.isInteger(message.betId) && !(message.betId && $util.isInteger(message.betId.low) && $util.isInteger(message.betId.high)))
                                    return "betId: integer|Long expected";
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                    return "roundId: integer|Long expected";
                            if (message.slotId != null && message.hasOwnProperty("slotId"))
                                if (!$util.isInteger(message.slotId))
                                    return "slotId: integer expected";
                            if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                                if (typeof message.betAmount !== "number")
                                    return "betAmount: number expected";
                            if (message.payout != null && message.hasOwnProperty("payout"))
                                if (typeof message.payout !== "number")
                                    return "payout: number expected";
                            if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                                if (typeof message.multiplier !== "number")
                                    return "multiplier: number expected";
                            if (message.status != null && message.hasOwnProperty("status"))
                                if (!$util.isString(message.status))
                                    return "status: string expected";
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                    return "timestamp: integer|Long expected";
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                properties._crashPoint = 1;
                                if (typeof message.crashPoint !== "number")
                                    return "crashPoint: number expected";
                            }
                            if (message.netProfit != null && message.hasOwnProperty("netProfit"))
                                if (typeof message.netProfit !== "number")
                                    return "netProfit: number expected";
                            return null;
                        };

                        /**
                         * Creates a BetHistoryEntry message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.BetHistoryEntry} BetHistoryEntry
                         */
                        BetHistoryEntry.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.BetHistoryEntry)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.BetHistoryEntry();
                            if (object.betId != null)
                                if ($util.Long)
                                    (message.betId = $util.Long.fromValue(object.betId)).unsigned = false;
                                else if (typeof object.betId === "string")
                                    message.betId = parseInt(object.betId, 10);
                                else if (typeof object.betId === "number")
                                    message.betId = object.betId;
                                else if (typeof object.betId === "object")
                                    message.betId = new $util.LongBits(object.betId.low >>> 0, object.betId.high >>> 0).toNumber();
                            if (object.roundId != null)
                                if ($util.Long)
                                    (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                                else if (typeof object.roundId === "string")
                                    message.roundId = parseInt(object.roundId, 10);
                                else if (typeof object.roundId === "number")
                                    message.roundId = object.roundId;
                                else if (typeof object.roundId === "object")
                                    message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                            if (object.slotId != null)
                                message.slotId = object.slotId | 0;
                            if (object.betAmount != null)
                                message.betAmount = Number(object.betAmount);
                            if (object.payout != null)
                                message.payout = Number(object.payout);
                            if (object.multiplier != null)
                                message.multiplier = Number(object.multiplier);
                            if (object.status != null)
                                message.status = String(object.status);
                            if (object.timestamp != null)
                                if ($util.Long)
                                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                                else if (typeof object.timestamp === "string")
                                    message.timestamp = parseInt(object.timestamp, 10);
                                else if (typeof object.timestamp === "number")
                                    message.timestamp = object.timestamp;
                                else if (typeof object.timestamp === "object")
                                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                            if (object.crashPoint != null)
                                message.crashPoint = Number(object.crashPoint);
                            if (object.netProfit != null)
                                message.netProfit = Number(object.netProfit);
                            return message;
                        };

                        /**
                         * Creates a plain object from a BetHistoryEntry message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.BetHistoryEntry} message BetHistoryEntry
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BetHistoryEntry.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.betId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.betId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.roundId = options.longs === String ? "0" : 0;
                                object.slotId = 0;
                                object.betAmount = 0;
                                object.payout = 0;
                                object.multiplier = 0;
                                object.status = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.timestamp = options.longs === String ? "0" : 0;
                                object.netProfit = 0;
                            }
                            if (message.betId != null && message.hasOwnProperty("betId"))
                                if (typeof message.betId === "number")
                                    object.betId = options.longs === String ? String(message.betId) : message.betId;
                                else
                                    object.betId = options.longs === String ? $util.Long.prototype.toString.call(message.betId) : options.longs === Number ? new $util.LongBits(message.betId.low >>> 0, message.betId.high >>> 0).toNumber() : message.betId;
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (typeof message.roundId === "number")
                                    object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                                else
                                    object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                            if (message.slotId != null && message.hasOwnProperty("slotId"))
                                object.slotId = message.slotId;
                            if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                                object.betAmount = options.json && !isFinite(message.betAmount) ? String(message.betAmount) : message.betAmount;
                            if (message.payout != null && message.hasOwnProperty("payout"))
                                object.payout = options.json && !isFinite(message.payout) ? String(message.payout) : message.payout;
                            if (message.multiplier != null && message.hasOwnProperty("multiplier"))
                                object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                            if (message.status != null && message.hasOwnProperty("status"))
                                object.status = message.status;
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (typeof message.timestamp === "number")
                                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                                else
                                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                                if (options.oneofs)
                                    object._crashPoint = "crashPoint";
                            }
                            if (message.netProfit != null && message.hasOwnProperty("netProfit"))
                                object.netProfit = options.json && !isFinite(message.netProfit) ? String(message.netProfit) : message.netProfit;
                            return object;
                        };

                        /**
                         * Converts this BetHistoryEntry to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BetHistoryEntry.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for BetHistoryEntry
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.BetHistoryEntry
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        BetHistoryEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.BetHistoryEntry";
                        };

                        return BetHistoryEntry;
                    })();

                    stateless.GetProvablyFairRoundRequest = (function() {

                        /**
                         * Properties of a GetProvablyFairRoundRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetProvablyFairRoundRequest
                         * @property {number|Long|null} [roundId] GetProvablyFairRoundRequest roundId
                         */

                        /**
                         * Constructs a new GetProvablyFairRoundRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetProvablyFairRoundRequest.
                         * @implements IGetProvablyFairRoundRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest=} [properties] Properties to set
                         */
                        function GetProvablyFairRoundRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetProvablyFairRoundRequest roundId.
                         * @member {number|Long} roundId
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @instance
                         */
                        GetProvablyFairRoundRequest.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Creates a new GetProvablyFairRoundRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairRoundRequest} GetProvablyFairRoundRequest instance
                         */
                        GetProvablyFairRoundRequest.create = function create(properties) {
                            return new GetProvablyFairRoundRequest(properties);
                        };

                        /**
                         * Encodes the specified GetProvablyFairRoundRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest} message GetProvablyFairRoundRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetProvablyFairRoundRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetProvablyFairRoundRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetProvablyFairRoundRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairRoundRequest} message GetProvablyFairRoundRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetProvablyFairRoundRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetProvablyFairRoundRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairRoundRequest} GetProvablyFairRoundRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetProvablyFairRoundRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.roundId = reader.int64();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetProvablyFairRoundRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairRoundRequest} GetProvablyFairRoundRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetProvablyFairRoundRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetProvablyFairRoundRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetProvablyFairRoundRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                    return "roundId: integer|Long expected";
                            return null;
                        };

                        /**
                         * Creates a GetProvablyFairRoundRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairRoundRequest} GetProvablyFairRoundRequest
                         */
                        GetProvablyFairRoundRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetProvablyFairRoundRequest();
                            if (object.roundId != null)
                                if ($util.Long)
                                    (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                                else if (typeof object.roundId === "string")
                                    message.roundId = parseInt(object.roundId, 10);
                                else if (typeof object.roundId === "number")
                                    message.roundId = object.roundId;
                                else if (typeof object.roundId === "object")
                                    message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetProvablyFairRoundRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetProvablyFairRoundRequest} message GetProvablyFairRoundRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetProvablyFairRoundRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.roundId = options.longs === String ? "0" : 0;
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (typeof message.roundId === "number")
                                    object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                                else
                                    object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                            return object;
                        };

                        /**
                         * Converts this GetProvablyFairRoundRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetProvablyFairRoundRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetProvablyFairRoundRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairRoundRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetProvablyFairRoundRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetProvablyFairRoundRequest";
                        };

                        return GetProvablyFairRoundRequest;
                    })();

                    stateless.ProvablyFairRoundResponse = (function() {

                        /**
                         * Properties of a ProvablyFairRoundResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IProvablyFairRoundResponse
                         * @property {number|Long|null} [roundId] ProvablyFairRoundResponse roundId
                         * @property {number|null} [crashPoint] ProvablyFairRoundResponse crashPoint
                         * @property {number|Long|null} [timestamp] ProvablyFairRoundResponse timestamp
                         * @property {string|null} [serverSeed] ProvablyFairRoundResponse serverSeed
                         * @property {string|null} [publicHash] ProvablyFairRoundResponse publicHash
                         * @property {Array.<string>|null} [clientSeeds] ProvablyFairRoundResponse clientSeeds
                         * @property {string|null} [combinedHash] ProvablyFairRoundResponse combinedHash
                         * @property {string|null} [hex] ProvablyFairRoundResponse hex
                         * @property {number|Long|null} [dec] ProvablyFairRoundResponse dec
                         * @property {number|null} [odds] ProvablyFairRoundResponse odds
                         * @property {boolean|null} [revealed] ProvablyFairRoundResponse revealed
                         */

                        /**
                         * Constructs a new ProvablyFairRoundResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ProvablyFairRoundResponse.
                         * @implements IProvablyFairRoundResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IProvablyFairRoundResponse=} [properties] Properties to set
                         */
                        function ProvablyFairRoundResponse(properties) {
                            this.clientSeeds = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ProvablyFairRoundResponse roundId.
                         * @member {number|Long} roundId
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ProvablyFairRoundResponse crashPoint.
                         * @member {number|null|undefined} crashPoint
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.crashPoint = null;

                        /**
                         * ProvablyFairRoundResponse timestamp.
                         * @member {number|Long} timestamp
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ProvablyFairRoundResponse serverSeed.
                         * @member {string|null|undefined} serverSeed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.serverSeed = null;

                        /**
                         * ProvablyFairRoundResponse publicHash.
                         * @member {string} publicHash
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.publicHash = "";

                        /**
                         * ProvablyFairRoundResponse clientSeeds.
                         * @member {Array.<string>} clientSeeds
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.clientSeeds = $util.emptyArray;

                        /**
                         * ProvablyFairRoundResponse combinedHash.
                         * @member {string|null|undefined} combinedHash
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.combinedHash = null;

                        /**
                         * ProvablyFairRoundResponse hex.
                         * @member {string|null|undefined} hex
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.hex = null;

                        /**
                         * ProvablyFairRoundResponse dec.
                         * @member {number|Long|null|undefined} dec
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.dec = null;

                        /**
                         * ProvablyFairRoundResponse odds.
                         * @member {number|null|undefined} odds
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.odds = null;

                        /**
                         * ProvablyFairRoundResponse revealed.
                         * @member {boolean} revealed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        ProvablyFairRoundResponse.prototype.revealed = false;

                        // OneOf field names bound to virtual getters and setters
                        let $oneOfFields;

                        /**
                         * ProvablyFairRoundResponse _crashPoint.
                         * @member {"crashPoint"|undefined} _crashPoint
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_crashPoint", {
                            get: $util.oneOfGetter($oneOfFields = ["crashPoint"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairRoundResponse _serverSeed.
                         * @member {"serverSeed"|undefined} _serverSeed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_serverSeed", {
                            get: $util.oneOfGetter($oneOfFields = ["serverSeed"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairRoundResponse _combinedHash.
                         * @member {"combinedHash"|undefined} _combinedHash
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_combinedHash", {
                            get: $util.oneOfGetter($oneOfFields = ["combinedHash"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairRoundResponse _hex.
                         * @member {"hex"|undefined} _hex
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_hex", {
                            get: $util.oneOfGetter($oneOfFields = ["hex"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairRoundResponse _dec.
                         * @member {"dec"|undefined} _dec
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_dec", {
                            get: $util.oneOfGetter($oneOfFields = ["dec"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairRoundResponse _odds.
                         * @member {"odds"|undefined} _odds
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairRoundResponse.prototype, "_odds", {
                            get: $util.oneOfGetter($oneOfFields = ["odds"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Creates a new ProvablyFairRoundResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairRoundResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairRoundResponse} ProvablyFairRoundResponse instance
                         */
                        ProvablyFairRoundResponse.create = function create(properties) {
                            return new ProvablyFairRoundResponse(properties);
                        };

                        /**
                         * Encodes the specified ProvablyFairRoundResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairRoundResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairRoundResponse} message ProvablyFairRoundResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairRoundResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.roundId);
                            if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                                writer.uint32(/* id 2, wireType 1 =*/17).double(message.crashPoint);
                            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.timestamp);
                            if (message.serverSeed != null && Object.hasOwnProperty.call(message, "serverSeed"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.serverSeed);
                            if (message.publicHash != null && Object.hasOwnProperty.call(message, "publicHash"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.publicHash);
                            if (message.clientSeeds != null && message.clientSeeds.length)
                                for (let i = 0; i < message.clientSeeds.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.clientSeeds[i]);
                            if (message.combinedHash != null && Object.hasOwnProperty.call(message, "combinedHash"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.combinedHash);
                            if (message.hex != null && Object.hasOwnProperty.call(message, "hex"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.hex);
                            if (message.dec != null && Object.hasOwnProperty.call(message, "dec"))
                                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.dec);
                            if (message.odds != null && Object.hasOwnProperty.call(message, "odds"))
                                writer.uint32(/* id 10, wireType 1 =*/81).double(message.odds);
                            if (message.revealed != null && Object.hasOwnProperty.call(message, "revealed"))
                                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.revealed);
                            return writer;
                        };

                        /**
                         * Encodes the specified ProvablyFairRoundResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairRoundResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairRoundResponse} message ProvablyFairRoundResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairRoundResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ProvablyFairRoundResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairRoundResponse} ProvablyFairRoundResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairRoundResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.roundId = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.crashPoint = reader.double();
                                        break;
                                    }
                                case 3: {
                                        message.timestamp = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.serverSeed = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.publicHash = reader.string();
                                        break;
                                    }
                                case 6: {
                                        if (!(message.clientSeeds && message.clientSeeds.length))
                                            message.clientSeeds = [];
                                        message.clientSeeds.push(reader.string());
                                        break;
                                    }
                                case 7: {
                                        message.combinedHash = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.hex = reader.string();
                                        break;
                                    }
                                case 9: {
                                        message.dec = reader.int64();
                                        break;
                                    }
                                case 10: {
                                        message.odds = reader.double();
                                        break;
                                    }
                                case 11: {
                                        message.revealed = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ProvablyFairRoundResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairRoundResponse} ProvablyFairRoundResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairRoundResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ProvablyFairRoundResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProvablyFairRoundResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            let properties = {};
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                    return "roundId: integer|Long expected";
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                properties._crashPoint = 1;
                                if (typeof message.crashPoint !== "number")
                                    return "crashPoint: number expected";
                            }
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                    return "timestamp: integer|Long expected";
                            if (message.serverSeed != null && message.hasOwnProperty("serverSeed")) {
                                properties._serverSeed = 1;
                                if (!$util.isString(message.serverSeed))
                                    return "serverSeed: string expected";
                            }
                            if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                                if (!$util.isString(message.publicHash))
                                    return "publicHash: string expected";
                            if (message.clientSeeds != null && message.hasOwnProperty("clientSeeds")) {
                                if (!Array.isArray(message.clientSeeds))
                                    return "clientSeeds: array expected";
                                for (let i = 0; i < message.clientSeeds.length; ++i)
                                    if (!$util.isString(message.clientSeeds[i]))
                                        return "clientSeeds: string[] expected";
                            }
                            if (message.combinedHash != null && message.hasOwnProperty("combinedHash")) {
                                properties._combinedHash = 1;
                                if (!$util.isString(message.combinedHash))
                                    return "combinedHash: string expected";
                            }
                            if (message.hex != null && message.hasOwnProperty("hex")) {
                                properties._hex = 1;
                                if (!$util.isString(message.hex))
                                    return "hex: string expected";
                            }
                            if (message.dec != null && message.hasOwnProperty("dec")) {
                                properties._dec = 1;
                                if (!$util.isInteger(message.dec) && !(message.dec && $util.isInteger(message.dec.low) && $util.isInteger(message.dec.high)))
                                    return "dec: integer|Long expected";
                            }
                            if (message.odds != null && message.hasOwnProperty("odds")) {
                                properties._odds = 1;
                                if (typeof message.odds !== "number")
                                    return "odds: number expected";
                            }
                            if (message.revealed != null && message.hasOwnProperty("revealed"))
                                if (typeof message.revealed !== "boolean")
                                    return "revealed: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a ProvablyFairRoundResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairRoundResponse} ProvablyFairRoundResponse
                         */
                        ProvablyFairRoundResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ProvablyFairRoundResponse();
                            if (object.roundId != null)
                                if ($util.Long)
                                    (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                                else if (typeof object.roundId === "string")
                                    message.roundId = parseInt(object.roundId, 10);
                                else if (typeof object.roundId === "number")
                                    message.roundId = object.roundId;
                                else if (typeof object.roundId === "object")
                                    message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                            if (object.crashPoint != null)
                                message.crashPoint = Number(object.crashPoint);
                            if (object.timestamp != null)
                                if ($util.Long)
                                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                                else if (typeof object.timestamp === "string")
                                    message.timestamp = parseInt(object.timestamp, 10);
                                else if (typeof object.timestamp === "number")
                                    message.timestamp = object.timestamp;
                                else if (typeof object.timestamp === "object")
                                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                            if (object.serverSeed != null)
                                message.serverSeed = String(object.serverSeed);
                            if (object.publicHash != null)
                                message.publicHash = String(object.publicHash);
                            if (object.clientSeeds) {
                                if (!Array.isArray(object.clientSeeds))
                                    throw TypeError(".com.achlid.crash.game.stateless.ProvablyFairRoundResponse.clientSeeds: array expected");
                                message.clientSeeds = [];
                                for (let i = 0; i < object.clientSeeds.length; ++i)
                                    message.clientSeeds[i] = String(object.clientSeeds[i]);
                            }
                            if (object.combinedHash != null)
                                message.combinedHash = String(object.combinedHash);
                            if (object.hex != null)
                                message.hex = String(object.hex);
                            if (object.dec != null)
                                if ($util.Long)
                                    (message.dec = $util.Long.fromValue(object.dec)).unsigned = false;
                                else if (typeof object.dec === "string")
                                    message.dec = parseInt(object.dec, 10);
                                else if (typeof object.dec === "number")
                                    message.dec = object.dec;
                                else if (typeof object.dec === "object")
                                    message.dec = new $util.LongBits(object.dec.low >>> 0, object.dec.high >>> 0).toNumber();
                            if (object.odds != null)
                                message.odds = Number(object.odds);
                            if (object.revealed != null)
                                message.revealed = Boolean(object.revealed);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ProvablyFairRoundResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ProvablyFairRoundResponse} message ProvablyFairRoundResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProvablyFairRoundResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.clientSeeds = [];
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.roundId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.timestamp = options.longs === String ? "0" : 0;
                                object.publicHash = "";
                                object.revealed = false;
                            }
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (typeof message.roundId === "number")
                                    object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                                else
                                    object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                                if (options.oneofs)
                                    object._crashPoint = "crashPoint";
                            }
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (typeof message.timestamp === "number")
                                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                                else
                                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                            if (message.serverSeed != null && message.hasOwnProperty("serverSeed")) {
                                object.serverSeed = message.serverSeed;
                                if (options.oneofs)
                                    object._serverSeed = "serverSeed";
                            }
                            if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                                object.publicHash = message.publicHash;
                            if (message.clientSeeds && message.clientSeeds.length) {
                                object.clientSeeds = [];
                                for (let j = 0; j < message.clientSeeds.length; ++j)
                                    object.clientSeeds[j] = message.clientSeeds[j];
                            }
                            if (message.combinedHash != null && message.hasOwnProperty("combinedHash")) {
                                object.combinedHash = message.combinedHash;
                                if (options.oneofs)
                                    object._combinedHash = "combinedHash";
                            }
                            if (message.hex != null && message.hasOwnProperty("hex")) {
                                object.hex = message.hex;
                                if (options.oneofs)
                                    object._hex = "hex";
                            }
                            if (message.dec != null && message.hasOwnProperty("dec")) {
                                if (typeof message.dec === "number")
                                    object.dec = options.longs === String ? String(message.dec) : message.dec;
                                else
                                    object.dec = options.longs === String ? $util.Long.prototype.toString.call(message.dec) : options.longs === Number ? new $util.LongBits(message.dec.low >>> 0, message.dec.high >>> 0).toNumber() : message.dec;
                                if (options.oneofs)
                                    object._dec = "dec";
                            }
                            if (message.odds != null && message.hasOwnProperty("odds")) {
                                object.odds = options.json && !isFinite(message.odds) ? String(message.odds) : message.odds;
                                if (options.oneofs)
                                    object._odds = "odds";
                            }
                            if (message.revealed != null && message.hasOwnProperty("revealed"))
                                object.revealed = message.revealed;
                            return object;
                        };

                        /**
                         * Converts this ProvablyFairRoundResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProvablyFairRoundResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ProvablyFairRoundResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairRoundResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ProvablyFairRoundResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ProvablyFairRoundResponse";
                        };

                        return ProvablyFairRoundResponse;
                    })();

                    stateless.GetProvablyFairBetsRequest = (function() {

                        /**
                         * Properties of a GetProvablyFairBetsRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetProvablyFairBetsRequest
                         * @property {number|null} [page] GetProvablyFairBetsRequest page
                         * @property {number|null} [pageSize] GetProvablyFairBetsRequest pageSize
                         */

                        /**
                         * Constructs a new GetProvablyFairBetsRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetProvablyFairBetsRequest.
                         * @implements IGetProvablyFairBetsRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest=} [properties] Properties to set
                         */
                        function GetProvablyFairBetsRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetProvablyFairBetsRequest page.
                         * @member {number} page
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @instance
                         */
                        GetProvablyFairBetsRequest.prototype.page = 0;

                        /**
                         * GetProvablyFairBetsRequest pageSize.
                         * @member {number} pageSize
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @instance
                         */
                        GetProvablyFairBetsRequest.prototype.pageSize = 0;

                        /**
                         * Creates a new GetProvablyFairBetsRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairBetsRequest} GetProvablyFairBetsRequest instance
                         */
                        GetProvablyFairBetsRequest.create = function create(properties) {
                            return new GetProvablyFairBetsRequest(properties);
                        };

                        /**
                         * Encodes the specified GetProvablyFairBetsRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest} message GetProvablyFairBetsRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetProvablyFairBetsRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.page);
                            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetProvablyFairBetsRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetProvablyFairBetsRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetProvablyFairBetsRequest} message GetProvablyFairBetsRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetProvablyFairBetsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetProvablyFairBetsRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairBetsRequest} GetProvablyFairBetsRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetProvablyFairBetsRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.page = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.pageSize = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetProvablyFairBetsRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairBetsRequest} GetProvablyFairBetsRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetProvablyFairBetsRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetProvablyFairBetsRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetProvablyFairBetsRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.page != null && message.hasOwnProperty("page"))
                                if (!$util.isInteger(message.page))
                                    return "page: integer expected";
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                if (!$util.isInteger(message.pageSize))
                                    return "pageSize: integer expected";
                            return null;
                        };

                        /**
                         * Creates a GetProvablyFairBetsRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetProvablyFairBetsRequest} GetProvablyFairBetsRequest
                         */
                        GetProvablyFairBetsRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetProvablyFairBetsRequest();
                            if (object.page != null)
                                message.page = object.page | 0;
                            if (object.pageSize != null)
                                message.pageSize = object.pageSize | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetProvablyFairBetsRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetProvablyFairBetsRequest} message GetProvablyFairBetsRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetProvablyFairBetsRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.page = 0;
                                object.pageSize = 0;
                            }
                            if (message.page != null && message.hasOwnProperty("page"))
                                object.page = message.page;
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                object.pageSize = message.pageSize;
                            return object;
                        };

                        /**
                         * Converts this GetProvablyFairBetsRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetProvablyFairBetsRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetProvablyFairBetsRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetProvablyFairBetsRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetProvablyFairBetsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetProvablyFairBetsRequest";
                        };

                        return GetProvablyFairBetsRequest;
                    })();

                    stateless.ProvablyFairBetsResponse = (function() {

                        /**
                         * Properties of a ProvablyFairBetsResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IProvablyFairBetsResponse
                         * @property {Array.<com.achlid.crash.game.stateless.IProvablyFairBetEntry>|null} [bets] ProvablyFairBetsResponse bets
                         * @property {number|null} [page] ProvablyFairBetsResponse page
                         * @property {number|null} [pageSize] ProvablyFairBetsResponse pageSize
                         * @property {number|null} [totalCount] ProvablyFairBetsResponse totalCount
                         * @property {number|null} [totalPages] ProvablyFairBetsResponse totalPages
                         */

                        /**
                         * Constructs a new ProvablyFairBetsResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ProvablyFairBetsResponse.
                         * @implements IProvablyFairBetsResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetsResponse=} [properties] Properties to set
                         */
                        function ProvablyFairBetsResponse(properties) {
                            this.bets = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ProvablyFairBetsResponse bets.
                         * @member {Array.<com.achlid.crash.game.stateless.IProvablyFairBetEntry>} bets
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         */
                        ProvablyFairBetsResponse.prototype.bets = $util.emptyArray;

                        /**
                         * ProvablyFairBetsResponse page.
                         * @member {number} page
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         */
                        ProvablyFairBetsResponse.prototype.page = 0;

                        /**
                         * ProvablyFairBetsResponse pageSize.
                         * @member {number} pageSize
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         */
                        ProvablyFairBetsResponse.prototype.pageSize = 0;

                        /**
                         * ProvablyFairBetsResponse totalCount.
                         * @member {number} totalCount
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         */
                        ProvablyFairBetsResponse.prototype.totalCount = 0;

                        /**
                         * ProvablyFairBetsResponse totalPages.
                         * @member {number} totalPages
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         */
                        ProvablyFairBetsResponse.prototype.totalPages = 0;

                        /**
                         * Creates a new ProvablyFairBetsResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetsResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetsResponse} ProvablyFairBetsResponse instance
                         */
                        ProvablyFairBetsResponse.create = function create(properties) {
                            return new ProvablyFairBetsResponse(properties);
                        };

                        /**
                         * Encodes the specified ProvablyFairBetsResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairBetsResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetsResponse} message ProvablyFairBetsResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairBetsResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.bets != null && message.bets.length)
                                for (let i = 0; i < message.bets.length; ++i)
                                    $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry.encode(message.bets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.page);
                            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                            if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.totalCount);
                            if (message.totalPages != null && Object.hasOwnProperty.call(message, "totalPages"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalPages);
                            return writer;
                        };

                        /**
                         * Encodes the specified ProvablyFairBetsResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairBetsResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetsResponse} message ProvablyFairBetsResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairBetsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ProvablyFairBetsResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetsResponse} ProvablyFairBetsResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairBetsResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        if (!(message.bets && message.bets.length))
                                            message.bets = [];
                                        message.bets.push($root.com.achlid.crash.game.stateless.ProvablyFairBetEntry.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 2: {
                                        message.page = reader.int32();
                                        break;
                                    }
                                case 3: {
                                        message.pageSize = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.totalCount = reader.int32();
                                        break;
                                    }
                                case 5: {
                                        message.totalPages = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ProvablyFairBetsResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetsResponse} ProvablyFairBetsResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairBetsResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ProvablyFairBetsResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProvablyFairBetsResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.bets != null && message.hasOwnProperty("bets")) {
                                if (!Array.isArray(message.bets))
                                    return "bets: array expected";
                                for (let i = 0; i < message.bets.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry.verify(message.bets[i]);
                                    if (error)
                                        return "bets." + error;
                                }
                            }
                            if (message.page != null && message.hasOwnProperty("page"))
                                if (!$util.isInteger(message.page))
                                    return "page: integer expected";
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                if (!$util.isInteger(message.pageSize))
                                    return "pageSize: integer expected";
                            if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                                if (!$util.isInteger(message.totalCount))
                                    return "totalCount: integer expected";
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                if (!$util.isInteger(message.totalPages))
                                    return "totalPages: integer expected";
                            return null;
                        };

                        /**
                         * Creates a ProvablyFairBetsResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetsResponse} ProvablyFairBetsResponse
                         */
                        ProvablyFairBetsResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ProvablyFairBetsResponse();
                            if (object.bets) {
                                if (!Array.isArray(object.bets))
                                    throw TypeError(".com.achlid.crash.game.stateless.ProvablyFairBetsResponse.bets: array expected");
                                message.bets = [];
                                for (let i = 0; i < object.bets.length; ++i) {
                                    if (typeof object.bets[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.ProvablyFairBetsResponse.bets: object expected");
                                    message.bets[i] = $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry.fromObject(object.bets[i]);
                                }
                            }
                            if (object.page != null)
                                message.page = object.page | 0;
                            if (object.pageSize != null)
                                message.pageSize = object.pageSize | 0;
                            if (object.totalCount != null)
                                message.totalCount = object.totalCount | 0;
                            if (object.totalPages != null)
                                message.totalPages = object.totalPages | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a ProvablyFairBetsResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ProvablyFairBetsResponse} message ProvablyFairBetsResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProvablyFairBetsResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.bets = [];
                            if (options.defaults) {
                                object.page = 0;
                                object.pageSize = 0;
                                object.totalCount = 0;
                                object.totalPages = 0;
                            }
                            if (message.bets && message.bets.length) {
                                object.bets = [];
                                for (let j = 0; j < message.bets.length; ++j)
                                    object.bets[j] = $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry.toObject(message.bets[j], options);
                            }
                            if (message.page != null && message.hasOwnProperty("page"))
                                object.page = message.page;
                            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                                object.pageSize = message.pageSize;
                            if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                                object.totalCount = message.totalCount;
                            if (message.totalPages != null && message.hasOwnProperty("totalPages"))
                                object.totalPages = message.totalPages;
                            return object;
                        };

                        /**
                         * Converts this ProvablyFairBetsResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProvablyFairBetsResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ProvablyFairBetsResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetsResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ProvablyFairBetsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ProvablyFairBetsResponse";
                        };

                        return ProvablyFairBetsResponse;
                    })();

                    stateless.ProvablyFairBetEntry = (function() {

                        /**
                         * Properties of a ProvablyFairBetEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IProvablyFairBetEntry
                         * @property {number|Long|null} [betId] ProvablyFairBetEntry betId
                         * @property {number|Long|null} [roundId] ProvablyFairBetEntry roundId
                         * @property {number|null} [slotId] ProvablyFairBetEntry slotId
                         * @property {number|null} [betAmount] ProvablyFairBetEntry betAmount
                         * @property {number|null} [payout] ProvablyFairBetEntry payout
                         * @property {number|null} [multiplier] ProvablyFairBetEntry multiplier
                         * @property {string|null} [status] ProvablyFairBetEntry status
                         * @property {number|Long|null} [timestamp] ProvablyFairBetEntry timestamp
                         * @property {number|null} [crashPoint] ProvablyFairBetEntry crashPoint
                         * @property {string|null} [serverSeed] ProvablyFairBetEntry serverSeed
                         * @property {string|null} [publicHash] ProvablyFairBetEntry publicHash
                         * @property {Array.<string>|null} [clientSeeds] ProvablyFairBetEntry clientSeeds
                         * @property {string|null} [nextClientSeed] ProvablyFairBetEntry nextClientSeed
                         * @property {string|null} [nextServerHash] ProvablyFairBetEntry nextServerHash
                         */

                        /**
                         * Constructs a new ProvablyFairBetEntry.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ProvablyFairBetEntry.
                         * @implements IProvablyFairBetEntry
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetEntry=} [properties] Properties to set
                         */
                        function ProvablyFairBetEntry(properties) {
                            this.clientSeeds = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ProvablyFairBetEntry betId.
                         * @member {number|Long} betId
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.betId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ProvablyFairBetEntry roundId.
                         * @member {number|Long} roundId
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.roundId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ProvablyFairBetEntry slotId.
                         * @member {number} slotId
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.slotId = 0;

                        /**
                         * ProvablyFairBetEntry betAmount.
                         * @member {number} betAmount
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.betAmount = 0;

                        /**
                         * ProvablyFairBetEntry payout.
                         * @member {number} payout
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.payout = 0;

                        /**
                         * ProvablyFairBetEntry multiplier.
                         * @member {number|null|undefined} multiplier
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.multiplier = null;

                        /**
                         * ProvablyFairBetEntry status.
                         * @member {string} status
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.status = "";

                        /**
                         * ProvablyFairBetEntry timestamp.
                         * @member {number|Long} timestamp
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ProvablyFairBetEntry crashPoint.
                         * @member {number|null|undefined} crashPoint
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.crashPoint = null;

                        /**
                         * ProvablyFairBetEntry serverSeed.
                         * @member {string|null|undefined} serverSeed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.serverSeed = null;

                        /**
                         * ProvablyFairBetEntry publicHash.
                         * @member {string} publicHash
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.publicHash = "";

                        /**
                         * ProvablyFairBetEntry clientSeeds.
                         * @member {Array.<string>} clientSeeds
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.clientSeeds = $util.emptyArray;

                        /**
                         * ProvablyFairBetEntry nextClientSeed.
                         * @member {string} nextClientSeed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.nextClientSeed = "";

                        /**
                         * ProvablyFairBetEntry nextServerHash.
                         * @member {string} nextServerHash
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        ProvablyFairBetEntry.prototype.nextServerHash = "";

                        // OneOf field names bound to virtual getters and setters
                        let $oneOfFields;

                        /**
                         * ProvablyFairBetEntry _multiplier.
                         * @member {"multiplier"|undefined} _multiplier
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairBetEntry.prototype, "_multiplier", {
                            get: $util.oneOfGetter($oneOfFields = ["multiplier"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairBetEntry _crashPoint.
                         * @member {"crashPoint"|undefined} _crashPoint
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairBetEntry.prototype, "_crashPoint", {
                            get: $util.oneOfGetter($oneOfFields = ["crashPoint"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * ProvablyFairBetEntry _serverSeed.
                         * @member {"serverSeed"|undefined} _serverSeed
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         */
                        Object.defineProperty(ProvablyFairBetEntry.prototype, "_serverSeed", {
                            get: $util.oneOfGetter($oneOfFields = ["serverSeed"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });

                        /**
                         * Creates a new ProvablyFairBetEntry instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetEntry=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetEntry} ProvablyFairBetEntry instance
                         */
                        ProvablyFairBetEntry.create = function create(properties) {
                            return new ProvablyFairBetEntry(properties);
                        };

                        /**
                         * Encodes the specified ProvablyFairBetEntry message. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairBetEntry.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetEntry} message ProvablyFairBetEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairBetEntry.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.betId != null && Object.hasOwnProperty.call(message, "betId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.betId);
                            if (message.roundId != null && Object.hasOwnProperty.call(message, "roundId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.roundId);
                            if (message.slotId != null && Object.hasOwnProperty.call(message, "slotId"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.slotId);
                            if (message.betAmount != null && Object.hasOwnProperty.call(message, "betAmount"))
                                writer.uint32(/* id 4, wireType 1 =*/33).double(message.betAmount);
                            if (message.payout != null && Object.hasOwnProperty.call(message, "payout"))
                                writer.uint32(/* id 5, wireType 1 =*/41).double(message.payout);
                            if (message.multiplier != null && Object.hasOwnProperty.call(message, "multiplier"))
                                writer.uint32(/* id 6, wireType 1 =*/49).double(message.multiplier);
                            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                            if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.timestamp);
                            if (message.crashPoint != null && Object.hasOwnProperty.call(message, "crashPoint"))
                                writer.uint32(/* id 9, wireType 1 =*/73).double(message.crashPoint);
                            if (message.serverSeed != null && Object.hasOwnProperty.call(message, "serverSeed"))
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.serverSeed);
                            if (message.publicHash != null && Object.hasOwnProperty.call(message, "publicHash"))
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.publicHash);
                            if (message.clientSeeds != null && message.clientSeeds.length)
                                for (let i = 0; i < message.clientSeeds.length; ++i)
                                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.clientSeeds[i]);
                            if (message.nextClientSeed != null && Object.hasOwnProperty.call(message, "nextClientSeed"))
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.nextClientSeed);
                            if (message.nextServerHash != null && Object.hasOwnProperty.call(message, "nextServerHash"))
                                writer.uint32(/* id 14, wireType 2 =*/114).string(message.nextServerHash);
                            return writer;
                        };

                        /**
                         * Encodes the specified ProvablyFairBetEntry message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ProvablyFairBetEntry.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.IProvablyFairBetEntry} message ProvablyFairBetEntry message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProvablyFairBetEntry.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ProvablyFairBetEntry message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetEntry} ProvablyFairBetEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairBetEntry.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.betId = reader.int64();
                                        break;
                                    }
                                case 2: {
                                        message.roundId = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.slotId = reader.int32();
                                        break;
                                    }
                                case 4: {
                                        message.betAmount = reader.double();
                                        break;
                                    }
                                case 5: {
                                        message.payout = reader.double();
                                        break;
                                    }
                                case 6: {
                                        message.multiplier = reader.double();
                                        break;
                                    }
                                case 7: {
                                        message.status = reader.string();
                                        break;
                                    }
                                case 8: {
                                        message.timestamp = reader.int64();
                                        break;
                                    }
                                case 9: {
                                        message.crashPoint = reader.double();
                                        break;
                                    }
                                case 10: {
                                        message.serverSeed = reader.string();
                                        break;
                                    }
                                case 11: {
                                        message.publicHash = reader.string();
                                        break;
                                    }
                                case 12: {
                                        if (!(message.clientSeeds && message.clientSeeds.length))
                                            message.clientSeeds = [];
                                        message.clientSeeds.push(reader.string());
                                        break;
                                    }
                                case 13: {
                                        message.nextClientSeed = reader.string();
                                        break;
                                    }
                                case 14: {
                                        message.nextServerHash = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ProvablyFairBetEntry message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetEntry} ProvablyFairBetEntry
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProvablyFairBetEntry.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ProvablyFairBetEntry message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProvablyFairBetEntry.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            let properties = {};
                            if (message.betId != null && message.hasOwnProperty("betId"))
                                if (!$util.isInteger(message.betId) && !(message.betId && $util.isInteger(message.betId.low) && $util.isInteger(message.betId.high)))
                                    return "betId: integer|Long expected";
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (!$util.isInteger(message.roundId) && !(message.roundId && $util.isInteger(message.roundId.low) && $util.isInteger(message.roundId.high)))
                                    return "roundId: integer|Long expected";
                            if (message.slotId != null && message.hasOwnProperty("slotId"))
                                if (!$util.isInteger(message.slotId))
                                    return "slotId: integer expected";
                            if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                                if (typeof message.betAmount !== "number")
                                    return "betAmount: number expected";
                            if (message.payout != null && message.hasOwnProperty("payout"))
                                if (typeof message.payout !== "number")
                                    return "payout: number expected";
                            if (message.multiplier != null && message.hasOwnProperty("multiplier")) {
                                properties._multiplier = 1;
                                if (typeof message.multiplier !== "number")
                                    return "multiplier: number expected";
                            }
                            if (message.status != null && message.hasOwnProperty("status"))
                                if (!$util.isString(message.status))
                                    return "status: string expected";
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                                    return "timestamp: integer|Long expected";
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                properties._crashPoint = 1;
                                if (typeof message.crashPoint !== "number")
                                    return "crashPoint: number expected";
                            }
                            if (message.serverSeed != null && message.hasOwnProperty("serverSeed")) {
                                properties._serverSeed = 1;
                                if (!$util.isString(message.serverSeed))
                                    return "serverSeed: string expected";
                            }
                            if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                                if (!$util.isString(message.publicHash))
                                    return "publicHash: string expected";
                            if (message.clientSeeds != null && message.hasOwnProperty("clientSeeds")) {
                                if (!Array.isArray(message.clientSeeds))
                                    return "clientSeeds: array expected";
                                for (let i = 0; i < message.clientSeeds.length; ++i)
                                    if (!$util.isString(message.clientSeeds[i]))
                                        return "clientSeeds: string[] expected";
                            }
                            if (message.nextClientSeed != null && message.hasOwnProperty("nextClientSeed"))
                                if (!$util.isString(message.nextClientSeed))
                                    return "nextClientSeed: string expected";
                            if (message.nextServerHash != null && message.hasOwnProperty("nextServerHash"))
                                if (!$util.isString(message.nextServerHash))
                                    return "nextServerHash: string expected";
                            return null;
                        };

                        /**
                         * Creates a ProvablyFairBetEntry message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ProvablyFairBetEntry} ProvablyFairBetEntry
                         */
                        ProvablyFairBetEntry.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ProvablyFairBetEntry();
                            if (object.betId != null)
                                if ($util.Long)
                                    (message.betId = $util.Long.fromValue(object.betId)).unsigned = false;
                                else if (typeof object.betId === "string")
                                    message.betId = parseInt(object.betId, 10);
                                else if (typeof object.betId === "number")
                                    message.betId = object.betId;
                                else if (typeof object.betId === "object")
                                    message.betId = new $util.LongBits(object.betId.low >>> 0, object.betId.high >>> 0).toNumber();
                            if (object.roundId != null)
                                if ($util.Long)
                                    (message.roundId = $util.Long.fromValue(object.roundId)).unsigned = false;
                                else if (typeof object.roundId === "string")
                                    message.roundId = parseInt(object.roundId, 10);
                                else if (typeof object.roundId === "number")
                                    message.roundId = object.roundId;
                                else if (typeof object.roundId === "object")
                                    message.roundId = new $util.LongBits(object.roundId.low >>> 0, object.roundId.high >>> 0).toNumber();
                            if (object.slotId != null)
                                message.slotId = object.slotId | 0;
                            if (object.betAmount != null)
                                message.betAmount = Number(object.betAmount);
                            if (object.payout != null)
                                message.payout = Number(object.payout);
                            if (object.multiplier != null)
                                message.multiplier = Number(object.multiplier);
                            if (object.status != null)
                                message.status = String(object.status);
                            if (object.timestamp != null)
                                if ($util.Long)
                                    (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                                else if (typeof object.timestamp === "string")
                                    message.timestamp = parseInt(object.timestamp, 10);
                                else if (typeof object.timestamp === "number")
                                    message.timestamp = object.timestamp;
                                else if (typeof object.timestamp === "object")
                                    message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                            if (object.crashPoint != null)
                                message.crashPoint = Number(object.crashPoint);
                            if (object.serverSeed != null)
                                message.serverSeed = String(object.serverSeed);
                            if (object.publicHash != null)
                                message.publicHash = String(object.publicHash);
                            if (object.clientSeeds) {
                                if (!Array.isArray(object.clientSeeds))
                                    throw TypeError(".com.achlid.crash.game.stateless.ProvablyFairBetEntry.clientSeeds: array expected");
                                message.clientSeeds = [];
                                for (let i = 0; i < object.clientSeeds.length; ++i)
                                    message.clientSeeds[i] = String(object.clientSeeds[i]);
                            }
                            if (object.nextClientSeed != null)
                                message.nextClientSeed = String(object.nextClientSeed);
                            if (object.nextServerHash != null)
                                message.nextServerHash = String(object.nextServerHash);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ProvablyFairBetEntry message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {com.achlid.crash.game.stateless.ProvablyFairBetEntry} message ProvablyFairBetEntry
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProvablyFairBetEntry.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.clientSeeds = [];
                            if (options.defaults) {
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.betId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.betId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.roundId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.roundId = options.longs === String ? "0" : 0;
                                object.slotId = 0;
                                object.betAmount = 0;
                                object.payout = 0;
                                object.status = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.timestamp = options.longs === String ? "0" : 0;
                                object.publicHash = "";
                                object.nextClientSeed = "";
                                object.nextServerHash = "";
                            }
                            if (message.betId != null && message.hasOwnProperty("betId"))
                                if (typeof message.betId === "number")
                                    object.betId = options.longs === String ? String(message.betId) : message.betId;
                                else
                                    object.betId = options.longs === String ? $util.Long.prototype.toString.call(message.betId) : options.longs === Number ? new $util.LongBits(message.betId.low >>> 0, message.betId.high >>> 0).toNumber() : message.betId;
                            if (message.roundId != null && message.hasOwnProperty("roundId"))
                                if (typeof message.roundId === "number")
                                    object.roundId = options.longs === String ? String(message.roundId) : message.roundId;
                                else
                                    object.roundId = options.longs === String ? $util.Long.prototype.toString.call(message.roundId) : options.longs === Number ? new $util.LongBits(message.roundId.low >>> 0, message.roundId.high >>> 0).toNumber() : message.roundId;
                            if (message.slotId != null && message.hasOwnProperty("slotId"))
                                object.slotId = message.slotId;
                            if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                                object.betAmount = options.json && !isFinite(message.betAmount) ? String(message.betAmount) : message.betAmount;
                            if (message.payout != null && message.hasOwnProperty("payout"))
                                object.payout = options.json && !isFinite(message.payout) ? String(message.payout) : message.payout;
                            if (message.multiplier != null && message.hasOwnProperty("multiplier")) {
                                object.multiplier = options.json && !isFinite(message.multiplier) ? String(message.multiplier) : message.multiplier;
                                if (options.oneofs)
                                    object._multiplier = "multiplier";
                            }
                            if (message.status != null && message.hasOwnProperty("status"))
                                object.status = message.status;
                            if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                                if (typeof message.timestamp === "number")
                                    object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                                else
                                    object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                            if (message.crashPoint != null && message.hasOwnProperty("crashPoint")) {
                                object.crashPoint = options.json && !isFinite(message.crashPoint) ? String(message.crashPoint) : message.crashPoint;
                                if (options.oneofs)
                                    object._crashPoint = "crashPoint";
                            }
                            if (message.serverSeed != null && message.hasOwnProperty("serverSeed")) {
                                object.serverSeed = message.serverSeed;
                                if (options.oneofs)
                                    object._serverSeed = "serverSeed";
                            }
                            if (message.publicHash != null && message.hasOwnProperty("publicHash"))
                                object.publicHash = message.publicHash;
                            if (message.clientSeeds && message.clientSeeds.length) {
                                object.clientSeeds = [];
                                for (let j = 0; j < message.clientSeeds.length; ++j)
                                    object.clientSeeds[j] = message.clientSeeds[j];
                            }
                            if (message.nextClientSeed != null && message.hasOwnProperty("nextClientSeed"))
                                object.nextClientSeed = message.nextClientSeed;
                            if (message.nextServerHash != null && message.hasOwnProperty("nextServerHash"))
                                object.nextServerHash = message.nextServerHash;
                            return object;
                        };

                        /**
                         * Converts this ProvablyFairBetEntry to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProvablyFairBetEntry.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ProvablyFairBetEntry
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ProvablyFairBetEntry
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ProvablyFairBetEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ProvablyFairBetEntry";
                        };

                        return ProvablyFairBetEntry;
                    })();

                    stateless.GetFreebetsRequest = (function() {

                        /**
                         * Properties of a GetFreebetsRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetFreebetsRequest
                         */

                        /**
                         * Constructs a new GetFreebetsRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetFreebetsRequest.
                         * @implements IGetFreebetsRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetFreebetsRequest=} [properties] Properties to set
                         */
                        function GetFreebetsRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * Creates a new GetFreebetsRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetFreebetsRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetFreebetsRequest} GetFreebetsRequest instance
                         */
                        GetFreebetsRequest.create = function create(properties) {
                            return new GetFreebetsRequest(properties);
                        };

                        /**
                         * Encodes the specified GetFreebetsRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetFreebetsRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetFreebetsRequest} message GetFreebetsRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetFreebetsRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            return writer;
                        };

                        /**
                         * Encodes the specified GetFreebetsRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetFreebetsRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetFreebetsRequest} message GetFreebetsRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetFreebetsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetFreebetsRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetFreebetsRequest} GetFreebetsRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetFreebetsRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetFreebetsRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetFreebetsRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetFreebetsRequest} GetFreebetsRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetFreebetsRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetFreebetsRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetFreebetsRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            return null;
                        };

                        /**
                         * Creates a GetFreebetsRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetFreebetsRequest} GetFreebetsRequest
                         */
                        GetFreebetsRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetFreebetsRequest)
                                return object;
                            return new $root.com.achlid.crash.game.stateless.GetFreebetsRequest();
                        };

                        /**
                         * Creates a plain object from a GetFreebetsRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetFreebetsRequest} message GetFreebetsRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetFreebetsRequest.toObject = function toObject() {
                            return {};
                        };

                        /**
                         * Converts this GetFreebetsRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetFreebetsRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetFreebetsRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetFreebetsRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetFreebetsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetFreebetsRequest";
                        };

                        return GetFreebetsRequest;
                    })();

                    stateless.FreebetsResponse = (function() {

                        /**
                         * Properties of a FreebetsResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IFreebetsResponse
                         * @property {Array.<com.achlid.crash.game.stateless.IFreebetInfo>|null} [freebets] FreebetsResponse freebets
                         */

                        /**
                         * Constructs a new FreebetsResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a FreebetsResponse.
                         * @implements IFreebetsResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IFreebetsResponse=} [properties] Properties to set
                         */
                        function FreebetsResponse(properties) {
                            this.freebets = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * FreebetsResponse freebets.
                         * @member {Array.<com.achlid.crash.game.stateless.IFreebetInfo>} freebets
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @instance
                         */
                        FreebetsResponse.prototype.freebets = $util.emptyArray;

                        /**
                         * Creates a new FreebetsResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetsResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.FreebetsResponse} FreebetsResponse instance
                         */
                        FreebetsResponse.create = function create(properties) {
                            return new FreebetsResponse(properties);
                        };

                        /**
                         * Encodes the specified FreebetsResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.FreebetsResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetsResponse} message FreebetsResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FreebetsResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.freebets != null && message.freebets.length)
                                for (let i = 0; i < message.freebets.length; ++i)
                                    $root.com.achlid.crash.game.stateless.FreebetInfo.encode(message.freebets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };

                        /**
                         * Encodes the specified FreebetsResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.FreebetsResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetsResponse} message FreebetsResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FreebetsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a FreebetsResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.FreebetsResponse} FreebetsResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FreebetsResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.FreebetsResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        if (!(message.freebets && message.freebets.length))
                                            message.freebets = [];
                                        message.freebets.push($root.com.achlid.crash.game.stateless.FreebetInfo.decode(reader, reader.uint32()));
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a FreebetsResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.FreebetsResponse} FreebetsResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FreebetsResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a FreebetsResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        FreebetsResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.freebets != null && message.hasOwnProperty("freebets")) {
                                if (!Array.isArray(message.freebets))
                                    return "freebets: array expected";
                                for (let i = 0; i < message.freebets.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.FreebetInfo.verify(message.freebets[i]);
                                    if (error)
                                        return "freebets." + error;
                                }
                            }
                            return null;
                        };

                        /**
                         * Creates a FreebetsResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.FreebetsResponse} FreebetsResponse
                         */
                        FreebetsResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.FreebetsResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.FreebetsResponse();
                            if (object.freebets) {
                                if (!Array.isArray(object.freebets))
                                    throw TypeError(".com.achlid.crash.game.stateless.FreebetsResponse.freebets: array expected");
                                message.freebets = [];
                                for (let i = 0; i < object.freebets.length; ++i) {
                                    if (typeof object.freebets[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.FreebetsResponse.freebets: object expected");
                                    message.freebets[i] = $root.com.achlid.crash.game.stateless.FreebetInfo.fromObject(object.freebets[i]);
                                }
                            }
                            return message;
                        };

                        /**
                         * Creates a plain object from a FreebetsResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.FreebetsResponse} message FreebetsResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        FreebetsResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.freebets = [];
                            if (message.freebets && message.freebets.length) {
                                object.freebets = [];
                                for (let j = 0; j < message.freebets.length; ++j)
                                    object.freebets[j] = $root.com.achlid.crash.game.stateless.FreebetInfo.toObject(message.freebets[j], options);
                            }
                            return object;
                        };

                        /**
                         * Converts this FreebetsResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        FreebetsResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for FreebetsResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.FreebetsResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        FreebetsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.FreebetsResponse";
                        };

                        return FreebetsResponse;
                    })();

                    stateless.FreebetInfo = (function() {

                        /**
                         * Properties of a FreebetInfo.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IFreebetInfo
                         * @property {string|null} [freebetId] FreebetInfo freebetId
                         * @property {number|null} [amount] FreebetInfo amount
                         * @property {number|Long|null} [expiresAt] FreebetInfo expiresAt
                         * @property {string|null} [source] FreebetInfo source
                         * @property {number|null} [targetSlotId] FreebetInfo targetSlotId
                         */

                        /**
                         * Constructs a new FreebetInfo.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a FreebetInfo.
                         * @implements IFreebetInfo
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IFreebetInfo=} [properties] Properties to set
                         */
                        function FreebetInfo(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * FreebetInfo freebetId.
                         * @member {string} freebetId
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         */
                        FreebetInfo.prototype.freebetId = "";

                        /**
                         * FreebetInfo amount.
                         * @member {number} amount
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         */
                        FreebetInfo.prototype.amount = 0;

                        /**
                         * FreebetInfo expiresAt.
                         * @member {number|Long} expiresAt
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         */
                        FreebetInfo.prototype.expiresAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * FreebetInfo source.
                         * @member {string} source
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         */
                        FreebetInfo.prototype.source = "";

                        /**
                         * FreebetInfo targetSlotId.
                         * @member {number} targetSlotId
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         */
                        FreebetInfo.prototype.targetSlotId = 0;

                        /**
                         * Creates a new FreebetInfo instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetInfo=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.FreebetInfo} FreebetInfo instance
                         */
                        FreebetInfo.create = function create(properties) {
                            return new FreebetInfo(properties);
                        };

                        /**
                         * Encodes the specified FreebetInfo message. Does not implicitly {@link com.achlid.crash.game.stateless.FreebetInfo.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetInfo} message FreebetInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FreebetInfo.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.freebetId != null && Object.hasOwnProperty.call(message, "freebetId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.freebetId);
                            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                                writer.uint32(/* id 2, wireType 1 =*/17).double(message.amount);
                            if (message.expiresAt != null && Object.hasOwnProperty.call(message, "expiresAt"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.expiresAt);
                            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.source);
                            if (message.targetSlotId != null && Object.hasOwnProperty.call(message, "targetSlotId"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.targetSlotId);
                            return writer;
                        };

                        /**
                         * Encodes the specified FreebetInfo message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.FreebetInfo.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {com.achlid.crash.game.stateless.IFreebetInfo} message FreebetInfo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FreebetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a FreebetInfo message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.FreebetInfo} FreebetInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FreebetInfo.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.FreebetInfo();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.freebetId = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.amount = reader.double();
                                        break;
                                    }
                                case 3: {
                                        message.expiresAt = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.source = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.targetSlotId = reader.int32();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a FreebetInfo message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.FreebetInfo} FreebetInfo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FreebetInfo.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a FreebetInfo message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        FreebetInfo.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.freebetId != null && message.hasOwnProperty("freebetId"))
                                if (!$util.isString(message.freebetId))
                                    return "freebetId: string expected";
                            if (message.amount != null && message.hasOwnProperty("amount"))
                                if (typeof message.amount !== "number")
                                    return "amount: number expected";
                            if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                                if (!$util.isInteger(message.expiresAt) && !(message.expiresAt && $util.isInteger(message.expiresAt.low) && $util.isInteger(message.expiresAt.high)))
                                    return "expiresAt: integer|Long expected";
                            if (message.source != null && message.hasOwnProperty("source"))
                                if (!$util.isString(message.source))
                                    return "source: string expected";
                            if (message.targetSlotId != null && message.hasOwnProperty("targetSlotId"))
                                if (!$util.isInteger(message.targetSlotId))
                                    return "targetSlotId: integer expected";
                            return null;
                        };

                        /**
                         * Creates a FreebetInfo message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.FreebetInfo} FreebetInfo
                         */
                        FreebetInfo.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.FreebetInfo)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.FreebetInfo();
                            if (object.freebetId != null)
                                message.freebetId = String(object.freebetId);
                            if (object.amount != null)
                                message.amount = Number(object.amount);
                            if (object.expiresAt != null)
                                if ($util.Long)
                                    (message.expiresAt = $util.Long.fromValue(object.expiresAt)).unsigned = false;
                                else if (typeof object.expiresAt === "string")
                                    message.expiresAt = parseInt(object.expiresAt, 10);
                                else if (typeof object.expiresAt === "number")
                                    message.expiresAt = object.expiresAt;
                                else if (typeof object.expiresAt === "object")
                                    message.expiresAt = new $util.LongBits(object.expiresAt.low >>> 0, object.expiresAt.high >>> 0).toNumber();
                            if (object.source != null)
                                message.source = String(object.source);
                            if (object.targetSlotId != null)
                                message.targetSlotId = object.targetSlotId | 0;
                            return message;
                        };

                        /**
                         * Creates a plain object from a FreebetInfo message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {com.achlid.crash.game.stateless.FreebetInfo} message FreebetInfo
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        FreebetInfo.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.freebetId = "";
                                object.amount = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.expiresAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.expiresAt = options.longs === String ? "0" : 0;
                                object.source = "";
                                object.targetSlotId = 0;
                            }
                            if (message.freebetId != null && message.hasOwnProperty("freebetId"))
                                object.freebetId = message.freebetId;
                            if (message.amount != null && message.hasOwnProperty("amount"))
                                object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                            if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                                if (typeof message.expiresAt === "number")
                                    object.expiresAt = options.longs === String ? String(message.expiresAt) : message.expiresAt;
                                else
                                    object.expiresAt = options.longs === String ? $util.Long.prototype.toString.call(message.expiresAt) : options.longs === Number ? new $util.LongBits(message.expiresAt.low >>> 0, message.expiresAt.high >>> 0).toNumber() : message.expiresAt;
                            if (message.source != null && message.hasOwnProperty("source"))
                                object.source = message.source;
                            if (message.targetSlotId != null && message.hasOwnProperty("targetSlotId"))
                                object.targetSlotId = message.targetSlotId;
                            return object;
                        };

                        /**
                         * Converts this FreebetInfo to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        FreebetInfo.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for FreebetInfo
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.FreebetInfo
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        FreebetInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.FreebetInfo";
                        };

                        return FreebetInfo;
                    })();

                    stateless.SendChatMessageRequest = (function() {

                        /**
                         * Properties of a SendChatMessageRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface ISendChatMessageRequest
                         * @property {string|null} [text] SendChatMessageRequest text
                         * @property {string|null} [clientMessageId] SendChatMessageRequest clientMessageId
                         */

                        /**
                         * Constructs a new SendChatMessageRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a SendChatMessageRequest.
                         * @implements ISendChatMessageRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.ISendChatMessageRequest=} [properties] Properties to set
                         */
                        function SendChatMessageRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * SendChatMessageRequest text.
                         * @member {string} text
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @instance
                         */
                        SendChatMessageRequest.prototype.text = "";

                        /**
                         * SendChatMessageRequest clientMessageId.
                         * @member {string} clientMessageId
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @instance
                         */
                        SendChatMessageRequest.prototype.clientMessageId = "";

                        /**
                         * Creates a new SendChatMessageRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.ISendChatMessageRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.SendChatMessageRequest} SendChatMessageRequest instance
                         */
                        SendChatMessageRequest.create = function create(properties) {
                            return new SendChatMessageRequest(properties);
                        };

                        /**
                         * Encodes the specified SendChatMessageRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.SendChatMessageRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.ISendChatMessageRequest} message SendChatMessageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SendChatMessageRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.text);
                            if (message.clientMessageId != null && Object.hasOwnProperty.call(message, "clientMessageId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.clientMessageId);
                            return writer;
                        };

                        /**
                         * Encodes the specified SendChatMessageRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.SendChatMessageRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.ISendChatMessageRequest} message SendChatMessageRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SendChatMessageRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a SendChatMessageRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.SendChatMessageRequest} SendChatMessageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SendChatMessageRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.SendChatMessageRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.text = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.clientMessageId = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a SendChatMessageRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.SendChatMessageRequest} SendChatMessageRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SendChatMessageRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a SendChatMessageRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SendChatMessageRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.text != null && message.hasOwnProperty("text"))
                                if (!$util.isString(message.text))
                                    return "text: string expected";
                            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                                if (!$util.isString(message.clientMessageId))
                                    return "clientMessageId: string expected";
                            return null;
                        };

                        /**
                         * Creates a SendChatMessageRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.SendChatMessageRequest} SendChatMessageRequest
                         */
                        SendChatMessageRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.SendChatMessageRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.SendChatMessageRequest();
                            if (object.text != null)
                                message.text = String(object.text);
                            if (object.clientMessageId != null)
                                message.clientMessageId = String(object.clientMessageId);
                            return message;
                        };

                        /**
                         * Creates a plain object from a SendChatMessageRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.SendChatMessageRequest} message SendChatMessageRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SendChatMessageRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.text = "";
                                object.clientMessageId = "";
                            }
                            if (message.text != null && message.hasOwnProperty("text"))
                                object.text = message.text;
                            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                                object.clientMessageId = message.clientMessageId;
                            return object;
                        };

                        /**
                         * Converts this SendChatMessageRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SendChatMessageRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for SendChatMessageRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.SendChatMessageRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        SendChatMessageRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.SendChatMessageRequest";
                        };

                        return SendChatMessageRequest;
                    })();

                    stateless.ChatSendResult = (function() {

                        /**
                         * Properties of a ChatSendResult.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IChatSendResult
                         * @property {boolean|null} [success] ChatSendResult success
                         * @property {string|null} [errorCode] ChatSendResult errorCode
                         * @property {string|null} [errorMessage] ChatSendResult errorMessage
                         * @property {string|null} [clientMessageId] ChatSendResult clientMessageId
                         * @property {string|null} [messageId] ChatSendResult messageId
                         * @property {number|Long|null} [sequence] ChatSendResult sequence
                         * @property {number|Long|null} [sentAt] ChatSendResult sentAt
                         * @property {string|null} [senderMessageId] ChatSendResult senderMessageId
                         */

                        /**
                         * Constructs a new ChatSendResult.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ChatSendResult.
                         * @implements IChatSendResult
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IChatSendResult=} [properties] Properties to set
                         */
                        function ChatSendResult(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ChatSendResult success.
                         * @member {boolean} success
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.success = false;

                        /**
                         * ChatSendResult errorCode.
                         * @member {string} errorCode
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.errorCode = "";

                        /**
                         * ChatSendResult errorMessage.
                         * @member {string} errorMessage
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.errorMessage = "";

                        /**
                         * ChatSendResult clientMessageId.
                         * @member {string} clientMessageId
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.clientMessageId = "";

                        /**
                         * ChatSendResult messageId.
                         * @member {string} messageId
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.messageId = "";

                        /**
                         * ChatSendResult sequence.
                         * @member {number|Long} sequence
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatSendResult sentAt.
                         * @member {number|Long} sentAt
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.sentAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatSendResult senderMessageId.
                         * @member {string} senderMessageId
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         */
                        ChatSendResult.prototype.senderMessageId = "";

                        /**
                         * Creates a new ChatSendResult instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatSendResult=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ChatSendResult} ChatSendResult instance
                         */
                        ChatSendResult.create = function create(properties) {
                            return new ChatSendResult(properties);
                        };

                        /**
                         * Encodes the specified ChatSendResult message. Does not implicitly {@link com.achlid.crash.game.stateless.ChatSendResult.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatSendResult} message ChatSendResult message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatSendResult.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorCode);
                            if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.errorMessage);
                            if (message.clientMessageId != null && Object.hasOwnProperty.call(message, "clientMessageId"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientMessageId);
                            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.messageId);
                            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.sequence);
                            if (message.sentAt != null && Object.hasOwnProperty.call(message, "sentAt"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.sentAt);
                            if (message.senderMessageId != null && Object.hasOwnProperty.call(message, "senderMessageId"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.senderMessageId);
                            return writer;
                        };

                        /**
                         * Encodes the specified ChatSendResult message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ChatSendResult.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatSendResult} message ChatSendResult message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatSendResult.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ChatSendResult message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ChatSendResult} ChatSendResult
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatSendResult.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ChatSendResult();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.success = reader.bool();
                                        break;
                                    }
                                case 2: {
                                        message.errorCode = reader.string();
                                        break;
                                    }
                                case 3: {
                                        message.errorMessage = reader.string();
                                        break;
                                    }
                                case 4: {
                                        message.clientMessageId = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.messageId = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.sequence = reader.int64();
                                        break;
                                    }
                                case 7: {
                                        message.sentAt = reader.int64();
                                        break;
                                    }
                                case 8: {
                                        message.senderMessageId = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ChatSendResult message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ChatSendResult} ChatSendResult
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatSendResult.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ChatSendResult message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ChatSendResult.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.success != null && message.hasOwnProperty("success"))
                                if (typeof message.success !== "boolean")
                                    return "success: boolean expected";
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                if (!$util.isString(message.errorCode))
                                    return "errorCode: string expected";
                            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                                if (!$util.isString(message.errorMessage))
                                    return "errorMessage: string expected";
                            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                                if (!$util.isString(message.clientMessageId))
                                    return "clientMessageId: string expected";
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                if (!$util.isString(message.messageId))
                                    return "messageId: string expected";
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                                    return "sequence: integer|Long expected";
                            if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                                if (!$util.isInteger(message.sentAt) && !(message.sentAt && $util.isInteger(message.sentAt.low) && $util.isInteger(message.sentAt.high)))
                                    return "sentAt: integer|Long expected";
                            if (message.senderMessageId != null && message.hasOwnProperty("senderMessageId"))
                                if (!$util.isString(message.senderMessageId))
                                    return "senderMessageId: string expected";
                            return null;
                        };

                        /**
                         * Creates a ChatSendResult message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ChatSendResult} ChatSendResult
                         */
                        ChatSendResult.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ChatSendResult)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ChatSendResult();
                            if (object.success != null)
                                message.success = Boolean(object.success);
                            if (object.errorCode != null)
                                message.errorCode = String(object.errorCode);
                            if (object.errorMessage != null)
                                message.errorMessage = String(object.errorMessage);
                            if (object.clientMessageId != null)
                                message.clientMessageId = String(object.clientMessageId);
                            if (object.messageId != null)
                                message.messageId = String(object.messageId);
                            if (object.sequence != null)
                                if ($util.Long)
                                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                                else if (typeof object.sequence === "string")
                                    message.sequence = parseInt(object.sequence, 10);
                                else if (typeof object.sequence === "number")
                                    message.sequence = object.sequence;
                                else if (typeof object.sequence === "object")
                                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
                            if (object.sentAt != null)
                                if ($util.Long)
                                    (message.sentAt = $util.Long.fromValue(object.sentAt)).unsigned = false;
                                else if (typeof object.sentAt === "string")
                                    message.sentAt = parseInt(object.sentAt, 10);
                                else if (typeof object.sentAt === "number")
                                    message.sentAt = object.sentAt;
                                else if (typeof object.sentAt === "object")
                                    message.sentAt = new $util.LongBits(object.sentAt.low >>> 0, object.sentAt.high >>> 0).toNumber();
                            if (object.senderMessageId != null)
                                message.senderMessageId = String(object.senderMessageId);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ChatSendResult message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {com.achlid.crash.game.stateless.ChatSendResult} message ChatSendResult
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ChatSendResult.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.success = false;
                                object.errorCode = "";
                                object.errorMessage = "";
                                object.clientMessageId = "";
                                object.messageId = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sequence = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sentAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sentAt = options.longs === String ? "0" : 0;
                                object.senderMessageId = "";
                            }
                            if (message.success != null && message.hasOwnProperty("success"))
                                object.success = message.success;
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                object.errorCode = message.errorCode;
                            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                                object.errorMessage = message.errorMessage;
                            if (message.clientMessageId != null && message.hasOwnProperty("clientMessageId"))
                                object.clientMessageId = message.clientMessageId;
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                object.messageId = message.messageId;
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (typeof message.sequence === "number")
                                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                                else
                                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
                            if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                                if (typeof message.sentAt === "number")
                                    object.sentAt = options.longs === String ? String(message.sentAt) : message.sentAt;
                                else
                                    object.sentAt = options.longs === String ? $util.Long.prototype.toString.call(message.sentAt) : options.longs === Number ? new $util.LongBits(message.sentAt.low >>> 0, message.sentAt.high >>> 0).toNumber() : message.sentAt;
                            if (message.senderMessageId != null && message.hasOwnProperty("senderMessageId"))
                                object.senderMessageId = message.senderMessageId;
                            return object;
                        };

                        /**
                         * Converts this ChatSendResult to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ChatSendResult.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ChatSendResult
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ChatSendResult
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ChatSendResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ChatSendResult";
                        };

                        return ChatSendResult;
                    })();

                    stateless.GetChatHistoryRequest = (function() {

                        /**
                         * Properties of a GetChatHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetChatHistoryRequest
                         * @property {number|null} [limit] GetChatHistoryRequest limit
                         * @property {number|Long|null} [beforeSequence] GetChatHistoryRequest beforeSequence
                         */

                        /**
                         * Constructs a new GetChatHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetChatHistoryRequest.
                         * @implements IGetChatHistoryRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetChatHistoryRequest=} [properties] Properties to set
                         */
                        function GetChatHistoryRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetChatHistoryRequest limit.
                         * @member {number} limit
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @instance
                         */
                        GetChatHistoryRequest.prototype.limit = 0;

                        /**
                         * GetChatHistoryRequest beforeSequence.
                         * @member {number|Long} beforeSequence
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @instance
                         */
                        GetChatHistoryRequest.prototype.beforeSequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * Creates a new GetChatHistoryRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetChatHistoryRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetChatHistoryRequest} GetChatHistoryRequest instance
                         */
                        GetChatHistoryRequest.create = function create(properties) {
                            return new GetChatHistoryRequest(properties);
                        };

                        /**
                         * Encodes the specified GetChatHistoryRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetChatHistoryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetChatHistoryRequest} message GetChatHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetChatHistoryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limit);
                            if (message.beforeSequence != null && Object.hasOwnProperty.call(message, "beforeSequence"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.beforeSequence);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetChatHistoryRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetChatHistoryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetChatHistoryRequest} message GetChatHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetChatHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetChatHistoryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetChatHistoryRequest} GetChatHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetChatHistoryRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetChatHistoryRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.limit = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.beforeSequence = reader.int64();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetChatHistoryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetChatHistoryRequest} GetChatHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetChatHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetChatHistoryRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetChatHistoryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                if (!$util.isInteger(message.limit))
                                    return "limit: integer expected";
                            if (message.beforeSequence != null && message.hasOwnProperty("beforeSequence"))
                                if (!$util.isInteger(message.beforeSequence) && !(message.beforeSequence && $util.isInteger(message.beforeSequence.low) && $util.isInteger(message.beforeSequence.high)))
                                    return "beforeSequence: integer|Long expected";
                            return null;
                        };

                        /**
                         * Creates a GetChatHistoryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetChatHistoryRequest} GetChatHistoryRequest
                         */
                        GetChatHistoryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetChatHistoryRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetChatHistoryRequest();
                            if (object.limit != null)
                                message.limit = object.limit | 0;
                            if (object.beforeSequence != null)
                                if ($util.Long)
                                    (message.beforeSequence = $util.Long.fromValue(object.beforeSequence)).unsigned = false;
                                else if (typeof object.beforeSequence === "string")
                                    message.beforeSequence = parseInt(object.beforeSequence, 10);
                                else if (typeof object.beforeSequence === "number")
                                    message.beforeSequence = object.beforeSequence;
                                else if (typeof object.beforeSequence === "object")
                                    message.beforeSequence = new $util.LongBits(object.beforeSequence.low >>> 0, object.beforeSequence.high >>> 0).toNumber();
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetChatHistoryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetChatHistoryRequest} message GetChatHistoryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetChatHistoryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.limit = 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.beforeSequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.beforeSequence = options.longs === String ? "0" : 0;
                            }
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                object.limit = message.limit;
                            if (message.beforeSequence != null && message.hasOwnProperty("beforeSequence"))
                                if (typeof message.beforeSequence === "number")
                                    object.beforeSequence = options.longs === String ? String(message.beforeSequence) : message.beforeSequence;
                                else
                                    object.beforeSequence = options.longs === String ? $util.Long.prototype.toString.call(message.beforeSequence) : options.longs === Number ? new $util.LongBits(message.beforeSequence.low >>> 0, message.beforeSequence.high >>> 0).toNumber() : message.beforeSequence;
                            return object;
                        };

                        /**
                         * Converts this GetChatHistoryRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetChatHistoryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetChatHistoryRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetChatHistoryRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetChatHistoryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetChatHistoryRequest";
                        };

                        return GetChatHistoryRequest;
                    })();

                    stateless.GetViewerAwareChatHistoryRequest = (function() {

                        /**
                         * Properties of a GetViewerAwareChatHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IGetViewerAwareChatHistoryRequest
                         * @property {number|null} [limit] GetViewerAwareChatHistoryRequest limit
                         * @property {string|null} [cursorV2] GetViewerAwareChatHistoryRequest cursorV2
                         */

                        /**
                         * Constructs a new GetViewerAwareChatHistoryRequest.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a GetViewerAwareChatHistoryRequest.
                         * @implements IGetViewerAwareChatHistoryRequest
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest=} [properties] Properties to set
                         */
                        function GetViewerAwareChatHistoryRequest(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * GetViewerAwareChatHistoryRequest limit.
                         * @member {number} limit
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @instance
                         */
                        GetViewerAwareChatHistoryRequest.prototype.limit = 0;

                        /**
                         * GetViewerAwareChatHistoryRequest cursorV2.
                         * @member {string} cursorV2
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @instance
                         */
                        GetViewerAwareChatHistoryRequest.prototype.cursorV2 = "";

                        /**
                         * Creates a new GetViewerAwareChatHistoryRequest instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest} GetViewerAwareChatHistoryRequest instance
                         */
                        GetViewerAwareChatHistoryRequest.create = function create(properties) {
                            return new GetViewerAwareChatHistoryRequest(properties);
                        };

                        /**
                         * Encodes the specified GetViewerAwareChatHistoryRequest message. Does not implicitly {@link com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest} message GetViewerAwareChatHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetViewerAwareChatHistoryRequest.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limit);
                            if (message.cursorV2 != null && Object.hasOwnProperty.call(message, "cursorV2"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.cursorV2);
                            return writer;
                        };

                        /**
                         * Encodes the specified GetViewerAwareChatHistoryRequest message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.IGetViewerAwareChatHistoryRequest} message GetViewerAwareChatHistoryRequest message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GetViewerAwareChatHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a GetViewerAwareChatHistoryRequest message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest} GetViewerAwareChatHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetViewerAwareChatHistoryRequest.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.limit = reader.int32();
                                        break;
                                    }
                                case 2: {
                                        message.cursorV2 = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a GetViewerAwareChatHistoryRequest message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest} GetViewerAwareChatHistoryRequest
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GetViewerAwareChatHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a GetViewerAwareChatHistoryRequest message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GetViewerAwareChatHistoryRequest.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                if (!$util.isInteger(message.limit))
                                    return "limit: integer expected";
                            if (message.cursorV2 != null && message.hasOwnProperty("cursorV2"))
                                if (!$util.isString(message.cursorV2))
                                    return "cursorV2: string expected";
                            return null;
                        };

                        /**
                         * Creates a GetViewerAwareChatHistoryRequest message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest} GetViewerAwareChatHistoryRequest
                         */
                        GetViewerAwareChatHistoryRequest.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest();
                            if (object.limit != null)
                                message.limit = object.limit | 0;
                            if (object.cursorV2 != null)
                                message.cursorV2 = String(object.cursorV2);
                            return message;
                        };

                        /**
                         * Creates a plain object from a GetViewerAwareChatHistoryRequest message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest} message GetViewerAwareChatHistoryRequest
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GetViewerAwareChatHistoryRequest.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.limit = 0;
                                object.cursorV2 = "";
                            }
                            if (message.limit != null && message.hasOwnProperty("limit"))
                                object.limit = message.limit;
                            if (message.cursorV2 != null && message.hasOwnProperty("cursorV2"))
                                object.cursorV2 = message.cursorV2;
                            return object;
                        };

                        /**
                         * Converts this GetViewerAwareChatHistoryRequest to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GetViewerAwareChatHistoryRequest.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for GetViewerAwareChatHistoryRequest
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        GetViewerAwareChatHistoryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.GetViewerAwareChatHistoryRequest";
                        };

                        return GetViewerAwareChatHistoryRequest;
                    })();

                    stateless.ChatHistoryResponse = (function() {

                        /**
                         * Properties of a ChatHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IChatHistoryResponse
                         * @property {boolean|null} [success] ChatHistoryResponse success
                         * @property {string|null} [errorCode] ChatHistoryResponse errorCode
                         * @property {Array.<com.achlid.crash.game.stateless.IChatMessage>|null} [messages] ChatHistoryResponse messages
                         * @property {number|Long|null} [nextBeforeSequence] ChatHistoryResponse nextBeforeSequence
                         * @property {boolean|null} [hasMore] ChatHistoryResponse hasMore
                         */

                        /**
                         * Constructs a new ChatHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ChatHistoryResponse.
                         * @implements IChatHistoryResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IChatHistoryResponse=} [properties] Properties to set
                         */
                        function ChatHistoryResponse(properties) {
                            this.messages = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ChatHistoryResponse success.
                         * @member {boolean} success
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         */
                        ChatHistoryResponse.prototype.success = false;

                        /**
                         * ChatHistoryResponse errorCode.
                         * @member {string} errorCode
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         */
                        ChatHistoryResponse.prototype.errorCode = "";

                        /**
                         * ChatHistoryResponse messages.
                         * @member {Array.<com.achlid.crash.game.stateless.IChatMessage>} messages
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         */
                        ChatHistoryResponse.prototype.messages = $util.emptyArray;

                        /**
                         * ChatHistoryResponse nextBeforeSequence.
                         * @member {number|Long} nextBeforeSequence
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         */
                        ChatHistoryResponse.prototype.nextBeforeSequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatHistoryResponse hasMore.
                         * @member {boolean} hasMore
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         */
                        ChatHistoryResponse.prototype.hasMore = false;

                        /**
                         * Creates a new ChatHistoryResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatHistoryResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ChatHistoryResponse} ChatHistoryResponse instance
                         */
                        ChatHistoryResponse.create = function create(properties) {
                            return new ChatHistoryResponse(properties);
                        };

                        /**
                         * Encodes the specified ChatHistoryResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.ChatHistoryResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatHistoryResponse} message ChatHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatHistoryResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorCode);
                            if (message.messages != null && message.messages.length)
                                for (let i = 0; i < message.messages.length; ++i)
                                    $root.com.achlid.crash.game.stateless.ChatMessage.encode(message.messages[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.nextBeforeSequence != null && Object.hasOwnProperty.call(message, "nextBeforeSequence"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.nextBeforeSequence);
                            if (message.hasMore != null && Object.hasOwnProperty.call(message, "hasMore"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hasMore);
                            return writer;
                        };

                        /**
                         * Encodes the specified ChatHistoryResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ChatHistoryResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatHistoryResponse} message ChatHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatHistoryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ChatHistoryResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ChatHistoryResponse} ChatHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatHistoryResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ChatHistoryResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.success = reader.bool();
                                        break;
                                    }
                                case 2: {
                                        message.errorCode = reader.string();
                                        break;
                                    }
                                case 3: {
                                        if (!(message.messages && message.messages.length))
                                            message.messages = [];
                                        message.messages.push($root.com.achlid.crash.game.stateless.ChatMessage.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 4: {
                                        message.nextBeforeSequence = reader.int64();
                                        break;
                                    }
                                case 5: {
                                        message.hasMore = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ChatHistoryResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ChatHistoryResponse} ChatHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatHistoryResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ChatHistoryResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ChatHistoryResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.success != null && message.hasOwnProperty("success"))
                                if (typeof message.success !== "boolean")
                                    return "success: boolean expected";
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                if (!$util.isString(message.errorCode))
                                    return "errorCode: string expected";
                            if (message.messages != null && message.hasOwnProperty("messages")) {
                                if (!Array.isArray(message.messages))
                                    return "messages: array expected";
                                for (let i = 0; i < message.messages.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.ChatMessage.verify(message.messages[i]);
                                    if (error)
                                        return "messages." + error;
                                }
                            }
                            if (message.nextBeforeSequence != null && message.hasOwnProperty("nextBeforeSequence"))
                                if (!$util.isInteger(message.nextBeforeSequence) && !(message.nextBeforeSequence && $util.isInteger(message.nextBeforeSequence.low) && $util.isInteger(message.nextBeforeSequence.high)))
                                    return "nextBeforeSequence: integer|Long expected";
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                if (typeof message.hasMore !== "boolean")
                                    return "hasMore: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a ChatHistoryResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ChatHistoryResponse} ChatHistoryResponse
                         */
                        ChatHistoryResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ChatHistoryResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ChatHistoryResponse();
                            if (object.success != null)
                                message.success = Boolean(object.success);
                            if (object.errorCode != null)
                                message.errorCode = String(object.errorCode);
                            if (object.messages) {
                                if (!Array.isArray(object.messages))
                                    throw TypeError(".com.achlid.crash.game.stateless.ChatHistoryResponse.messages: array expected");
                                message.messages = [];
                                for (let i = 0; i < object.messages.length; ++i) {
                                    if (typeof object.messages[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.ChatHistoryResponse.messages: object expected");
                                    message.messages[i] = $root.com.achlid.crash.game.stateless.ChatMessage.fromObject(object.messages[i]);
                                }
                            }
                            if (object.nextBeforeSequence != null)
                                if ($util.Long)
                                    (message.nextBeforeSequence = $util.Long.fromValue(object.nextBeforeSequence)).unsigned = false;
                                else if (typeof object.nextBeforeSequence === "string")
                                    message.nextBeforeSequence = parseInt(object.nextBeforeSequence, 10);
                                else if (typeof object.nextBeforeSequence === "number")
                                    message.nextBeforeSequence = object.nextBeforeSequence;
                                else if (typeof object.nextBeforeSequence === "object")
                                    message.nextBeforeSequence = new $util.LongBits(object.nextBeforeSequence.low >>> 0, object.nextBeforeSequence.high >>> 0).toNumber();
                            if (object.hasMore != null)
                                message.hasMore = Boolean(object.hasMore);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ChatHistoryResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ChatHistoryResponse} message ChatHistoryResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ChatHistoryResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.messages = [];
                            if (options.defaults) {
                                object.success = false;
                                object.errorCode = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.nextBeforeSequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.nextBeforeSequence = options.longs === String ? "0" : 0;
                                object.hasMore = false;
                            }
                            if (message.success != null && message.hasOwnProperty("success"))
                                object.success = message.success;
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                object.errorCode = message.errorCode;
                            if (message.messages && message.messages.length) {
                                object.messages = [];
                                for (let j = 0; j < message.messages.length; ++j)
                                    object.messages[j] = $root.com.achlid.crash.game.stateless.ChatMessage.toObject(message.messages[j], options);
                            }
                            if (message.nextBeforeSequence != null && message.hasOwnProperty("nextBeforeSequence"))
                                if (typeof message.nextBeforeSequence === "number")
                                    object.nextBeforeSequence = options.longs === String ? String(message.nextBeforeSequence) : message.nextBeforeSequence;
                                else
                                    object.nextBeforeSequence = options.longs === String ? $util.Long.prototype.toString.call(message.nextBeforeSequence) : options.longs === Number ? new $util.LongBits(message.nextBeforeSequence.low >>> 0, message.nextBeforeSequence.high >>> 0).toNumber() : message.nextBeforeSequence;
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                object.hasMore = message.hasMore;
                            return object;
                        };

                        /**
                         * Converts this ChatHistoryResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ChatHistoryResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ChatHistoryResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ChatHistoryResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ChatHistoryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ChatHistoryResponse";
                        };

                        return ChatHistoryResponse;
                    })();

                    stateless.ViewerAwareChatHistoryResponse = (function() {

                        /**
                         * Properties of a ViewerAwareChatHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IViewerAwareChatHistoryResponse
                         * @property {boolean|null} [success] ViewerAwareChatHistoryResponse success
                         * @property {string|null} [errorCode] ViewerAwareChatHistoryResponse errorCode
                         * @property {Array.<com.achlid.crash.game.stateless.IChatMessage>|null} [messages] ViewerAwareChatHistoryResponse messages
                         * @property {string|null} [nextCursorV2] ViewerAwareChatHistoryResponse nextCursorV2
                         * @property {boolean|null} [hasMore] ViewerAwareChatHistoryResponse hasMore
                         */

                        /**
                         * Constructs a new ViewerAwareChatHistoryResponse.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ViewerAwareChatHistoryResponse.
                         * @implements IViewerAwareChatHistoryResponse
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse=} [properties] Properties to set
                         */
                        function ViewerAwareChatHistoryResponse(properties) {
                            this.messages = [];
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ViewerAwareChatHistoryResponse success.
                         * @member {boolean} success
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         */
                        ViewerAwareChatHistoryResponse.prototype.success = false;

                        /**
                         * ViewerAwareChatHistoryResponse errorCode.
                         * @member {string} errorCode
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         */
                        ViewerAwareChatHistoryResponse.prototype.errorCode = "";

                        /**
                         * ViewerAwareChatHistoryResponse messages.
                         * @member {Array.<com.achlid.crash.game.stateless.IChatMessage>} messages
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         */
                        ViewerAwareChatHistoryResponse.prototype.messages = $util.emptyArray;

                        /**
                         * ViewerAwareChatHistoryResponse nextCursorV2.
                         * @member {string} nextCursorV2
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         */
                        ViewerAwareChatHistoryResponse.prototype.nextCursorV2 = "";

                        /**
                         * ViewerAwareChatHistoryResponse hasMore.
                         * @member {boolean} hasMore
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         */
                        ViewerAwareChatHistoryResponse.prototype.hasMore = false;

                        /**
                         * Creates a new ViewerAwareChatHistoryResponse instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse} ViewerAwareChatHistoryResponse instance
                         */
                        ViewerAwareChatHistoryResponse.create = function create(properties) {
                            return new ViewerAwareChatHistoryResponse(properties);
                        };

                        /**
                         * Encodes the specified ViewerAwareChatHistoryResponse message. Does not implicitly {@link com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse} message ViewerAwareChatHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ViewerAwareChatHistoryResponse.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
                            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorCode);
                            if (message.messages != null && message.messages.length)
                                for (let i = 0; i < message.messages.length; ++i)
                                    $root.com.achlid.crash.game.stateless.ChatMessage.encode(message.messages[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.nextCursorV2 != null && Object.hasOwnProperty.call(message, "nextCursorV2"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nextCursorV2);
                            if (message.hasMore != null && Object.hasOwnProperty.call(message, "hasMore"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hasMore);
                            return writer;
                        };

                        /**
                         * Encodes the specified ViewerAwareChatHistoryResponse message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.IViewerAwareChatHistoryResponse} message ViewerAwareChatHistoryResponse message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ViewerAwareChatHistoryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ViewerAwareChatHistoryResponse message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse} ViewerAwareChatHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ViewerAwareChatHistoryResponse.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.success = reader.bool();
                                        break;
                                    }
                                case 2: {
                                        message.errorCode = reader.string();
                                        break;
                                    }
                                case 3: {
                                        if (!(message.messages && message.messages.length))
                                            message.messages = [];
                                        message.messages.push($root.com.achlid.crash.game.stateless.ChatMessage.decode(reader, reader.uint32()));
                                        break;
                                    }
                                case 4: {
                                        message.nextCursorV2 = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.hasMore = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ViewerAwareChatHistoryResponse message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse} ViewerAwareChatHistoryResponse
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ViewerAwareChatHistoryResponse.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ViewerAwareChatHistoryResponse message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ViewerAwareChatHistoryResponse.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.success != null && message.hasOwnProperty("success"))
                                if (typeof message.success !== "boolean")
                                    return "success: boolean expected";
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                if (!$util.isString(message.errorCode))
                                    return "errorCode: string expected";
                            if (message.messages != null && message.hasOwnProperty("messages")) {
                                if (!Array.isArray(message.messages))
                                    return "messages: array expected";
                                for (let i = 0; i < message.messages.length; ++i) {
                                    let error = $root.com.achlid.crash.game.stateless.ChatMessage.verify(message.messages[i]);
                                    if (error)
                                        return "messages." + error;
                                }
                            }
                            if (message.nextCursorV2 != null && message.hasOwnProperty("nextCursorV2"))
                                if (!$util.isString(message.nextCursorV2))
                                    return "nextCursorV2: string expected";
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                if (typeof message.hasMore !== "boolean")
                                    return "hasMore: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a ViewerAwareChatHistoryResponse message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse} ViewerAwareChatHistoryResponse
                         */
                        ViewerAwareChatHistoryResponse.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse();
                            if (object.success != null)
                                message.success = Boolean(object.success);
                            if (object.errorCode != null)
                                message.errorCode = String(object.errorCode);
                            if (object.messages) {
                                if (!Array.isArray(object.messages))
                                    throw TypeError(".com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.messages: array expected");
                                message.messages = [];
                                for (let i = 0; i < object.messages.length; ++i) {
                                    if (typeof object.messages[i] !== "object")
                                        throw TypeError(".com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse.messages: object expected");
                                    message.messages[i] = $root.com.achlid.crash.game.stateless.ChatMessage.fromObject(object.messages[i]);
                                }
                            }
                            if (object.nextCursorV2 != null)
                                message.nextCursorV2 = String(object.nextCursorV2);
                            if (object.hasMore != null)
                                message.hasMore = Boolean(object.hasMore);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ViewerAwareChatHistoryResponse message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse} message ViewerAwareChatHistoryResponse
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ViewerAwareChatHistoryResponse.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.arrays || options.defaults)
                                object.messages = [];
                            if (options.defaults) {
                                object.success = false;
                                object.errorCode = "";
                                object.nextCursorV2 = "";
                                object.hasMore = false;
                            }
                            if (message.success != null && message.hasOwnProperty("success"))
                                object.success = message.success;
                            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                                object.errorCode = message.errorCode;
                            if (message.messages && message.messages.length) {
                                object.messages = [];
                                for (let j = 0; j < message.messages.length; ++j)
                                    object.messages[j] = $root.com.achlid.crash.game.stateless.ChatMessage.toObject(message.messages[j], options);
                            }
                            if (message.nextCursorV2 != null && message.hasOwnProperty("nextCursorV2"))
                                object.nextCursorV2 = message.nextCursorV2;
                            if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                                object.hasMore = message.hasMore;
                            return object;
                        };

                        /**
                         * Converts this ViewerAwareChatHistoryResponse to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ViewerAwareChatHistoryResponse.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ViewerAwareChatHistoryResponse
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ViewerAwareChatHistoryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ViewerAwareChatHistoryResponse";
                        };

                        return ViewerAwareChatHistoryResponse;
                    })();

                    stateless.ChatMessage = (function() {

                        /**
                         * Properties of a ChatMessage.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IChatMessage
                         * @property {string|null} [messageId] ChatMessage messageId
                         * @property {number|Long|null} [sequence] ChatMessage sequence
                         * @property {number|Long|null} [sentAt] ChatMessage sentAt
                         * @property {string|null} [playerName] ChatMessage playerName
                         * @property {string|null} [avatar] ChatMessage avatar
                         * @property {string|null} [text] ChatMessage text
                         * @property {boolean|null} [deleted] ChatMessage deleted
                         * @property {number|Long|null} [deletedAt] ChatMessage deletedAt
                         * @property {string|null} [senderMessageId] ChatMessage senderMessageId
                         */

                        /**
                         * Constructs a new ChatMessage.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ChatMessage.
                         * @implements IChatMessage
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IChatMessage=} [properties] Properties to set
                         */
                        function ChatMessage(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ChatMessage messageId.
                         * @member {string} messageId
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.messageId = "";

                        /**
                         * ChatMessage sequence.
                         * @member {number|Long} sequence
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatMessage sentAt.
                         * @member {number|Long} sentAt
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.sentAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatMessage playerName.
                         * @member {string} playerName
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.playerName = "";

                        /**
                         * ChatMessage avatar.
                         * @member {string} avatar
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.avatar = "";

                        /**
                         * ChatMessage text.
                         * @member {string} text
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.text = "";

                        /**
                         * ChatMessage deleted.
                         * @member {boolean} deleted
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.deleted = false;

                        /**
                         * ChatMessage deletedAt.
                         * @member {number|Long} deletedAt
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.deletedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatMessage senderMessageId.
                         * @member {string} senderMessageId
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         */
                        ChatMessage.prototype.senderMessageId = "";

                        /**
                         * Creates a new ChatMessage instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessage=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ChatMessage} ChatMessage instance
                         */
                        ChatMessage.create = function create(properties) {
                            return new ChatMessage(properties);
                        };

                        /**
                         * Encodes the specified ChatMessage message. Does not implicitly {@link com.achlid.crash.game.stateless.ChatMessage.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessage} message ChatMessage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatMessage.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
                            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sequence);
                            if (message.sentAt != null && Object.hasOwnProperty.call(message, "sentAt"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.sentAt);
                            if (message.playerName != null && Object.hasOwnProperty.call(message, "playerName"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.playerName);
                            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.avatar);
                            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.text);
                            if (message.deleted != null && Object.hasOwnProperty.call(message, "deleted"))
                                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.deleted);
                            if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
                                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.deletedAt);
                            if (message.senderMessageId != null && Object.hasOwnProperty.call(message, "senderMessageId"))
                                writer.uint32(/* id 9, wireType 2 =*/74).string(message.senderMessageId);
                            return writer;
                        };

                        /**
                         * Encodes the specified ChatMessage message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ChatMessage.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessage} message ChatMessage message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatMessage.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ChatMessage message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ChatMessage} ChatMessage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatMessage.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ChatMessage();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.messageId = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.sequence = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.sentAt = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.playerName = reader.string();
                                        break;
                                    }
                                case 5: {
                                        message.avatar = reader.string();
                                        break;
                                    }
                                case 6: {
                                        message.text = reader.string();
                                        break;
                                    }
                                case 7: {
                                        message.deleted = reader.bool();
                                        break;
                                    }
                                case 8: {
                                        message.deletedAt = reader.int64();
                                        break;
                                    }
                                case 9: {
                                        message.senderMessageId = reader.string();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ChatMessage message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ChatMessage} ChatMessage
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatMessage.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ChatMessage message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ChatMessage.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                if (!$util.isString(message.messageId))
                                    return "messageId: string expected";
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                                    return "sequence: integer|Long expected";
                            if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                                if (!$util.isInteger(message.sentAt) && !(message.sentAt && $util.isInteger(message.sentAt.low) && $util.isInteger(message.sentAt.high)))
                                    return "sentAt: integer|Long expected";
                            if (message.playerName != null && message.hasOwnProperty("playerName"))
                                if (!$util.isString(message.playerName))
                                    return "playerName: string expected";
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                if (!$util.isString(message.avatar))
                                    return "avatar: string expected";
                            if (message.text != null && message.hasOwnProperty("text"))
                                if (!$util.isString(message.text))
                                    return "text: string expected";
                            if (message.deleted != null && message.hasOwnProperty("deleted"))
                                if (typeof message.deleted !== "boolean")
                                    return "deleted: boolean expected";
                            if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
                                if (!$util.isInteger(message.deletedAt) && !(message.deletedAt && $util.isInteger(message.deletedAt.low) && $util.isInteger(message.deletedAt.high)))
                                    return "deletedAt: integer|Long expected";
                            if (message.senderMessageId != null && message.hasOwnProperty("senderMessageId"))
                                if (!$util.isString(message.senderMessageId))
                                    return "senderMessageId: string expected";
                            return null;
                        };

                        /**
                         * Creates a ChatMessage message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ChatMessage} ChatMessage
                         */
                        ChatMessage.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ChatMessage)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ChatMessage();
                            if (object.messageId != null)
                                message.messageId = String(object.messageId);
                            if (object.sequence != null)
                                if ($util.Long)
                                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                                else if (typeof object.sequence === "string")
                                    message.sequence = parseInt(object.sequence, 10);
                                else if (typeof object.sequence === "number")
                                    message.sequence = object.sequence;
                                else if (typeof object.sequence === "object")
                                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
                            if (object.sentAt != null)
                                if ($util.Long)
                                    (message.sentAt = $util.Long.fromValue(object.sentAt)).unsigned = false;
                                else if (typeof object.sentAt === "string")
                                    message.sentAt = parseInt(object.sentAt, 10);
                                else if (typeof object.sentAt === "number")
                                    message.sentAt = object.sentAt;
                                else if (typeof object.sentAt === "object")
                                    message.sentAt = new $util.LongBits(object.sentAt.low >>> 0, object.sentAt.high >>> 0).toNumber();
                            if (object.playerName != null)
                                message.playerName = String(object.playerName);
                            if (object.avatar != null)
                                message.avatar = String(object.avatar);
                            if (object.text != null)
                                message.text = String(object.text);
                            if (object.deleted != null)
                                message.deleted = Boolean(object.deleted);
                            if (object.deletedAt != null)
                                if ($util.Long)
                                    (message.deletedAt = $util.Long.fromValue(object.deletedAt)).unsigned = false;
                                else if (typeof object.deletedAt === "string")
                                    message.deletedAt = parseInt(object.deletedAt, 10);
                                else if (typeof object.deletedAt === "number")
                                    message.deletedAt = object.deletedAt;
                                else if (typeof object.deletedAt === "object")
                                    message.deletedAt = new $util.LongBits(object.deletedAt.low >>> 0, object.deletedAt.high >>> 0).toNumber();
                            if (object.senderMessageId != null)
                                message.senderMessageId = String(object.senderMessageId);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ChatMessage message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {com.achlid.crash.game.stateless.ChatMessage} message ChatMessage
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ChatMessage.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.messageId = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sequence = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sentAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sentAt = options.longs === String ? "0" : 0;
                                object.playerName = "";
                                object.avatar = "";
                                object.text = "";
                                object.deleted = false;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.deletedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.deletedAt = options.longs === String ? "0" : 0;
                                object.senderMessageId = "";
                            }
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                object.messageId = message.messageId;
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (typeof message.sequence === "number")
                                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                                else
                                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
                            if (message.sentAt != null && message.hasOwnProperty("sentAt"))
                                if (typeof message.sentAt === "number")
                                    object.sentAt = options.longs === String ? String(message.sentAt) : message.sentAt;
                                else
                                    object.sentAt = options.longs === String ? $util.Long.prototype.toString.call(message.sentAt) : options.longs === Number ? new $util.LongBits(message.sentAt.low >>> 0, message.sentAt.high >>> 0).toNumber() : message.sentAt;
                            if (message.playerName != null && message.hasOwnProperty("playerName"))
                                object.playerName = message.playerName;
                            if (message.avatar != null && message.hasOwnProperty("avatar"))
                                object.avatar = message.avatar;
                            if (message.text != null && message.hasOwnProperty("text"))
                                object.text = message.text;
                            if (message.deleted != null && message.hasOwnProperty("deleted"))
                                object.deleted = message.deleted;
                            if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
                                if (typeof message.deletedAt === "number")
                                    object.deletedAt = options.longs === String ? String(message.deletedAt) : message.deletedAt;
                                else
                                    object.deletedAt = options.longs === String ? $util.Long.prototype.toString.call(message.deletedAt) : options.longs === Number ? new $util.LongBits(message.deletedAt.low >>> 0, message.deletedAt.high >>> 0).toNumber() : message.deletedAt;
                            if (message.senderMessageId != null && message.hasOwnProperty("senderMessageId"))
                                object.senderMessageId = message.senderMessageId;
                            return object;
                        };

                        /**
                         * Converts this ChatMessage to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ChatMessage.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ChatMessage
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ChatMessage
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ChatMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ChatMessage";
                        };

                        return ChatMessage;
                    })();

                    stateless.ChatMessageDeleted = (function() {

                        /**
                         * Properties of a ChatMessageDeleted.
                         * @memberof com.achlid.crash.game.stateless
                         * @interface IChatMessageDeleted
                         * @property {string|null} [messageId] ChatMessageDeleted messageId
                         * @property {number|Long|null} [sequence] ChatMessageDeleted sequence
                         * @property {number|Long|null} [deletedAt] ChatMessageDeleted deletedAt
                         * @property {boolean|null} [deleted] ChatMessageDeleted deleted
                         */

                        /**
                         * Constructs a new ChatMessageDeleted.
                         * @memberof com.achlid.crash.game.stateless
                         * @classdesc Represents a ChatMessageDeleted.
                         * @implements IChatMessageDeleted
                         * @constructor
                         * @param {com.achlid.crash.game.stateless.IChatMessageDeleted=} [properties] Properties to set
                         */
                        function ChatMessageDeleted(properties) {
                            if (properties)
                                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }

                        /**
                         * ChatMessageDeleted messageId.
                         * @member {string} messageId
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @instance
                         */
                        ChatMessageDeleted.prototype.messageId = "";

                        /**
                         * ChatMessageDeleted sequence.
                         * @member {number|Long} sequence
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @instance
                         */
                        ChatMessageDeleted.prototype.sequence = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatMessageDeleted deletedAt.
                         * @member {number|Long} deletedAt
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @instance
                         */
                        ChatMessageDeleted.prototype.deletedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                        /**
                         * ChatMessageDeleted deleted.
                         * @member {boolean} deleted
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @instance
                         */
                        ChatMessageDeleted.prototype.deleted = false;

                        /**
                         * Creates a new ChatMessageDeleted instance using the specified properties.
                         * @function create
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessageDeleted=} [properties] Properties to set
                         * @returns {com.achlid.crash.game.stateless.ChatMessageDeleted} ChatMessageDeleted instance
                         */
                        ChatMessageDeleted.create = function create(properties) {
                            return new ChatMessageDeleted(properties);
                        };

                        /**
                         * Encodes the specified ChatMessageDeleted message. Does not implicitly {@link com.achlid.crash.game.stateless.ChatMessageDeleted.verify|verify} messages.
                         * @function encode
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessageDeleted} message ChatMessageDeleted message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatMessageDeleted.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
                            if (message.sequence != null && Object.hasOwnProperty.call(message, "sequence"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sequence);
                            if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.deletedAt);
                            if (message.deleted != null && Object.hasOwnProperty.call(message, "deleted"))
                                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.deleted);
                            return writer;
                        };

                        /**
                         * Encodes the specified ChatMessageDeleted message, length delimited. Does not implicitly {@link com.achlid.crash.game.stateless.ChatMessageDeleted.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {com.achlid.crash.game.stateless.IChatMessageDeleted} message ChatMessageDeleted message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ChatMessageDeleted.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };

                        /**
                         * Decodes a ChatMessageDeleted message from the specified reader or buffer.
                         * @function decode
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {com.achlid.crash.game.stateless.ChatMessageDeleted} ChatMessageDeleted
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatMessageDeleted.decode = function decode(reader, length, error) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.achlid.crash.game.stateless.ChatMessageDeleted();
                            while (reader.pos < end) {
                                let tag = reader.uint32();
                                if (tag === error)
                                    break;
                                switch (tag >>> 3) {
                                case 1: {
                                        message.messageId = reader.string();
                                        break;
                                    }
                                case 2: {
                                        message.sequence = reader.int64();
                                        break;
                                    }
                                case 3: {
                                        message.deletedAt = reader.int64();
                                        break;
                                    }
                                case 4: {
                                        message.deleted = reader.bool();
                                        break;
                                    }
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };

                        /**
                         * Decodes a ChatMessageDeleted message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {com.achlid.crash.game.stateless.ChatMessageDeleted} ChatMessageDeleted
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ChatMessageDeleted.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };

                        /**
                         * Verifies a ChatMessageDeleted message.
                         * @function verify
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ChatMessageDeleted.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                if (!$util.isString(message.messageId))
                                    return "messageId: string expected";
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (!$util.isInteger(message.sequence) && !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high)))
                                    return "sequence: integer|Long expected";
                            if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
                                if (!$util.isInteger(message.deletedAt) && !(message.deletedAt && $util.isInteger(message.deletedAt.low) && $util.isInteger(message.deletedAt.high)))
                                    return "deletedAt: integer|Long expected";
                            if (message.deleted != null && message.hasOwnProperty("deleted"))
                                if (typeof message.deleted !== "boolean")
                                    return "deleted: boolean expected";
                            return null;
                        };

                        /**
                         * Creates a ChatMessageDeleted message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {com.achlid.crash.game.stateless.ChatMessageDeleted} ChatMessageDeleted
                         */
                        ChatMessageDeleted.fromObject = function fromObject(object) {
                            if (object instanceof $root.com.achlid.crash.game.stateless.ChatMessageDeleted)
                                return object;
                            let message = new $root.com.achlid.crash.game.stateless.ChatMessageDeleted();
                            if (object.messageId != null)
                                message.messageId = String(object.messageId);
                            if (object.sequence != null)
                                if ($util.Long)
                                    (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
                                else if (typeof object.sequence === "string")
                                    message.sequence = parseInt(object.sequence, 10);
                                else if (typeof object.sequence === "number")
                                    message.sequence = object.sequence;
                                else if (typeof object.sequence === "object")
                                    message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
                            if (object.deletedAt != null)
                                if ($util.Long)
                                    (message.deletedAt = $util.Long.fromValue(object.deletedAt)).unsigned = false;
                                else if (typeof object.deletedAt === "string")
                                    message.deletedAt = parseInt(object.deletedAt, 10);
                                else if (typeof object.deletedAt === "number")
                                    message.deletedAt = object.deletedAt;
                                else if (typeof object.deletedAt === "object")
                                    message.deletedAt = new $util.LongBits(object.deletedAt.low >>> 0, object.deletedAt.high >>> 0).toNumber();
                            if (object.deleted != null)
                                message.deleted = Boolean(object.deleted);
                            return message;
                        };

                        /**
                         * Creates a plain object from a ChatMessageDeleted message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {com.achlid.crash.game.stateless.ChatMessageDeleted} message ChatMessageDeleted
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ChatMessageDeleted.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            let object = {};
                            if (options.defaults) {
                                object.messageId = "";
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.sequence = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.sequence = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    let long = new $util.Long(0, 0, false);
                                    object.deletedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.deletedAt = options.longs === String ? "0" : 0;
                                object.deleted = false;
                            }
                            if (message.messageId != null && message.hasOwnProperty("messageId"))
                                object.messageId = message.messageId;
                            if (message.sequence != null && message.hasOwnProperty("sequence"))
                                if (typeof message.sequence === "number")
                                    object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
                                else
                                    object.sequence = options.longs === String ? $util.Long.prototype.toString.call(message.sequence) : options.longs === Number ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber() : message.sequence;
                            if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
                                if (typeof message.deletedAt === "number")
                                    object.deletedAt = options.longs === String ? String(message.deletedAt) : message.deletedAt;
                                else
                                    object.deletedAt = options.longs === String ? $util.Long.prototype.toString.call(message.deletedAt) : options.longs === Number ? new $util.LongBits(message.deletedAt.low >>> 0, message.deletedAt.high >>> 0).toNumber() : message.deletedAt;
                            if (message.deleted != null && message.hasOwnProperty("deleted"))
                                object.deleted = message.deleted;
                            return object;
                        };

                        /**
                         * Converts this ChatMessageDeleted to JSON.
                         * @function toJSON
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ChatMessageDeleted.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };

                        /**
                         * Gets the default type url for ChatMessageDeleted
                         * @function getTypeUrl
                         * @memberof com.achlid.crash.game.stateless.ChatMessageDeleted
                         * @static
                         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                         * @returns {string} The default type url
                         */
                        ChatMessageDeleted.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                            if (typeUrlPrefix === undefined) {
                                typeUrlPrefix = "type.googleapis.com";
                            }
                            return typeUrlPrefix + "/com.achlid.crash.game.stateless.ChatMessageDeleted";
                        };

                        return ChatMessageDeleted;
                    })();

                    return stateless;
                })();

                return game;
            })();

            return crash;
        })();

        return achlid;
    })();

    return com;
})();

export { $root as default };
